{
  "app.name": "DoneTalk",
  "nav.inbox": "Atenciones",
  "nav.contacts": "Contactos",
  "nav.flows": "Flujos",
  "nav.assistants": "Asistentes",
  "nav.numbers": "Números",
  "nav.settings": "Configuración",
  "inbox.view.mine": "Mías",
  "inbox.view.team": "Mi equipo",
  "inbox.view.queue": "Cola",
  "inbox.view.waiting_contact": "Esperando contacto",
  "inbox.view.snoozed": "Pospuestas",
  "inbox.view.closed": "Concluidas",
  "conversation.status.new": "Nueva",
  "conversation.status.active": "En atención",
  "conversation.status.waiting_contact": "Esperando contacto",
  "conversation.status.waiting_internal": "Esperando interno",
  "conversation.status.snoozed": "Pospuesta",
  "conversation.status.closed": "Concluida",
  "conversation.outcome": "Resultado",
  "conversation.close": "Concluir atención",
  "handler.flow": "Flujo",
  "handler.assistant": "Asistente",
  "handler.human": "Persona",
  "common.close": "Cerrar",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "locale.name": "Español",
  "auth.title": "Iniciar sesión",
  "auth.email": "Correo",
  "auth.password": "Contraseña",
  "auth.submit": "Entrar",
  "auth.invalid": "Correo o contraseña incorrectos.",
  "auth.blocked": "Este acceso está bloqueado.",
  "auth.logout": "Salir",
  "workspaces.title": "Elige el cliente",
  "workspaces.subtitle": "Tu acceso vale para más de un cliente.",
  "workspaces.none": "Todavía no tienes acceso a ningún cliente.",
  "workspaces.not_ready": "En preparación",
  "role.owner": "Propietario",
  "role.admin": "Administrador",
  "role.manager": "Gestor",
  "role.supervisor": "Supervisor",
  "role.operator": "Agente",
  "role.auditor": "Auditor",
  "role.integration": "Integración",
  "inbox.search": "Buscar por nombre o teléfono",
  "inbox.empty": "Ninguna atención en esta vista",
  "inbox.empty_hint": "Cambia la vista o espera nuevos mensajes.",
  "inbox.select": "Selecciona una atención",
  "inbox.select_hint": "Las atenciones de la vista elegida aparecen a la izquierda.",
  "inbox.loading": "Cargando…",
  "inbox.no_messages": "Aún no hay mensajes.",
  "inbox.action.take": "Tomar",
  "inbox.action.assign": "Asignar",
  "inbox.action.transfer": "Transferir",
  "handoff.to_assistant": "Devolver al asistente",
  "handoff.to_flow": "Iniciar un flujo…",
  "handoff.assistant_title": "Devolver al asistente de IA",
  "handoff.flow_title": "Iniciar un flujo",
  "handoff.assistant_text": "Si el cliente espera respuesta, el asistente responde ahora; si no, responde su próximo mensaje. Vuelve a llamar al equipo si hace falta, y dejas de atender esta conversación.",
  "handoff.flow_text": "El flujo empieza ahora: desde el inicio, donde se detuvo cuando alguien del equipo escribió, o en un paso elegido. Dejas de atender esta conversación.",
  "handoff.window_closed": "La ventana de 24 horas está cerrada: un flujo solo puede empezar después de que el cliente vuelva a escribir.",
  "handoff.flow_pick": "Flujo publicado",
  "handoff.assistant_pick": "Asistente publicado",
  "handoff.no_flows": "No hay flujos publicados. Publica uno en el constructor de flujos.",
  "handoff.no_assistants": "No hay asistentes publicados. Publica uno en Configuración › Asistentes de IA.",
  "handoff.confirm": "Devolver",
  "handoff.assistant_done": "El asistente tomó la conversación.",
  "handoff.flow_done": "El flujo empezó.",
  "errors.flow_not_published": "Ese flujo no está publicado.",
  "errors.outside_session_window": "La ventana de 24 horas está cerrada. Usa una plantilla aprobada.",
  "errors.conversation_closed": "Esta conversación ya se cerró.",
  "inbox.action.snooze": "Posponer",
  "inbox.action.wait_contact": "Esperar contacto",
  "inbox.action.wait_internal": "Esperar interno",
  "inbox.action.resume": "Retomar",
  "inbox.action.close": "Concluir",
  "inbox.action.reopen": "Reabrir",
  "inbox.action.note": "Anotar",
  "inbox.action.more": "Más acciones",
  "inbox.header.queue": "En la cola",
  "inbox.header.mine": "Conmigo",
  "inbox.header.with": "Con {name}",
  "inbox.header.assistant": "Con el asistente",
  "inbox.header.flow": "En el flujo",
  "inbox.header.closed": "Concluida: {outcome}",
  "inbox.window.remaining": "Ventana de respuesta: {time} restantes",
  "inbox.window.expired": "La ventana de 24 horas cerró. Solo se puede enviar una plantilla aprobada.",
  "inbox.window.free": "Conversación de anuncio: gratuita por {time}",
  "inbox.window.send_template": "Enviar plantilla",
  "inbox.snoozed_until": "Pospuesta hasta {time}",
  "inbox.priority.low": "Baja",
  "inbox.priority.normal": "Normal",
  "inbox.priority.high": "Alta",
  "inbox.priority.urgent": "Urgente",
  "outcome.title": "Concluir atención",
  "outcome.select": "Resultado",
  "outcome.note": "Observación",
  "outcome.note_required": "Este resultado exige una observación.",
  "outcome.confirm": "Concluir",
  "outcome.success": "Éxito",
  "outcome.neutral": "Neutro",
  "outcome.negative": "Negativo",
  "outcome.invalid": "Inválido",
  "assign.title": "Asignar atención",
  "assign.member": "Agente",
  "assign.unassigned": "Sin agente",
  "assign.confirm": "Asignar",
  "transfer.title": "Transferir atención",
  "transfer.team": "Equipo",
  "transfer.keep_team": "Mantener equipo",
  "transfer.member": "Agente",
  "transfer.any_member": "Cualquier agente del equipo",
  "transfer.note": "Contexto para quien recibe",
  "transfer.confirm": "Transferir",
  "snooze.title": "Posponer",
  "snooze.hint": "La atención sale de la bandeja y vuelve sola a la hora elegida.",
  "snooze.1h": "En 1 hora",
  "snooze.3h": "En 3 horas",
  "snooze.tomorrow": "Mañana a las 9",
  "snooze.next_week": "Próxima semana",
  "snooze.custom": "Elegir fecha y hora",
  "snooze.reason": "Motivo",
  "snooze.confirm": "Posponer",
  "note.title": "Nota interna",
  "note.placeholder": "Visible solo para el equipo",
  "note.save": "Guardar nota",
  "event.created": "Atención abierta",
  "event.assigned": "Asignada a {name}",
  "event.unassigned": "Devuelta a la cola",
  "event.transferred": "Transferida",
  "event.status_changed": "Estado: {to}",
  "event.snoozed": "Pospuesta hasta {until}",
  "event.closed": "Concluida",
  "event.reopened": "Reabierta",
  "event.note_added": "Nota añadida",
  "event.priority_changed": "Prioridad: {to}",
  "event.outcome_set": "Resultado: {outcome}",
  "event.policy": "Regla automática",
  "event.handler_changed": "Atiende: {to}",
  "message.failed": "No enviado",
  "message.queued": "Enviando…",
  "message.media.image": "Imagen",
  "message.media.audio": "Audio",
  "message.media.video": "Video",
  "message.media.document": "Documento",
  "message.media.sticker": "Sticker",
  "message.location": "Ubicación",
  "message.template": "Plantilla",
  "message.reaction": "Reaccionó con {emoji}",
  "time.yesterday": "Ayer",
  "time.now": "ahora",
  "time.minutes": "{n} min",
  "time.hours": "{n} h",
  "common.confirm": "Confirmar",
  "common.back": "Volver",
  "common.error": "Algo salió mal. Inténtalo de nuevo.",
  "common.none": "Ninguno",
  "common.styleguide": "Styleguide",
  "flows.title": "Flujos",
  "flows.new": "Nuevo flujo",
  "flows.empty": "Aún no hay flujos",
  "flows.empty_hint": "Crea un flujo para atender automáticamente antes de llegar a una persona.",
  "flows.name": "Nombre",
  "flows.description": "Descripción",
  "flows.status.draft": "Borrador",
  "flows.status.published": "Publicado",
  "flows.status.archived": "Archivado",
  "flows.active_runs": "{n} en curso",
  "flows.version": "v{n}",
  "flows.unsaved": "Cambios sin guardar",
  "builder.save": "Guardar borrador",
  "builder.saved": "Borrador guardado",
  "builder.publish": "Publicar",
  "builder.published": "Versión {n} publicada",
  "builder.test": "Probar",
  "builder.triggers": "Disparadores",
  "builder.versions": "Versiones",
  "builder.restore": "Restaurar",
  "builder.restored": "Versión {n} restaurada como v{next}",
  "builder.add": "Añadir bloque",
  "builder.delete_node": "Quitar bloque",
  "builder.inspector_empty": "Selecciona un bloque para editar",
  "builder.exit": "Salida",
  "builder.exit_next": "Siguiente",
  "builder.exit_fallback": "Sin respuesta válida",
  "builder.exit_invalid": "Inválido",
  "builder.exit_error": "Error",
  "builder.exit_default": "Si no",
  "builder.exit_inside": "Dentro del horario",
  "builder.exit_outside": "Fuera del horario",
  "builder.exit_done": "Al terminar",
  "builder.unconnected": "Salida sin destino",
  "builder.invalid": "El flujo tiene errores: {detail}",
  "builder.channel_default": "Cuando un contacto inicia una conversación en el número",
  "builder.keywords": "Palabras clave (una por línea)",
  "builder.trigger_saved": "Disparadores guardados",
  "builder.variables_hint": "Usa {{contact.name}}, {{vars.nombre}} o {{input.text}} en el texto.",
  "node.start": "Inicio",
  "node.message": "Mensaje",
  "node.menu": "Menú",
  "node.input": "Pregunta",
  "node.condition": "Condición",
  "node.http_request": "Llamada a API",
  "node.script": "Script",
  "node.field.code": "Código (JavaScript)",
  "node.field.code_hint": "Usa vars (variables del flujo) y contact (nombre y campos) y devuelve un objeto: cada clave se vuelve una variable. Corre aislado, sin internet, hasta 0,2 segundos; si falla, sigue por la salida Error con vars.script_error.",
  "node.set_variable": "Definir variable",
  "node.set_field": "Guardar campo del contacto",
  "node.tag": "Etiquetar",
  "node.wait": "Esperar",
  "node.business_hours": "Horario de atención",
  "node.transfer": "Transferir a persona",
  "node.assistant": "Asistente de IA",
  "node.close": "Concluir",
  "node.event": "Registrar evento",
  "node.exception": "Excepción",
  "node.end": "Fin",
  "node.field.text": "Texto",
  "node.field.body": "Texto del menú",
  "node.field.header": "Encabezado",
  "node.field.footer": "Pie",
  "node.field.options": "Opciones",
  "node.field.option_title": "Título",
  "node.field.option_id": "Identificador",
  "node.field.add_option": "Añadir opción",
  "node.field.retries": "Intentos",
  "node.field.retry_text": "Texto al no entender",
  "node.field.variable": "Guardar en",
  "node.field.prompt": "Pregunta",
  "node.field.validation": "Validación",
  "node.field.pattern": "Expresión regular",
  "node.field.error_text": "Texto si es inválido",
  "node.field.rules": "Reglas",
  "node.field.add_rule": "Añadir regla",
  "node.field.op": "Operador",
  "node.field.value": "Valor",
  "node.field.method": "Método",
  "node.field.url": "URL",
  "node.field.headers": "Encabezados (JSON)",
  "node.field.request_body": "Cuerpo",
  "node.field.timeout": "Tiempo límite (ms)",
  "node.field.field": "Campo",
  "node.field.tag": "Etiqueta",
  "node.field.seconds": "Segundos",
  "node.field.business_hours": "Horario",
  "node.field.team": "Equipo",
  "node.field.member": "Agente",
  "node.field.note": "Contexto para quien recibe",
  "node.field.assistant": "Asistente",
  "node.field.outcome": "Resultado",
  "node.field.event_name": "Nombre del evento",
  "node.field.any": "Cualquiera",
  "validation.text": "Texto libre",
  "validation.number": "Número",
  "validation.email": "Correo",
  "validation.phone": "Teléfono",
  "validation.cpf": "CPF",
  "validation.cnpj": "CNPJ",
  "validation.date": "Fecha",
  "validation.regex": "Expresión regular",
  "op.exists": "existe",
  "op.eq": "es igual a",
  "op.neq": "es distinto de",
  "op.contains": "contiene",
  "op.starts_with": "empieza con",
  "op.ends_with": "termina con",
  "op.gt": "mayor que",
  "op.gte": "mayor o igual a",
  "op.lt": "menor que",
  "op.lte": "menor o igual a",
  "op.regex": "coincide con regex",
  "op.in": "está entre",
  "simulator.title": "Prueba del flujo",
  "simulator.hint": "Conversa como el cliente. El borrador actual se ejecuta en memoria, sin enviar nada.",
  "simulator.placeholder": "Responde como el cliente",
  "simulator.reset": "Reiniciar",
  "simulator.state": "Estado: {status}",
  "simulator.action": "Acción: {type}",
  "gate.title": "Revisión antes de enviar",
  "gate.hint": "La política de la empresa revisó tu mensaje antes de salir.",
  "gate.draft": "Tu mensaje",
  "gate.suggestion": "Sugerencia",
  "gate.reasons": "Motivos",
  "gate.verdict.rewrite": "Ajuste sugerido",
  "gate.verdict.block": "Bloqueado",
  "gate.accept": "Usar sugerencia",
  "gate.edit": "Enviar mi edición",
  "gate.override": "Enviar de todos modos",
  "gate.blocked_hint": "Este mensaje no puede enviarse así. Edita el texto.",
  "gate.rule.blocked_term": "término bloqueado",
  "gate.rule.pii": "dato sensible",
  "gate.rule.link": "enlace no permitido",
  "gate.rule.promise": "promesa",
  "settings.title": "Configuración",
  "settings.numbers": "Números",
  "settings.team": "Equipo y personas",
  "settings.assistants": "Asistentes de IA",
  "settings.knowledge": "Base de conocimiento",
  "settings.policies": "Políticas",
  "settings.ai": "IA: modelos, claves y uso",
  "settings.integrations": "Integraciones",
  "settings.save": "Guardar",
  "settings.saved": "Guardado",
  "settings.new": "Nuevo",
  "settings.none": "Nada por aquí todavía",
  "numbers.connect": "Conectar número",
  "numbers.connect_hint": "Pega el token del usuario de sistema o el código del registro integrado de Meta.",
  "numbers.waba": "ID de la cuenta WhatsApp Business (WABA)",
  "numbers.phone_id": "ID del número",
  "numbers.token": "Token de acceso",
  "numbers.pin": "PIN de registro (opcional)",
  "numbers.mode": "Modo de atención",
  "numbers.quality": "Calidad",
  "numbers.tier": "Límite",
  "numbers.templates": "Plantillas aprobadas",
  "numbers.templates_hint": "1 plantilla en esta cuenta. Crea, corrige y sigue la revisión de Meta.|{count} plantillas en esta cuenta. Crea, corrige y sigue la revisión de Meta.",
  "numbers.sync": "Sincronizar con Meta",
  "numbers.synced": "{n} plantillas sincronizadas, {changes} cambiaron de categoría",
  "numbers.category": "Categoría",
  "numbers.language": "Idioma",
  "numbers.status": "Estado",
  "team.members": "Personas",
  "team.invite": "Invitar",
  "team.invite_hint": "La invitación genera un enlace para crear la contraseña. Aún sin correo automático: cópialo y envíalo.",
  "team.invite_link": "Enlace de invitación",
  "team.name": "Nombre",
  "team.role": "Rol",
  "team.presence": "Presencia",
  "team.teams": "Equipos",
  "team.new_team": "Nuevo equipo",
  "team.distribution": "Distribución",
  "team.capacity": "Capacidad por persona",
  "team.auto_assign": "Distribuir automáticamente",
  "team.add_member": "Añadir al equipo",
  "team.hours": "Horario de atención",
  "team.new_hours": "Nuevo horario",
  "team.timezone": "Zona horaria",
  "distribution.least_busy": "Menos ocupado",
  "distribution.most_idle": "Más inactivo",
  "distribution.round_robin": "Rotativo",
  "distribution.manual": "Manual",
  "presence.online": "En línea",
  "presence.paused": "En pausa",
  "presence.offline": "Desconectado",
  "assistant.new": "Nuevo asistente",
  "assistant.persona_name": "Nombre de la persona",
  "assistant.tone": "Tono",
  "assistant.language": "Idioma de las respuestas",
  "assistant.instructions": "Instrucciones",
  "assistant.instructions_hint": "Explica el negocio, qué responder, qué nunca prometer y cuándo llamar a una persona.",
  "assistant.knowledge": "Bases de conocimiento",
  "assistant.tools": "Herramientas",
  "assistant.exit": "Condiciones de salida",
  "assistant.exit_field": "Cuando el campo esté completo",
  "assistant.exit_keyword": "Cuando el cliente diga",
  "assistant.filters": "Términos bloqueados en la respuesta (uno por línea)",
  "assistant.fallback": "Texto de seguridad",
  "assistant.max_turns": "Máximo de respuestas antes de pasar a una persona",
  "assistant.handoff_team": "Equipo que recibe",
  "assistant.publish": "Publicar",
  "assistant.published": "Versión {n} publicada",
  "assistant.status.draft": "Borrador",
  "assistant.status.active": "Activo",
  "assistant.status.archived": "Archivado",
  "assistant.running": "{n} en atención",
  "assistant.temperature": "Creatividad",
  "knowledge.collections": "Colecciones",
  "knowledge.new_collection": "Nueva colección",
  "knowledge.documents": "Documentos",
  "knowledge.add": "Agregar contenido",
  "knowledge.source.text": "Texto",
  "knowledge.source.site": "Sitio web",
  "knowledge.source.faq": "Preguntas frecuentes",
  "knowledge.site_url": "Dirección de la página",
  "knowledge.site_crawl": "Leer también las páginas enlazadas del mismo sitio (hasta 10)",
  "knowledge.site_hint": "Cada página se vuelve un documento. Las páginas con poco texto y las que ya están en la colección quedan fuera.",
  "knowledge.site_read": "Leer el sitio",
  "knowledge.site_error.private": "Esa dirección no es de un sitio público.",
  "knowledge.site_error.missing": "Página no encontrada en esa dirección.",
  "knowledge.site_error.not_page": "Esa dirección no es una página de texto.",
  "knowledge.site_error.unreachable": "No pudimos abrir el sitio ahora. Revisa la dirección e inténtalo de nuevo.",
  "knowledge.site_added": "1 página agregada|{count} páginas agregadas",
  "knowledge.pdf_ready": "{name}: {pages} páginas, {chars} caracteres de texto.",
  "knowledge.pdf_truncated": "Solo cabe el principio del archivo; el resto queda fuera.",
  "knowledge.pdf_no_text": "Ese PDF no tiene texto para leer (quizás es una imagen escaneada).",
  "knowledge.doc_title": "Título",
  "knowledge.doc_text": "Contenido",
  "knowledge.chunks": "{n} fragmentos",
  "knowledge.search": "Probar búsqueda",
  "knowledge.search_hint": "Mira lo que el asistente encontraría para una pregunta.",
  "knowledge.status.ready": "Listo",
  "knowledge.status.processing": "Procesando",
  "knowledge.status.failed": "Falló",
  "knowledge.status.pending": "Pendiente",
  "policy.new": "Nueva política",
  "policy.kind": "Tipo",
  "policy.kind.lifecycle": "Cierre automático",
  "policy.kind.gate": "Revisión de mensajes",
  "policy.scope": "Alcance",
  "policy.scope.customer": "Toda la empresa",
  "policy.scope.team": "Equipo",
  "policy.scope.channel": "Número",
  "policy.mode": "Modo",
  "policy.mode.shadow": "Sombra (solo registra)",
  "policy.mode.log": "Registrar",
  "policy.mode.suggest": "Sugerir al agente",
  "policy.mode.auto_fix": "Corregir y enviar",
  "policy.mode.block": "Bloquear",
  "policy.active": "Activa",
  "policy.rules": "Reglas",
  "policy.rule.no_inbound_for": "Sin respuesta del contacto hace {hours} h, concluir como",
  "policy.rule.window_expired": "Ventana de 24 h cerrada: marcar como esperando contacto",
  "policy.rule.unanswered_new_for": "Sin primera respuesta hace {hours} h: prioridad",
  "policy.hours": "Horas",
  "policy.outcome": "Resultado",
  "policy.add_rule": "Añadir regla",
  "policy.gate.blocked": "Términos bloqueados (uno por línea)",
  "policy.gate.domains": "Dominios permitidos en enlaces (uno por línea)",
  "policy.gate.promises": "Patrones de promesa (regex, uno por línea)",
  "policy.gate.pii": "Bloquear datos sensibles (tarjeta, CPF)",
  "policy.gate.judge": "Usar juez de IA",
  "policy.gate.instructions": "Política para el juez de IA",
  "policy.gate.override": "Roles que pueden enviar de todos modos",
  "ai.own_keys": "Usar mis propias claves de IA",
  "ai.budget": "Presupuesto mensual (USD)",
  "ai.budget_action": "Al alcanzar el presupuesto",
  "ai.budget.warn": "Avisar",
  "ai.budget.block": "Bloquear",
  "ai.keys": "Claves",
  "ai.add_key": "Añadir clave",
  "ai.provider": "Proveedor",
  "ai.key": "Clave",
  "ai.usage": "Uso del mes",
  "ai.surface.assistant.reply": "Respuestas del asistente",
  "ai.surface.gate.judge": "Revisión de mensajes",
  "ai.surface.outcome.classify": "Sugerencia de resultado",
  "ai.surface.summary.brief": "Resumen de la atención",
  "ai.surface.knowledge.embed": "Base de conocimiento",
  "ai.surface.audio.transcribe": "Transcripción de audio",
  "ai.surface.learning.mine": "Aprendizaje semanal",
  "ai.surface.onboarding.propose": "Sugerencias de la implementación",
  "ai.calls.previous": "Mes anterior",
  "ai.calls.next": "Mes siguiente",
  "ai.calls.cost": "Costo",
  "ai.calls.of_budget": "de {budget} en el mes ({share}%)",
  "ai.calls.calls": "Llamadas",
  "ai.calls.tokens": "Tokens",
  "ai.calls.cached": "{n} en caché",
  "ai.calls.failed": "Con fallas",
  "ai.calls.failed_detail": "{errors} errores · {blocked} bloqueadas por el presupuesto",
  "ai.calls.n_calls": "1 llamada|{count} llamadas",
  "ai.calls.use": "Uso",
  "ai.calls.all_uses": "Todos los usos",
  "ai.calls.status_label": "Estado",
  "ai.calls.all_status": "Todas",
  "ai.calls.status.success": "Completada",
  "ai.calls.status.error": "Error",
  "ai.calls.status.blocked": "Bloqueada",
  "ai.calls.when": "Cuándo",
  "ai.calls.model": "Modelo",
  "ai.calls.latency": "Tiempo",
  "ai.calls.conversation": "Ver atención",
  "ai.calls.own_key": "clave propia",
  "ai.calls.none": "Ninguna llamada de IA en este período.",
  "ai.calls.more": "Cargar más",
  "ai.label": "Etiqueta",
  "member.status.active": "Activo",
  "member.status.invited": "Invitado",
  "member.status.suspended": "Suspendido",
  "contact.panel": "Datos del contacto",
  "contact.name": "Nombre del contacto",
  "contact.edit_name": "Editar nombre",
  "contact.this_conversation": "Esta atención",
  "contact.source": "Origen",
  "contact.goal": "Objetivo",
  "contact.channel": "Canal",
  "contact.started": "Inicio",
  "contact.meta_cost": "Costo Meta",
  "contact.fields": "Campos",
  "contact.consent": "Consentimiento y bloqueo",
  "contact.consent_marketing": "Acepta mensajes de marketing",
  "contact.blocked": "Contacto bloqueado",
  "contact.history": "Atenciones anteriores",
  "contact.no_history": "Primera atención de este contacto.",
  "source.inbound": "El contacto inició",
  "source.ad": "Anuncio (clic a WhatsApp)",
  "source.template": "Plantilla enviada",
  "source.campaign": "Campaña",
  "source.api": "API",
  "source.flow": "Flujo",
  "source.connector": "Integración",
  "source.reopen": "Reapertura",
  "common.yes": "Sí",
  "common.no": "No",
  "template.pick": "Enviar plantilla aprobada",
  "template.search": "Buscar plantilla",
  "template.none_approved": "Ninguna plantilla aprobada en esta cuenta de WhatsApp. Si ya creaste una y Meta la aprobó, sincroniza; si no, crea una en Configuración › Plantillas de mensaje.",
  "template.waiting": "Aún no habilitadas por Meta",
  "template.category.marketing": "Marketing",
  "template.category.utility": "Utilidad",
  "template.category.authentication": "Autenticación",
  "template.change": "Cambiar plantilla",
  "template.param": "Variable {n}",
  "template.header": "encabezado",
  "template.no_params": "Esta plantilla no tiene variables.",
  "template.preview": "Vista previa",
  "template.send": "Enviar plantilla",
  "settings.templates": "Plantillas de mensaje",
  "template.param_button": "Final del enlace de “{text}”",
  "common.more": "Más opciones",
  "templates.title": "Plantillas de mensaje",
  "templates.lead": "Pasadas 24 horas desde el último mensaje del cliente, WhatsApp solo deja que la empresa escriba con una plantilla aprobada por Meta. Crea las plantillas aquí y sigue la revisión.",
  "templates.new": "Nueva plantilla",
  "templates.sync": "Traer de Meta",
  "templates.no_account": "Conecta un número en Configuración › Números para crear plantillas.",
  "templates.empty": "Aún no hay plantillas. Crea la primera o trae las que ya existen en Meta.",
  "templates.filter.all": "Todas",
  "templates.filter.approved": "Aprobadas",
  "templates.filter.review": "En revisión",
  "templates.filter.rejected": "Con problemas",
  "templates.filter.draft": "Borradores",
  "templates.status.draft": "Borrador",
  "templates.status.pending": "En revisión",
  "templates.status.approved": "Aprobada",
  "templates.status.rejected": "Rechazada",
  "templates.status.paused": "Pausada",
  "templates.status.disabled": "Desactivada",
  "templates.status.archived": "Eliminada",
  "templates.quality.GREEN": "Calidad alta",
  "templates.quality.YELLOW": "Calidad media",
  "templates.quality.RED": "Calidad baja",
  "templates.quality.UNKNOWN": "Calidad en evaluación",
  "templates.recategorized": "Meta cambió la categoría de {from} a {to}. El precio de cada envío sigue la categoría de Meta.",
  "templates.reason": "Motivo de Meta: {reason}",
  "templates.reason.ABUSIVE_CONTENT": "contenido abusivo",
  "templates.reason.INCORRECT_CATEGORY": "categoría incorrecta",
  "templates.reason.INVALID_FORMAT": "formato inválido (variables, ejemplos o botones)",
  "templates.reason.PROMOTIONAL": "contenido promocional fuera de la categoría marketing",
  "templates.reason.SCAM": "sospecha de estafa",
  "templates.reason.TAG_CONTENT_MISMATCH": "el contenido no corresponde a la categoría elegida",
  "templates.reason.NONE": "Meta no informó el motivo",
  "templates.not_editable": "Hecha en WhatsApp Manager con recursos que este editor aún no escribe (código de un toque, carrusel, catálogo o flujo). Sigue disponible para enviar.",
  "templates.edit": "Editar",
  "templates.fix": "Corregir y reenviar",
  "templates.duplicate": "Duplicar",
  "templates.delete": "Eliminar",
  "templates.delete_title": "¿Eliminar plantilla?",
  "templates.delete_confirm": "La plantilla {name} ({language}) se eliminará en Meta. Los mensajes ya enviados siguen en el historial, y Meta bloquea ese nombre durante 30 días.",
  "templates.delete_draft": "El borrador {name} se descartará. Meta nunca lo recibió.",
  "templates.deleted": "Plantilla eliminada",
  "templates.back": "Volver a las plantillas",
  "templates.new_title": "Nueva plantilla",
  "templates.edit_title": "Editar plantilla",
  "templates.add": "Agregar",
  "templates.remove": "Quitar",
  "templates.field.account": "Cuenta de WhatsApp",
  "templates.field.name": "Nombre de la plantilla",
  "templates.field.name_hint": "En Meta: {name}",
  "templates.field.name_locked": "El nombre y el idioma no cambian después de que Meta recibe la plantilla. Para otro nombre, duplícala.",
  "templates.field.language": "Idioma",
  "templates.field.category": "Categoría",
  "templates.category.utility_hint": "Confirmaciones, recordatorios y novedades de algo que el cliente pidió o compró.",
  "templates.category.marketing_hint": "Ofertas, novedades, invitaciones y mensajes para retomar el contacto.",
  "templates.category.note": "Meta revisa la categoría y puede cambiarla. El precio de cada envío sigue la categoría final.",
  "templates.field.header": "Encabezado",
  "templates.field.header_text": "Texto del encabezado",
  "templates.field.body": "Mensaje",
  "templates.field.body_text": "Texto del mensaje",
  "templates.field.examples": "Ejemplos de las variables",
  "templates.field.examples_hint": "Meta usa los ejemplos para revisar la plantilla. Usa valores realistas, sin datos de clientes reales.",
  "templates.field.example": "Ejemplo de {variable}",
  "templates.field.footer": "Pie de página",
  "templates.field.footer_text": "Texto del pie",
  "templates.field.buttons": "Botones",
  "templates.button.add": "Agregar botón",
  "templates.button.quick_reply": "Respuesta rápida",
  "templates.button.url": "Abrir sitio web",
  "templates.button.phone": "Llamar",
  "templates.button.remove": "Quitar botón",
  "templates.button.text": "Texto del botón",
  "templates.button.url_field": "Dirección del sitio",
  "templates.button.url_hint": "Con https://. Para un enlace por cliente, termina con {{1}}.",
  "templates.button.url_example": "Ejemplo del final de la dirección",
  "templates.button.phone_field": "Teléfono con código de país",
  "templates.variable.add": "Agregar variable",
  "templates.format.bold": "Negrita",
  "templates.format.italic": "Cursiva",
  "templates.format.strike": "Tachado",
  "templates.format.sample": "texto",
  "templates.preview": "Cómo lo ve el cliente",
  "templates.preview_empty": "Escribe el mensaje para ver la vista previa.",
  "templates.all_options": "Ver todas las opciones",
  "templates.save_draft": "Guardar borrador",
  "templates.submit": "Enviar a Meta",
  "templates.saved": "Borrador guardado",
  "templates.submitted": "Enviada a la revisión de Meta. Suele tardar de minutos a 24 horas, y el estado cambia aquí solo.",
  "templates.approved_now": "Meta aprobó la plantilla {name} al instante.",
  "templates.meta_refused": "Meta rechazó el envío",
  "templates.pending_issues": "Falta 1 ajuste antes de enviar|Faltan {count} ajustes antes de enviar",
  "templates.ready": "Lista para enviar a Meta",
  "templates.rules.title": "Lo que Meta revisa",
  "templates.rules.1": "Variables en orden ({{1}}, {{2}}…), nunca al inicio ni al final del mensaje.",
  "templates.rules.2": "Mensaje claro y completo: se rechazan los textos vagos o hechos casi solo de variables.",
  "templates.rules.3": "Utilidad es sobre algo que el cliente pidió. Oferta, descuento o invitación es marketing.",
  "templates.rules.4": "Enlaces con el dominio de la empresa, sin acortadores.",
  "templates.rules.5": "Nunca pidas datos sensibles, como contraseñas, número completo de tarjeta o documento.",
  "templates.issue.name_format": "Ponle un nombre con letras, números o _.",
  "templates.issue.name_too_long": "El nombre puede tener hasta 512 caracteres.",
  "templates.issue.language_required": "Elige el idioma.",
  "templates.issue.header_too_long": "El encabezado puede tener hasta 60 caracteres.",
  "templates.issue.header_format": "El encabezado es una sola línea.",
  "templates.issue.header_variables": "El encabezado acepta una variable, la {{1}}.",
  "templates.issue.header_example_missing": "Escribe un ejemplo para la variable del encabezado.",
  "templates.issue.body_required": "Escribe el mensaje.",
  "templates.issue.body_too_long": "El mensaje puede tener hasta 1024 caracteres.",
  "templates.issue.variables_not_sequential": "Las variables deben seguir el orden {{1}}, {{2}}, {{3}}… sin saltar números.",
  "templates.issue.variable_at_edge": "Meta rechaza mensajes que empiezan o terminan con una variable. Pon texto antes y después.",
  "templates.issue.example_missing": "Escribe un ejemplo para cada variable.",
  "templates.issue.footer_too_long": "El pie puede tener hasta 60 caracteres.",
  "templates.issue.footer_variables": "El pie no acepta variables.",
  "templates.issue.too_many_buttons": "Como máximo 10 botones.",
  "templates.issue.too_many_url_buttons": "Como máximo 2 botones de sitio web.",
  "templates.issue.too_many_phone_buttons": "Como máximo 1 botón de llamar.",
  "templates.issue.buttons_not_grouped": "Deja las respuestas rápidas juntas, antes o después de los botones de sitio y de llamar.",
  "templates.issue.button_text_required": "Escribe el texto del botón.",
  "templates.issue.button_text_too_long": "El texto del botón puede tener hasta 25 caracteres.",
  "templates.issue.button_text_duplicate": "Cada botón necesita un texto distinto.",
  "templates.issue.url_invalid": "Usa una dirección completa que empiece con https://.",
  "templates.issue.url_variable_position": "El enlace acepta una variable, la {{1}}, al final de la dirección.",
  "templates.issue.url_example_missing": "Escribe un ejemplo del final de la dirección.",
  "templates.issue.phone_invalid": "Usa el teléfono con + y código de país, como +54 11 5555-0000.",
  "templates.warning.variables_dense": "Muchas variables para poco texto: Meta suele rechazarlo. Escribe más texto fijo.",
  "templates.warning.adjacent_variables": "Dos variables seguidas, sin texto entre ellas, suelen rechazarse.",
  "templates.warning.promotional_utility": "El texto parece promocional. Meta probablemente lo clasifique como marketing, que cuesta más.",
  "templates.warning.url_shortener": "Los enlaces acortados (bit.ly y similares) suelen rechazarse. Usa la dirección completa.",
  "errors.template_name_taken": "Ya existe una plantilla con ese nombre e idioma en esta cuenta.",
  "errors.template_not_editable": "Esta plantilla no se puede editar ahora: en revisión espera a Meta, y una aprobada se puede duplicar.",
  "errors.template_identity_locked": "El nombre y el idioma no cambian después de que Meta recibe la plantilla. Duplícala para usar otro nombre.",
  "errors.template_rejected_by_meta": "Meta rechazó la plantilla.",
  "errors.template_not_found": "Plantilla no encontrada. Actualiza la página.",
  "errors.template_other_account": "Esta plantilla es de otra cuenta de WhatsApp: solo sale por los números de esa cuenta.",
  "presence.title": "Mi disponibilidad",
  "inbox.contact_info": "Datos del contacto",
  "nav.reports": "Informes",
  "reports.title": "Informes",
  "reports.tab.overview": "Resumen",
  "reports.tab.team": "Equipo",
  "reports.tab.outcomes": "Desenlaces",
  "reports.tab.gate": "Revisión de mensajes",
  "reports.tab.audit": "Auditoría",
  "reports.period": "Período",
  "reports.period.7d": "7 días",
  "reports.period.30d": "30 días",
  "reports.period.month": "Este mes",
  "reports.period.custom": "Personalizado",
  "reports.from": "Desde",
  "reports.to": "Hasta",
  "reports.team": "Equipo",
  "reports.all_teams": "Todos los equipos",
  "reports.export": "Exportar CSV",
  "reports.loading": "Calculando…",
  "reports.empty": "Sin datos en el período.",
  "reports.kpi.opened": "Atenciones abiertas",
  "reports.kpi.closed": "Concluidas",
  "reports.kpi.success": "Tasa de éxito",
  "reports.kpi.first_response": "1ª respuesta (mediana)",
  "reports.kpi.handling": "Duración (mediana)",
  "reports.kpi.messages": "Mensajes",
  "reports.kpi.inbound": "recibidos",
  "reports.kpi.outbound": "enviados",
  "reports.kpi.meta_cost": "Costo Meta",
  "reports.kpi.meta_charged": "1 mensaje cobrado · estimación|{count} mensajes cobrados · estimación",
  "reports.kpi.ai_cost": "Costo de IA",
  "reports.kpi.p90": "p90",
  "reports.daily": "Por día",
  "reports.daily.opened": "Abiertas",
  "reports.daily.closed": "Concluidas",
  "reports.daily.success": "Éxito",
  "reports.open_by_status": "Abiertas ahora",
  "reports.closed_by": "Quién concluyó",
  "reports.closer.member": "Personas",
  "reports.closer.assistant": "Asistente de IA",
  "reports.closer.policy": "Política automática",
  "reports.closer.contact": "Contacto",
  "reports.closer.api": "API",
  "reports.handler_mix": "Quién atendió",
  "reports.handler.flow": "Flujo",
  "reports.handler.assistant": "Asistente",
  "reports.handler.human": "Humano",
  "reports.members": "Por persona",
  "reports.teams": "Por equipo",
  "reports.col.name": "Nombre",
  "reports.col.assigned": "Asignadas",
  "reports.col.closed": "Concluidas",
  "reports.col.success": "Éxito",
  "reports.col.first_response": "1ª respuesta",
  "reports.col.queue_wait": "Espera en cola",
  "reports.col.sent": "Enviados",
  "reports.col.active": "Abiertas",
  "reports.outcomes": "Desenlaces en el período",
  "reports.without_outcome": "Sin desenlace",
  "reports.col.count": "Cant.",
  "reports.col.share": "Participación",
  "reports.gate.decisions": "Decisiones",
  "reports.gate.verdict.approve": "Aprobadas",
  "reports.gate.verdict.rewrite": "Reescritas",
  "reports.gate.verdict.block": "Bloqueadas",
  "reports.gate.actions": "Acción de la persona",
  "reports.gate.action.accepted": "Aceptó la sugerencia",
  "reports.gate.action.edited": "Editó",
  "reports.gate.action.overridden": "Envió de todos modos",
  "reports.gate.action.cancelled": "Canceló",
  "reports.gate.action.auto_sent": "Corregida automáticamente",
  "reports.gate.action.pending": "Pendiente",
  "reports.gate.latency": "Latencia del juez",
  "reports.gate.top_rules": "Reglas más activadas",
  "reports.gate.review": "Mensajes humanos revisados",
  "reports.gate.none": "Ninguna política de revisión activa en el período.",
  "audit.title": "Auditoría",
  "audit.search": "Buscar en la acción",
  "audit.action": "Acción",
  "audit.all_actions": "Todas las acciones",
  "audit.actor": "Autor",
  "audit.actor.member": "Persona",
  "audit.actor.system": "Sistema",
  "audit.actor.assistant": "Asistente",
  "audit.actor.flow": "Flujo",
  "audit.actor.policy": "Política",
  "audit.when": "Cuándo",
  "audit.entity": "Entidad",
  "audit.details": "Detalles",
  "audit.before": "Antes",
  "audit.after": "Después",
  "audit.load_more": "Cargar más",
  "audit.empty": "Ningún evento en el período.",
  "audit.actor.api_key": "Clave de API",
  "audit.actor.platform_admin": "Admin de la plataforma",
  "integrations.title": "Integraciones",
  "integrations.api_keys": "Claves de API",
  "integrations.api_keys_hint": "Úsala en el encabezado Authorization: ApiKey <clave>. La clave se muestra una sola vez.",
  "integrations.new_key": "Nueva clave",
  "integrations.key_name": "Nombre de la clave",
  "integrations.key_created": "Cópiala ahora: esta clave no se mostrará de nuevo.",
  "integrations.revoke": "Revocar",
  "integrations.last_used": "Último uso",
  "integrations.never": "nunca",
  "integrations.copy": "Copiar",
  "integrations.copied": "Copiado",
  "integrations.hooks": "Entrada de leads (webhook de entrada)",
  "integrations.hooks_hint": "Envía un POST con JSON o formulario a la dirección del gancho. El contacto se crea o reutiliza y se abre una atención.",
  "integrations.new_hook": "Nuevo gancho",
  "integrations.hook_name": "Nombre",
  "integrations.hook_phone": "Ruta del teléfono en el payload",
  "integrations.hook_contact_name": "Ruta del nombre",
  "integrations.hook_fields": "Campos del contacto (clave = ruta, uno por línea)",
  "integrations.hook_goal": "Objetivo de la atención",
  "integrations.hook_team": "Equipo por defecto",
  "integrations.hook_flow": "Flujo inicial",
  "integrations.hook_url": "Dirección del gancho",
  "integrations.hook_created": "Copia la dirección ahora: el token no se mostrará de nuevo.",
  "integrations.rotate": "Generar nuevo token",
  "integrations.active": "Activo",
  "integrations.webhooks": "Webhooks de salida",
  "integrations.webhooks_hint": "Recibimos eventos y enviamos un POST firmado: DoneTalk-Signature trae t=<hora>,v1=<HMAC SHA-256 de \"t.cuerpo\">. El encabezado antiguo x-donetalk-signature sigue junto hasta el 21/01/2027.",
  "integrations.new_webhook": "Nuevo webhook",
  "integrations.webhook_url": "URL de destino",
  "integrations.events": "Eventos",
  "integrations.secret_created": "Secreto para validar la firma. Cópialo ahora: no se mostrará de nuevo.",
  "integrations.test": "Enviar prueba",
  "integrations.test_sent": "Evento de prueba encolado.",
  "integrations.pause": "Pausar",
  "integrations.resume": "Reanudar",
  "integrations.deliveries": "Entregas",
  "integrations.failures": "fallos seguidos",
  "integrations.status.active": "Activo",
  "integrations.status.paused": "Pausado",
  "integrations.status.failing": "Con fallos",
  "integrations.event.conversation.opened": "Atención abierta",
  "integrations.event.conversation.closed": "Atención concluida",
  "integrations.event.conversation.assigned": "Atención asignada",
  "integrations.event.conversation.transferred": "Atención transferida",
  "integrations.event.conversation.reopened": "Atención reabierta",
  "integrations.event.contact.updated": "Contacto actualizado",
  "integrations.event.message.received": "Mensaje recibido",
  "integrations.event.message.sent": "Mensaje enviado",
  "integrations.event.flow.event": "Evento de flujo",
  "common.edit": "Editar",
  "common.remove": "Eliminar",
  "contacts.title": "Contactos",
  "contacts.search": "Buscar por nombre o teléfono",
  "contacts.import": "Importar CSV",
  "contacts.new": "Nuevo contacto",
  "contacts.start": "Iniciar atención",
  "contacts.col.name": "Nombre",
  "contacts.col.phone": "Teléfono",
  "contacts.col.tags": "Etiquetas",
  "contacts.col.last_activity": "Última actividad",
  "contacts.col.source": "Origen",
  "contacts.empty": "Ningún contacto encontrado.",
  "contacts.load_more": "Cargar más",
  "contacts.blocked": "Bloqueado",
  "contacts.open_conversation": "Abrir atención",
  "contacts.source.inbound": "Espontáneo",
  "contacts.source.ad": "Anuncio",
  "contacts.source.import": "Importación",
  "contacts.source.api": "API",
  "contacts.source.connector": "Integración",
  "contacts.source.manual": "Manual",
  "import.title": "Importar datos",
  "import.file": "Elige un archivo CSV (separado por coma o punto y coma, con encabezado)",
  "import.rows": "{n} filas encontradas",
  "import.map": "Mapea las columnas",
  "import.col.phone": "Teléfono (obligatorio)",
  "import.col.name": "Nombre",
  "import.col.tags": "Etiquetas (separadas por coma)",
  "import.col.marketing": "Acepta marketing (sí/no)",
  "import.col.external": "ID externo",
  "import.col.field": "Campo del contacto",
  "import.col.ignore": "Ignorar",
  "import.marketing_all": "Marcar todos como aceptando marketing",
  "import.preview": "Vista previa",
  "import.run": "Importar {n} contactos",
  "import.progress": "Importando… {done} de {total}",
  "import.done": "Importación concluida: {created} nuevos, {updated} actualizados, {errors} con error.",
  "import.errors": "Filas con error",
  "import.reason.invalid_phone": "Teléfono inválido",
  "start.title": "Iniciar atención por plantilla",
  "start.goal": "Objetivo",
  "start.team": "Equipo",
  "start.open_exists": "Este contacto ya tiene una atención abierta.",
  "start.marketing_opted_out": "El contacto rechazó mensajes de marketing.",
  "start.blocked": "Contacto bloqueado.",
  "tags.title": "Etiquetas",
  "tags.add": "Agregar etiqueta",
  "tags.new": "Nueva etiqueta",
  "tags.name": "Nombre",
  "tags.color": "Color",
  "tags.applies": "Se aplica a",
  "tags.applies.contact": "Contactos",
  "tags.applies.conversation": "Atenciones",
  "tags.applies.both": "Ambos",
  "tags.usage": "{contacts} contactos · {conversations} atenciones",
  "tags.none": "Sin etiquetas",
  "snippets.title": "Respuestas rápidas",
  "snippets.hint": "Escribe / en el campo de mensaje para buscar. Variables: {{contact.first_name}}, {{contact.name}}, {{member.name}}, {{member.first_name}}.",
  "snippets.new": "Nueva respuesta",
  "snippets.name": "Título",
  "snippets.shortcut": "Atajo",
  "snippets.body": "Texto",
  "snippets.team": "Equipo (vacío = todos)",
  "snippets.global": "Todos los equipos",
  "snippets.picker": "Respuestas rápidas",
  "snippets.no_match": "Ninguna respuesta encontrada",
  "optout.title": "Baja por palabra clave",
  "optout.hint": "Cuando el contacto envía una de estas palabras, registramos el rechazo de marketing y, si está configurado, respondemos automáticamente.",
  "optout.keywords": "Palabras clave (una por línea)",
  "optout.reply": "Respuesta automática (opcional)",
  "settings.organization": "Resultados, etiquetas y respuestas",
  "platform.title": "Consola de la plataforma",
  "platform.open": "Abrir consola de la plataforma",
  "platform.tab.overview": "Resumen",
  "platform.tab.customers": "Clientes",
  "platform.tab.plans": "Planes",
  "platform.tab.ai": "IA",
  "platform.tab.admins": "Administradores",
  "platform.tab.audit": "Auditoría",
  "platform.kpi.customers": "Clientes",
  "platform.kpi.active": "Activos",
  "platform.kpi.trial": "En prueba",
  "platform.kpi.failed": "Bases con fallo",
  "platform.kpi.conversations": "Atenciones en el mes",
  "platform.kpi.messages_out": "Mensajes enviados en el mes",
  "platform.kpi.ai_cost": "Costo de IA en el mes",
  "platform.kpi.meta_cost": "Costo Meta en el mes",
  "platform.days": "Últimos 14 días",
  "platform.by_lifecycle": "Por situación",
  "platform.by_db": "Por estado de la base",
  "platform.lifecycle.prospect": "Prospecto",
  "platform.lifecycle.trial": "Prueba",
  "platform.lifecycle.active": "Activo",
  "platform.lifecycle.suspended": "Suspendido",
  "platform.lifecycle.churned": "Cerrado",
  "platform.db.pending": "Pendiente",
  "platform.db.provisioning": "Aprovisionando",
  "platform.db.migrating": "Migrando",
  "platform.db.seeding": "Sembrando",
  "platform.db.ready": "Listo",
  "platform.db.failed": "Falló",
  "platform.customers.search": "Buscar por nombre, identificador o dueño",
  "platform.customers.new": "Nuevo cliente",
  "platform.customers.col.name": "Cliente",
  "platform.customers.col.plan": "Plan",
  "platform.customers.col.lifecycle": "Situación",
  "platform.customers.col.db": "Base",
  "platform.customers.col.members": "Personas",
  "platform.customers.col.created": "Creado el",
  "platform.customers.empty": "Ningún cliente.",
  "platform.customer.slug": "Identificador",
  "platform.customer.name": "Nombre",
  "platform.customer.legal_name": "Razón social",
  "platform.customer.tax_id": "CNPJ",
  "platform.customer.owner_email": "E-mail del dueño",
  "platform.customer.owner_name": "Nombre del dueño",
  "platform.customer.locale": "Idioma por defecto",
  "platform.customer.timezone": "Zona horaria",
  "platform.customer.plan": "Plan",
  "platform.customer.no_plan": "Sin plan",
  "platform.customer.visibility": "Visibilidad de las atenciones",
  "platform.visibility.open": "Todos ven todo",
  "platform.visibility.team": "Por equipo",
  "platform.visibility.own": "Solo las propias",
  "platform.customer.lifecycle": "Situación",
  "platform.customer.created": "Cliente creado. Dueño: {email}.",
  "platform.customer.invite": "Enlace de acceso del dueño (se muestra una vez)",
  "platform.customer.provision": "Aprovisionar la base de nuevo",
  "platform.customer.provisioned": "Base aprovisionada: {state}",
  "platform.customer.stats": "Números",
  "platform.customer.stat.contacts": "Contactos",
  "platform.customer.stat.open": "Atenciones abiertas",
  "platform.customer.stat.closed_month": "Concluidas en el mes",
  "platform.customer.stat.channels": "Números",
  "platform.customer.stat.flows": "Flujos publicados",
  "platform.customer.stat.assistants": "Asistentes activos",
  "platform.customer.members": "Personas",
  "platform.customer.add_owner": "Agregar dueño",
  "platform.customer.usage": "Uso en el mes",
  "platform.customer.open_workspace": "Abrir como cliente",
  "platform.plans.new": "Nuevo plan",
  "platform.plans.code": "Código",
  "platform.plans.name": "Nombre",
  "platform.plans.limits": "Límites",
  "platform.plans.features": "Recursos incluidos",
  "platform.plans.customers": "{n} clientes",
  "platform.plans.invalid_json": "JSON inválido",
  "platform.ai.models": "Modelos",
  "platform.ai.keys": "Claves de la plataforma",
  "platform.ai.surfaces": "Enrutamiento por tarea",
  "platform.ai.refresh": "Leer modelos de los proveedores",
  "platform.ai.sync_pricing": "Actualizar catálogo y precios",
  "platform.ai.col.model": "Modelo",
  "platform.ai.col.provider": "Proveedor",
  "platform.ai.col.input": "Entrada / 1M",
  "platform.ai.col.output": "Salida / 1M",
  "platform.ai.col.enabled": "Activo",
  "platform.ai.add_key": "Agregar clave",
  "platform.ai.surface": "Tarea",
  "platform.ai.default_model": "Modelo por defecto",
  "platform.admins.add": "Agregar administrador",
  "platform.admins.email": "E-mail (usuario existente)",
  "platform.admins.role": "Rol",
  "platform.admins.role.super": "Súper",
  "platform.admins.role.support": "Soporte",
  "platform.admins.remove": "Quitar",
  "platform.audit.actor": "Quién",
  "platform.audit.action": "Acción",
  "platform.audit.entity": "Entidad",
  "platform.audit.data": "Datos",
  "auth.account": "Cuenta",
  "media.unsupported": "Tipo de archivo no aceptado por WhatsApp.",
  "media.too_large": "Archivo demasiado grande para WhatsApp.",
  "reports.by_tag": "Por etiqueta",
  "settings.learning": "Aprendizaje",
  "learning.title": "Aprendizaje de la cuenta",
  "learning.hint": "Cada semana el sistema analiza las atenciones concluidas con éxito y propone respuestas para el playbook, ajustes de instrucciones del asistente, preguntas para el flujo y documentos de conocimiento. Nada cambia solo: tú apruebas.",
  "learning.generate": "Analizar ahora",
  "learning.generating": "Analizando…",
  "learning.period": "Período",
  "learning.status.generating": "Analizando",
  "learning.status.ready": "Listo",
  "learning.status.failed": "Falló",
  "learning.status.archived": "Archivado",
  "learning.trigger.manual": "Manual",
  "learning.trigger.weekly": "Semanal",
  "learning.stats": "{analyzed} atenciones analizadas · {successful} con éxito",
  "learning.suggestions": "Sugerencias",
  "learning.counts": "{proposed} propuestas · {applied} aplicadas · {rejected} rechazadas",
  "learning.summary": "Resumen",
  "learning.empty": "Ningún análisis todavía. Genera el primero o espera el semanal.",
  "learning.no_suggestions": "Ninguna sugerencia en este informe.",
  "learning.kind.playbook_reply": "Respuesta para el playbook",
  "learning.kind.prompt_change": "Ajuste del asistente",
  "learning.kind.flow_question": "Pregunta para el flujo",
  "learning.kind.knowledge_doc": "Documento de conocimiento",
  "learning.rationale": "Por qué",
  "learning.evidence": "Evidencias",
  "learning.success_rate": "{rate}% de éxito en {n} atenciones",
  "learning.approve": "Aprobar y aplicar",
  "learning.approve_only": "Aprobar",
  "learning.reject": "Rechazar",
  "learning.applied": "Aplicado",
  "learning.rejected": "Rechazado",
  "learning.approved": "Aprobado",
  "learning.target.collection": "Colección de destino",
  "learning.target.assistant": "Asistente de destino",
  "learning.target.team": "Equipo (vacío = todos)",
  "learning.body": "Texto (puedes editarlo antes de aplicar)",
  "learning.archive": "Archivar",
  "learning.prompt_note": "El texto entra en el borrador del asistente. Publica después de probar.",
  "brief.generate": "Resumen de la IA",
  "brief.generating": "Resumiendo…",
  "brief.title": "Resumen de la atención",
  "brief.empty": "Sin mensajes para resumir.",
  "outcome.suggestion": "Sugerencia de la IA: {label} · {confidence}%",
  "outcome.suggestion_reason": "Motivo",
  "hours.title": "Horarios de atención",
  "hours.new": "Nuevo horario",
  "hours.name": "Nombre",
  "hours.timezone": "Zona horaria",
  "hours.weekly": "Días y horarios",
  "hours.from": "Abre {day}",
  "hours.to": "Cierra {day}",
  "hours.closed": "Cerrado",
  "hours.none": "Sin horario",
  "hours.day.mon": "Lunes",
  "hours.day.tue": "Martes",
  "hours.day.wed": "Miércoles",
  "hours.day.thu": "Jueves",
  "hours.day.fri": "Viernes",
  "hours.day.sat": "Sábado",
  "hours.day.sun": "Domingo",
  "hours.hint": "Fuera del horario, el flujo puede responder con el mensaje de ausencia y la atención queda en cola.",
  "reports.tab.monitor": "Monitor en vivo",
  "monitor.updated": "Actualizado {time}",
  "monitor.total.open": "Abiertas",
  "monitor.total.waiting_reply": "Esperando nuestra respuesta",
  "monitor.total.unanswered": "Sin respuesta hace 15+ min",
  "monitor.total.closed_today": "Concluidas hoy",
  "monitor.total.success_today": "Éxito hoy",
  "monitor.queues": "Colas",
  "monitor.col.queue": "Cola",
  "monitor.col.waiting": "En cola",
  "monitor.col.oldest": "Espera más antigua",
  "monitor.col.active": "En atención",
  "monitor.col.online": "En línea",
  "monitor.no_team": "Sin equipo",
  "monitor.members": "Personas ahora",
  "monitor.col.member": "Persona",
  "monitor.col.presence": "Disponibilidad",
  "monitor.col.load": "Carga",
  "monitor.col.oldest_unanswered": "Sin respuesta hace",
  "monitor.alerts": "Alertas",
  "monitor.alert.first_response_over": "{name} espera la 1ª respuesta hace {minutes} min",
  "monitor.alert.unanswered_over": "{name} sin respuesta hace {minutes} min",
  "monitor.alert.queue_over": "Cola {name} con espera de {minutes} min",
  "monitor.no_alerts": "Todo al día.",
  "monitor.open": "Abrir",
  "inbox.window.chip": "{time} restantes",
  "inbox.window.free_chip": "Anuncio · gratis por {time}",
  "inbox.window.closing": "Ventana cerrando",
  "fields.title": "Campos del contacto",
  "fields.hint": "Campos extra que aparecen en los datos del contacto, en la importación y en el gancho de entrada. Marca «la IA puede completar» para que el asistente guarde el valor durante la conversación.",
  "fields.new": "Nuevo campo",
  "fields.label": "Nombre del campo",
  "fields.key": "Clave (API e importación)",
  "fields.type": "Tipo",
  "fields.options": "Opciones (una por línea)",
  "fields.ai": "La IA puede completar",
  "fields.ai_hint": "Pista para la IA (cómo identificar el valor)",
  "fields.required": "Obligatorio",
  "fields.active": "Activo",
  "fields.type.text": "Texto",
  "fields.type.number": "Número",
  "fields.type.date": "Fecha",
  "fields.type.boolean": "Sí/no",
  "fields.type.select": "Lista de opciones",
  "fields.type.phone": "Teléfono",
  "fields.type.email": "E-mail",
  "fields.type.cpf": "CPF",
  "fields.type.cnpj": "CNPJ",
  "fields.key_taken": "Ya existe un campo con esa clave.",
  "policy.priority": "Prioridad",
  "select.search": "Buscar…",
  "select.empty": "Ninguna opción encontrada",
  "inbox.action.open": "Abrir",
  "inbox.action.copy_phone": "Copiar teléfono",
  "message.reply": "Responder",
  "message.copy": "Copiar texto",
  "message.download": "Descargar archivo",
  "message.copied": "Copiado",
  "message.replying": "Respondiendo a",
  "contact.media": "Medios, enlaces y docs",
  "contact.media.tab.media": "Medios",
  "contact.media.tab.docs": "Docs",
  "contact.media.tab.links": "Enlaces",
  "contact.media.empty": "Nada para mostrar",
  "inbox.reconnecting": "Reconectando…",
  "composer.failed": "No se pudo enviar",
  "composer.attach.label": "Adjuntar",
  "composer.attach.document": "Documento",
  "composer.attach.media": "Fotos y videos",
  "composer.attach.camera": "Cámara",
  "composer.attach.audio": "Audio",
  "composer.attach.contact": "Contacto",
  "composer.attach.poll": "Encuesta",
  "composer.attach.event": "Evento",
  "composer.attach.sticker": "Nuevo sticker",
  "composer.mic_denied": "No se pudo acceder al micrófono. Permite el acceso en el navegador o adjunta un archivo de audio.",
  "composer.mic_unavailable": "Micrófono no disponible",
  "composer.voice_note": "Mensaje de voz",
  "composer.edit": "Editar mensaje",
  "composer.reply": "Responder",
  "composer.cancel_reference": "Cancelar respuesta o edición",
  "composer.voice_discard": "Descartar grabación",
  "composer.voice_preview": "Escuchar la grabación",
  "composer.voice_resume": "Reanudar grabación",
  "composer.voice_pause": "Pausar grabación",
  "composer.voice_send": "Enviar audio",
  "composer.no_snippet": "Ninguna respuesta encontrada",
  "composer.expressions": "Emojis, GIF y stickers",
  "composer.placeholder": "Escribe un mensaje",
  "composer.save_edit": "Guardar edición",
  "composer.send": "Enviar",
  "composer.voice": "Mensaje de voz",
  "media.pages": "{count} página|{count} páginas",
  "media.composer_label": "Enviar archivos",
  "media.preparing": "Preparando archivo…",
  "media.remove": "Quitar archivo",
  "media.remove_file": "Quitar {name}",
  "media.no_preview": "Vista previa no disponible",
  "media.drop_more": "Suelta para añadir",
  "media.drop_here": "Suelta los archivos para enviarlos",
  "media.caption": "Escribe un mensaje",
  "media.caption_none": "Los audios y stickers no llevan texto",
  "media.emoji": "Emojis",
  "media.files": "Archivos seleccionados",
  "media.add_more": "Añadir archivo",
  "media.refused_count": "{count} archivo no se enviará|{count} archivos no se enviarán",
  "media.send": "Enviar {count} archivo|Enviar {count} archivos",
  "media.error.type": "WhatsApp no acepta archivos {ext} en la API oficial.",
  "media.error.too_large": "Supera el límite de WhatsApp para este tipo de archivo ({max}).",
  "media.error.empty": "El archivo está vacío.",
  "media.error.heic": "Este navegador no abre fotos HEIC. Abre DoneTalk en Safari o exporta la foto como JPG.",
  "media.error.conversion": "No se pudo preparar este archivo.",
  "media.error.gate": "El texto necesita revisión antes de enviarse.",
  "media.error.network": "Error de conexión durante el envío.",
  "media.note.converted_jpeg": "Se envía como foto JPG, el formato que acepta WhatsApp.",
  "media.note.compressed": "Foto comprimida para caber en el límite de 5 MB de WhatsApp.",
  "media.note.as_text": "Se envía como archivo de texto, con el nombre original.",
  "media.note.sticker": "Se convierte en un sticker de 512 × 512.",
  "media.open": "Abrir multimedia",
  "media.download_named": "Descargar {name}",
  "media.retry": "Reintentar",
  "media.discard": "Descartar",
  "media.album": "Álbum con {count} elementos",
  "media.album_more": "{count} elementos más",
  "media.audio.play": "Reproducir",
  "media.audio.pause": "Pausar",
  "media.audio.position": "Posición del audio",
  "media.audio.rate": "Velocidad de reproducción",
  "media.viewer.label": "Visor de multimedia",
  "media.viewer.you": "Tú",
  "media.viewer.previous": "Anterior",
  "media.viewer.next": "Siguiente",
  "media.viewer.item": "Elemento {n} de {total}",
  "camera.title": "Tomar foto",
  "camera.denied": "No se pudo acceder a la cámara. Permite el acceso en el navegador.",
  "camera.shoot": "Tomar foto",
  "share_contact.title": "Enviar contacto",
  "share_contact.search": "Buscar contactos",
  "share_contact.empty": "No se encontraron contactos con WhatsApp.",
  "share_contact.count": "{count} de {max} seleccionados",
  "share_contact.send": "Enviar",
  "media.caption_refused": "Este archivo no se enviará",
  "delivery.pending": "Pendiente",
  "delivery.sent": "Enviado",
  "delivery.delivered": "Entregado",
  "delivery.read": "Leído",
  "delivery.failed": "No enviado",
  "delivery.help.pending": "Esperando conexión o confirmación del envío.",
  "delivery.help.sent": "Aceptado por el servicio; aún sin confirmación de entrega.",
  "delivery.help.delivered": "Entregado al destinatario.",
  "delivery.help.read": "Lectura confirmada por el destinatario.",
  "delivery.help.failed": "El envío falló. Puedes intentarlo de nuevo.",
  "delivery.demo.title": "Estados de envío",
  "delivery.demo.description": "Elige un estado para inspeccionarlo o simula el envío. Esta demostración es local y no envía mensajes.",
  "delivery.demo.states": "Estados del mensaje",
  "delivery.demo.scenario": "Condición de la red",
  "delivery.demo.normal": "Normal",
  "delivery.demo.slow": "Red lenta",
  "delivery.demo.offline": "Sin conexión",
  "delivery.demo.failure": "Error de envío",
  "delivery.demo.start": "Simular envío",
  "delivery.demo.reconnect": "Restablecer conexión",
  "delivery.demo.message": "¡Todo listo! Te envío los detalles por aquí.",
  "delivery.demo.error": "No se pudo enviar este mensaje.",
  "delivery.demo.discarded": "Mensaje descartado. Simula un nuevo envío para empezar de nuevo.",
  "delivery.played": "Reproducido",
  "delivery.info.title": "Info. del mensaje",
  "delivery.info.at": "{day} a las {time}",
  "delivery.info.code": "Código de Meta: {code}",
  "delivery.info.no_read": "WhatsApp solo informa la lectura cuando el contacto abre el chat y tiene activadas las confirmaciones de lectura.",
  "meta.pricing.title": "Cobro de Meta",
  "meta.pricing.estimate_hint": "Estimación según la tabla pública de Meta. Los descuentos por volumen pueden bajar el valor; la factura de Meta es la referencia.",
  "meta.pricing.free_customer_service": "Gratis · dentro de la ventana de atención de 24 horas",
  "meta.pricing.free_entry_point": "Gratis · ventana gratuita de quien vino de un anuncio",
  "meta.pricing.charged_unknown": "Cobrado por Meta · {category}",
  "meta.pricing.unknown_currency_hint": "El valor aparece cuando la cuenta de WhatsApp en Meta tenga moneda definida.",
  "meta.pricing.category.marketing": "Marketing",
  "meta.pricing.category.marketing_lite": "Marketing (MM Lite)",
  "meta.pricing.category.utility": "Utilidad",
  "meta.pricing.category.authentication": "Autenticación",
  "meta.pricing.category.authentication-international": "Autenticación internacional",
  "meta.pricing.category.service": "Servicio",
  "meta.pricing.category.referral_conversion": "Entrada gratuita",
  "meta.market.north_america": "América del Norte",
  "meta.market.rest_of_africa": "Resto de África",
  "meta.market.rest_of_asia_pacific": "Resto de Asia-Pacífico",
  "meta.market.rest_of_central_eastern_europe": "Resto de Europa Central y del Este",
  "meta.market.rest_of_latin_america": "Resto de América Latina",
  "meta.market.rest_of_middle_east": "Resto de Oriente Medio",
  "meta.market.rest_of_western_europe": "Resto de Europa Occidental",
  "meta.market.other": "Otros países",
  "delivery.retry.window": "Más de 24 horas sin mensajes del cliente: envía una plantilla para retomar.",
  "delivery.retry.final": "Este error debe resolverse antes de reenviar.",
  "delivery.error.131047": "Pasaron más de 24 horas desde el último mensaje del cliente. Envía una plantilla para retomar la conversación.",
  "delivery.error.131026": "No entregado: el número puede no tener WhatsApp, estar desactualizado o haber bloqueado a la empresa.",
  "delivery.error.131049": "Meta no lo entregó para cuidar la interacción: límite de mensajes de marketing para este contacto.",
  "delivery.error.131050": "El contacto pidió no recibir mensajes de marketing.",
  "delivery.error.131051": "Tipo de mensaje no aceptado por WhatsApp.",
  "delivery.error.131053": "Error al enviar el archivo: formato o tamaño no aceptados por WhatsApp.",
  "delivery.error.131056": "Demasiados mensajes al mismo contacto en poco tiempo. Espera e inténtalo de nuevo.",
  "delivery.error.130429": "Se alcanzó el límite de envío del número. Inténtalo de nuevo en unos instantes.",
  "delivery.error.131048": "Envío limitado por Meta por bloqueos o denuncias recientes.",
  "delivery.error.131042": "Problema de pago en la cuenta de WhatsApp Business: moneda, forma de pago o límite de crédito. Revísalo en Facturación y pagos, en Meta Business Suite.",
  "delivery.error.131031": "La cuenta de WhatsApp Business está bloqueada por Meta.",
  "delivery.error.368": "Envío bloqueado por infringir las políticas de WhatsApp.",
  "delivery.error.131000": "Error inesperado en Meta. Inténtalo de nuevo.",
  "delivery.error.131005": "El token del número no tiene permiso para enviar. Vuelve a conectar el número.",
  "delivery.error.132000": "La cantidad de variables no coincide con la plantilla aprobada.",
  "delivery.error.132001": "La plantilla no existe en este idioma o aún no fue aprobada.",
  "delivery.error.132015": "Meta pausó la plantilla por baja calidad.",
  "delivery.error.132016": "Meta desactivó la plantilla.",
  "delivery.error.133010": "El número de la empresa no está registrado en la API de WhatsApp.",
  "delivery.error.130472": "El contacto está en un experimento de Meta que suspende mensajes de marketing.",
  "delivery.error.credential_invalid": "No se pudo leer la credencial del número. Vuelve a conectarlo en Configuración › Números.",
  "delivery.error.media_missing": "No se encontró el archivo de este mensaje para enviarlo.",
  "delivery.error.contact_without_identity": "El contacto no tiene número de WhatsApp.",
  "message.edited": "editado",
  "message.contact": "Contacto",
  "message.options": "Opciones del mensaje",
  "message.quote_unavailable": "Mensaje no cargado",
  "message.quote.photo": "Foto",
  "message.quote.video": "Video",
  "message.quote.voice": "Mensaje de voz",
  "message.quote.audio": "Audio",
  "message.quote.sticker": "Sticker",
  "message.quote.contact": "Contacto",
  "outcomes.title": "Resultados",
  "outcomes.new": "Nuevo resultado",
  "outcomes.hint": "Toda atención termina con un resultado. Los de éxito cuentan como logro en los informes y el aprendizaje.",
  "outcomes.name": "Nombre",
  "outcomes.category": "Tipo",
  "outcomes.category.success": "Éxito",
  "outcomes.category.neutral": "Neutro",
  "outcomes.category.negative": "Sin éxito",
  "outcomes.category.invalid": "Inválido",
  "outcomes.requires_note": "Pedir una nota al cerrar",
  "outcomes.reopen": "Permitir reabrir la atención",
  "outcomes.used": "Usado en {count} atención|Usado en {count} atenciones",
  "outcomes.unused": "Aún sin usar",
  "outcomes.note": "pide nota",
  "outcomes.move_up": "Subir",
  "outcomes.move_down": "Bajar",
  "outcomes.archived_hint": "Archivado: ya no aparece para cerrar, pero sigue en el historial y los informes.",
  "errors.validation_failed": "Revisa los campos e inténtalo de nuevo.",
  "errors.last_active_outcome": "Mantén al menos un resultado activo: toda atención necesita uno para cerrarse.",
  "errors.outcome_not_found": "Ese resultado ya no existe.",
  "errors.forbidden": "No tienes permiso para esto.",
  "common.done": "Listo",
  "handler.hybrid": "Híbrido",
  "numbers.connected": "Conectado",
  "numbers.off": "Apagado",
  "numbers.display_name": "Nombre visible",
  "numbers.name.approved": "Aprobado por Meta",
  "numbers.name.pending": "En revisión por Meta",
  "numbers.name.declined": "Rechazado por Meta",
  "numbers.name.expired": "Vencido",
  "numbers.quality.green": "Alta",
  "numbers.quality.yellow": "Media",
  "numbers.quality.red": "Baja",
  "numbers.quality.unknown": "Sin evaluación",
  "numbers.health.ok": "Listo para enviar mensajes",
  "numbers.health.limited": "Envío limitado por Meta",
  "numbers.health.blocked": "Algo impide enviar mensajes",
  "numbers.health.unknown": "Aún no verificado con Meta",
  "numbers.health.checked": "Verificado el {when}",
  "numbers.health.check": "Verificar ahora",
  "numbers.health.meta_code": "Código de Meta: {code}",
  "numbers.health.code.141006": "Falta un método de pago válido en Meta. Sin él, la empresa no puede iniciar conversaciones con plantillas. Agrega una tarjeta en WhatsApp Manager.",
  "numbers.manager": "Abrir en WhatsApp Manager",
  "numbers.pin.show": "Ver PIN",
  "numbers.pin.title": "PIN de verificación en dos pasos",
  "numbers.pin.fresh_title": "Número conectado. Guarda el PIN",
  "numbers.pin.explain": "Registramos {number} en la API oficial con este PIN de verificación en dos pasos:",
  "numbers.pin.keep": "Queda guardado aquí, cifrado. Lo necesitarás si algún día llevas el número a otra plataforma.",
  "numbers.pin.copy": "Copiar PIN",
  "numbers.pin.copied": "PIN copiado",
  "numbers.meta.title": "Conectar un número de WhatsApp",
  "numbers.meta.hint": "La conexión se hace en la ventana oficial de Meta, sin instalar nada. Al terminar, vuelves aquí.",
  "numbers.meta.before": "Vas a necesitar",
  "numbers.meta.req_facebook": "El Facebook de quien administra la empresa",
  "numbers.meta.req_number": "Un número libre, o el de WhatsApp Business de la empresa (sigue funcionando en el celular)",
  "numbers.meta.req_code": "El celular de ese número cerca, para recibir el código por SMS o llamada",
  "numbers.meta.connect": "Conectar con Meta",
  "numbers.meta.step1": "Entrar con Facebook",
  "numbers.meta.step2": "Elegir o crear el portafolio de la empresa",
  "numbers.meta.step3": "Nombre visible, categoría y número",
  "numbers.meta.step4": "Confirmar el número con el código",
  "numbers.meta.unavailable": "La conexión por la ventana de Meta aún no está configurada en esta plataforma. Usa la conexión manual o contacta al soporte.",
  "numbers.meta.connected": "{number} conectado",
  "numbers.meta.cancelled": "La ventana de Meta se cerró antes de terminar. Nada cambió.",
  "numbers.meta.sdk_blocked": "No se pudo abrir la ventana de Meta. Revisa si hay un bloqueador de anuncios o de ventanas emergentes.",
  "numbers.manual.toggle": "Conexión manual (avanzado)",
  "errors.waba_not_found": "Meta no informó qué cuenta de WhatsApp se eligió. Rehaz la conexión y completa todos los pasos de la ventana.",
  "errors.waba_without_number": "La cuenta de WhatsApp se conectó, pero aún no tiene número. Rehaz la conexión y agrega el número en la ventana de Meta.",
  "errors.phone_number_required": "Esa cuenta tiene más de un número. Rehaz la conexión y elige el número en la ventana de Meta.",
  "errors.pin_not_found": "Este número no tiene PIN guardado aquí.",
  "errors.account_without_credential": "La cuenta de WhatsApp perdió el acceso. Conecta el número de nuevo.",
  "errors.channel_not_found": "Ese número ya no existe.",
  "numbers.name.unknown": "Aún no informado por Meta",
  "numbers.health.info.display_name_pending": "Meta aún no aprobó el nombre visible. El límite de mensajes sube después de la aprobación.",
  "numbers.token_soon": "El acceso de Meta a este número vence el {date}. La renovación es automática; si no ocurre, vuelve a conectar el número para no dejar de atender.",
  "numbers.token_expired": "El acceso de Meta a este número venció el {date}. Vuelve a conectar el número para enviar y recibir mensajes.",
  "numbers.reconnect": "Reconectar con Meta",
  "platform.customer.billing": "Cobro de Meta",
  "platform.customer.billing.customer": "El cliente paga a Meta con su propia tarjeta",
  "platform.customer.billing.partner": "Línea de crédito de socio (Nuvvun paga y cobra al cliente)",
  "numbers.meta.billing_partner": "Los mensajes de Meta se cobran en la línea de crédito de nuestro socio: no hace falta registrar tarjeta",
  "nav.onboarding": "Implementación",
  "common.copy_link": "Copiar enlace",
  "common.link_copied": "Enlace copiado",
  "errors.channel_unavailable": "Conecta un número de WhatsApp primero.",
  "errors.step_required": "Este paso es obligatorio y no se puede omitir.",
  "errors.onboarding_incomplete": "Aún faltan pasos obligatorios.",
  "errors.onboarding_not_answered": "Responde el cuestionario primero.",
  "errors.assistant_not_published": "Publica el asistente antes de elegirlo.",
  "onboarding.stage.welcome": "Bienvenida",
  "onboarding.stage.whatsapp": "WhatsApp",
  "onboarding.stage.team": "Equipo",
  "onboarding.stage.organization": "Organización",
  "onboarding.stage.entry": "Entrada",
  "onboarding.stage.outbound": "Mensajes activos",
  "onboarding.stage.golive": "Ensayo y lanzamiento",
  "onboarding.stage.welcome.summary": "Cuéntanos sobre la empresa para que el recorrido se ajuste a ti.",
  "onboarding.stage.whatsapp.summary": "Conecta el número oficial de la empresa a DoneTalk.",
  "onboarding.stage.team.summary": "Quién atiende, en qué colas y en qué horario.",
  "onboarding.stage.organization.summary": "Cómo terminan las atenciones y cómo se organiza el equipo.",
  "onboarding.stage.entry.summary": "Lo que recibe el cliente cuando envía el primer mensaje.",
  "onboarding.stage.outbound.summary": "Para escribirle primero al cliente, Meta exige plantillas aprobadas.",
  "onboarding.stage.golive.summary": "Prueba de punta a punta con tu celular; después, a abrir para el equipo.",
  "onboarding.step.welcome.questionnaire": "Cuestionario rápido",
  "onboarding.step.whatsapp.connect": "Conectar con Meta",
  "onboarding.step.whatsapp.payment": "Medio de pago en Meta",
  "onboarding.step.team.invite": "Invitar personas",
  "onboarding.step.team.queues": "Equipos (colas)",
  "onboarding.step.team.hours": "Horario de atención",
  "onboarding.step.organization.outcomes": "Resultados",
  "onboarding.step.organization.snippets": "Respuestas rápidas",
  "onboarding.step.organization.autoclose": "Cierre automático",
  "onboarding.step.organization.tags": "Etiquetas",
  "onboarding.step.entry.first_contact": "Primer contacto",
  "onboarding.step.entry.after_hours": "Fuera de horario",
  "onboarding.step.entry.assistant": "Asistente de IA",
  "onboarding.step.outbound.templates": "Plantillas aprobadas",
  "onboarding.step.outbound.optout": "Baja",
  "onboarding.step.golive.rehearsal": "Ensayo general",
  "onboarding.step.golive.tour": "Tour del equipo",
  "onboarding.step.golive.live": "Salir en vivo",
  "onboarding.when.welcome.questionnaire": "Listo cuando se responde o se omite.",
  "onboarding.when.whatsapp.connect": "Listo cuando el número está activo. El nombre visible sigue en revisión, y se puede usar mientras tanto.",
  "onboarding.when.whatsapp.payment": "Listo cuando la tarjeta está registrada. Sin ella no salen plantillas ni, a partir del 1 de octubre de 2026, las respuestas más allá de las 1.000 gratis del mes.",
  "onboarding.when.team.invite": "Listo cuando se envía una invitación o eliges atender solo.",
  "onboarding.when.team.queues": "Listo cuando un equipo tiene personas.",
  "onboarding.when.team.hours": "Listo cuando el horario está guardado y vinculado a los equipos.",
  "onboarding.when.organization.outcomes": "Listo cuando la lista está revisada, con los de éxito marcados.",
  "onboarding.when.organization.snippets": "Listo con tres o más.",
  "onboarding.when.organization.autoclose": "Listo con una regla activa.",
  "onboarding.when.organization.tags": "Listo con una o más.",
  "onboarding.when.entry.first_contact": "Listo cuando menú, asistente o equipo están elegidos y publicados.",
  "onboarding.when.entry.after_hours": "Listo cuando el mensaje está publicado con el menú.",
  "onboarding.when.entry.assistant": "Listo cuando está publicado, con conocimiento.",
  "onboarding.when.outbound.templates": "Listo cuando Meta aprueba una plantilla.",
  "onboarding.when.outbound.optout": "Listo cuando las palabras están guardadas. La respuesta de confirmación es opcional.",
  "onboarding.when.golive.rehearsal": "Listo cuando la atención de prueba termina con un resultado.",
  "onboarding.when.golive.tour": "Listo cuando el equipo invitado vio el tour.",
  "onboarding.when.golive.live": "Listo cuando todos los obligatorios están hechos.",
  "onboarding.done.welcome.questionnaire": "Cuestionario respondido",
  "onboarding.done.whatsapp.connect": "Número conectado",
  "onboarding.done.whatsapp.payment": "Medio de pago registrado en Meta",
  "onboarding.done.team.invite": "Invitaciones enviadas",
  "onboarding.done.team.queues": "Equipos con personas",
  "onboarding.done.team.hours": "Horario vinculado a los equipos",
  "onboarding.done.organization.outcomes": "Resultados revisados",
  "onboarding.done.organization.snippets": "Respuestas rápidas creadas",
  "onboarding.done.organization.autoclose": "Cierre automático activado",
  "onboarding.done.organization.tags": "Etiquetas creadas",
  "onboarding.done.entry.first_contact": "Entrada publicada",
  "onboarding.done.entry.after_hours": "Mensaje fuera de horario publicado",
  "onboarding.done.entry.assistant": "Asistente publicado, con conocimiento",
  "onboarding.done.outbound.templates": "Plantilla aprobada por Meta",
  "onboarding.done.outbound.optout": "Baja configurada",
  "onboarding.done.golive.rehearsal": "Ensayo general completado",
  "onboarding.done.golive.tour": "El equipo vio el tour",
  "onboarding.done.golive.live": "En vivo",
  "onboarding.lead.welcome.questionnaire": "Cuéntanos un poco sobre la empresa. Con las respuestas, el recorrido sugiere equipos, resultados, respuestas rápidas y el mensaje de bienvenida.",
  "onboarding.lead.whatsapp.connect": "Conecta el número oficial de la empresa desde la ventana de Meta. Toma unos 10 minutos.",
  "onboarding.lead.whatsapp.payment": "Registra una tarjeta en Meta. Sin ella no salen plantillas y, a partir del 1 de octubre de 2026, las respuestas también se detienen después de las 1.000 gratis del mes por número. El pago de los mensajes va directo a Meta.",
  "onboarding.lead.team.invite": "Invita a las personas de la empresa y elige el rol de cada una. Reciben la invitación por correo. Toma unos 5 minutos.",
  "onboarding.lead.team.queues": "Crea las colas por tema y agrega a las personas en cada una.",
  "onboarding.lead.team.hours": "Vincula el horario de atención a los equipos.",
  "onboarding.lead.organization.outcomes": "Revisa cómo terminan las atenciones y marca las que cuentan como éxito.",
  "onboarding.lead.organization.snippets": "Deja listas las respuestas que el equipo más escribe.",
  "onboarding.lead.organization.autoclose": "Activa el cierre automático para que ninguna atención quede abierta por olvido.",
  "onboarding.lead.organization.tags": "Crea etiquetas para marcar y filtrar contactos y atenciones.",
  "onboarding.lead.entry.first_contact": "Elige lo que recibe el cliente en el primer mensaje: menú, asistente o directo al equipo.",
  "onboarding.lead.entry.after_hours": "Escribe el mensaje que recibe el cliente fuera de horario.",
  "onboarding.lead.entry.assistant": "Publica un asistente de IA con el conocimiento de la empresa.",
  "onboarding.lead.outbound.templates": "Crea una plantilla para retomar y otra de recordatorio y envíalas a Meta para aprobar.",
  "onboarding.lead.outbound.optout": "Define las palabras de baja y la respuesta.",
  "onboarding.lead.golive.rehearsal": "Recorre el camino de tu cliente con tu celular, del “Hola” al resultado.",
  "onboarding.lead.golive.tour": "Envía el tour corto para que el equipo lo vea en el primer acceso.",
  "onboarding.lead.golive.live": "Todo listo: abre la atención para el equipo.",
  "onboarding.level.required": "Obligatorio",
  "onboarding.level.recommended": "Recomendado",
  "onboarding.level.optional": "Opcional",
  "onboarding.status.done": "Completada",
  "onboarding.status.now": "Ahora",
  "onboarding.status.step_done": "Hecho",
  "onboarding.status.skipped": "Omitido",
  "onboarding.hub.title": "Implementación",
  "onboarding.hub.started": "Empezó el {date}.",
  "onboarding.hub.left": "Faltan unos {minutes} minutos de trabajo.",
  "onboarding.hub.no_left": "Todas las etapas están listas.",
  "onboarding.hub.done_count": "{done} de {total} etapas completadas",
  "onboarding.hub.now": "Ahora · etapa {n} · {stage}",
  "onboarding.hub.start": "Empezar",
  "onboarding.hub.skip_now": "Omitir por ahora",
  "onboarding.hub.open": "Abrir",
  "onboarding.hub.resume": "Retomar",
  "onboarding.hub.steps_progress": "{done} de {total} pasos · unos {minutes} min",
  "onboarding.hub.minutes": "unos {minutes} min",
  "onboarding.hub.meta_review": "más la revisión de Meta",
  "onboarding.hub.help_title": "¿Necesitas ayuda?",
  "onboarding.hub.help_text": "Un especialista de Nuvvun hace esta etapa contigo en una llamada.",
  "onboarding.hub.help_cta": "Hablar con un especialista",
  "onboarding.hub.share_title": "Comparte la implementación",
  "onboarding.hub.share_text": "Invita como admin a quien cuida del WhatsApp o del equipo. Esa persona ve este mismo panel.",
  "onboarding.hub.share_cta": "Invitar a ayudar",
  "onboarding.hub.end_title": "Cuando termines",
  "onboarding.hub.end_text": "La implementación sale del menú después del lanzamiento y queda en Configuración › Cuenta, si quieres revisarla.",
  "onboarding.hub.go_live_ready": "Todo lo obligatorio está listo.",
  "onboarding.hub.live_since": "En vivo desde el {date}.",
  "onboarding.detail.connected": "{number} conectado",
  "onboarding.detail.name_review": "nombre en revisión por Meta",
  "onboarding.detail.name_approved": "nombre aprobado",
  "onboarding.detail.name_declined": "nombre rechazado por Meta",
  "onboarding.detail.paid_by_partner": "Nuvvun le paga a Meta por ti",
  "onboarding.detail.solo": "Vas a atender solo por ahora",
  "onboarding.detail.invited": "1 persona invitada|{count} personas invitadas",
  "onboarding.detail.teams": "1 equipo con personas|{count} equipos con personas",
  "onboarding.detail.snippets": "1 respuesta rápida|{count} respuestas rápidas",
  "onboarding.detail.tags": "1 etiqueta|{count} etiquetas",
  "onboarding.detail.templates_approved": "1 aprobada|{count} aprobadas",
  "onboarding.detail.templates_pending": "1 en revisión por Meta|{count} en revisión por Meta",
  "onboarding.detail.from_questionnaire": "Vino del cuestionario",
  "onboarding.detail.suggestion_ready": "Sugerencia lista",
  "onboarding.detail.entry_menu": "Menú de bienvenida publicado",
  "onboarding.detail.entry_team": "Directo al equipo",
  "onboarding.detail.entry_assistant": "Asistente de IA en la entrada",
  "onboarding.detail.tour_pending": "1 persona aún no lo vio|{count} personas aún no lo vieron",
  "onboarding.welcome.eyebrow": "Bienvenida",
  "onboarding.welcome.title": "Hola, {name}. Vamos a dejar DoneTalk listo para {company}.",
  "onboarding.welcome.lead": "En 7 etapas cortas conectas WhatsApp, armas el equipo y haces una atención de prueba desde tu celular. Puedes parar y seguir cuando quieras: la implementación queda en el menú hasta el lanzamiento.",
  "onboarding.q.title": "Cuéntanos un poco sobre {company}",
  "onboarding.q.lead": "Toma 2 minutos. Con las respuestas, DoneTalk sugiere equipos, resultados, respuestas rápidas y el mensaje de bienvenida. Revisas todo antes de aplicarlo.",
  "onboarding.q.purposes": "¿Qué van a hacer por WhatsApp?",
  "onboarding.purpose.sell": "Vender",
  "onboarding.purpose.support": "Atender clientes",
  "onboarding.purpose.tech_support": "Soporte técnico",
  "onboarding.purpose.billing": "Cobranza",
  "onboarding.purpose.scheduling": "Agendamientos",
  "onboarding.q.segment": "Segmento",
  "onboarding.segment.real_estate": "Inmobiliaria",
  "onboarding.segment.education": "Educación",
  "onboarding.segment.health": "Salud",
  "onboarding.segment.retail": "Comercio",
  "onboarding.segment.services": "Servicios",
  "onboarding.segment.finance": "Finanzas",
  "onboarding.segment.automotive": "Automotriz",
  "onboarding.segment.travel": "Turismo",
  "onboarding.segment.other": "Otro",
  "onboarding.q.team_size": "¿Cuántas personas van a atender?",
  "onboarding.size.solo": "Solo yo",
  "onboarding.size.small": "2 a 5",
  "onboarding.size.medium": "6 a 20",
  "onboarding.size.large": "Más de 20",
  "onboarding.q.hours": "Horario de atención",
  "onboarding.q.hours_to": "a",
  "onboarding.q.add_hours": "Agregar horario",
  "onboarding.q.remove_hours": "Quitar horario",
  "onboarding.q.website": "Sitio de la empresa (opcional)",
  "onboarding.q.website_hint": "La IA lee el sitio para sugerir respuestas rápidas y el conocimiento del asistente.",
  "onboarding.q.submit": "Armar mi implementación",
  "onboarding.q.skip": "Omitir y ver la lista de pasos",
  "onboarding.q.refining": "Ajustando las sugerencias a {company}…",
  "onboarding.page.eyebrow": "Implementación · etapa {n} de 7",
  "onboarding.page.key_moment": "momento clave",
  "onboarding.page.ready_when": "Listo cuando",
  "onboarding.page.back": "Volver a la implementación",
  "onboarding.page.faq": "Dudas frecuentes",
  "onboarding.page.minutes": "unos {minutes} minutos",
  "onboarding.page.close_guide": "Cerrar la guía",
  "onboarding.org.title": "Organiza la atención",
  "onboarding.org.lead": "Estas sugerencias vienen del cuestionario. Revisa, ajusta y aplica; nada cambia antes.",
  "onboarding.org.badge_ai": "Sugerencias de la IA",
  "onboarding.org.badge_presets": "Sugerencias para tu segmento",
  "onboarding.org.outcomes_hint": "Toda atención termina con uno. Es lo que alimenta informes y aprendizaje.",
  "onboarding.org.add_outcome": "Agregar resultado",
  "onboarding.org.outcome_label": "Nombre del resultado",
  "onboarding.org.snippets_hint": "En el editor, escribe / y el atajo. Las variables se convierten en el nombre del contacto y de quien atiende.",
  "onboarding.org.tags_hint": "Para marcar contactos y atenciones y filtrar después.",
  "onboarding.org.add_tag": "Agregar",
  "onboarding.org.tag_name": "Nueva etiqueta",
  "onboarding.org.autoclose_hint": "Ninguna atención queda abierta por olvido.",
  "onboarding.org.autoclose_rule": "Sin respuesta del contacto por {days} días: cerrar como “{outcome}”",
  "onboarding.org.window_rule": "Ventana de 24 horas vencida: mover a “Esperando al contacto”",
  "onboarding.org.selected": "1 sugerencia seleccionada. Después editas todo en Configuración.|{count} sugerencias seleccionadas. Después editas todo en Configuración.",
  "onboarding.org.later": "Revisar después",
  "onboarding.org.apply": "Aplicar y continuar",
  "onboarding.org.applied": "Aplicado. Todo queda en Configuración para editar.",
  "onboarding.org.guide_title": "Cómo terminan las atenciones",
  "onboarding.org.guide_text": "Los resultados son el corazón de DoneTalk: dicen qué salió bien y qué no. Marca como éxito los que cuentan como resultado.",
  "onboarding.org.why_title": "Por qué esto es una página propia",
  "onboarding.org.why_text": "Reúne cuatro configuraciones que están en pantallas distintas. Después de aplicar, cada una aparece en su lugar en Configuración.",
  "onboarding.org.ready_text": "Los resultados revisados. El resto es recomendado.",
  "onboarding.org.none": "Responde el cuestionario para recibir sugerencias.",
  "onboarding.entry.title": "Cómo empieza la atención",
  "onboarding.entry.lead": "Elige lo que recibe el cliente cuando envía el primer mensaje.",
  "onboarding.entry.suggested": "Sugerido",
  "onboarding.entry.mode.menu": "Menú de bienvenida",
  "onboarding.entry.mode.menu_text": "El cliente elige el tema y llega a la cola correcta.",
  "onboarding.entry.mode.assistant": "Asistente de IA",
  "onboarding.entry.mode.assistant_text": "Responde con el conocimiento de la empresa y llama al equipo cuando hace falta.",
  "onboarding.entry.mode.team": "Directo al equipo",
  "onboarding.entry.mode.team_text": "Sin automatización: el mensaje entra en la cola y alguien responde.",
  "onboarding.entry.message": "Mensaje de bienvenida",
  "onboarding.entry.options": "Opciones y adónde va cada una",
  "onboarding.entry.option": "Opción {n}",
  "onboarding.entry.add_option": "Agregar opción",
  "onboarding.entry.remove_option": "Quitar opción",
  "onboarding.entry.options_hint": "Hasta 3 opciones se muestran como botones en WhatsApp; de 4 a 10, como lista.",
  "onboarding.entry.team": "Equipo que recibe",
  "onboarding.entry.after_hours": "Fuera de horario",
  "onboarding.entry.after_hours_hint": "Se envía antes del menú cuando alguien escribe fuera del horario de atención. Déjalo en blanco para no enviarlo.",
  "onboarding.entry.assistant_pick": "Asistente",
  "onboarding.entry.no_assistant": "Aún no hay asistentes publicados. Crea uno en Configuración › Asistentes de IA y vuelve aquí.",
  "onboarding.entry.open_assistants": "Abrir asistentes",
  "onboarding.entry.behind": "Por detrás, esto se convierte en un flujo publicado; puedes abrirlo en el constructor cuando quieras.",
  "onboarding.entry.open_builder": "Abrir en el constructor",
  "onboarding.entry.publish": "Publicar",
  "onboarding.entry.published": "Publicado. Las próximas atenciones ya empiezan así.",
  "onboarding.entry.no_teams": "Crea los equipos en la etapa Equipo antes de armar la entrada.",
  "onboarding.entry.open_team": "Abrir equipos",
  "onboarding.entry.preview": "Cómo lo ve el cliente",
  "onboarding.entry.preview_hi": "Hola",
  "onboarding.entry.list_button": "Ver opciones",
  "onboarding.entry.guide_title": "La primera impresión",
  "onboarding.entry.guide_text": "El menú separa los temas antes de llegar a alguien, y cada atención ya entra en la cola correcta.",
  "onboarding.entry.ai_title": "¿Quieres el asistente de IA?",
  "onboarding.entry.ai_text": "Puedes empezar con el menú y activar el asistente después, con la base de conocimiento lista.",
  "onboarding.entry.ready_text": "La entrada publicada. El mensaje fuera de horario es recomendado.",
  "onboarding.rehearsal.title": "Ensayo general",
  "onboarding.rehearsal.lead": "Recorre el camino de tu cliente con tu celular. Ves cada pieza funcionando: número, bienvenida, cola, respuesta y resultado.",
  "onboarding.rehearsal.start": "Empezar el ensayo",
  "onboarding.rehearsal.restart": "Reiniciar el ensayo",
  "onboarding.rehearsal.send_title": "Envía “Hola” a {company}",
  "onboarding.rehearsal.send_text": "Apunta la cámara del celular al código o abre el enlace en el celular. El mensaje ya lleva el código de la prueba.",
  "onboarding.rehearsal.open_whatsapp": "Abrir en WhatsApp",
  "onboarding.rehearsal.test_note": "Esta atención queda marcada como prueba y no entra en los informes.",
  "onboarding.rehearsal.live_title": "Síguelo en vivo",
  "onboarding.rehearsal.s.received": "Mensaje recibido",
  "onboarding.rehearsal.s.received_text": "Con el código de la prueba, desde tu celular",
  "onboarding.rehearsal.s.automated": "Bienvenida enviada",
  "onboarding.rehearsal.s.automated_text": "La entrada publicada respondió",
  "onboarding.rehearsal.s.queued": "Entró en la cola",
  "onboarding.rehearsal.s.queued_text": "La atención llegó a un equipo",
  "onboarding.rehearsal.s.taken": "Toma la atención y responde",
  "onboarding.rehearsal.s.taken_text": "Como lo haría cualquier persona del equipo",
  "onboarding.rehearsal.s.closed": "Cierra con un resultado",
  "onboarding.rehearsal.s.closed_text": "Elige cómo terminó la atención",
  "onboarding.rehearsal.s.monitor": "Míralo en el monitor en vivo",
  "onboarding.rehearsal.s.monitor_text": "La cola y el tiempo de respuesta aparecen en Informes › En vivo",
  "onboarding.rehearsal.open_inbox": "Abrir en el inbox",
  "onboarding.rehearsal.open_monitor": "Abrir el monitor",
  "onboarding.rehearsal.blocked": "Ya había una atención abierta con ese celular, y la prueba necesita empezar una nueva. Cierra la atención abierta y envía el mensaje otra vez.",
  "onboarding.rehearsal.open_blocked": "Abrir la atención abierta",
  "onboarding.rehearsal.done": "Ensayo completado en {minutes} min, con el resultado “{outcome}”.",
  "onboarding.rehearsal.no_number": "Conecta el número en la etapa WhatsApp para hacer el ensayo.",
  "onboarding.rehearsal.waiting": "Esperando tu mensaje…",
  "onboarding.live.title_done": "{company} está en vivo",
  "onboarding.live.lead_done": "El equipo ya puede atender, y el tour corto aparece para cada persona en su primer acceso.",
  "onboarding.live.title_ready": "Todo listo para salir en vivo",
  "onboarding.live.lead_ready": "Todo lo obligatorio está listo. Al salir en vivo, la implementación sale del menú y el tour corto aparece para cada persona del equipo en su primer acceso.",
  "onboarding.live.title_pending": "Faltan algunos pasos",
  "onboarding.live.lead_pending": "Termina los pasos obligatorios para habilitar el lanzamiento.",
  "onboarding.live.cta": "Salir en vivo",
  "onboarding.live.resend_tour": "Reenviar el tour al equipo",
  "onboarding.live.tour_resent": "El tour volverá a aparecer para el equipo.",
  "onboarding.live.open_inbox": "Abrir el inbox",
  "onboarding.live.not_set": "No configurado",
  "onboarding.live.beyond": "Ve más allá",
  "onboarding.live.beyond.review.title": "Revisión de mensajes",
  "onboarding.live.beyond.review.text": "La IA evalúa lo que envía el equipo, en modo sombra, sin bloquear nada, para que calibres las reglas.",
  "onboarding.live.beyond.import.title": "Importar contactos",
  "onboarding.live.beyond.import.text": "Trae la base por planilla, con el consentimiento de cada contacto.",
  "onboarding.live.beyond.integrations.title": "Integraciones",
  "onboarding.live.beyond.integrations.text": "Formularios, CRM y API: los leads entran directo como atención.",
  "onboarding.live.beyond.reports.title": "Informes y monitor",
  "onboarding.live.beyond.reports.text": "Colas, tiempos de respuesta y resultados, en vivo y por período.",
  "onboarding.live.beyond.learning.title": "Aprendizaje semanal",
  "onboarding.live.beyond.learning.text": "Cada lunes, sugerencias sacadas de las atenciones que salieron bien.",
  "onboarding.guide.whatsapp.title": "Conecta el WhatsApp de la empresa",
  "onboarding.guide.whatsapp.text": "Es el número oficial que verán tus clientes. La conexión usa la API oficial de Meta, y todo lo que llegue a él aparece en las atenciones.",
  "onboarding.guide.whatsapp.q1": "¿Puedo usar el número que ya está en WhatsApp?",
  "onboarding.guide.whatsapp.a1": "Sí. Con la cuenta borrada en la aplicación, pasa entero a DoneTalk; o, si prefieres, mantén la app de WhatsApp Business junto, con la opción de coexistencia.",
  "onboarding.guide.whatsapp.a1_soon": "Sí, después de borrar su cuenta en la aplicación. Mantener la app de WhatsApp Business junto llega pronto.",
  "onboarding.guide.whatsapp.q2": "¿Cuánto cuesta?",
  "onboarding.guide.whatsapp.a2": "Meta cobra por mensaje entregado, en la tarjeta registrada en ella: las plantillas siempre, al precio de su categoría (marketing, utilidad o autenticación). A partir del 1 de octubre de 2026, las respuestas dentro de las 24 horas también se cobran, después de las 1.000 gratis del mes por número. Quien llega por un anuncio de clic a WhatsApp tiene 72 horas gratis. El costo de cada mensaje aparece en Info. del mensaje, en los informes y en Configuración › Costos y límites.",
  "onboarding.guide.whatsapp.a2_partner": "Nuvvun le paga a Meta por las plantillas enviadas y lo incluye en tu plan. Responder dentro de las 24 horas después del mensaje del cliente no se cobra.",
  "onboarding.guide.whatsapp.q3": "El nombre no fue aprobado. ¿Y ahora?",
  "onboarding.guide.whatsapp.a3": "Te avisamos aquí, en la tarjeta del número. Envía otro nombre por WhatsApp Manager siguiendo las reglas de Meta: el nombre debe tener relación con la empresa.",
  "onboarding.guide.payment_title": "Medio de pago en Meta",
  "onboarding.guide.payment_text": "Necesaria para enviar plantillas y, a partir del 1 de octubre de 2026, para las respuestas más allá de las 1.000 gratis del mes por número: sin tarjeta, Meta deja de entregarlas. El pago va directo a Meta.",
  "onboarding.guide.payment_cta": "Abrir pagos en Meta",
  "onboarding.guide.payment_partner": "Nuvvun le paga a Meta por ti; no necesitas registrar tarjeta.",
  "onboarding.guide.team.title": "Arma el equipo",
  "onboarding.guide.team.text": "Cada atención nueva entra en una cola y va a quien está en línea y con menos atenciones abiertas.",
  "onboarding.guide.team.roles": "Los roles",
  "onboarding.guide.team.role_operator": "Agente: responde las atenciones de los equipos en los que está.",
  "onboarding.guide.team.role_manager": "Gestor: además, invita personas, publica flujos y asistentes y crea campañas.",
  "onboarding.guide.team.role_admin": "Administrador: configura todo, como tú, incluso números, costos e integraciones.",
  "onboarding.guide.team.suggested": "Equipos sugeridos por el cuestionario",
  "onboarding.guide.team.create": "Crear estos equipos",
  "onboarding.guide.team.created": "Equipos creados. Ahora agrega a las personas en cada uno.",
  "onboarding.guide.team.solo": "Voy a atender solo por ahora",
  "onboarding.guide.team.ready": "Una invitación enviada. Los equipos y el horario son recomendados.",
  "onboarding.guide.outbound.title": "Escríbele primero al cliente",
  "onboarding.guide.outbound.text": "Para retomar una conversación parada o recordar una visita, Meta exige una plantilla aprobada. Empieza con una para retomar y otra de recordatorio.",
  "onboarding.guide.outbound.categories": "Las categorías de Meta",
  "onboarding.guide.outbound.utility": "Utilidad: avisos sobre algo que el cliente ya pidió, como recordatorio, confirmación o estado.",
  "onboarding.guide.outbound.marketing": "Marketing: ofertas y seguimientos. Cuesta más por mensaje, y Meta puede cambiar la categoría en la revisión.",
  "onboarding.guide.outbound.suggested": "Plantillas sugeridas",
  "onboarding.guide.outbound.use": "Usar esta sugerencia",
  "onboarding.guide.outbound.optout": "Baja",
  "onboarding.guide.outbound.optout_text": "Quien escribe una de las palabras de baja (como SALIR o PARAR) deja de recibir plantillas de marketing. Revisa las palabras y, si quieres, escribe una respuesta de confirmación.",
  "onboarding.guide.outbound.optout_cta": "Abrir bajas",
  "onboarding.guide.outbound.ready": "Una plantilla aprobada. Se puede salir en vivo sin ella y volver aquí después.",
  "onboarding.guide.entry.title": "Asistente de IA",
  "onboarding.guide.entry.text": "Responde con el conocimiento de la empresa y llama al equipo cuando hace falta. Publícalo aquí y después elígelo en la etapa Entrada.",
  "onboarding.guide.entry.ready": "Publicado, con conocimiento. Es opcional.",
  "tour.step": "{n} de {total}",
  "tour.skip": "Omitir tour",
  "tour.next": "Siguiente",
  "tour.done": "Empezar a atender",
  "tour.1.title": "Toma una atención de la cola",
  "tour.1.text": "Las atenciones nuevas de tus equipos aparecen aquí. Abre una y toca “Tomar” para quedarte con ella.",
  "tour.2.title": "Responde como en WhatsApp",
  "tour.2.text": "Escribe normalmente. Escribe / para usar una respuesta rápida, con el nombre del cliente ya completado.",
  "tour.3.title": "Transfiere con una nota",
  "tour.3.text": "Si otra persona o equipo debe continuar, transfiere y deja una nota con lo que ya se hizo.",
  "tour.4.title": "Cierra con un resultado",
  "tour.4.text": "Al terminar, elige cómo acabó la atención. Eso alimenta los informes y el aprendizaje.",
  "platform.customer.onboarding": "Implementación",
  "platform.customer.onboarding_live": "En vivo desde el {date}",
  "platform.customer.onboarding_progress": "{done} de {total} etapas · ahora: {stage}",
  "platform.customer.onboarding_pending": "Pendiente: {steps}",
  "platform.customer.onboarding_none": "Aún no empezó",
  "permissions.open": "Permisos",
  "permissions.title": "Permisos de {name}",
  "permissions.lead": "Cada permiso sigue el rol ({role}) o vale solo para esta persona: permitido o denegado.",
  "permissions.readonly": "Solo puedes cambiar los permisos de quien está por debajo de tu rol.",
  "permissions.role_yes": "Rol: sí",
  "permissions.role_no": "Rol: no",
  "permissions.allow": "Permitir",
  "permissions.deny": "Denegar",
  "permissions.exceptions": "1 excepción al rol|{count} excepciones al rol",
  "permissions.group.conversations": "Atenciones",
  "permissions.group.contacts": "Contactos",
  "permissions.group.flows": "Flujos",
  "permissions.group.assistants": "Asistentes de IA",
  "permissions.group.members": "Equipo",
  "permissions.group.channels": "Números y plantillas",
  "permissions.group.policies": "Políticas",
  "permissions.group.other": "Otros",
  "permission.conversations.read": "Ver atenciones",
  "permission.conversations.write": "Responder",
  "permission.conversations.assign": "Asignar a alguien",
  "permission.conversations.transfer": "Transferir y devolver",
  "permission.conversations.close": "Cerrar con resultado",
  "permission.conversations.send_template": "Enviar plantillas (mensajes activos)",
  "permission.contacts.read": "Ver contactos",
  "permission.contacts.write": "Editar e importar contactos",
  "permission.contacts.export": "Exportar contactos",
  "permission.flows.read": "Ver flujos",
  "permission.flows.write": "Editar flujos",
  "permission.flows.publish": "Publicar flujos",
  "permission.assistants.read": "Ver asistentes",
  "permission.assistants.write": "Editar asistentes",
  "permission.assistants.publish": "Publicar asistentes",
  "permission.members.read": "Ver el equipo",
  "permission.members.manage": "Invitar y gestionar personas",
  "permission.channels.read": "Ver números y plantillas",
  "permission.channels.manage": "Conectar números y crear plantillas",
  "permission.policies.read": "Ver políticas",
  "permission.policies.manage": "Editar políticas",
  "permission.reports.read": "Ver informes y monitor",
  "permission.audit.read": "Ver registro de auditoría",
  "permission.settings.manage": "Cambiar la configuración de la empresa",
  "permission.api.use": "Usar la API",
  "errors.permission_above_own_level": "No puedes dar un permiso que tú mismo no tienes.",
  "errors.member_above_own_level": "Esa persona está en tu nivel o por encima.",
  "errors.cannot_modify_self": "No puedes cambiar tus propios permisos.",
  "nav.main": "Navegación principal",
  "common.search": "Buscar",
  "composer.poll.title": "Crear encuesta",
  "composer.poll.question": "Pregunta",
  "composer.poll.question_placeholder": "Haz una pregunta",
  "composer.poll.options": "Opciones",
  "composer.poll.option": "Opción {n}",
  "composer.poll.option_placeholder": "Agregar texto",
  "composer.poll.move_up": "Mover la opción {n} hacia arriba",
  "composer.poll.remove": "Quitar opción {n}",
  "composer.poll.add": "Agregar opción",
  "composer.poll.multiple": "Permitir varias respuestas",
  "composer.poll.anonymous": "Ocultar los nombres de quienes votan",
  "composer.poll.end": "Definir hora de cierre",
  "composer.poll.ends_at": "Cerrar el",
  "composer.event.title": "Crear evento",
  "composer.event.name": "Nombre del evento",
  "composer.event.name_placeholder": "Ej.: Charla sobre el proyecto",
  "composer.event.when": "Fecha y hora",
  "composer.event.description": "Descripción",
  "composer.event.description_placeholder": "Agrega más información",
  "composer.event.call_link": "Enlace de llamada de WhatsApp",
  "composer.contact.title": "Compartir contacto",
  "composer.contact.demo_hint": "Elige un contacto de demostración.",
  "composer.contact.pick": "Contacto para compartir",
  "composer.contact.share": "Compartir",
  "composer.contact.message": "Contacto: {name}",
  "emoji.pick_reaction": "Elegir reacción",
  "emoji.panel": "Emojis, GIF y stickers",
  "emoji.back_to_quick": "Volver a las reacciones rápidas",
  "emoji.close": "Cerrar expresiones",
  "emoji.search_reaction": "Buscar reacción",
  "emoji.search_emoji": "Buscar emoji",
  "emoji.search_gif": "Buscar GIF",
  "emoji.search_sticker": "Buscar stickers",
  "emoji.category.smileys": "Emoticonos y personas",
  "emoji.category.animals": "Animales y naturaleza",
  "emoji.category.food": "Comida y bebida",
  "emoji.category.activities": "Actividades",
  "emoji.category.travel": "Viajes y lugares",
  "emoji.category.objects": "Objetos",
  "emoji.category.symbols": "Símbolos",
  "emoji.category.flags": "Banderas",
  "message.select": "Seleccionar mensaje {text}",
  "message.poll.pick_many": "Selecciona una o más opciones",
  "message.poll.pick_one": "Selecciona una opción",
  "message.see_reactions": "Ver reacciones",
  "message.react": "Reaccionar al mensaje",
  "reaction.quick": "Reacciones rápidas",
  "reaction.with": "Reaccionar con {emoji}",
  "reaction.more": "Más emojis",
  "reaction.error.window": "La ventana de 24 horas se cerró: WhatsApp solo acepta reacciones con ella abierta.",
  "reaction.error.too_old": "WhatsApp solo acepta reacciones en mensajes de hasta 30 días.",
  "reaction.error.not_allowed": "WhatsApp no acepta reacciones en este mensaje.",
  "reaction.error.failed": "No se pudo enviar la reacción.",
  "chat.unread": "1 mensaje no leído|{count} mensajes no leídos",
  "builder.default_option": "Opción {n}",
  "builder.script_default": "// vars: variables del flujo; contact: nombre y campos del contacto\nreturn { resultado: vars.respuesta };",
  "snippets.body_placeholder": "Hola {{contact.first_name}}, soy {{member.first_name}} de {company}.",
  "message.poll.votes": "1 voto|{count} votos",
  "message.poll.anonymous": "Anónima",
  "message.event.going": "Participando",
  "message.event.join": "Voy a participar",
  "auth.forgot": "Olvidé mi contraseña",
  "auth.forgot_help": "Si el correo no llega, pide a un administrador de tu empresa: en Configuración › Equipo genera un enlace para que crees una nueva contraseña.",
  "auth.mfa.title": "Verificación en dos pasos",
  "auth.mfa.lead": "Escribe el código de 6 dígitos que aparece en la app de autenticación de tu celular.",
  "auth.mfa.recovery_lead": "¿Sin el celular? Usa uno de los códigos de recuperación que guardaste. Cada uno funciona una vez.",
  "auth.mfa.code": "Código de la app",
  "auth.mfa.recovery_code": "Código de recuperación",
  "auth.mfa.submit": "Confirmar",
  "auth.mfa.use_recovery": "Usar un código de recuperación",
  "auth.mfa.use_app": "Usar el código de la app",
  "auth.mfa.back": "Entrar con otra cuenta",
  "account.title": "Mi cuenta",
  "account.mfa.title": "Verificación en dos pasos",
  "account.mfa.on": "Activada",
  "account.mfa.off": "Desactivada",
  "account.mfa.on_lead": "Desde el {since}, el ingreso pide el código de la app de autenticación después de la contraseña.",
  "account.mfa.off_lead": "Protege tu cuenta: después de la contraseña, el ingreso pide un código de la app de autenticación del celular (Google Authenticator, Microsoft Authenticator u otra).",
  "account.mfa.enable": "Activar",
  "account.mfa.disable": "Desactivar",
  "account.mfa.disabled": "Verificación en dos pasos desactivada.",
  "account.mfa.regenerate": "Generar nuevos códigos de recuperación",
  "account.mfa.codes_left": "Queda 1 código de recuperación|Quedan {count} códigos de recuperación",
  "account.mfa.code_or_recovery": "Código de la app o de recuperación",
  "account.mfa.setup_title": "Activar la verificación en dos pasos",
  "account.mfa.setup_step1": "Instala una app de autenticación en el celular, si todavía no tienes.",
  "account.mfa.setup_step2": "En la app, agrega una cuenta y lee este código QR con la cámara.",
  "account.mfa.setup_step3": "Escribe el código de 6 dígitos que muestre la app.",
  "account.mfa.qr_label": "Código QR para la app de autenticación",
  "account.mfa.manual": "¿No puedes leerlo? Escribe esta clave en la app:",
  "account.mfa.confirm": "Confirmar y activar",
  "account.mfa.codes_title": "Guarda tus códigos de recuperación",
  "account.mfa.codes_lead": "Si pierdes el celular, cada código abre tu cuenta una vez. No vuelven a aparecer: cópialos o descárgalos y guárdalos en un lugar seguro.",
  "account.mfa.copy": "Copiar",
  "account.mfa.download": "Descargar",
  "account.mfa.done": "Ya los guardé",
  "account.mfa.codes_copied": "Códigos copiados.",
  "account.mfa.codes_file_title": "Códigos de recuperación de DoneTalk · {email}",
  "account.mfa.codes_hint": "Cada código funciona una vez, en lugar del código de la app.",
  "account.password.title": "Contraseña",
  "account.password.change": "Cambiar contraseña",
  "account.password.current": "Contraseña actual",
  "account.password.new": "Nueva contraseña",
  "account.password.confirm": "Repite la nueva contraseña",
  "account.password.hint": "Al menos 10 caracteres, con letras y números.",
  "account.password.save": "Guardar contraseña",
  "account.password.changed": "Contraseña cambiada. Las otras sesiones abiertas se cerraron.",
  "account.password.mismatch": "Las dos contraseñas nuevas no coinciden.",
  "reset.title": "Crear una contraseña nueva",
  "reset.save": "Guardar contraseña",
  "reset.done": "Contraseña creada. Ingresa con ella.",
  "reset.mfa_stays": "La verificación en dos pasos sigue activada.",
  "reset.to_login": "Ir al ingreso",
  "team.reset_link": "Enlace para nueva contraseña",
  "team.reset_link_title": "Enlace para que {name} cree una contraseña nueva",
  "team.reset_link_lead": "Envía este enlace solo a esa persona. Funciona una vez, hasta el {until}, y cierra sus sesiones abiertas.",
  "team.reset_link_copy": "Copiar enlace",
  "team.reset_link_copied": "Enlace copiado.",
  "errors.too_many_attempts": "Demasiados intentos. Espera unos minutos y vuelve a intentar.",
  "errors.mfa_code_invalid": "Código incorrecto. Revisa la app y escribe el código actual.",
  "errors.mfa_code_used": "Ese código ya se usó. Espera a que aparezca el siguiente en la app.",
  "errors.mfa_challenge_expired": "Se acabó el tiempo para el código. Ingresa con la contraseña de nuevo.",
  "errors.mfa_already_enabled": "La verificación en dos pasos ya está activada.",
  "errors.mfa_not_enabled": "La verificación en dos pasos no está activada.",
  "errors.mfa_not_set_up": "Empieza la activación de nuevo para generar el código QR.",
  "errors.current_password_wrong": "La contraseña actual es incorrecta.",
  "errors.password_reset_invalid": "Este enlace ya no sirve: ya se usó o pasaron más de 24 horas. Pide uno nuevo al administrador.",
  "errors.password_reset_needs_support": "Esa persona también usa la plataforma en otra empresa. Por seguridad, solo el soporte de Nuvvun puede generar la nueva contraseña.",
  "errors.invite_not_found": "Esta invitación ya no existe. Pide una nueva a quien te invitó.",
  "errors.invite_expired": "Esta invitación venció. Pide una nueva a quien te invitó.",
  "errors.already_member": "Ya eres miembro de este cliente: abre el workspace directamente.",
  "errors.member_not_found": "Esa persona ya no está en el equipo.",
  "errors.user_blocked": "Este acceso está bloqueado.",
  "errors.session_invalid": "Tu sesión terminó. Ingresa de nuevo.",
  "platform.access.mfa_reset": "Desactivar la verificación en dos pasos",
  "platform.access.mfa_title": "Desactivar la verificación en dos pasos de {name}",
  "platform.access.mfa_lead": "Solo para quien perdió el celular y los códigos de recuperación, después de confirmar quién es por otro canal. Sus sesiones abiertas terminan y la vuelve a activar en Mi cuenta.",
  "platform.access.mfa_confirm": "Desactivar",
  "platform.access.mfa_done": "Verificación en dos pasos de {name} desactivada.",
  "platform.access.password_lead": "El enlace sirve una vez, por 24 horas, y cierra sus sesiones abiertas. Envíalo solo a esa persona, después de confirmar quién es.",
  "platform.access.password_confirm": "Generar enlace",
  "platform.access.reason": "Motivo (queda en la auditoría)",
  "platform.access.reason_placeholder": "Ej.: lo pidió por el WhatsApp de soporte, confirmado por llamada",
  "errors.platform_super_required": "Solo un administrador general de la plataforma puede hacer esto con alguien del equipo de Nuvvun.",
  "errors.user_not_found": "Esa persona ya no existe.",
  "security.title": "Protege tu cuenta",
  "security.lead": "Quien es gestor, administrador o dueño necesita la verificación en dos pasos: después de la contraseña, el ingreso pide un código de la app de autenticación del celular. Toma un minuto.",
  "security.leave": "Salir ({email})",
  "errors.mfa_required": "Activa la verificación en dos pasos para continuar.",
  "settings.privacy": "Datos y privacidad",
  "privacy.retention.title": "Cuánto tiempo guardar",
  "privacy.retention.lead": "Pasado el plazo, el contenido se va y los números quedan: las atenciones siguen en los informes, con tiempos, desenlaces y costos, sin los mensajes, los archivos ni las notas. El plazo de los mensajes cuenta desde que concluye la atención.",
  "privacy.retention.messages": "Mensajes",
  "privacy.retention.media": "Fotos, audios, videos y documentos",
  "privacy.retention.audit": "Registro de auditoría",
  "privacy.retention.technical": "Las copias técnicas (avisos brutos de Meta, entregas de webhooks y búsquedas en la base de conocimiento) quedan de 30 a 90 días. La auditoría guarda al menos 6 meses.",
  "privacy.retention.last_run": "Última limpieza: {when} · {conversations} atenciones y {files} archivos",
  "privacy.keep.forever": "Guardar siempre",
  "privacy.keep.years": "1 año|{count} años",
  "privacy.keep.days": "1 día|{count} días",
  "privacy.export.title": "Exportación completa",
  "privacy.export.lead": "Un archivo ZIP con todos los datos de la empresa: contactos, atenciones con los mensajes, equipo, plantillas, flujos, asistentes, base de conocimiento y auditoría. Queda disponible 7 días. Contraseñas y claves nunca van incluidas.",
  "privacy.export.media": "Incluir fotos, audios, videos y documentos",
  "privacy.export.request": "Generar exportación",
  "privacy.export.requested": "Exportación solicitada. Aparece aquí cuando esté lista.",
  "privacy.export.with_media": "con archivos",
  "privacy.export.until": "disponible hasta el {when}",
  "privacy.export.download": "Descargar",
  "privacy.export.status.queued": "En cola",
  "privacy.export.status.running": "Generando",
  "privacy.export.status.ready": "Lista",
  "privacy.export.status.failed": "Falló",
  "privacy.export.status.expired": "Vencida",
  "privacy.subjects.title": "Solicitudes de los titulares",
  "privacy.subjects.lead": "Para atender a quien pide una copia de sus datos o su eliminación, abre el contacto: al final del panel están Exportar datos y Borrar datos.",
  "contact.privacy": "Privacidad",
  "contact.export_data": "Exportar datos de este contacto",
  "contact.erase.open": "Borrar datos de este contacto",
  "contact.erase.title": "Borrar los datos de {name}",
  "contact.erase.lead": "Úsalo cuando la propia persona pida la eliminación de sus datos. No se puede deshacer.",
  "contact.erase.goes": "Se va: nombre, número, campos, etiquetas, todos los mensajes, archivos y notas.",
  "contact.erase.stays": "Queda: las atenciones en los informes, sin nada que identifique a la persona.",
  "contact.erase.confirm": "La persona lo pidió y entiendo que no se puede deshacer",
  "contact.erase.submit": "Borrar datos",
  "contact.erase.done": "Datos del contacto borrados.",
  "message.purged": "Contenido eliminado por la política de privacidad",
  "errors.contact_has_open_conversation": "Concluye la atención abierta de este contacto antes de borrar los datos.",
  "errors.contact_not_found": "Ese contacto ya no existe.",
  "errors.export_in_progress": "Ya hay una exportación en curso. Espera a que termine.",
  "errors.export_not_ready": "Esa exportación todavía no está lista o ya venció.",
  "errors.export_not_found": "Esa exportación ya no existe.",
  "errors.export_too_large": "La exportación superó 2 GB. Genérala sin los archivos o habla con soporte.",
  "numbers.app.title": "WhatsApp Business en el celular",
  "numbers.app.lead": "El número sigue en la app del celular. Lo que se envíe desde allí aparece aquí, y Meta copia una vez los contactos y las conversaciones de los últimos 180 días, si la empresa lo aceptó en la app.",
  "numbers.app.contacts": "Contactos de la agenda",
  "numbers.app.history": "Conversaciones anteriores",
  "numbers.app.not_requested": "Aún no solicitado",
  "numbers.app.requested": "Solicitado a Meta, llegando",
  "numbers.app.running": "Copiando: {progress}%",
  "numbers.app.contacts_done": "1 contacto recibido|{count} contactos recibidos",
  "numbers.app.history_done": "Listo · 1 mensaje|Listo · {count} mensajes",
  "numbers.app.declined": "La empresa no compartió el historial en la app",
  "numbers.app.failed": "Meta no aceptó la solicitud",
  "numbers.app.retry": "Pedir de nuevo",
  "errors.app_sync_expired": "Meta solo entrega la copia de la app en las primeras 24 horas después de conectar. Para tenerla de nuevo, desconecta en la app y conecta otra vez.",
  "errors.not_coexistence": "Ese número no está en la app WhatsApp Business.",
  "message.deleted_text": "Mensaje eliminado",
  "message.from_phone": "Enviado desde el celular",
  "contact.history_app": "Historial de WhatsApp Business",
  "deletion.title": "Solicitud de eliminación de datos",
  "deletion.received": "Recibimos tu solicitud (código {code}) el {when}.",
  "deletion.done": "Concluido: DoneTalk no guarda datos de tu perfil de Facebook. Al conectar un número, solo queda con la empresa el acceso a su cuenta de WhatsApp Business.",
  "deletion.business": "Las conversaciones de WhatsApp pertenecen a la empresa que te atiende. Para pedir su eliminación, habla con la empresa; para desconectar un número, ella usa Configuración › Números o el WhatsApp Manager de Meta.",
  "deletion.not_found": "No encontramos una solicitud con el código {code}.",
  "errors.deletion_request_not_found": "Solicitud no encontrada.",
  "crm.note.title": "Atención por WhatsApp",
  "crm.note.outcome": "Desenlace: {outcome}",
  "crm.note.attendant": "Agente: {name}",
  "crm.note.team": "Equipo: {name}",
  "crm.note.goal": "Objetivo: {goal}",
  "crm.note.summary": "Resumen",
  "crm.note.messages": "Mensajes: {inbound} del contacto, {outbound} de la empresa",
  "crm.note.open": "Abrir la atención en DoneTalk",
  "crm.title": "CRM",
  "crm.lead": "Conecta OutboundPro o Pipedrive: cada atención concluida se vuelve una nota en la persona (y en su negocio abierto), y el panel del contacto muestra los negocios abiertos.",
  "crm.kind.outboundpro": "OutboundPro",
  "crm.kind.pipedrive": "Pipedrive",
  "crm.provider": "CRM",
  "crm.token": "Token de la API",
  "crm.token_hint.outboundpro": "En OutboundPro, en Configuración › API y tokens.",
  "crm.token_hint.pipedrive": "En Pipedrive, en Preferencias personales › API.",
  "crm.token_kept": "Token guardado. Déjalo en blanco para mantener el actual.",
  "crm.base_url": "Dirección de la API",
  "crm.create_persons": "Crear la persona en el CRM cuando el número no esté allí",
  "crm.log_conversations": "Registrar cada atención concluida como nota",
  "crm.deal_outcome": "Un desenlace de éxito marca el negocio abierto como ganado; uno negativo, como perdido",
  "crm.connect": "Conectar",
  "crm.save": "Guardar",
  "crm.remove": "Desconectar",
  "crm.connected_as": "Conectado como {user}",
  "crm.status.active": "Activo",
  "crm.status.error": "Con error",
  "crm.tasks": "{done} atenciones registradas en la última semana · {pending} en cola",
  "crm.dead": "1 atención no se pudo registrar|{count} atenciones no se pudieron registrar",
  "crm.last_error": "Último error: {error}",
  "crm.saved": "CRM conectado.",
  "crm.removed": "CRM desconectado.",
  "crm.card.title": "En {crm}",
  "crm.card.none": "Ese número todavía no está en {crm}.",
  "crm.card.create": "Crear persona en {crm}",
  "crm.card.deals": "Negocios abiertos",
  "crm.card.no_deals": "Ningún negocio abierto.",
  "crm.card.open": "Abrir en {crm}",
  "crm.card.error": "No fue posible hablar con {crm} ahora.",
  "errors.crm_token_rejected": "El CRM rechazó ese token. Revisa que lo copiaste entero y que sigue vigente.",
  "errors.crm_unreachable": "No fue posible hablar con el CRM. Revisa la dirección e intenta de nuevo.",
  "errors.crm_address_refused": "Esa dirección no se puede usar.",
  "errors.crm_error": "El CRM respondió con un error.",
  "errors.connector_not_found": "Ese conector ya no existe.",
  "templates.header.kind": "Tipo de encabezado",
  "templates.header.text": "Texto",
  "templates.header.image": "Imagen",
  "templates.header.video": "Video",
  "templates.header.document": "Documento",
  "templates.header.sample_none": "Ningún archivo de ejemplo",
  "templates.header.sample_kept": "Archivo de ejemplo guardado",
  "templates.header.sample_choose": "Elegir archivo",
  "templates.header.sample_hint_image": "JPG o PNG hasta 5 MB. Meta usa el ejemplo para aprobar; en cada envío va la imagen que elijas.",
  "templates.header.sample_hint_video": "MP4 hasta 16 MB. Meta usa el ejemplo para aprobar; en cada envío va el video que elijas.",
  "templates.header.sample_hint_document": "PDF hasta 100 MB. Meta usa el ejemplo para aprobar; en cada envío va el documento que elijas.",
  "templates.issue.header_media_sample_missing": "Elige un archivo de ejemplo: Meta lo necesita para aprobar.",
  "templates.issue.header_media_type": "Ese tipo de archivo no sirve para este encabezado.",
  "templates.issue.header_media_too_large": "El archivo supera el límite de este tipo.",
  "templates.issue.header_conflict": "El encabezado es de texto o de medio, no de ambos.",
  "template.header_file": "Archivo del encabezado",
  "template.header_file_hint": "Esta plantilla empieza con {kind}: elige el archivo de este envío.",
  "template.header_file_choose": "Elegir archivo",
  "errors.template_sample_missing": "El archivo de ejemplo del encabezado ya no está. Elígelo de nuevo antes de enviar a Meta.",
  "errors.header_media_required": "Elige el archivo del encabezado de esta plantilla.",
  "platform.customer.billing_unavailable": "La línea de crédito de socio estará disponible cuando la solución con un Socio de Soluciones de Meta esté registrada.",
  "platform.customer.billing_stale": "Este cliente está marcado con la línea de crédito de socio, pero no hay ninguna solución registrada: Meta sigue pidiendo su tarjeta. Guarda para volver a la tarjeta del cliente.",
  "errors.meta_solution_missing": "Registra la solución con el Socio de Soluciones de Meta antes de usar la línea de crédito de socio.",
  "contact.ai_cost": "Costo de IA",
  "contact.ai_cost_hint": "Llamadas de IA de esta atención (asistente, resúmenes y revisión de mensajes), en dólares, como cobran los proveedores.",
  "tags.color.blue": "Azul",
  "tags.color.green": "Verde",
  "tags.color.yellow": "Amarillo",
  "tags.color.red": "Rojo",
  "tags.color.purple": "Morado",
  "tags.color.light_gray": "Gris claro",
  "tags.color.brown": "Marrón",
  "tags.color.orange": "Naranja",
  "tags.color.dark_gray": "Gris oscuro",
  "tags.color.pink": "Rosa",
  "tags.color.custom": "Otro color",
  "onboarding.org.add_snippet": "Añadir respuesta",
  "onboarding.org.snippet_shortcut": "atajo",
  "onboarding.org.snippet_body": "Texto de la respuesta",
  "integrations.event.contact.consent_changed": "Consentimiento modificado",
  "integrations.event.message.delivered": "Mensaje entregado",
  "integrations.event.message.read": "Mensaje leído",
  "integrations.event.message.failed": "Mensaje con error",
  "errors.integration_template_only": "Por la API solo se pueden enviar plantillas aprobadas. Los textos y archivos los envían personas y pasan por la revisión de mensajes.",
  "errors.members_only": "Solo una persona del equipo puede hacer esto; una clave de API no.",
  "event.gate_held_assistant": "La revisión de mensajes retuvo una respuesta del asistente y pasó la atención a una persona: “{draft}”",
  "event.gate_held_flow": "La revisión de mensajes retuvo un mensaje del flujo y pasó la atención a una persona: “{draft}”",
  "inbox.gate_logged": "Enviado. La revisión de mensajes marcó este mensaje para que lo vea el gerente.",
  "policy.gate.shadow_of": "Modo que está calibrando",
  "policy.gate.shadow_hint": "En sombra, los mensajes salen como fueron escritos y nadie ve nada. La revisión anota lo que el modo elegido habría hecho; los números están en Informes › Revisión de mensajes.",
  "reports.gate.action.held": "Retenido y pasado a una persona",
  "reports.gate.action.shadowed": "Evaluado en sombra",
  "reports.gate.authors": "Quién escribió",
  "reports.gate.author.member": "Personas",
  "reports.gate.author.assistant": "Asistente",
  "reports.gate.author.flow": "Flujos",
  "reports.gate.shadow": "En sombra",
  "reports.gate.shadow_hint": "Lo que el modo en calibración habría hecho con los mensajes evaluados en sombra.",
  "reports.gate.simulated.pass": "Lo habría enviado tal cual",
  "reports.gate.simulated.rewrite": "Lo habría enviado corregido",
  "reports.gate.simulated.review": "Habría pedido revisión",
  "reports.gate.simulated.block": "Lo habría bloqueado",
  "weekday.short.sun": "dom",
  "weekday.short.mon": "lun",
  "weekday.short.tue": "mar",
  "weekday.short.wed": "mié",
  "weekday.short.thu": "jue",
  "weekday.short.fri": "vie",
  "weekday.short.sat": "sáb",
  "node.template": "Enviar plantilla",
  "node.field.template": "Plantilla aprobada",
  "node.template.none": "Aún no hay plantillas aprobadas. Créalas y envíalas a Meta en Configuración › Plantillas de mensaje.",
  "node.template.variable": "Valor de {{{name}}}",
  "node.template.header_link": "Enlace público del archivo del encabezado",
  "node.template.button": "Final del enlace del botón {n}",
  "node.template.hint": "Las plantillas se pueden enviar incluso después de las 24 horas. Usa {{contact.name}} o {{vars.x}} en los valores.",
  "node.wait.mode": "Esperar",
  "node.wait.mode.seconds": "Un tiempo",
  "node.wait.mode.until": "Hasta una fecha y hora",
  "node.wait.mode.at": "Hasta una hora del día",
  "node.wait.amount": "Cuánto tiempo",
  "node.wait.unit": "Unidad",
  "node.wait.unit.minutes": "minutos",
  "node.wait.unit.hours": "horas",
  "node.wait.unit.days": "días",
  "node.wait.until": "Fecha y hora",
  "node.wait.until_hint": "Una variable con la fecha, como {{vars.fecha_visita}} o {{contact.fields.retorno}}. Acepta 02/10/2026 15:30, solo la fecha (a las 9h) o el formato ISO. Una fecha pasada sigue en el acto.",
  "node.wait.at": "Hora",
  "node.wait.weekdays": "Días de la semana",
  "node.wait.time_zone": "Zona horaria",
  "builder.exit_invalid_date": "Fecha inválida",
  "builder.wait_until_summary": "hasta {when}",
  "builder.wait_at_summary": "hasta las {time}",
  "builder.wait_at_days_summary": "hasta las {time} · {days}",
  "builder.wait_minutes": "{n} min",
  "builder.wait_hours": "{n} h",
  "builder.wait_days": "{n} días",
  "builder.flow_settings": "Configuración del flujo",
  "builder.exception_target": "Si hay un error, ir a",
  "builder.exception_none": "Terminar el flujo",
  "builder.inactivity_minutes": "Tiempo límite de respuesta (minutos)",
  "builder.timeout_target": "Después del tiempo límite, ir a",
  "builder.timeout_end": "Terminar el flujo",
  "builder.inactivity_hint": "Vale para menús y preguntas: si el contacto no responde en ese tiempo, el flujo sigue por el camino elegido. 0 lo desactiva.",
  "simulator.template": "Envía la plantilla {name}",
  "simulator.assistant": "El asistente toma la conversación",
  "simulator.wait": "Espera hasta {until}",
  "simulator.transfer": "Pasa a una persona",
  "simulator.close": "Cierra con el resultado {outcome}",
  "simulator.vars": "Variables:",
  "simulator.no_vars": "ninguna",
  "simulator.assistant_waiting": "Aquí el asistente conversaría con el contacto.",
  "simulator.assistant_done": "Terminar el asistente y seguir",
  "assistant.versions": "Versiones publicadas",
  "assistant.version": "Versión {n}",
  "assistant.version_active": "En uso",
  "assistant.restore": "Restaurar",
  "assistant.restored": "La versión {from} vuelve a valer como versión {n}.",
  "context.from": "Del sistema: {source}",
  "context.open": "Abrir en el sistema",
  "context.updated": "Actualizado el {when}",
  "simulator.status.running": "en curso",
  "simulator.status.waiting": "esperando al contacto",
  "simulator.status.completed": "terminado",
  "simulator.status.failed": "se detuvo con un error",
  "simulator.status.handed_off": "con una persona",
  "assistant.tool.transfer_to_human": "Pasar a una persona",
  "assistant.tool.close_conversation": "Cerrar con resultado",
  "assistant.tool.set_contact_field": "Guardar dato del contacto",
  "assistant.tool.end_assistant": "Devolver al flujo",
  "assistant.tool.start_flow": "Iniciar un flujo",
  "assistant.tool_hint.transfer_to_human": "Cuando el contacto pide una persona, está molesto o el pedido está fuera de lo que puede hacer el asistente.",
  "assistant.tool_hint.close_conversation": "Cuando se alcanzó el objetivo o el contacto rechazó con claridad.",
  "assistant.tool_hint.set_contact_field": "Guarda lo que informó el contacto (nombre, documento, e-mail, preferencia).",
  "assistant.tool_hint.end_assistant": "Dentro de un flujo: termina la parte del asistente y el flujo sigue.",
  "assistant.tool_hint.start_flow": "Llama a un flujo para una tarea con guion (agendar, completar un registro, pagar).",
  "assistant.start_flow_hint": "Quedan disponibles los flujos publicados marcados con “El asistente de IA puede iniciar este flujo” (en el constructor, en Disparadores).",
  "builder.assistant_tool": "El asistente de IA puede iniciar este flujo",
  "builder.assistant_tool_when": "Cuándo debe usarlo el asistente",
  "builder.assistant_tool_placeholder": "Ej.: cuando el contacto quiera agendar una visita",
  "contact.ad": "Anuncio",
  "reports.by_source": "Por origen",
  "reports.by_ad": "Por anuncio",
  "reports.col.source": "Origen",
  "reports.col.opened": "Abiertas",
  "reports.col.ad": "Anuncio",
  "email.greeting": "¡Hola, {name}!",
  "email.signature": "Equipo DoneTalk",
  "email.reset.subject": "Crea una nueva contraseña en DoneTalk",
  "email.reset.body": "Recibimos un pedido para crear una nueva contraseña en tu cuenta. Usa el botón de abajo para elegirla.",
  "email.reset.button": "Crear nueva contraseña",
  "email.reset.expires": "El enlace vale por {count} hora y solo se puede usar una vez.|El enlace vale por {count} horas y solo se puede usar una vez.",
  "email.reset.ignore": "Si no lo pediste, ignora este correo: tu contraseña sigue igual.",
  "email.invite.subject": "{inviter} te invitó a {workspace} en DoneTalk",
  "email.invite.body": "{inviter} te invitó a atender a los clientes de {workspace} por WhatsApp en DoneTalk. Acepta la invitación y crea tu contraseña.",
  "email.invite.button": "Aceptar invitación",
  "email.invite.expires": "La invitación vale por {count} día.|La invitación vale por {count} días.",
  "auth.forgot_lead": "Enviamos un enlace al correo de arriba. Con él creas una nueva contraseña.",
  "auth.forgot_send": "Enviar enlace por correo",
  "auth.forgot_sent": "Si hay una cuenta con {email}, el enlace ya está en camino. Vale por 1 hora.",
  "auth.forgot_email_first": "Escribe primero tu correo arriba.",
  "team.invite_emailed": "Invitación enviada a {email}. El enlace de abajo también sirve.",
  "inbox.view.mentions": "Menciones",
  "message.forward": "Reenviar",
  "message.pin": "Fijar",
  "message.unpin": "Desfijar",
  "message.remove": "Eliminar",
  "message.restore": "Restaurar mensaje",
  "message.restored": "Mensaje restaurado",
  "message.removed_by": "Eliminado por {name} · {when}",
  "message.removed_show": "Ver el mensaje eliminado",
  "message.removed_hide": "Ocultar el mensaje eliminado",
  "message.someone": "alguien del equipo",
  "message.pinned_label": "Mensaje fijado",
  "pin.banner": "Ir al mensaje fijado",
  "pin.done": "Mensaje fijado para el equipo. El contacto no lo ve.",
  "pin.undone": "Mensaje desfijado",
  "pin.not_loaded": "Ese mensaje fijado es antiguo y no está cargado en la conversación.",
  "selection.count": "1 elemento seleccionado|{count} elementos seleccionados",
  "selection.cancel": "Cancelar selección",
  "remove.title": "¿Eliminar el mensaje?|¿Eliminar {count} mensajes?",
  "remove.hint": "Desaparece de esta conversación para el equipo y queda registrado quién lo eliminó y cuándo. El contacto lo sigue viendo en su WhatsApp: Meta no permite eliminarlo allí.",
  "remove.confirm": "Eliminar",
  "remove.done": "Mensaje eliminado|{count} mensajes eliminados",
  "forward.title": "Reenviar mensaje|Reenviar {count} mensajes",
  "forward.search": "Buscar conversación o colega",
  "forward.chats": "Conversaciones",
  "forward.chats_hint": "Aparecen las conversaciones abiertas con la ventana de 24 horas abierta: fuera de ella, WhatsApp solo acepta plantillas.",
  "forward.no_chats": "Ninguna conversación con la ventana abierta ahora.",
  "forward.team": "Equipo",
  "forward.team_hint": "Lo recibe en una nota de esta conversación",
  "forward.comment": "Mensaje para el colega (opcional)",
  "forward.send": "Reenviar",
  "forward.done": "Reenviado a 1 destino.|Reenviado a {count} destinos.",
  "forward.failed": "No se envió a {name}: {reason}.",
  "forward.reason.window": "la ventana de 24 horas se cerró",
  "forward.reason.closed": "la conversación se cerró",
  "forward.held": "Algunos mensajes quedaron en la revisión de mensajes y no se enviaron.",
  "forward.received": "{name} te reenvió mensajes. Míralos en Menciones.",
  "notes.forwarded_to": "Reenviado a {names}",
  "permission.conversations.view_hidden": "Ver mensajes eliminados",
  "event.info.open": "Datos del evento",
  "event.info.title": "Datos del evento",
  "event.info.who": "Quién",
  "event.info.when": "Cuándo",
  "event.info.from": "De",
  "event.info.to": "A",
  "event.info.reason": "Motivo",
  "event.info.note": "Nota",
  "event.info.until": "Hasta",
  "event.info.outcome": "Resultado",
  "event.info.queue": "Cola",
  "event.actor.contact": "El contacto",
  "event.actor.flow": "Flujo automático",
  "event.actor.assistant": "Asistente de IA",
  "event.actor.api": "Integración",
  "event.actor.policy": "Regla automática",
  "event.actor.system": "DoneTalk (automático)",
  "event.reason.first_reply": "Respondió primero",
  "event.reason.self": "Tomó la conversación",
  "event.reason.distribution": "Distribución automática",
  "event.reason.manual": "Asignación manual",
  "event.reason.integration": "Integración",
  "event.reason.business_app_reply": "Respondió desde la app WhatsApp Business",
  "composer.voice_preview_pause": "Pausar la escucha",
  "inbox.row_options": "Opciones de la conversación con {name}",
  "permission.conversations.send_marketing": "Enviar plantilla de marketing individual",
  "permission.campaigns.read": "Ver campañas",
  "permission.campaigns.write": "Crear y editar campañas",
  "permission.campaigns.start": "Iniciar, pausar y cancelar campañas",
  "permission.campaigns.approve": "Aprobar campañas",
  "permission.costs.read": "Ver costos",
  "permission.costs.manage": "Cambiar presupuestos y límites de gasto",
  "permissions.group.campaigns": "Campañas",
  "permissions.group.costs": "Costos",
  "email.cost_alert.subject": "DoneTalk · {workspace}: {title}",
  "email.cost_alert.cta": "Ver los costos",
  "email.cost_alert.why": "Recibes este aviso porque sigues los costos de la empresa en DoneTalk. Quién lo recibe se define en Configuración › Costos y límites.",
  "cost.scope.company": "La empresa",
  "cost.scope.team": "El equipo {name}",
  "cost.alert.budget_threshold.title": "{scope} superó el {threshold}% del presupuesto del mes",
  "cost.alert.budget_threshold.text": "{spent} de {amount} gastados este mes.",
  "cost.alert.forecast_over.title": "{scope} debería superar el presupuesto el día {day}",
  "cost.alert.forecast_over.text": "Al ritmo actual, el mes cierra en {forecast} para un presupuesto de {amount}.",
  "cost.alert.daily_spike.title": "El gasto de hoy es {factor}× lo normal",
  "cost.alert.daily_spike.text": "{spent} hasta ahora; lo normal para este día de la semana es {usual}.",
  "cost.alert.category_changed.title": "Una plantilla cambió de categoría",
  "cost.alert.category_changed.text": "Meta pasó “{name}” de {from} a {to}: cada envío cuesta más. Se envió {volume} veces en los últimos 30 días.",
  "cost.alert.campaign_costly.title": "Campaña cara por respuesta",
  "cost.alert.campaign_costly.text": "“{name}” cuesta {perReply} por respuesta; el promedio de las campañas es {average}.",
  "errors.marketing_not_allowed": "No tienes permiso para enviar plantillas de marketing. Pide a un gestor.",
  "errors.budget_limit_reached": "El presupuesto del mes se agotó: este envío necesita a quien aprueba campañas.",
  "nav.campaigns": "Campañas",
  "settings.costs": "Costos y límites",
  "reports.tab.costs": "Costos",
  "reports.period.last_month": "Mes pasado",
  "reports.period.90d": "Últimos 90 días",
  "costs.view.overview": "Resumen",
  "costs.view.meta": "Estimado × Meta",
  "costs.view.trends": "Tendencias y alertas",
  "costs.mixed_currencies": "Hay números cobrados en otra moneda: los valores de abajo suman solo los cobrados en {currency}.",
  "costs.kpi.meta": "Costo Meta",
  "costs.kpi.delta": "{delta}% frente al período anterior",
  "costs.kpi.confirmed": "{value} confirmado por Meta",
  "costs.kpi.ai": "IA",
  "costs.kpi.ai_no_rate": "En dólares: la cotización de hoy aún no llegó",
  "costs.kpi.per_conversation": "Por atención",
  "costs.kpi.conversations": "1 atención con respuesta|{count} atenciones con respuesta",
  "costs.kpi.per_success": "Por venta",
  "costs.kpi.successes": "1 desenlace de éxito|{count} desenlaces de éxito",
  "costs.kpi.forecast": "Previsión del mes",
  "costs.kpi.forecast_hint": "{spent} en {day} de {days} días",
  "costs.daily": "Costo por día",
  "costs.previous_period": "Período anterior",
  "costs.who": "Quién generó el costo",
  "costs.by.source": "Origen",
  "costs.by.team": "Equipo",
  "costs.by.channel": "Número",
  "costs.by.member": "Persona",
  "costs.source.campaign": "Campañas",
  "costs.source.member": "Personas",
  "costs.source.flow": "Flujos",
  "costs.source.assistant": "Asistente",
  "costs.source.api": "Integraciones y API",
  "costs.source.system": "Sistema",
  "costs.no_team": "Sin equipo",
  "costs.templates": "Plantillas que más costaron",
  "costs.col.template": "Plantilla",
  "costs.col.category": "Categoría",
  "costs.col.charged": "Cobradas",
  "costs.col.cost": "Costo",
  "costs.col.day": "Día",
  "costs.col.estimated": "Estimado en el momento",
  "costs.col.meta": "Valor de Meta",
  "costs.col.difference": "Diferencia",
  "costs.col.status": "Situación",
  "costs.projection.badge": "Desde el 01/10",
  "costs.projection.title": "Con el nuevo cobro, responder costaría {value}",
  "costs.projection.text": "El período tuvo {messages} mensajes de servicio. {free} serían gratis ({numbers} números × 1.000 al mes); {chargeable} se cobrarían.",
  "costs.top_conversations": "Atenciones más caras",
  "costs.period_note": "Costos por el día en que Meta cobró (la entrega), del {from} al {to}. El valor confirmado por Meta reemplaza al estimado al día siguiente.",
  "costs.meta.days": "Día a día",
  "costs.meta.last_sync": "Meta consultada el {at}",
  "costs.meta.never": "Meta aún no fue consultada",
  "costs.meta.sync": "Consultar ahora",
  "costs.meta.synced": "Meta consultada: 1 grupo confirmado|Meta consultada: {count} grupos confirmados",
  "costs.meta.sync_errors": "Meta no respondió para 1 cuenta|Meta no respondió para {count} cuentas",
  "costs.meta.status.confirmed": "Confirmado",
  "costs.meta.status.partial": "1 mensaje sin cifra de Meta|{count} mensajes sin cifra de Meta",
  "costs.meta.status.estimated": "Estimado",
  "costs.meta.status.no_cost": "Meta no informa el valor",
  "costs.meta.empty": "Ningún mensaje cobrado en el período.",
  "costs.meta.how": "Cómo llega el valor",
  "costs.meta.how_1": "Al instante: Meta dice la categoría de cada mensaje entregado y si se cobró; DoneTalk lo calcula con la tabla pública del mercado del contacto.",
  "costs.meta.how_2": "Al día siguiente: el informe de precios de Meta trae el valor por día, número, país y categoría. Reemplaza al estimado y reparte la diferencia entre los mensajes del día.",
  "costs.meta.how_3": "En el mes: la factura de Meta es la referencia final. Los descuentos por volumen en utilidad y autenticación solo aparecen aquí y en la factura.",
  "costs.meta.credit_line": "Si la empresa paga a Meta con la línea de crédito de un socio, Meta no informa el valor: queda el estimado.",
  "costs.meta.quota": "Mensajes de servicio gratis este mes",
  "costs.meta.quota_used": "{used} de {free}",
  "costs.meta.quota_over": "Se agotaron los {free} gratis",
  "costs.meta.quota_hint": "Desde el 01/10/2026 cada número tiene 1.000 mensajes de servicio gratis al mes, sin acumular. Después, cada respuesta se cobra.",
  "costs.meta.tiers": "Tramo de volumen",
  "costs.meta.tier_open": "desde {from}",
  "costs.meta.tier_range": "{from} a {to}",
  "costs.meta.tiers_hint": "Meta descuenta utilidad y autenticación cuando el volumen del mes supera ciertos tramos, sumando todas las cuentas de la empresa en Meta.",
  "costs.trends.months": "Costo por mes",
  "costs.trends.meta": "Meta",
  "costs.trends.ai": "IA",
  "costs.trends.forecast": "Previsión",
  "costs.trends.forecast_hint": "El mes debería cerrar en {value} al ritmo actual ({day} de {days} días).",
  "costs.save.title": "Dónde ahorrar",
  "costs.save.split_title": "Las respuestas partidas cuestan.",
  "costs.save.split_text": "Cada respuesta sale en {perReply} mensajes en promedio. Después de los 1.000 gratis del mes, unirlas ahorraría cerca de {value} al mes.",
  "costs.save.ads_title": "Anuncios de clic a WhatsApp:",
  "costs.save.ads_text": "las 72 horas después del anuncio son gratis, plantillas incluidas. 1 atención vino de un anuncio en los últimos 30 días.|las 72 horas después del anuncio son gratis, plantillas incluidas. {count} atenciones vinieron de anuncios en los últimos 30 días.",
  "costs.save.utility_title": "Utilidad cuesta 9× menos que marketing.",
  "costs.save.utility_text": "Avisos de cuota, pedido y agenda deben ser utilidad; Meta decide la categoría y puede cambiarla.",
  "costs.save.quota_title": "Cada número tiene 1.000 respuestas gratis al mes.",
  "costs.save.quota_text": "Se sigue en Estimado × Meta.",
  "costs.alerts.title": "Alertas",
  "costs.alerts.dismiss": "Descartar alerta",
  "costs.alerts.none": "Ninguna alerta abierta.",
  "costs.settings.lead": "Gobierno del gasto: cuánto puede gastar cada área por mes, a quién se avisa y qué pasa en el límite. Todo queda en la auditoría.",
  "costs.settings.budgets": "Presupuesto del mes · Meta + IA",
  "costs.settings.budgets_lead": "En reales, sumando lo que cobró Meta y la IA al dólar de hoy. Sin presupuesto, nada se limita.",
  "costs.settings.spent": "{spent} de {amount}",
  "costs.settings.forecast": "Previsión: {value} a fin de mes",
  "costs.settings.monthly": "Por mes (R$)",
  "costs.settings.team": "Equipo",
  "costs.settings.add_team": "Agregar equipo",
  "costs.settings.campaign_budget": "Cada campaña puede tener su propio presupuesto, definido en ella.",
  "costs.settings.saved": "Guardado.",
  "costs.settings.limit": "Cuando el presupuesto llega al 100%",
  "costs.limit.notify": "Solo avisar",
  "costs.limit.notify_hint": "Nada se detiene. Bueno para empezar y entender el gasto.",
  "costs.limit.pause_campaigns": "Pausar campañas y retener marketing individual",
  "costs.limit.pause_campaigns_hint": "Las campañas se pausan; una plantilla de marketing individual solo sale por quien aprueba campañas. Recomendado.",
  "costs.limit.pause_paid": "Pausar todo envío pago que no sea respuesta",
  "costs.limit.pause_paid_hint": "Campañas, flujos y plantillas individuales se detienen hasta que alguien que aprueba campañas los libere.",
  "costs.settings.never_blocked": "Nunca se detienen: respuestas dentro de la atención y códigos de acceso. El cliente que escribió siempre recibe respuesta.",
  "costs.settings.alerts": "Avisos",
  "costs.settings.who_hears": "Quién los recibe, además del aviso en la pantalla de costos:",
  "costs.settings.email": "También por correo",
  "costs.settings.approval": "Aprobación de campaña",
  "costs.settings.approval_on": "Pedir aprobación antes de campañas grandes",
  "costs.settings.approval_amount": "Cuando la campaña pueda costar más de (R$)",
  "costs.settings.approval_audience": "O vaya a más de (personas)",
  "costs.settings.approval_hint": "Aprueba: quien tiene permiso para aprobar campañas (dueños y admins). Quien la creó no aprueba la propia.",
  "costs.settings.frequency": "Frecuencia de marketing",
  "costs.settings.frequency_days": "Días entre campañas de marketing",
  "costs.settings.frequency_hint": "Un contacto que recibió una campaña de marketing queda fuera de las siguientes por esa cantidad de días. 0 lo desactiva.",
  "costs.settings.who_spends": "Quién puede gastar",
  "costs.settings.who_spends_hint": "Predeterminado de cada rol. Las excepciones por persona están en Equipo › Permisos.",
  "costs.settings.insights": "Métricas de plantillas de Meta",
  "costs.settings.insights_lead": "Activa, en Meta, el gasto, el costo por entrega y los clics en botones de cada plantilla. Meta no permite desactivarlo después y no funciona para cuentas de Europa y Japón.",
  "costs.settings.insights_active": "Activadas",
  "costs.settings.insights_enable": "Activar métricas",
  "costs.settings.insights_confirm_title": "¿Activar métricas de plantillas?",
  "costs.settings.insights_confirm": "Las métricas de plantillas de la cuenta {name} se activarán en Meta. No se puede deshacer.",
  "costs.settings.insights_on": "Métricas de plantillas activadas.",
  "contact.costs.title": "Costo de esta atención",
  "contact.costs.bucket.marketing": "Marketing",
  "contact.costs.bucket.utility": "Utilidad",
  "contact.costs.bucket.authentication": "Autenticación",
  "contact.costs.bucket.service": "Servicio",
  "contact.costs.bucket.other": "Otras",
  "contact.costs.ai": "IA",
  "contact.costs.messages": "1 mensaje|{count} mensajes",
  "contact.costs.messages_free": "1 mensaje, {free} gratis|{count} mensajes, {free} gratis",
  "contact.costs.quota_over": "Los 1.000 mensajes de servicio gratis de este número se agotaron el {day}. Hasta fin de mes cada respuesta se cobra.",
  "contact.costs.contact_year": "Este contacto: 1 atención en 12 meses, {value}|Este contacto: {count} atenciones en 12 meses, {value}",
  "meta.pricing.free_quota": "Gratis · dentro de los 1.000 mensajes de servicio del mes de este número",
  "meta.pricing.confirmed": "Confirmado por Meta el {day}",
  "segments.title": "Segmentos",
  "segments.new": "Nuevo segmento",
  "segments.everyone_item": "Todos los contactos",
  "segments.note": "Un segmento es un filtro guardado con nombre. Quien empieza a cumplir las condiciones entra solo; quien deja de cumplirlas sale.",
  "segments.save": "Guardar segmento",
  "segments.update": "Actualizar segmento",
  "segments.delete": "Eliminar segmento",
  "segments.saved": "Segmento guardado.",
  "segments.name": "Nombre del segmento",
  "segments.add_condition": "Condición",
  "segments.remove_condition": "Quitar condición",
  "segments.field": "Campo",
  "segments.condition": "Condición",
  "segments.value": "Valor",
  "segments.value_days": "Días",
  "segments.add": "Agregar",
  "segments.everyone": "Todos los contactos",
  "segments.days": "1 día|{count} días",
  "segments.field.tag": "Etiqueta",
  "segments.field.source": "Origen del contacto",
  "segments.field.last_outcome": "Último desenlace",
  "segments.field.last_conversation": "Última atención",
  "segments.field.created": "Registro",
  "segments.field.marketing": "Marketing",
  "segments.field.name": "Nombre",
  "segments.op.eq": "es",
  "segments.op.neq": "no es",
  "segments.op.has": "tiene",
  "segments.op.not_has": "no tiene",
  "segments.op.contains": "contiene",
  "segments.op.empty": "está vacío",
  "segments.op.not_empty": "está completo",
  "segments.op.gt": "mayor que",
  "segments.op.lt": "menor que",
  "segments.op.none": "nunca tuvo",
  "segments.op.days_gt": "hace más de",
  "segments.op.days_lt": "hace menos de",
  "segments.marketing.opted_in": "Acepta",
  "segments.marketing.opted_out": "No acepta",
  "segments.marketing.unknown": "Sin registro",
  "segments.col.last_outcome": "Último desenlace",
  "segments.col.marketing": "Marketing",
  "segments.total": "1 contacto|{count} contactos",
  "segments.marketing_ok": "1 puede recibir marketing|{count} pueden recibir marketing",
  "segments.selected": "1 seleccionado|{count} seleccionados",
  "segments.clear": "Limpiar selección",
  "segments.add_tag": "Agregar etiqueta",
  "segments.apply": "Aplicar",
  "segments.tagged": "Etiqueta aplicada a 1 contacto.|Etiqueta aplicada a {count} contactos.",
  "segments.export": "Exportar",
  "segments.create_campaign": "Crear campaña",
  "segments.select": "Seleccionar {name}",
  "segments.select_all": "Seleccionar todos de la página",
  "segments.fields_note": "Los campos son los del contacto. Planillas, Pipedrive, OutboundPro y las demás integraciones completan estos mismos campos, así que el segmento no depende de dónde vino el contacto.",
  "segments.import_tag": "Importación {when}",
  "campaigns.new": "Nueva campaña",
  "campaigns.new_name": "Nueva campaña",
  "campaigns.lead": "Envío de plantilla aprobada a un segmento de contactos, con el costo por respuesta y por venta.",
  "campaigns.kpi.count": "Campañas del mes",
  "campaigns.kpi.reached": "Personas alcanzadas",
  "campaigns.kpi.cost": "Costo del mes",
  "campaigns.kpi.per_reply": "Costo por respuesta",
  "campaigns.tab.all": "Todas",
  "campaigns.tab.draft": "Borradores",
  "campaigns.tab.pending_approval": "Para aprobar",
  "campaigns.tab.scheduled": "Programadas",
  "campaigns.tab.running": "Enviando",
  "campaigns.tab.done": "Concluidas",
  "campaigns.status.draft": "Borrador",
  "campaigns.status.pending_approval": "Esperando aprobación",
  "campaigns.status.scheduled": "Programada",
  "campaigns.status.running": "Enviando",
  "campaigns.status.paused": "Pausada",
  "campaigns.status.completed": "Concluida",
  "campaigns.status.cancelled": "Cancelada",
  "campaigns.status.scheduled_at": "Programada · {at}",
  "campaigns.col.campaign": "Campaña",
  "campaigns.col.status": "Situación",
  "campaigns.col.audience": "Público",
  "campaigns.col.delivered": "Entregados",
  "campaigns.col.replied": "Respondieron",
  "campaigns.col.sales": "Ventas",
  "campaigns.col.cost": "Costo",
  "campaigns.col.per_reply": "Por respuesta",
  "campaigns.col.sent": "Enviado",
  "campaigns.col.read": "Leído",
  "campaigns.col.replied_at": "Respondió",
  "campaigns.up_to": "hasta {value}",
  "campaigns.empty": "Ninguna campaña aquí.",
  "campaigns.replies_note": "Las respuestas se vuelven atenciones con origen “Campaña”, en el equipo, flujo o asistente elegido en la campaña.",
  "campaigns.name": "Nombre de la campaña",
  "campaigns.save_draft": "Guardar borrador",
  "campaigns.saved": "Borrador guardado.",
  "campaigns.step.1": "Público",
  "campaigns.step.2": "Mensaje",
  "campaigns.step.3": "Envío y respuestas",
  "campaigns.step.4": "Revisión",
  "campaigns.next.2": "Siguiente: mensaje",
  "campaigns.next.3": "Siguiente: envío",
  "campaigns.next.4": "Siguiente: revisión",
  "campaigns.source.segment": "Segmento de contactos",
  "campaigns.source.segment_hint": "Un segmento creado en Contactos, siempre actualizado",
  "campaigns.source.filter": "Filtro solo de esta campaña",
  "campaigns.source.filter_hint": "Las mismas condiciones de Contactos, sin guardar",
  "campaigns.source.contacts": "Contactos elegidos",
  "campaigns.source.contacts_hint": "1 contacto elegido en Contactos|{count} contactos elegidos en Contactos",
  "campaigns.source.import": "Importar planilla",
  "campaigns.source.import_hint": "Los contactos entran con sus campos y se vuelven el segmento “Importación”",
  "campaigns.which_segment": "Qué segmento",
  "campaigns.edit_in_contacts": "Editar en Contactos",
  "campaigns.who_enters": "Quién entra",
  "campaigns.fields_note": "Los segmentos nacen en Contactos, por los campos del contacto. Quien llega por Contactos › Crear campaña ya encuentra el público elegido.",
  "campaigns.frozen_note": "Cuando la campaña empieza a enviar, la lista se congela: quien entre al segmento después no recibe esta campaña.",
  "campaigns.who_receives": "Quién lo recibe",
  "campaigns.found": "Encontrados",
  "campaigns.skip.blocked": "Contacto bloqueado",
  "campaigns.skip.no_whatsapp": "Sin número de WhatsApp",
  "campaigns.skip.opted_out": "Pidieron no recibir promociones",
  "campaigns.skip.duplicate": "Número repetido",
  "campaigns.skip.frequency": "Recibieron marketing hace poco",
  "campaigns.skip.open_conversation": "Están en atención ahora",
  "campaigns.skip.cancelled": "Campaña cancelada",
  "campaigns.receive": "Recibirán",
  "campaigns.skip_note": "“Pidieron no recibir promociones” y la frecuencia de marketing no se pueden desmarcar; la frecuencia se ajusta en Configuración › Costos y límites.",
  "campaigns.samples": "Ejemplos: {names}",
  "campaigns.pick_audience": "Elige un segmento o arma un filtro.",
  "campaigns.template": "Plantilla",
  "campaigns.number": "Número",
  "campaigns.approved_template": "Plantilla aprobada",
  "campaigns.quality": "Calidad {q}",
  "campaigns.template_hint": "Solo aparecen plantillas aprobadas de la cuenta de este número. El precio por entrega aparece en la revisión.",
  "campaigns.variables": "Variables",
  "campaigns.var.from": "Viene de",
  "campaigns.var.format": "Formato",
  "campaigns.var.fallback": "Si está vacío",
  "campaigns.var.text": "Texto",
  "campaigns.var.first_name": "Primer nombre",
  "campaigns.var.name": "Nombre",
  "campaigns.var.phone": "Teléfono",
  "campaigns.var.field": "Campo: {name}",
  "campaigns.var.fixed": "Texto fijo",
  "campaigns.var.button": "Final del enlace del botón {n}",
  "campaigns.format.none": "Como está",
  "campaigns.format.title": "Nombre Propio",
  "campaigns.format.first": "Solo la primera palabra",
  "campaigns.format.upper": "MAYÚSCULAS",
  "campaigns.format.lower": "minúsculas",
  "campaigns.header": "Archivo del encabezado ({kind})",
  "campaigns.header_choose": "Elegir archivo",
  "campaigns.media.image": "foto",
  "campaigns.media.video": "video",
  "campaigns.media.document": "documento",
  "campaigns.buttons": "Botones",
  "campaigns.quick_reply": "Respuesta rápida",
  "campaigns.when_tapped": "Al tocar",
  "campaigns.button.route": "Abre atención como la respuesta",
  "campaigns.button.optout": "Saca el contacto del marketing",
  "campaigns.button.none": "Solo cuenta el toque",
  "campaigns.preview": "Vista previa · {name}",
  "campaigns.prev_sample": "Ejemplo anterior",
  "campaigns.next_sample": "Siguiente ejemplo",
  "campaigns.missing": "Falta valor para {slots}: Meta rechazaría este mensaje.",
  "campaigns.test_phone": "Enviar prueba a",
  "campaigns.send_test": "Enviar prueba",
  "campaigns.test_hint": "La prueba va a ese WhatsApp, abre una atención de prueba para ti y no cuenta en los números de la campaña.",
  "campaigns.test_sent": "Prueba enviada.",
  "campaigns.when": "Cuándo",
  "campaigns.when_now": "Ahora",
  "campaigns.when_later": "Programar",
  "campaigns.start_at": "Empieza el",
  "campaigns.window": "Envía solo en estos días y horarios (hora de Brasilia):",
  "campaigns.from": "Desde",
  "campaigns.to": "Hasta",
  "campaigns.window_hint": "La velocidad es automática: respeta el límite diario de Meta de personas nuevas, sumando todos los números y envíos de la empresa. Sin ningún día marcado, envía a cualquier hora.",
  "campaigns.stop": "Se detiene sola si",
  "campaigns.stop_template": "Meta pausa o rechaza la plantilla",
  "campaigns.stop_quality": "La calidad del número baja",
  "campaigns.stop_optout": "Más del 3% pide parar",
  "campaigns.stop_budget": "Se acaba el presupuesto de la campaña",
  "campaigns.budget": "Presupuesto de la campaña (R$)",
  "campaigns.stop_hint": "Cuando se detiene, avisa a quien la creó y muestra el motivo. Reanudar es un clic.",
  "campaigns.on_reply": "Cuando alguien responda",
  "campaigns.reply.team": "Abre atención en el equipo",
  "campaigns.reply.team_hint": "Se distribuye como las otras atenciones",
  "campaigns.reply.flow": "Empieza un flujo",
  "campaigns.reply.flow_hint": "Un flujo publicado conduce la conversación",
  "campaigns.reply.assistant": "El asistente atiende",
  "campaigns.reply.assistant_hint": "Con el mensaje de la campaña como contexto",
  "campaigns.reply.pick_team": "Equipo",
  "campaigns.reply.pick_flow": "Flujo",
  "campaigns.reply.pick_assistant": "Asistente",
  "campaigns.reply.default_team": "Equipo predeterminado del número",
  "campaigns.goal": "Objetivo de la atención",
  "campaigns.success_days": "Días para contar la venta",
  "campaigns.success_hint": "Venta = atención abierta por la respuesta y concluida con desenlace de éxito en hasta {days} días. Si el contacto estaba en dos campañas, cuenta solo la última.",
  "campaigns.summary": "Resumen",
  "campaigns.people": "1 persona|{count} personas",
  "campaigns.starts": "Empieza",
  "campaigns.estimate": "Costo estimado",
  "campaigns.market": "Mercado",
  "campaigns.price": "Precio",
  "campaigns.up_to_col": "Hasta",
  "campaigns.total": "Total",
  "campaigns.estimate_hint": "“Hasta” porque solo se cobra lo entregado; quien llegó al límite de marketing del día no se cobra. Las respuestas que abre la campaña también cuestan (servicio) y entran en el resultado.",
  "campaigns.checks": "Antes de enviar",
  "campaigns.check.template": "Plantilla aprobada",
  "campaigns.check.number": "El número puede enviar · calidad {quality}",
  "campaigns.check.days": "Termina en 1 día (límite de {limit} personas nuevas por día)|Termina en {days} días (límite de {limit} personas nuevas por día)",
  "campaigns.check.unlimited": "Sin límite diario en Meta",
  "campaigns.check.budget": "{scope}: {spent} de {amount}; con esta campaña, hasta {after}",
  "campaigns.needs_approval": "Necesita aprobación",
  "campaigns.needs_approval_hint": "La campaña supera el valor o el público que la regla de la empresa manda aprobar.",
  "campaigns.ask": "Pedir a",
  "campaigns.request_approval": "Pedir aprobación",
  "campaigns.ready_hint": "Todo listo. La campaña empieza ahora o a la hora programada.",
  "campaigns.schedule": "Programar",
  "campaigns.send_now": "Enviar ahora",
  "campaigns.submitted.pending_approval": "Aprobación solicitada.",
  "campaigns.submitted.running": "Campaña enviando.",
  "campaigns.submitted.scheduled": "Campaña programada.",
  "campaigns.byline": "Creada por {who} · {at}",
  "campaigns.api": "integración",
  "campaigns.approved_by": "aprobada por {name}",
  "campaigns.duplicate": "Duplicar",
  "campaigns.banner.running": "Enviando · {sent} de {total}. Respeta el horario de la campaña y el límite diario de Meta.",
  "campaigns.banner.scheduled": "Programada para {at}.",
  "campaigns.banner.pending": "Esperando la aprobación de un admin.",
  "campaigns.pause_reason.member": "Pausada por una persona.",
  "campaigns.pause_reason.template_paused": "Pausada sola: Meta pausó o rechazó la plantilla.",
  "campaigns.pause_reason.quality_low": "Pausada sola: la calidad del número bajó.",
  "campaigns.pause_reason.optout_rate": "Pausada sola: mucha gente pidió parar.",
  "campaigns.pause_reason.budget": "Pausada sola: se acabó el presupuesto de la campaña.",
  "campaigns.pause_reason.company_budget": "Pausada sola: el presupuesto del mes llegó al límite.",
  "campaigns.pause_reason.channel_unavailable": "Pausada sola: el número no puede enviar.",
  "campaigns.pause": "Pausar",
  "campaigns.resume": "Reanudar",
  "campaigns.cancel": "Cancelar campaña",
  "campaigns.approve": "Aprobar",
  "campaigns.reject": "Rechazar con motivo",
  "campaigns.reject_reason": "Motivo",
  "campaigns.kpi.campaign_cost": "Costo de la campaña",
  "campaigns.kpi.estimated": "Estimado: hasta {value}",
  "campaigns.kpi.with_conversations": "Con las atenciones",
  "campaigns.kpi.follow_hint": "+ {value} de las respuestas (servicio)",
  "campaigns.kpi.per_sale": "Por venta",
  "campaigns.funnel": "Embudo",
  "campaigns.funnel_step.audience": "Público",
  "campaigns.funnel_step.sent": "Enviados",
  "campaigns.funnel_step.delivered": "Entregados",
  "campaigns.funnel_step.read": "Leídos",
  "campaigns.funnel_step.replied": "Respondieron",
  "campaigns.funnel_step.sales": "Ventas",
  "campaigns.sale_rule": "Venta = atención abierta por la campaña y concluida con desenlace de éxito en hasta {days} días.",
  "campaigns.link": "Enlace",
  "campaigns.links_hint": "Los clics en enlaces vienen de las métricas de plantilla de Meta, con hasta 2 días de retraso, y suman todos los envíos de la plantilla en los días de la campaña.",
  "campaigns.failures": "No entregados · {count}",
  "campaigns.no_failures": "Ninguna falla.",
  "campaigns.retry": "Reintentar los que se puede",
  "campaigns.requeued": "1 persona volvió a la cola.|{count} personas volvieron a la cola.",
  "campaigns.skipped_title": "Fuera de la lista",
  "campaigns.people_title": "Personas",
  "campaigns.filter.all": "Todas",
  "campaigns.filter.delivered": "Entregados",
  "campaigns.filter.read": "Leídos",
  "campaigns.filter.replied": "Respondieron",
  "campaigns.filter.success": "Ventas",
  "campaigns.filter.failed": "Fallaron",
  "campaigns.filter.skipped": "Fuera",
  "campaigns.filter.queued": "En cola",
  "campaigns.recipient.queued": "En cola",
  "campaigns.recipient.sending": "Enviando",
  "campaigns.recipient.sent": "Enviado",
  "campaigns.recipient.delivered": "Entregado",
  "campaigns.recipient.read": "Leído",
  "campaigns.recipient.failed": "No entregado",
  "campaigns.recipient.replied": "Respondió",
  "campaigns.recipient.success": "Compró",
  "campaigns.recipient.skip.blocked": "Fuera: bloqueado",
  "campaigns.recipient.skip.no_whatsapp": "Fuera: sin WhatsApp",
  "campaigns.recipient.skip.opted_out": "Fuera: no acepta promociones",
  "campaigns.recipient.skip.duplicate": "Fuera: número repetido",
  "campaigns.recipient.skip.frequency": "Fuera: recibió marketing hace poco",
  "campaigns.recipient.skip.open_conversation": "Fuera: en atención",
  "campaigns.recipient.skip.cancelled": "Fuera: campaña cancelada",
  "campaigns.recipient.skip.other": "Fuera",
  "campaigns.failure.131049": "Límite de marketing de la persona en el día",
  "campaigns.failure.131026": "Número sin WhatsApp",
  "campaigns.failure.131050": "Bloqueó marketing en WhatsApp",
  "campaigns.failure.131047": "Fuera de la ventana de 24 horas",
  "campaigns.failure.131051": "Tipo de mensaje no aceptado",
  "campaigns.failure.132015": "Plantilla pausada por Meta",
  "campaigns.failure.135000": "Ritmo de envío de Meta",
  "campaigns.failure.131042": "Problema de pago en Meta",
  "campaigns.failure.variable_missing": "Faltó valor en una variable",
  "campaigns.failure.cancelled": "Campaña cancelada",
  "campaigns.failure.unknown": "Motivo no informado",
  "campaigns.failure.other": "Error {code}",
  "campaigns.next.tomorrow": "Reintenta sola mañana · no cobrado",
  "campaigns.next.mark": "No se reintenta",
  "campaigns.next.optout": "Sale del marketing",
  "campaigns.next.retry": "Se puede reintentar",
  "campaigns.open_conversation": "Abrir atención",
  "campaigns.no_people": "Nadie aquí.",
  "errors.campaign_not_editable": "Esta campaña ya salió de borrador y no se puede editar.",
  "errors.campaign_audience_empty": "Nadie para recibirla: revisa el público.",
  "errors.campaign_not_pending": "Esta campaña no espera aprobación.",
  "errors.campaign_own_approval": "Quien creó la campaña no puede aprobarla.",
  "errors.campaign_wrong_status": "La situación de la campaña no permite esto.",
  "errors.campaign_not_found": "Campaña no encontrada.",
  "errors.segment_not_found": "Segmento no encontrado.",
  "errors.template_without_media_header": "Esta plantilla no tiene encabezado con archivo.",
  "errors.upload_used": "Este archivo ya se usó; elígelo de nuevo.",
  "errors.template_not_approved": "La plantilla no está aprobada por Meta.",
  "campaigns.var.slot_header": "Encabezado {name}",
  "campaigns.var.slot_body": "Texto {name}",
  "campaigns.check.missing": "1 persona quedaría sin valor en una variable: completa “Si está vacío”|{count} personas quedarían sin valor en una variable: completa “Si está vacío”",
  "campaigns.not_ready_hint": "Resuelve los ítems marcados arriba para enviar.",
  "fx.approx_today": "≈ {value} hoy",
  "fx.approx": "≈ {value}",
  "fx.rate": "Dólar de hoy: US$ 1 = {rate} (PTAX del {day})",
  "fx.no_rate": "La cotización del dólar aún no llegó",
  "fx.ai_note": "La IA se cobra en dólares y se convierte al dólar de hoy: US$ 1 = {rate} (PTAX del {day}).",
  "platform.ai.pricing_synced": "Precio actualizado en {count} modelo|Precios actualizados en {count} modelos",
  "platform.ai.last_sync": "Última actualización del catálogo: {when}, precio de {count} modelo. La tabla pública de LiteLLM se lee todos los días a las 3:15 (Brasilia).|Última actualización del catálogo: {when}, precios de {count} modelos. La tabla pública de LiteLLM se lee todos los días a las 3:15 (Brasilia).",
  "platform.ai.alert.retiring": "{model} será retirado por el proveedor el {date}.",
  "platform.ai.alert.price_moved": "{model}: el precio de {field} pasó de {from} a {to} por millón de tokens. Revíselo antes de trasladarlo.",
  "platform.ai.alert.input": "entrada",
  "platform.ai.alert.output": "salida",
  "platform.ai.unpriced": "Sin precio en la tabla (la IA de estos modelos cuenta como cero): {models}",
  "platform.ai.retires": "se retira el {date}",
  "platform.ai.synced_at": "Precio de la tabla de LiteLLM del {when}",
  "page.back_to": "Volver a {name}",
  "page.unsaved": "Cambios sin guardar",
  "page.leave_title": "¿Salir sin guardar?",
  "page.leave_text": "Los cambios de esta página aún no se guardaron y se perderán.",
  "page.leave": "Salir sin guardar",
  "page.stay": "Seguir editando",
  "chips.remove": "Quitar {value}",
  "assistants.lead": "Quien responde por la empresa mientras no hay una persona. Haga clic en un asistente para abrirlo.",
  "assistants.empty": "Aún no hay asistentes. Cree el primero y pruébelo antes de publicar.",
  "assistants.speaks_as": "Habla como {name} · {tone}",
  "assistants.no_tone": "tono sin definir",
  "assistants.no_persona": "Sin persona definida",
  "assistants.now": "Ahora",
  "assistants.consults": "Consulta",
  "assistants.hands_to": "Pasa a",
  "assistants.running": "{count} atención|{count} atenciones",
  "assistants.none_now": "Ninguna ahora",
  "assistants.never_published": "Nunca publicado",
  "assistants.collections": "{count} colección|{count} colecciones",
  "assistants.consults_nothing": "Nada aún",
  "assistants.same_team": "Cola del equipo actual",
  "assistants.published_on": "Versión {n} · publicada el {day}",
  "assistants.created_on": "Modificado el {day}",
  "assistants.show_archived": "Ver archivado ({count})|Ver archivados ({count})",
  "assistants.show_active": "Volver a los activos",
  "assistants.unpublished": "Cambios sin publicar",
  "assistants.live": "Activo · versión {n}",
  "assistants.not_found": "Este asistente ya no existe.",
  "assistants.default_name": "Nuevo asistente",
  "assistants.save_draft": "Guardar borrador",
  "assistants.tab.voice": "Cómo habla",
  "assistants.tab.knows": "Qué sabe y hace",
  "assistants.tab.handoff": "Cuándo pasa a una persona",
  "assistants.tab.versions": "Versiones y uso",
  "assistants.field.name": "Nombre interno",
  "assistants.field.persona": "Nombre que ve el contacto",
  "assistants.instructions_hint": "Escríbalo como si explicara el trabajo a alguien nuevo en el equipo: el negocio, qué responder, qué nunca prometer y cuándo llamar a alguien.",
  "assistants.creativity.low": "más previsible",
  "assistants.creativity.mid": "equilibrado",
  "assistants.creativity.high": "más creativo",
  "assistants.knows.title": "Qué consulta",
  "assistants.knows.hint": "Colecciones de la base de conocimiento que lee antes de responder.",
  "assistants.knows.none": "Aún no hay colecciones.",
  "assistants.knows.open": "Abrir la base de conocimiento",
  "assistants.does.title": "Qué puede hacer",
  "assistants.does.hint": "Acciones que el asistente toma solo durante la atención.",
  "assistants.handoff.title": "Cuándo pasa a una persona",
  "assistants.handoff.keywords": "Cuando el contacto diga",
  "assistants.handoff.keywords_placeholder": "agente, humano",
  "assistants.handoff.hint": "También pasa cuando no sabe responder o el contacto lo pide, si “Pasar a una persona” está activado en “Qué sabe y hace”.",
  "assistants.limits.title": "Límites de la respuesta",
  "assistants.limits.blocked": "Términos que nunca usa",
  "assistants.limits.blocked_placeholder": "garantizado, sin intereses",
  "assistants.limits.hint": "Si una respuesta tiene uno de estos términos, se envía el texto de seguridad en su lugar.",
  "assistants.versions.none": "Aún no hay versiones publicadas.",
  "assistants.runs.title": "Atenciones recientes",
  "assistants.runs.none": "Aún no atendió a nadie.",
  "assistants.runs.turns": "{count} respuesta|{count} respuestas",
  "assistants.run.running": "Atendiendo",
  "assistants.run.completed": "Concluido",
  "assistants.run.handed_off": "Pasó a una persona",
  "assistants.run.cancelled": "Interrumpido",
  "assistants.run.failed": "Falló",
  "assistants.test.title": "Probar",
  "assistants.test.open": "Probar",
  "assistants.test.close": "Cerrar la prueba",
  "assistants.test.draft": "Con lo que está en pantalla",
  "assistants.test.restart": "Empezar de nuevo",
  "assistants.test.empty": "Escriba como si fuera el contacto. El asistente responde con lo que está en pantalla, aunque no esté guardado.",
  "assistants.test.placeholder": "Escriba como el contacto",
  "assistants.test.send": "Enviar mensaje de prueba",
  "assistants.test.typing": "Respondiendo",
  "assistants.test.note": "No envía nada a WhatsApp y no entra en los informes. El costo de IA aparece en Uso de IA como prueba.",
  "assistants.test.consulted": "Consultó: {sources}",
  "assistants.test.handoff": "Pasaría a una persona ({team}). Motivo: {reason}",
  "assistants.test.closes": "Concluiría la atención como {outcome}",
  "assistants.test.set_field": "Guardaría en el contacto: {field} = {value}",
  "assistants.test.start_flow": "Iniciaría el flujo {flow}",
  "assistants.test.end": "Devolvería la atención al flujo",
  "assistants.test.exit_keyword": "El contacto dijo “{keyword}”: pasaría a una persona ({team})",
  "assistants.test.exit_field": "El campo {field} se completó: pasaría a una persona ({team})",
  "assistants.test.max_turns": "Llegó al límite de respuestas: pasaría a una persona ({team})",
  "assistants.test.ended": "La prueba terminó aquí. Empiece de nuevo para probar otra vez.",
  "assistants.test.closed_hint": "La prueba está cerrada. “Probar” arriba la abre de nuevo, en cualquier pestaña.",
  "knowledge.lead": "Lo que los asistentes consultan para responder, organizado en colecciones.",
  "knowledge.empty": "Aún no hay colecciones. Cree una y agregue textos, páginas del sitio o PDF.",
  "knowledge.new_collection_button": "Nueva colección",
  "knowledge.collection_name": "Nombre de la colección",
  "knowledge.collection_hint": "Después agregue contenido y marque la colección en los asistentes que deben consultarla.",
  "knowledge.create": "Crear",
  "knowledge.card.contents": "{count} contenido|{count} contenidos",
  "knowledge.card.ready": "Todo listo",
  "knowledge.card.processing": "Procesando",
  "knowledge.card.empty": "Vacía",
  "knowledge.card.failed": "{count} con error|{count} con error",
  "knowledge.card.used_by": "Usada por",
  "knowledge.card.unused": "Ningún asistente la usa. Márquela en “Qué consulta” en el asistente.",
  "knowledge.not_found": "Esta colección ya no existe.",
  "knowledge.page.used_by": "Usada por {names}",
  "knowledge.page.empty": "Aún no hay contenido. Use “Agregar contenido”.",
  "knowledge.rename": "Renombrar",
  "knowledge.col.content": "Contenido",
  "knowledge.col.source": "Fuente",
  "knowledge.col.chunks": "Fragmentos",
  "knowledge.col.status": "Estado",
  "knowledge.failed_generic": "No se pudo leer este contenido.",
  "knowledge.retry": "Intentar de nuevo",
  "knowledge.remove": "Quitar {name}",
  "knowledge.test.title": "Probar la búsqueda",
  "knowledge.test.hint": "Escriba una pregunta de cliente y vea los fragmentos que el asistente leería antes de responder.",
  "knowledge.test.question": "Pregunta",
  "knowledge.test.placeholder": "¿Cuál es el plazo de entrega?",
  "knowledge.test.search": "Buscar",
  "knowledge.test.very_close": "muy parecido",
  "knowledge.test.close": "parecido",
  "knowledge.test.far": "poco parecido",
  "knowledge.test.nothing": "Ningún fragmento parecido. Falta contenido sobre esto.",
  "knowledge.test.advice": "Si el fragmento correcto no aparece, falta contenido o está escrito distinto de cómo pregunta el cliente.",
  "learning.lead": "Cada semana la IA lee las atenciones concluidas y sugiere mejoras. Nada cambia sin su aprobación.",
  "learning.waiting": "{count} sugerencia esperándolo|{count} sugerencias esperándolo",
  "learning.waiting_hint": "Del informe de {period}. Las aprobadas se vuelven respuestas rápidas, ajustes del asistente o contenido de la base.",
  "learning.review_now": "Revisar ahora",
  "learning.row_counts": "{analyzed} atenciones leídas · {applied} aplicadas",
  "learning.to_review": "{count} por revisar|{count} por revisar",
  "learning.reviewed": "Revisado",
  "learning.show_archived": "Ver archivado ({count})|Ver archivados ({count})",
  "learning.show_current": "Volver a los actuales",
  "learning.period_range": "{from} al {to}",
  "learning.week_of": "Semana del {period}",
  "learning.filter.proposed": "Por revisar",
  "learning.filter.applied": "Aplicadas",
  "learning.filter.rejected": "Rechazadas",
  "learning.filter_empty.proposed": "Nada por revisar en este informe.",
  "learning.filter_empty.applied": "Aún no se aplicó ninguna sugerencia.",
  "learning.filter_empty.rejected": "Ninguna sugerencia rechazada.",
  "learning.body_editable": "Texto (puede editarlo antes de aprobar)",
  "learning.evidence_count": "Ver {count} atención de ejemplo|Ver las {count} atenciones de ejemplo",
  "learning.approve_draft": "Aprobar como borrador",
  "learning.the_week": "La semana",
  "learning.stat.analyzed": "Atenciones leídas",
  "learning.stat.successful": "Concluidas con éxito",
  "learning.stat.suggestions": "Sugerencias",
  "policy.lead": "Reglas automáticas para las atenciones, sin que nadie tenga que acordarse.",
  "policy.empty": "Aún no hay políticas.",
  "policy.kind_hint.lifecycle": "Cierra o prioriza atenciones detenidas",
  "policy.kind_hint.gate": "Revisa lo que el equipo escribe antes de enviarlo",
  "policy.inactive": "Desactivada",
  "policy.new_title": "¿Qué hace la nueva política?",
  "policy.kind_choice.lifecycle": "Concluye, prioriza o marca como en espera después de un tiempo sin respuesta.",
  "policy.kind_choice.gate": "Frena palabras, promesas y datos sensibles, con o sin revisión por IA.",
  "policy.continue": "Continuar",
  "policy.not_found": "Esta política ya no existe.",
  "policy.scope_team": "equipo {name}",
  "policy.applies_to": "Vale para",
  "policy.when": "Cuando",
  "policy.rule_kind": "Qué pasa",
  "policy.when_kind.no_inbound_for": "el contacto no responde",
  "policy.when_kind.unanswered_new_for": "una atención nueva queda sin primera respuesta",
  "policy.when_kind.window_expired": "la ventana de 24 h se cierra",
  "policy.for": "durante",
  "policy.hours_word": "horas",
  "policy.then_close": "concluir como",
  "policy.then_priority": "prioridad",
  "policy.then_waiting": "marcar como esperando al contacto",
  "policy.remove_rule": "Quitar regla",
  "policy.sentence.no_inbound_for": "Cuando el contacto no responde durante {hours} horas → concluir como {outcome}",
  "policy.sentence.unanswered_new_for": "Cuando una atención nueva queda {hours} horas sin primera respuesta → prioridad {priority}",
  "policy.sentence.window_expired": "Cuando la ventana de 24 h se cierra → marcar como esperando al contacto",
  "policy.practice.title": "Cómo queda en la práctica",
  "policy.practice.t0": "Inicio",
  "policy.practice.t1": "Después",
  "policy.practice.t2": "{hours} h después",
  "policy.practice.last_message": "El contacto envía su último mensaje.",
  "policy.practice.reply": "El equipo responde y el contacto no vuelve.",
  "policy.practice.closed": "Concluida como {outcome}, por la política. En los informes aparece como cerrada automáticamente.",
  "policy.practice.other": "Las reglas valen para las atenciones de toda la empresa o del equipo elegido.",
  "policy.practice.many": "Solo la regla más específica vale para cada conversación: la de la campaña, luego la del número, la del equipo y por último la de la empresa. Las reglas del mismo nivel valen juntas: actúa la que venza primero.",
  "policy.advanced": "Avanzado",
  "policy.gate.when_fails": "Cuando un mensaje no pasa",
  "policy.mode_card.log": "Solo registrar",
  "policy.mode_card.suggest": "Sugerir al agente",
  "policy.mode_card.auto_fix": "Corregir y enviar",
  "policy.mode_card.block": "Bloquear",
  "policy.mode_hint.log": "Lo envía tal cual y lo anota para los informes.",
  "policy.mode_hint.suggest": "Muestra el problema y una versión corregida. El agente elige.",
  "policy.mode_hint.auto_fix": "Lo reemplaza solo por el texto corregido.",
  "policy.mode_hint.block": "No lo envía. El agente lo reescribe.",
  "policy.gate.checks": "Qué revisa",
  "policy.gate.blocked_chips": "No deja pasar",
  "policy.gate.blocked_placeholder": "garantizado, sin intereses",
  "policy.gate.phrases": "Promesas, con frases de ejemplo",
  "policy.gate.phrases_placeholder": "le garantizo que sale, seguro que se aprueba",
  "policy.gate.phrases_hint": "Detecta la frase con mayúsculas, sin acentos o con hasta tres palabras en medio: “garantizo que sale” detecta “Le garantizo que su crédito sale”.",
  "policy.gate.domains_chips": "Enlaces solo a estos sitios",
  "policy.gate.judge_label": "Revisión por IA",
  "policy.gate.judge_hint": "Una segunda IA lee el mensaje con las indicaciones de abajo.",
  "policy.summary.blocks": "No deja pasar: {words}",
  "policy.summary.pii": "frena tarjeta y documento",
  "policy.summary.links": "enlaces solo a {count} sitio|enlaces solo a {count} sitios",
  "policy.summary.judge_on": "revisión por IA activada",
  "policy.summary.judge_off": "sin revisión por IA",
  "policy.example.title": "Qué ve el agente",
  "policy.example.draft": "¡Le garantizo que su crédito se aprueba hoy, sin intereses!",
  "policy.example.hint": "El ejemplo cambia con lo que elige arriba.",
  "policy.example.log.title": "Enviado tal como se escribió",
  "policy.example.log.text": "La revisión anota que prometía aprobación y decía “sin intereses”; aparece en los informes.",
  "policy.example.suggest.title": "No enviado: promete aprobación y dice “sin intereses”",
  "policy.example.suggest.text": "Sugerencia: “Puedo verificar las condiciones y explicarle cómo funciona la aprobación.” El agente la usa o la edita.",
  "policy.example.auto_fix.title": "Enviado ya corregido",
  "policy.example.auto_fix.text": "El contacto recibe: “Puedo verificar las condiciones y explicarle cómo funciona la aprobación.”",
  "policy.example.block.title": "No enviado",
  "policy.example.block.text": "El agente ve el motivo y tiene que reescribir el mensaje.",
  "templates.not_found": "Esta plantilla ya no existe.",
  "errors.ai_key_missing": "No hay ninguna clave de IA configurada. Agregue una en Configuración › IA y claves o hable con soporte.",
  "errors.ai_budget_exceeded": "Se alcanzó el límite de gasto en IA de este mes.",
  "errors.ai_provider_error": "El proveedor de IA no respondió bien. Intente de nuevo en unos instantes.",
  "errors.ai_provider_timeout": "El proveedor de IA tardó demasiado en responder. Intente de nuevo.",
  "errors.ai_surface_not_configured": "No se eligió ningún modelo de IA para esta tarea. Hable con soporte.",
  "errors.ai_capability_unsupported": "El modelo de IA elegido no puede hacer esto.",
  "errors.ai_provider_unsupported": "Este proveedor de IA no es compatible.",
  "templates.cannot_edit": "Solo se pueden editar borradores y plantillas rechazadas o pausadas por Meta. Para cambiar una aprobada, duplíquela.",
  "ai.calls.test": "prueba",
  "settings.fields": "Campos del contacto",
  "settings.optout": "Baja de marketing",
  "settings.hours": "Horarios de atención",
  "settings.search": "Buscar en la configuración",
  "settings.search_empty": "Nada encontrado para “{query}”.",
  "settings.in_section": "en {section}",
  "settings.find.numbers": "whatsapp, conectar, teléfono, número, api oficial, calidad, pin, coexistencia, meta",
  "settings.find.templates": "plantilla, hsm, meta, aprobación, marketing, utilidad, mensaje activo",
  "settings.find.optout": "salir, parar, stop, darse de baja, consentimiento",
  "settings.find.members": "miembros, invitar, agentes, usuarios, roles, permisos, contraseña, acceso",
  "settings.find.teams": "grupos, distribución, capacidad, rotación, cola, asignación automática",
  "settings.find.hours": "horario comercial, zona horaria, fin de semana, feriado, ausencia",
  "settings.find.assistants": "bot, robot, chatbot, persona, instrucciones, ia, probar",
  "settings.find.knowledge": "documentos, pdf, sitio, preguntas frecuentes, contenido, colección",
  "settings.find.learning": "sugerencias, mejoras, informe semanal, análisis",
  "settings.find.policies": "cierre automático, revisión de mensajes, gate, palabras prohibidas, promesas, prioridad, regex",
  "settings.find.outcomes": "resultado, venta, cerrar, motivo de cierre, éxito",
  "settings.find.tags": "etiquetas, marcadores, colores, clasificar",
  "settings.find.snippets": "atajos, respuestas rápidas, textos listos, playbook",
  "settings.find.fields": "documento, datos del contacto, campos personalizados, segmentación, importación",
  "settings.find.budgets": "presupuesto, límite de gasto, costo, dinero",
  "settings.find.limit": "pausar, bloquear envío, exceder presupuesto",
  "settings.find.cost_alerts": "alertas, avisos de costo, correo, notificación",
  "settings.find.approval": "aprobar campaña, aprobación",
  "settings.find.frequency": "frecuencia, intervalo, cuántos mensajes, marketing, días",
  "settings.find.spenders": "quién puede enviar marketing, permisos de envío",
  "settings.find.insights": "métricas, clics, rendimiento de plantillas",
  "settings.find.ai_keys": "claves de ia, openai, anthropic, gemini, claude, gpt, clave propia",
  "settings.find.ai_usage": "uso de ia, costo de ia, tokens, llamadas, presupuesto de ia",
  "settings.find.api_keys": "claves de api, token, integración, desarrollador",
  "settings.find.hooks": "webhook de entrada, captura de leads, formulario, sitio, anuncios",
  "settings.find.webhooks": "webhooks, eventos, notificaciones, callback, integración",
  "settings.find.crm": "crm, pipedrive, outboundpro, negocios, embudo",
  "settings.find.retention": "retención, borrar datos, guardar, archivos",
  "settings.find.export": "exportar, respaldo, descargar datos, copia",
  "settings.find.subjects": "lgpd, titular, borrar contacto, derechos, datos personales",
  "fields.lead": "Lo que la empresa registra de cada contacto. Segmentos, campañas, importación, integraciones y el asistente usan estos campos.",
  "fields.ai_short": "la IA lo completa",
  "fields.used_by": "Marque “La IA puede completarlo” para que el asistente guarde el valor durante la conversación.",
  "fields.options_chips": "Opciones",
  "fields.options_placeholder": "Escriba una opción y presione Enter",
  "optout.keywords_chips": "Palabras que dan de baja del marketing",
  "optout.keywords_placeholder": "salir, parar, stop",
  "optout.effect": "Quien se da de baja no recibe más campañas ni plantillas de marketing hasta que pida volver. Los mensajes de utilidad y las conversaciones que inicia siguen con normalidad.",
  "hours.lead": "Cuándo atiende cada equipo. Fuera del horario, la atención espera en la cola y el flujo puede responder con el mensaje de ausencia.",
  "hours.used_by": "usado por {teams}",
  "hours.unused": "ningún equipo lo usa",
  "hours.empty": "Aún no hay horarios. Cree uno y elíjalo en cada equipo, en Equipo y personas.",
  "hours.where": "Cada equipo elige su horario en Equipo y personas. En los flujos, el paso “Horario de atención” divide el camino entre dentro y fuera del horario.",
  "hours.short.mon": "lun",
  "hours.short.tue": "mar",
  "hours.short.wed": "mié",
  "hours.short.thu": "jue",
  "hours.short.fri": "vie",
  "hours.short.sat": "sáb",
  "hours.short.sun": "dom",
  "hours.span": "{from} a {to}",
  "hours.always_closed": "Siempre cerrado",
  "team.hours_hint": "Los horarios que cada equipo puede elegir están en",
  "settings.group.channel": "Canal y mensajes",
  "settings.group.service": "Atención",
  "settings.group.ai": "Inteligencia artificial",
  "settings.group.account": "Cuenta",
  "settings.marketing": "Reglas de marketing",
  "settings.outcomes": "Resultados",
  "settings.tags": "Etiquetas",
  "settings.snippets": "Respuestas rápidas",
  "marketing.lead": "Quién recibe marketing y con qué frecuencia: la baja, el intervalo entre mensajes, cuándo una campaña necesita aprobación y quién puede enviar.",
  "marketing.who": "Quién puede enviar y aprobar",
  "tags.lead": "Marcadores con color para contactos y atenciones. Sirven para filtrar, segmentar y en los informes.",
  "costs.settings.ai_limit": "Límite de gasto en IA",
  "costs.settings.ai_limit_hint": "En dólares, como cobran los proveedores de IA. Al llegar al límite, solo avisa o detiene la IA hasta el mes siguiente.",
  "ai.lead": "Las claves que usa la IA y el uso del mes. El límite de gasto está en Costos y límites.",
  "ai.own_keys_hint": "Usa las claves de la propia empresa en lugar de las de la plataforma.",
  "ai.limit_is": "Límite mensual de IA: {value}.",
  "ai.no_limit": "Sin límite mensual de IA.",
  "ai.limit_where": "Ajustar en Costos y límites",
  "settings.find.marketing": "marketing, campañas, reglas, consentimiento, envío masivo",
  "settings.find.ai_limit": "límite de ia, presupuesto de ia, gasto en ia, dólar, bloquear ia",
  "numbers.lead": "Los números de WhatsApp de la empresa, conectados por la API oficial de Meta, con la salud de cada uno.",
  "team.lead": "Quién atiende y en qué equipo. Los roles dan los permisos; las excepciones están en cada persona.",
  "integrations.lead": "Cómo otros sistemas hablan con DoneTalk: CRM, claves de API, entrada de leads y avisos de eventos.",
  "privacy.lead": "Cuánto tiempo se guardan los datos, la copia completa de la cuenta y los pedidos de las personas por la LGPD.",
  "platform.group.customers": "Clientes",
  "platform.group.business": "Comercial",
  "platform.group.platform": "Plataforma",
  "platform.lead.overview": "Cómo está la plataforma: clientes, atenciones, mensajes y costos del mes.",
  "platform.lead.customers": "Cada empresa que usa DoneTalk. Regístrala, sigue su implementación y cuida el acceso de las personas.",
  "platform.lead.plans": "Lo que contrata cada cliente: límites y recursos de cada plan.",
  "platform.lead.ai": "Claves de IA de la plataforma, modelos disponibles, precios y qué modelo hace cada tarea.",
  "platform.lead.admins": "Quién de Nuvvun entra en esta consola y qué puede hacer.",
  "platform.lead.audit": "Todo lo que el equipo de Nuvvun hizo en la consola: quién, cuándo y qué.",
  "platform.trial_over": "Prueba vencida",
  "platform.trial_until": "Prueba hasta {date}",
  "platform.people": "1 persona|{count} personas",
  "platform.invited": "1 invitación pendiente|{count} invitaciones pendientes",
  "platform.onboarding_short": "{done} de {total} etapas",
  "platform.action.customer_created": "Cliente creado",
  "platform.action.customer_updated": "Datos o situación cambiados",
  "platform.action.owner_added": "Dueño agregado",
  "platform.action.provisioned": "Base de datos creada",
  "platform.action.provision_failed": "Falló la creación de la base de datos",
  "platform.action.password_link": "Enlace de nueva contraseña generado",
  "platform.action.mfa_reset": "Verificación en dos pasos desactivada",
  "platform.action.plan_created": "Plan creado",
  "platform.action.plan_updated": "Plan cambiado",
  "platform.action.admin_added": "Administrador agregado",
  "platform.action.admin_removed": "Administrador eliminado",
  "platform.filter.all": "Todos",
  "platform.owner_and_more": "{email} y {count} más",
  "platform.no_owner": "Sin dueño",
  "platform.created_on": "Creado el {date}",
  "platform.db_state": "Base de datos: {state}",
  "platform.customers.none_match": "Ningún cliente con ese nombre o en esa situación.",
  "platform.customers.empty_lead": "Aún no hay clientes. Registra el primero: el dueño recibe una invitación para crear la contraseña y empezar la implementación.",
  "platform.start.trial": "En prueba por 14 días",
  "platform.start.active": "Activo (cliente que paga)",
  "platform.new.create": "Registrar cliente",
  "platform.new.done_title": "Cliente registrado: {name}",
  "platform.new.done_active": "{email} ya tiene cuenta en DoneTalk y ya puede entrar a este cliente.",
  "platform.new.done_emailed": "Enviamos la invitación a {email}. Si no llega, envía este enlace:",
  "platform.new.done_link": "El correo no se envió. Envía este enlace a {name} para crear la contraseña:",
  "platform.new.link_hint": "La invitación dura 7 días y funciona una vez. Envíala por un canal seguro, como el WhatsApp de la persona.",
  "platform.new.open": "Abrir el cliente",
  "platform.new.another": "Registrar otro",
  "platform.new.company": "Empresa",
  "platform.new.slug_taken": "Ese identificador ya es de otro cliente. Elige otro.",
  "platform.new.slug_hint": "Identificador del cliente: {slug}. Aparece en las integraciones y la API, nunca en la dirección de las pantallas. Minúsculas, números y guiones; no cambia después.",
  "platform.new.owner": "Dueño de la cuenta",
  "platform.new.owner_hint": "El dueño recibe una invitación para crear su propia contraseña. Nadie de Nuvvun la elige ni la ve.",
  "platform.new.start": "Cómo empieza",
  "platform.new.start_hint": "En prueba, el cliente usa todo por 14 días; después cámbialo a Activo en Plan y situación.",
  "platform.link_copied": "Enlace copiado",
  "common.copy": "Copiar",
  "common.loading": "Cargando…",
  "platform.page.summary": "Resumen",
  "platform.page.company": "Datos",
  "platform.page.people": "Personas",
  "platform.page.plan": "Plan y situación",
  "platform.page.numbers": "Números",
  "platform.page.usage": "Uso",
  "platform.page.history": "Historial",
  "platform.summary.account": "Cuenta",
  "platform.summary.address": "Identificador",
  "platform.summary.created": "Cliente desde",
  "platform.summary.database": "Base de datos",
  "platform.summary.owners": "Dueños",
  "platform.company.slug_fixed": "El identificador {slug} no cambia, para no romper las integraciones del cliente.",
  "platform.people.title": "1 persona|{count} personas",
  "platform.people.never": "nunca entró",
  "platform.people.seen": "último acceso: {when}",
  "platform.people.mfa_on": "dos pasos activada",
  "platform.people.mfa_off": "dos pasos desactivada",
  "platform.people.reinvite": "Reenviar invitación",
  "platform.people.password_link": "Generar enlace de nueva contraseña",
  "platform.people.hint": "El resto del equipo del cliente lo invita el propio dueño, en Configuración › Equipo y personas.",
  "platform.people.invite_title": "Invitación de {name}",
  "platform.people.seated": "{email} ya tenía cuenta y ya puede entrar como dueño.",
  "platform.people.password_title": "Enlace de nueva contraseña para {name}",
  "platform.people.send_invite": "Invitar",
  "platform.lifecycle_hint.trial": "En prueba: el cliente usa todo hasta que termina la prueba de 14 días.",
  "platform.lifecycle_hint.active": "Activo: cliente que paga, con acceso normal.",
  "platform.lifecycle_hint.suspended": "Suspendido: nadie de la empresa entra y las automatizaciones se detienen hasta reactivarlo. Los datos se guardan.",
  "platform.lifecycle_hint.churned": "Cerrado: el cliente se fue. Nadie entra y las automatizaciones se detienen; los datos siguen la retención acordada.",
  "platform.plan.trial_ends": "La prueba termina el {date}.",
  "platform.numbers.empty": "Ningún número aquí.",
  "platform.numbers.account": "Cuenta {name} ({id})",
  "platform.numbers.method.embedded_signup": "registro por Meta",
  "platform.numbers.method.coexistence": "junto con la app WhatsApp Business",
  "platform.numbers.method.token": "token del sistema",
  "platform.numbers.since": "desde {date}",
  "platform.numbers.quality": "Calidad {value}",
  "platform.numbers.can_send.AVAILABLE": "Puede enviar",
  "platform.numbers.can_send.LIMITED": "Envío limitado",
  "platform.numbers.can_send.BLOCKED": "Bloqueado por Meta",
  "platform.numbers.status.active": "Activo",
  "platform.numbers.status.pending": "Pendiente",
  "platform.numbers.status.disabled": "Desactivado",
  "platform.numbers.status.error": "Con error",
  "platform.usage.title": "Uso en {month}",
  "platform.usage.conversations_opened": "Atenciones abiertas",
  "platform.usage.conversations_closed": "Atenciones concluidas",
  "platform.usage.messages_inbound": "Mensajes recibidos",
  "platform.usage.messages_outbound": "Mensajes enviados",
  "platform.usage.active_contacts": "Contactos activos",
  "platform.usage.day": "Día",
  "platform.usage.empty": "Sin movimiento este mes todavía.",
  "platform.confirm.suspended.title": "¿Suspender {name}?",
  "platform.confirm.suspended.lead": "Nadie de la empresa puede entrar y los flujos, asistentes y campañas se detienen hasta reactivarlo. No se borra nada.",
  "platform.confirm.suspended.button": "Suspender",
  "platform.confirm.churned.title": "¿Cerrar {name}?",
  "platform.confirm.churned.lead": "Úsalo cuando el cliente se fue. Nadie entra y las automatizaciones se detienen. Los datos siguen la retención acordada hasta borrarse.",
  "platform.confirm.churned.button": "Cerrar",
  "platform.admins.count": "1 administrador|{count} administradores",
  "platform.admins.you": "tú",
  "platform.admins.since": "desde {date}",
  "platform.admins.only_super": "Solo los administradores Super agregan o quitan personas.",
  "platform.admins.roles_title": "Qué puede cada rol",
  "platform.admins.role_hint.super": "todo: clientes, planes, IA, administradores y el acceso de cualquier persona, incluso del equipo de Nuvvun.",
  "platform.admins.role_hint.support": "registra y acompaña clientes y ayuda con el acceso de su gente; no cambia administradores.",
  "platform.admins.email_label": "Correo",
  "platform.admins.name": "Nombre",
  "platform.admins.new_account": "Ese correo aún no tiene cuenta. Indica el nombre: se crea la cuenta y recibes un enlace para que la persona cree la contraseña.",
  "platform.admins.added": "{name} ahora es administrador.",
  "platform.admins.remove_title": "¿Quitar a {name} de la consola?",
  "platform.admins.remove_lead": "La persona deja de ver la consola al instante. Su cuenta sigue existiendo.",
  "platform.admins.link_title": "Enlace de acceso de {name}",
  "platform.admins.link_lead": "Envía este enlace para que la persona cree la contraseña. Dura 3 días y funciona una vez.",
  "platform.attention.title": "Requiere atención",
  "platform.attention.none": "Nada requiere atención ahora.",
  "platform.attention.db_failed": "La base de datos no se creó",
  "platform.attention.trial_over": "La prueba venció el {date}",
  "platform.attention.trial_ending": "La prueba termina el {date}",
  "platform.attention.invite_pending": "El dueño aún no aceptó la invitación",
  "platform.attention.urgent": "Resolver",
  "platform.attention.soon": "Seguir",
  "settings.plan": "Plan",
  "settings.find.plan": "plan suscripción precio límites contrato cuota clientes atendidos",
  "plan.lead": "Lo que la empresa contrató, lo que incluye y cuánto de cada límite está en uso.",
  "plan.none": "Aún no hay plan: nada está limitado. Habla con Nuvvun para elegir el tuyo.",
  "plan.on_request": "A consultar",
  "plan.per_month": "{price}/mes",
  "plan.usage": "Uso ahora",
  "plan.label.customers_month": "Clientes atendidos en el mes",
  "plan.label.channels": "Números de WhatsApp",
  "plan.label.members": "Personas",
  "plan.label.flows_published": "Flujos publicados",
  "plan.label.assistants_active": "Asistentes activos",
  "plan.label.ai_usd_month": "IA pagada por la plataforma en el mes",
  "plan.short.channels": "Números",
  "plan.short.ai_usd_month": "IA por mes",
  "plan.feature.campaigns": "Campañas",
  "plan.feature.api": "API e integraciones",
  "plan.feature.gate": "Revisión de lo que se dice antes de enviar",
  "plan.feature.sso": "Inicio de sesión con la cuenta de la empresa (SSO)",
  "plan.feature.dedicated_db": "Servidor de base de datos exclusivo",
  "plan.extra_hint": "Pasando de {quota} clientes atendidos en el mes, cada cliente extra cuesta {price}.",
  "plan.change_hint": "Para cambiar de plan, habla con Nuvvun. En el límite solo se bloquea lo nuevo: lo que ya funciona sigue funcionando.",
  "plan.no_limit": "{used} · sin límite",
  "plan.used_of": "{used} de {limit}",
  "plan.limit.channels": "1 número de WhatsApp|{count} números de WhatsApp",
  "plan.limit.members": "1 persona|{count} personas",
  "plan.limit.flows_published": "1 flujo publicado|{count} flujos publicados",
  "plan.limit.assistants_active": "1 asistente activo|{count} asistentes activos",
  "plan.limit.ai_usd_month": "US$ {max} de IA por mes",
  "plan.limit.customers_month": "{max} clientes atendidos por mes",
  "errors.plan_limit": "Tu plan permite {what}. Para tener más, habla con Nuvvun. Lo que ya funciona sigue funcionando.",
  "platform.plans.active": "Activo",
  "platform.plans.inactive": "Inactivo",
  "platform.plans.customers_count": "1 cliente en este plan|{count} clientes en este plan",
  "platform.plans.empty": "Aún no hay planes.",
  "platform.plans.identity": "Plan",
  "platform.plans.description": "Descripción para el cliente",
  "platform.plans.translations": "Nombre y descripción en inglés y español",
  "platform.plans.name_en": "Nombre en inglés",
  "platform.plans.name_es": "Nombre en español",
  "platform.plans.description_en": "Descripción en inglés",
  "platform.plans.description_es": "Descripción en español",
  "platform.plans.sort": "Orden en la lista",
  "platform.plans.price": "Precio",
  "platform.plans.monthly": "Mensualidad (R$)",
  "platform.plans.extra": "Cada cliente atendido sobre la cuota (R$)",
  "platform.plans.price_hint": "Mensualidad vacía = a consultar. Los mensajes de Meta van siempre aparte: el cliente paga a Meta directamente.",
  "platform.plans.unlimited": "Sin límite",
  "platform.plans.limits_hint": "Vacío = sin límite. El cliente recibe aviso desde el 80% y, en el límite, solo se bloquea lo nuevo.",
  "platform.plans.features_hint": "Se muestran al cliente en Configuración › Plan.",
  "platform.plans.hint.customers_month": "Contactos que escribieron en el mes, una vez cada uno. Nunca bloquea: el excedente se cobra.",
  "platform.plans.hint.channels": "Números conectados. Bloquea conectar uno más.",
  "platform.plans.hint.members": "Personas con acceso, contando invitaciones. Bloquea invitar una más.",
  "platform.plans.hint.flows_published": "Bloquea publicar un flujo más.",
  "platform.plans.hint.assistants_active": "Bloquea activar un asistente más.",
  "platform.plans.hint.ai_usd_month": "En dólares, solo lo que paga la plataforma; la clave de IA del propio cliente no cuenta. En el límite, la IA se detiene hasta el mes siguiente.",
  "email.support.subject": "El soporte de Nuvvun entró al DoneTalk de {workspace}",
  "email.support.body_view": "{who}, del soporte de Nuvvun, entró al DoneTalk de {workspace} solo para mirar, hasta {until}.",
  "email.support.body_edit": "{who}, del soporte de Nuvvun, entró al DoneTalk de {workspace} con permiso para ajustar la configuración, hasta {until}.",
  "email.support.reason": "Motivo: {reason}",
  "email.support.button": "Ver o terminar el acceso",
  "email.support.why": "Recibes este aviso porque eres dueño de la cuenta. Todo lo que hace el soporte queda en la Auditoría, y puedes desactivar el acceso del soporte en Configuración › Datos y privacidad.",
  "platform.support.enter": "Entrar como soporte",
  "platform.support.open": "Abrir como soporte",
  "platform.support.until": "Soporte hasta {time}",
  "platform.support.end": "Terminar acceso",
  "platform.support.title": "Entrar como soporte en {name}",
  "platform.support.lead": "El acceso queda registrado para Nuvvun y para el cliente, los dueños reciben un aviso por correo y el cliente puede terminarlo cuando quiera.",
  "platform.support.reason": "Motivo (el cliente lo ve)",
  "platform.support.reason_placeholder": "Ej.: María pidió ayuda para configurar el flujo de bienvenida",
  "platform.support.duration": "Por cuánto tiempo",
  "platform.support.minutes.30": "30 minutos",
  "platform.support.minutes.60": "1 hora",
  "platform.support.minutes.120": "2 horas",
  "platform.support.minutes.240": "4 horas",
  "platform.support.level": "Qué puedes hacer",
  "platform.support.level.view": "Solo mirar",
  "platform.support.level.edit": "Ajustar configuración",
  "platform.support.level_hint.view": "Ve todo como un auditor, sin cambiar nada.",
  "platform.support.level_hint.edit": "Cambia la configuración como un administrador. No toca dueños ni el plan.",
  "platform.support.confirm": "Entrar",
  "platform.support.off": "Este cliente desactivó el acceso del soporte. Un administrador suyo lo reactiva en Configuración › Datos y privacidad.",
  "platform.support.ended": "Acceso de soporte terminado.",
  "platform.action.support_started": "Acceso de soporte iniciado",
  "platform.action.support_ended": "Acceso de soporte terminado",
  "support.banner": "Estás como soporte de Nuvvun en {name}, {level}, hasta {time}",
  "support.leave": "Terminar y salir",
  "support.title": "Acceso del soporte de Nuvvun",
  "support.lead": "Cuando pides ayuda, alguien de Nuvvun puede entrar por un tiempo limitado, con el motivo registrado. Los dueños reciben un correo, todo queda en la Auditoría y puedes terminarlo cuando quieras.",
  "support.allow": "Permitir que el soporte de Nuvvun entre cuando haga falta",
  "support.none": "Nadie del soporte está aquí ahora.",
  "support.session": "{name} · {level} · hasta {time}",
  "support.session_reason": "Motivo: {reason}",
  "support.end": "Terminar",
  "support.level.view": "solo mirando",
  "support.level.edit": "pudiendo ajustar la configuración",
  "errors.support_access_off": "El acceso del soporte está desactivado para este cliente.",
  "errors.customer_not_open": "Este cliente no está activo ahora.",
  "errors.support_cannot_change_consent": "Solo la propia empresa activa o desactiva el acceso del soporte.",
  "settings.find.support": "soporte nuvvun acceso ayuda consentimiento",
  "phone.ddi": "Código de país",
  "phone.number": "Número",
  "phone.invalid": "Revisa el número. Para este país se ve así: {example}",
  "template.no_number": "Aún no hay número de WhatsApp conectado. Las plantillas vienen de la cuenta de WhatsApp del número: conecta uno para usarlas.",
  "template.connect_number": "Conectar un número",
  "template.sync_now": "Sincronizar con Meta",
  "template.create": "Crear plantilla",
  "template.synced": "1 plantilla traída de Meta.|{count} plantillas traídas de Meta.",
  "template.synced_none": "Meta no devolvió ninguna plantilla para esta cuenta.",
  "mobile.tab.you": "Tú",
  "mobile.company": "Empresa",
  "mobile.switch_company": "Cambiar de empresa",
  "mobile.mfa_setup": "Para usar la app, activa la verificación en dos pasos en DoneTalk desde una computadora (Seguridad) y vuelve a entrar.",
  "mobile.soon": "Llega en la próxima versión de la app.",
  "mobile.signin_title": "Entrar en DoneTalk",
  "mobile.today": "Hoy",
  "push.queue.title": "Nueva conversación en la cola",
  "push.assigned.title": "Conversación asignada a ti",
  "push.assigned.body": "{name} ahora es tuya.",
  "push.campaign.title": "Campaña esperando tu aprobación",
  "push.cost.title": "Alerta de costo",
  "push.cost.body": "Mira en Costos y límites.",
  "mobile.faceid": "Abrir con Face ID",
  "mobile.faceid_reason": "Desbloquear DoneTalk",
  "mobile.locked": "DoneTalk está bloqueado.",
  "mobile.unlock": "Desbloquear",
  "mobile.notifications": "Notificaciones",
  "mobile.security": "Seguridad y Face ID",
  "mobile.faceid_hint": "La app pide Face ID al abrir y después de un minuto fuera.",
  "mobile.mfa_hint": "Para desactivarla o generar nuevos códigos de recuperación, usa DoneTalk en la computadora.",
  "mobile.group.service_hint": "horarios, resultados…",
  "mobile.group.ai": "Automatización e IA",
  "mobile.group.ai_hint": "flujos, asistentes…",
  "mobile.group.account": "Cuenta de la empresa",
  "mobile.group.account_hint": "plan, costos…",
  "mobile.push.lead": "DoneTalk avisa en este celular cuando:",
  "mobile.push.rule.message": "llega un mensaje en una de tus conversaciones",
  "mobile.push.rule.queue": "una conversación entra en la cola de tu equipo",
  "mobile.push.rule.assigned": "alguien te pasa una conversación",
  "mobile.push.rule.mention": "alguien te menciona en una nota",
  "mobile.push.rule.campaign": "una campaña espera tu aprobación",
  "mobile.push.rule.cost": "un límite de costo está por alcanzarse",
  "mobile.push.presence": "La cola solo avisa a quien está Online. En Offline, los mensajes y las conversaciones que te pasan no avisan; las menciones, aprobaciones y costos avisan siempre.",
  "mobile.push.system": "Ajustes de notificaciones del teléfono",
  "mobile.numbers.approved": "1 aprobada|{count} aprobadas",
  "mobile.numbers.sending": "Envío",
  "mobile.numbers.sync_templates": "Sincronizar plantillas",
  "mobile.numbers.connect_other": "Conectar otro número",
  "mobile.numbers.connect_hint": "Abre la ventana oficial de Meta en un navegador dentro de la app. Entras a DoneTalk con tu e-mail, luego al Facebook de quien administra la empresa, eliges el portafolio y confirmas el número por SMS.",
  "mobile.team.more": "Equipos, horarios y permisos",
  "mobile.team.role_changed": "Rol cambiado",
  "mobile.flows.starts": "Empieza cuando",
  "mobile.flows.trigger.channel_default": "Nueva conversación en el número",
  "mobile.flows.trigger.keyword": "Mensaje con: {words}",
  "mobile.flows.trigger.out_of_hours": "Mensaje fuera del horario",
  "mobile.flows.trigger.api": "Una llamada por la API",
  "mobile.flows.trigger.template_reply": "Respuesta a una plantilla",
  "mobile.flows.trigger.assistant_tool": "El asistente de IA inicia el flujo",
  "mobile.flows.trigger.manual": "Una persona inicia el flujo",
  "mobile.flows.trigger.none": "Ningún disparador aún",
  "mobile.flows.version_line": "Versión {n} publicada",
  "mobile.flows.draft_line": "borrador con cambios",
  "mobile.flows.not_published": "Aún no publicado",
  "mobile.flows.changed": "cambiado",
  "mobile.flows.other_blocks": "Otros bloques",
  "mobile.flows.phone_note": "En el celular: ver, probar, publicar, volver de versión y editar textos. Para cambiar caminos y bloques, usa la computadora o el iPad.",
  "mobile.flows.edit_text": "Editar texto",
  "mobile.flows.publish_confirm": "Las próximas conversaciones usan la nueva versión. Las que ya están en el flujo terminan en la versión con la que empezaron.",
  "mobile.flows.restore_confirm": "¿Volver a la versión {n}? Se publica de nuevo, como una versión nueva.",
  "mobile.flows.no_draft": "Nada nuevo para publicar",
  "mobile.mfa_hint_off": "Para activarla, usa DoneTalk en la computadora: muestra el código QR para la app autenticadora.",
  "contact.marketing": "Mensajes de marketing",
  "contact.marketing_hint": "Las campañas de marketing llegan a quien acepta y a quien no tiene registro. Quien no acepta queda fuera.",
  "onboarding.guide.team.role_supervisor": "Supervisor: sigue las colas, asigna, transfiere y ve los informes.",
  "onboarding.guide.team.role_auditor": "Auditor: ve todo, sin cambiar nada.",
  "onboarding.guide.team.hours_next": "Después de los equipos, vincúlales el horario de atención. Fuera de él, la atención espera en la cola.",
  "onboarding.guide.team.hours_cta": "Abrir horarios",
  "onboarding.guide.hours.title": "Horario de atención",
  "onboarding.guide.hours.text": "El horario del cuestionario ya está guardado aquí. Falta vincularlo a los equipos: fuera de él, la atención espera en la cola y la entrada puede enviar el mensaje de ausencia.",
  "onboarding.guide.hours.no_teams": "Aún no hay equipos. Crea los equipos primero y vuelve para vincular el horario.",
  "onboarding.guide.hours.without": "1 equipo aún no tiene horario.|{count} equipos aún no tienen horario.",
  "onboarding.guide.hours.link": "Usar este horario en los equipos",
  "onboarding.guide.hours.linked": "Horario vinculado a 1 equipo.|Horario vinculado a {count} equipos.",
  "onboarding.guide.hours.all_linked": "Todos los equipos ya tienen horario.",
  "onboarding.guide.hours.where_title": "Horarios distintos por equipo",
  "onboarding.guide.hours.where_text": "Crea otro horario aquí y elígelo en el equipo, en Equipo y personas.",
  "onboarding.guide.hours.ready": "El horario guardado y vinculado a los equipos. Es recomendado.",
  "onboarding.guide.whatsapp.ready": "El número está activo. El nombre visible sigue en revisión, y se puede usar mientras tanto.",
  "onboarding.guide.optout.title": "Quien no quiere recibir marketing",
  "onboarding.guide.optout.frequency_title": "Frecuencia y aprobación",
  "onboarding.guide.optout.frequency_text": "En esta misma pantalla están el intervalo entre campañas para el mismo contacto y cuándo una campaña necesita aprobación. Los valores por defecto ya protegen a la empresa; ajústalos antes de la primera campaña.",
  "onboarding.guide.optout.ready": "Las palabras y la respuesta guardadas. Es recomendado.",
  "onboarding.guide.optout.back_templates": "Volver a las plantillas",
  "onboarding.guide.budget.title": "Presupuesto del mes",
  "onboarding.guide.budget.text": "Indica cuánto puede gastar la empresa por mes con Meta y la IA. Sin presupuesto, nada se limita: es la forma de evitar sorpresas en la factura antes de las campañas.",
  "onboarding.guide.budget.limit_title": "Qué pasa en el límite",
  "onboarding.guide.budget.limit_text": "Empieza con “Solo avisar” para conocer el gasto. Después, puedes pausar campañas o todo envío pago cuando el presupuesto llegue al 100%. Quien gestiona los costos recibe las alertas.",
  "onboarding.guide.budget.short": "Define cuánto puede gastar la empresa por mes con Meta y la IA, y qué pasa cerca del límite.",
  "onboarding.guide.budget.cta": "Abrir costos y límites",
  "onboarding.guide.budget.ready": "Un presupuesto mensual guardado para la empresa. Es recomendado.",
  "onboarding.guide.knowledge.title": "Base de conocimiento",
  "onboarding.guide.knowledge.text": "Lo que el asistente sabe de la empresa: el sitio, PDFs y textos. Responde solo con lo que está aquí.",
  "onboarding.guide.knowledge.ready_count": "1 documento listo en la base.|{count} documentos listos en la base.",
  "onboarding.guide.knowledge.none": "El asistente solo cuenta como listo con al menos un documento en la base de conocimiento.",
  "onboarding.guide.knowledge.cta": "Abrir base de conocimiento",
  "onboarding.guide.knowledge.back": "Volver a los asistentes",
  "onboarding.rehearsal.ready_text": "La atención de prueba cerrada con un resultado.",
  "onboarding.step.outbound.budget": "Presupuesto del mes",
  "onboarding.when.outbound.budget": "Listo cuando la empresa tenga un presupuesto mensual.",
  "onboarding.done.outbound.budget": "Presupuesto del mes definido",
  "onboarding.lead.outbound.budget": "Define cuánto puede gastar la empresa por mes con Meta y la IA, y qué pasa cerca del límite.",
  "onboarding.detail.budget": "Hasta {amount} por mes",
  "onboarding.live.beyond.campaigns.title": "Campañas",
  "onboarding.live.beyond.campaigns.text": "Una plantilla aprobada para un segmento de contactos, con costo por respuesta y por venta.",
  "onboarding.live.beyond.costs.title": "Costos y límites",
  "onboarding.live.beyond.costs.text": "Cuánto cuestan Meta y la IA, por número, equipo y campaña, con presupuesto y alertas.",
  "onboarding.guide.hours.text_empty": "Crea aquí el horario en que atiende la empresa y vincúlalo a los equipos: fuera de él, la atención espera en la cola y la entrada puede enviar el mensaje de ausencia.",
  "onboarding.guide.hours.create_first": "Crea el primer horario en “Nuevo horario”. Después, puede ir a todos los equipos de una vez.",
  "push.number_code.title": "Llegó el código de WhatsApp",
  "push.number_code.body": "{code} es el código del número {number}.",
  "push.number_return.title": "Número aún sin conectar a WhatsApp",
  "push.number_return.body": "Si {number} no se conecta a WhatsApp, se devuelve el {date}, sin cargo.",
  "numbers.connect.two_paths": "Usa un número que la empresa ya tiene o contrata uno aquí mismo.",
  "numbers.connect.own_title": "Ya tengo un número",
  "numbers.connect.own_price": "Sin costo extra",
  "numbers.connect.own_time": "unos 10 minutos",
  "numbers.connect.rent_title": "Contratar un número por DoneTalk",
  "numbers.connect.new": "Nuevo",
  "numbers.connect.rent_text": "Un número de celular nuevo, solo para el WhatsApp de la empresa. Sin chip ni celular: el código de Meta llega aquí.",
  "numbers.connect.rent_ddd": "Eliges el DDD (código de área)",
  "numbers.connect.rent_fast": "Listo en unos 5 minutos",
  "numbers.connect.rent_app": "Funciona por DoneTalk; no sirve para la app WhatsApp Business del celular",
  "numbers.connect.rent_cta": "Contratar número",
  "numbers.connect.rent_ask": "Pídeselo a un Dueño o Administrador",
  "numbers.connect.rent_billing": "junto con el plan, desde la activación",
  "numbers.rent.title": "Contratar un número",
  "numbers.rent.lead": "Elige el DDD. El número se sortea entre los disponibles.",
  "numbers.rent.search": "Ciudad, estado o DDD",
  "numbers.rent.ddds": "DDD disponibles",
  "numbers.rent.out_of_stock": "El DDD {ddd} no tiene números ahora. Prueba otro o vuelve más tarde.",
  "numbers.rent.none": "Ningún DDD encontrado.",
  "numbers.rent.summary": "Número de celular con DDD {ddd}",
  "numbers.rent.per_month": "{price} por mes",
  "numbers.rent.cond_billing": "Se cobra junto con el plan desde el día en que el número se activa en WhatsApp.",
  "numbers.rent.cond_owner": "El número lo provee Nuvvun y queda con tu empresa mientras seas cliente. Si te vas, puedes pedir la transferencia de la línea ({fee}).",
  "numbers.rent.cond_cancel": "Puedes cancelar cuando quieras: vale al final del ciclo y el mes en curso se cobra entero.",
  "numbers.rent.cond_app": "Funciona solo por DoneTalk, en la API oficial de WhatsApp; no sirve para la app WhatsApp Business del celular.",
  "numbers.rent.plan_place": "Cuenta en el límite de números del plan: será el {n}º de {max}.",
  "numbers.rent.plan_full": "El plan ya está en el límite de números",
  "numbers.rent.sandbox": "Entorno de prueba de Salvy: el número es ficticio, no recibe SMS reales y no se cobra. Solo el equipo de Nuvvun ve esta opción.",
  "numbers.rent.accept": "Leí y acepto las",
  "numbers.rent.terms": "condiciones del número contratado",
  "numbers.rent.confirm": "Contratar por {price}/mes",
  "numbers.rent.done": "Número contratado. Ahora solo falta conectarlo a WhatsApp.",
  "numbers.rented.awaiting": "Esperando el código",
  "numbers.rented.sandbox": "Prueba (sandbox)",
  "numbers.rented.not_billed": "Aún sin cobro",
  "numbers.rented.your_number": "Tu número nuevo",
  "numbers.rented.copy_number": "Copiar número",
  "numbers.rented.number_copied": "Número copiado, sin el +55",
  "numbers.rented.phase1_title": "Ahora conecta el número a WhatsApp",
  "numbers.rented.phase1_step1": "Haz clic en “Conectar con Meta” e ingresa con el Facebook de quien administra la empresa.",
  "numbers.rented.phase1_step2": "Cuando Meta pida el número, elige agregar un número nuevo y pega el número de arriba.",
  "numbers.rented.phase1_step3": "Elige recibir el código por SMS (este número no recibe llamadas).",
  "numbers.rented.phase1_step4": "Copia el código que aparece aquí al lado y pégalo en la ventana de Meta.",
  "numbers.rented.phase1_hint": "Si necesitas parar, el número queda guardado aquí. El cobro empieza solo cuando esté activo.",
  "numbers.rented.phase2_title": "Conectar al WhatsApp de la empresa",
  "numbers.rented.phase2_lead": "En la ventana de Meta solo eliges la empresa y la cuenta de WhatsApp. DoneTalk agrega el número, confirma el código y lo registra, sin nada que escribir.",
  "numbers.rented.display_name": "Nombre que verán los clientes",
  "numbers.rented.phase2_start": "Conectar con Meta",
  "numbers.rented.step_rented": "Número contratado con DDD {ddd}",
  "numbers.rented.step_adding": "Agregando el número a la cuenta de WhatsApp",
  "numbers.rented.step_requesting": "Pidiendo el código a Meta",
  "numbers.rented.step_awaiting": "Esperando el SMS con el código",
  "numbers.rented.step_verifying": "Confirmando el código",
  "numbers.rented.step_registering": "Registrando con el PIN de seguridad",
  "numbers.rented.phase2_failed": "No funcionó: {reason}",
  "numbers.rented.retry": "Intentar de nuevo",
  "numbers.rented.returns": "Si no se conecta a WhatsApp antes del {date}, el número se devuelve sin cargo.",
  "numbers.rented.swap": "Cambiar de número",
  "numbers.rented.swap_confirm": "¿Devolver este número y contratar otro? Aún no se usó, así que no hay cobro.",
  "numbers.rented.simulate": "Simular SMS de Meta",
  "numbers.rented.code_title": "Código de WhatsApp",
  "numbers.rented.code_at": "Llegó a las {time} por SMS",
  "numbers.rented.copy_code": "Copiar código",
  "numbers.rented.code_copied": "Código copiado",
  "numbers.rented.code_arrived": "Llegó el código de WhatsApp",
  "numbers.rented.code_waiting": "Esperando el SMS de Meta…",
  "numbers.rented.code_waiting_hint": "Suele llegar en segundos. Si pasan más de 2 minutos, pide otro código en la ventana de Meta.",
  "numbers.rented.raw_title": "Otro SMS recibido|{count} otros SMS recibidos",
  "numbers.rented.code_app": "También avisamos en la app del celular de quien lo contrató.",
  "numbers.rented.by_donetalk": "Contratado por DoneTalk",
  "numbers.rented.active_line": "{price}/mes · activo desde {since} · próximo cobro el {next}",
  "numbers.rented.cancel_line": "Cancelación programada: el número funciona hasta el {date}.",
  "numbers.rented.transfer_line": "Transferencia pedida el {date}. El equipo de DoneTalk hablará contigo; el número sigue funcionando.",
  "numbers.rented.transferred_line": "La línea fue transferida a tu empresa.",
  "numbers.rented.sms_title": "Códigos y SMS recibidos",
  "numbers.rented.sms_none": "Aún no se recibió ningún SMS.",
  "numbers.rented.sms_code": "Código",
  "numbers.rented.undo": "Deshacer la cancelación",
  "numbers.rented.take": "Llevarse el número",
  "numbers.rented.cancel": "Cancelar el número",
  "numbers.rented.cancel_title": "¿Cancelar el número {number}?",
  "numbers.rented.cancel_lead": "La cancelación vale al final del ciclo.",
  "numbers.rented.cancel_1": "Hasta entonces el número sigue atendiendo normalmente.",
  "numbers.rented.cancel_2": "Al final del ciclo, DoneTalk desconecta el número de WhatsApp y cierra la línea. Las conversaciones quedan en el historial.",
  "numbers.rented.cancel_3": "Durante 6 meses, DoneTalk no entrega este número a ninguna otra empresa.",
  "numbers.rented.cancel_4": "Una vez cerrado, el número no vuelve. Si quieres quedártelo, pide la transferencia.",
  "numbers.rented.cancel_digits": "Para confirmar, escribe los 4 últimos dígitos del número",
  "numbers.rented.keep": "Mantener el número",
  "numbers.rented.cancel_confirm": "Cancelar al final del ciclo",
  "numbers.rented.cancel_done": "Cancelación programada. Puedes deshacerla hasta la fecha.",
  "numbers.rented.take_title": "Llevarse el número",
  "numbers.rented.take_lead": "Para pasar la línea a nombre de tu empresa, con otra operadora o fuera de DoneTalk.",
  "numbers.rented.take_1": "Envías el pedido por aquí.",
  "numbers.rented.take_2": "El equipo de DoneTalk responde en hasta 2 días hábiles con lo que necesita (normalmente el CNPJ y quién firma).",
  "numbers.rented.take_3": "El número sigue funcionando hasta que termine la transferencia.",
  "numbers.rented.take_fee": "Tasa de transferencia: {fee}, cobrada una vez junto con el plan.",
  "numbers.rented.take_note": "¿Algo que el equipo deba saber? (opcional)",
  "numbers.rented.take_confirm": "Pedir la transferencia",
  "numbers.rented.transfer_done": "Pedido enviado. El equipo de DoneTalk hablará contigo.",
  "errors.numbers_unavailable": "La contratación de números no está disponible ahora. Intenta de nuevo en unos instantes o habla con Nuvvun.",
  "errors.area_code_out_of_stock": "Este DDD se quedó sin números ahora. Elige otro.",
  "errors.numbers_provider_error": "La operadora del número no respondió. Intenta de nuevo en unos instantes.",
  "errors.number_not_found": "Número no encontrado.",
  "errors.number_not_cancellable": "Este número no se puede cancelar ahora.",
  "errors.number_not_cancel_scheduled": "Este número no tiene cancelación programada.",
  "errors.number_not_transferable": "La transferencia solo se puede pedir para un número activo.",
  "errors.number_not_transfer_requested": "Este número no tiene pedido de transferencia.",
  "errors.number_not_awaiting": "Este número ya está conectado a WhatsApp.",
  "errors.auto_attach_off": "La conexión automática aún no está disponible. Usa “Conectar con Meta”.",
  "errors.attach_not_failed": "Nada que reintentar.",
  "errors.sandbox_only": "Solo en el entorno de prueba.",
  "plan.addon.title": "Adicionales",
  "plan.addon.numbers": "Números contratados por DoneTalk",
  "plan.addon.count": "{count} × {price} este mes|{count} × {price} este mes",
  "plan.addon.awaiting": "esperando conectarse a WhatsApp, aún sin cobro",
  "plan.addon.since": "activo desde el {date}",
  "plan.addon.ends": "cancelación programada, termina el {date}",
  "plan.addon.closed": "cerrado el {date}",
  "plan.addon.transferred": "transferido a la empresa",
  "plan.addon.total": "Total del mes, sin los mensajes de Meta",
  "plan.addon.hint": "Los mensajes de Meta siguen cobrados por Meta, directo en la tarjeta de la empresa. El adicional de números lo cobra Nuvvun junto con el plan.",
  "plan.addon.rented_count": "1 contratado por DoneTalk|{count} contratados por DoneTalk",
  "platform.tab.numbers": "Números contratados",
  "platform.lead.numbers": "Las líneas de Salvy que DoneTalk provee a los clientes: quién las usa, cuánto rinden y cuestan, y qué está pendiente.",
  "platform.numbers.kpi.active": "Activos",
  "platform.numbers.kpi.charged": "Cobrado en el mes",
  "platform.numbers.kpi.paid": "Pagado a Salvy",
  "platform.numbers.kpi.margin": "Margen del mes",
  "platform.numbers.kpi.fees": "Tasas de transferencia",
  "platform.numbers.filter.all": "Todos",
  "platform.numbers.filter.awaiting": "Esperando conectar",
  "platform.numbers.filter.cancel": "Cancelación programada",
  "platform.numbers.filter.transfer": "Transferencia pedida",
  "platform.numbers.filter.quarantine": "Cuarentena",
  "platform.numbers.col.number": "Número",
  "platform.numbers.col.customer": "Cliente",
  "platform.numbers.col.state": "Situación",
  "platform.numbers.col.next": "Próximo paso",
  "platform.numbers.col.action": "Acción",
  "platform.numbers.state.awaiting_code": "Esperando conectarse a WhatsApp",
  "platform.numbers.state.active": "Activo",
  "platform.numbers.state.cancel_scheduled": "Cancelación programada",
  "platform.numbers.state.transfer_requested": "Transferencia pedida",
  "platform.numbers.state.transferred": "Transferido",
  "platform.numbers.state.quarantine": "Cuarentena",
  "platform.numbers.state.closed": "Cerrado",
  "platform.numbers.next.returns": "se devuelve solo el {date} si no se conecta",
  "platform.numbers.next.active": "cobrado desde el {date}",
  "platform.numbers.next.ends": "termina el {date}",
  "platform.numbers.next.transfer": "hablar con el cliente sobre la transferencia",
  "platform.numbers.next.transferred": "transferido el {date}",
  "platform.numbers.next.free_on": "libre el {date}",
  "platform.numbers.next.closed": "cerrado el {date}",
  "platform.numbers.mark_transferred": "Marcar como transferido",
  "platform.numbers.cancel_cycle": "Cancelar al final del ciclo",
  "platform.numbers.cancel_now": "Cancelar ahora",
  "platform.numbers.cancel_now_confirm": "¿Cancelar {number} ahora? Sale de WhatsApp en el acto y entra en cuarentena.",
  "platform.numbers.cancel_cycle_confirm": "¿Programar la cancelación de {number} para el final del ciclo?",
  "platform.numbers.hint": "La cuarentena vale dentro de DoneTalk: un número en cuarentena nunca se entrega a otro cliente; si Salvy sortea uno en una contratación nueva, DoneTalk lo devuelve y pide otro. Las líneas de prueba (sandbox) no entran en los totales.",
  "platform.action.number_rented": "Número contratado por DoneTalk",
  "platform.action.number_transfer_requested": "Transferencia de número pedida",
  "platform.action.number_transferred": "Número transferido al cliente",
  "platform.action.number_cancelled": "Número cancelado por Nuvvun",
  "onboarding.q.number": "¿Qué número vas a usar en el WhatsApp oficial?",
  "onboarding.q.number_hint": "¿Sin número libre? DoneTalk te provee uno, con el DDD que elijas.",
  "onboarding.number.app": "El de WhatsApp Business del celular",
  "onboarding.number.own": "Un número libre de la empresa",
  "onboarding.number.rent": "Quiero contratar uno por DoneTalk",
  "onboarding.guide.rent_title": "¿No tienes un número libre?",
  "onboarding.guide.rent_text": "Contrata uno aquí por {price}/mes. Eliges el DDD, el código de Meta aparece en la pantalla y la conexión termina en unos 5 minutos.",
  "onboarding.guide.rent_cta": "Contratar un número",
  "onboarding.guide.rented_title": "Tu número contratado está listo",
  "onboarding.guide.rented_text": "Falta conectar {number} a WhatsApp: sigue los pasos en la tarjeta del número. El código de Meta aparece allí.",
  "onboarding.guide.whatsapp.q_rent_app": "¿Puedo usar el número contratado en el celular?",
  "onboarding.guide.whatsapp.a_rent_app": "No. Funciona solo por DoneTalk, en la API oficial. Para atender también desde la app del celular, conecta el número que ya usas allí.",
  "onboarding.guide.whatsapp.q_rent_owner": "¿El número contratado es mío?",
  "onboarding.guide.whatsapp.a_rent_owner": "Lo provee Nuvvun y queda con tu empresa mientras seas cliente. Si te vas, puedes pedir la transferencia de la línea.",
  "onboarding.detail.rented_waiting": "Número contratado ({number}), falta conectarlo en Meta",
  "mobile.numbers.rented_paste": "Pega el código en la ventana de Meta, en la computadora. Contratado por DoneTalk; aún sin cobro.",
  "numbers.rented.code_received": "Código recibido",
  "plan.addon.count_none": "Nada cobrado este mes todavía",
  "numbers.rent.plan_full_line": "El plan ya usa los {max} números que permite. Para contratar otro, habla con Nuvvun para cambiar de plan.",
  "page.unsaved_bar": "Tienes cambios sin guardar",
  "platform.ai.base_url": "Dirección de la API (opcional)",
  "platform.ai.default_key": "Clave predeterminada de este proveedor",
  "platform.ai.auto": "Automático",
  "platform.ai.manual": "Elegido a mano",
  "platform.ai.back_to_auto": "volver al automático",
  "platform.ai.task_retiring": "{model} se retira el {date}; el sustituto es {next}.",
  "platform.ai.task_manual_until": "{model} se retira el {date}. Como se eligió a mano, queda hasta entonces y luego pasa a {next}.",
  "platform.ai.task_retiring_alone": "{model} se retira el {date} y aún no tiene sustituto. Elige otro modelo.",
  "platform.ai.task_replaced": "Cambiado automáticamente de {from} el {date}.",
  "platform.ai.task_moved": "{task}: {from} → {to} (retiro anunciado)",
  "platform.ai.task_moved_retired": "{task}: {from} → {to} (modelo retirado)",
  "platform.ai.catalog_added": "{count} modelo nuevo en el catálogo|{count} modelos nuevos en el catálogo",
  "platform.ai.replaced_by": "sustituto: {model}",
  "platform.ai.col.mode": "Tipo",
  "platform.ai.mode.chat": "Conversación",
  "platform.ai.mode.embedding": "Embeddings",
  "platform.ai.mode.audio_transcription": "Transcripción",
  "platform.ai.surfaces_hint": "Automático: cuando el proveedor anuncia el retiro de un modelo, la tarea pasa sola al sustituto. Elegir otro modelo aquí fija la elección hasta el día del retiro; desde ese día, las llamadas van al sustituto, incluidas las de los clientes que eligieron ese modelo.",
  "builder.arrange": "Organizar",
  "builder.arrange_selection": "Organizar selección",
  "builder.arrange_hint": "Ordena los bloques de izquierda a derecha, con menos líneas cruzadas, y muestra todo el flujo en pantalla (Shift+Alt+T). Con varios bloques seleccionados, solo esos.",
  "builder.arranged": "Bloques organizados",
  "builder.selection_count": "{count} bloque seleccionado|{count} bloques seleccionados",
  "builder.duplicate": "Duplicar",
  "builder.duplicated": "{count} bloque duplicado|{count} bloques duplicados",
  "builder.delete_selected": "Eliminar",
  "builder.deleted_many": "{count} bloque eliminado|{count} bloques eliminados",
  "builder.clear_selection": "Limpiar selección",
  "builder.canvas_hint": "Shift o ⌘/Ctrl + clic elige varios · suelte un enlace en el vacío para crear el próximo bloque · ⌨ muestra los atajos",
  "onboarding.guide.payment_done": "Registrada. Meta confirma que el número puede enviar.",
  "onboarding.guide.payment_done_at": "Registrada. Meta confirmó que el número puede enviar en la verificación del {when}.",
  "onboarding.guide.payment_change": "Ver o cambiar la tarjeta en Meta",
  "onboarding.guide.payment_after": "Después de registrarla, haz clic en “Verificar ahora” en la tarjeta del número: la etapa queda lista cuando Meta lo confirme.",
  "tags.pill.label": "Etiquetas: {names}",
  "tags.menu.manage": "Gestionar etiquetas",
  "tags.panel.close": "Cerrar etiquetas",
  "tags.panel.people": "{count} contacto|{count} contactos",
  "tags.panel.empty": "Aún no hay etiquetas",
  "tags.panel.empty_hint": "Crea etiquetas como Lead o Pago pendiente para agrupar a las personas y filtrar las atenciones por ellas.",
  "tags.editor.new": "Crear nueva etiqueta",
  "tags.editor.edit": "Editar etiqueta",
  "tags.editor.name": "Nombre de la etiqueta",
  "tags.editor.color": "Elegir el color",
  "tags.editor.suggestions": "Sugerencias",
  "tags.editor.people": "Personas incluidas",
  "tags.editor.add_people": "Agregar personas",
  "tags.editor.remove_person": "Quitar a {name} de la etiqueta",
  "tags.editor.create": "Crear etiqueta",
  "tags.editor.archive": "Archivar etiqueta",
  "tags.editor.archive_hint": "Sale de los filtros y de las listas; los informes la conservan.",
  "tags.editor.archived": "Etiqueta archivada",
  "tags.editor.created": "Etiqueta creada",
  "tags.editor.saved": "Etiqueta guardada",
  "tags.editor.exists": "Ya existe una etiqueta con ese nombre",
  "tags.picker.search": "Buscar nombre o número",
  "tags.picker.add": "Agregar ({count})",
  "tags.picker.empty": "No se encontró a nadie",
  "tags.filter.empty": "Nadie tiene esta etiqueta",
  "tags.filter.empty_hint": "Usa el botón de etiqueta arriba de una atención para incluir a alguien.",
  "tags.suggest.new_customer": "Nuevo cliente",
  "tags.suggest.new_order": "Nuevo pedido",
  "tags.suggest.payment_pending": "Pago pendiente",
  "tags.suggest.follow_up": "Seguimiento",
  "tags.suggest.paid": "Pagado",
  "tags.suggest.order_done": "Pedido finalizado",
  "tags.suggest.lead": "Lead",
  "tags.suggest.important": "Importante",
  "permission.tags.manage": "Crear y editar etiquetas",
  "permission.appointments.read": "Ver agendas y citas",
  "permission.appointments.write": "Agendar, reprogramar y cancelar para contactos",
  "permission.scheduling.manage": "Configurar agendas, horarios y avisos",
  "permissions.group.scheduling": "Agenda",
  "plan.label.agendas": "Agendas",
  "plan.label.appointment_types": "Tipos de cita",
  "plan.limit.agendas": "1 agenda|{count} agendas",
  "plan.limit.appointment_types": "1 tipo de cita|{count} tipos de cita",
  "platform.plans.hint.agendas": "Agendas activas. Bloquea crear una más.",
  "platform.plans.hint.appointment_types": "Tipos de cita activos. Bloquea crear uno más.",
  "integrations.event.appointment.booked": "Cita agendada",
  "integrations.event.appointment.rescheduled": "Cita reprogramada",
  "integrations.event.appointment.cancelled": "Cita cancelada",
  "integrations.event.appointment.confirmed": "Cita confirmada",
  "integrations.event.appointment.attended": "Asistió a la cita",
  "integrations.event.appointment.no_show": "Faltó a la cita",
  "push.appointment.booked": "Nueva cita",
  "push.appointment.rescheduled": "Cita reprogramada",
  "push.appointment.cancelled": "Cita cancelada",
  "push.appointment.unconfirmed": "El cliente no confirmó",
  "push.appointment.change_requested": "El cliente quiere cambiar la hora",
  "push.appointment.confirmed": "El cliente confirmó",
  "push.appointment.summary": "Tu agenda de hoy",
  "push.appointment.summary_body": "1 cita|{count} citas",
  "mail.appointment.booked": "Nueva cita: {contact} · {type} · {when}",
  "mail.appointment.rescheduled": "Cita reprogramada: {contact} · {type} · {when}",
  "mail.appointment.cancelled": "Cita cancelada: {contact} · {type} · {when}",
  "mail.appointment.add": "Agregar a tu calendario: {link}",
  "date.previous_month": "Mes anterior",
  "date.next_month": "Mes siguiente",
  "node.schedule": "Agendar",
  "node.schedule.type": "Agenda y tipo",
  "node.schedule.no_types": "Crea una agenda con un tipo de cita en Configuración › Agendas.",
  "node.schedule.body": "Texto antes de los horarios",
  "node.schedule.body_placeholder": "Elige un horario para tu visita:",
  "node.schedule.mode": "Cómo mostrar los horarios",
  "node.schedule.mode.list": "Lista de WhatsApp",
  "node.schedule.mode.calendar": "Calendario de WhatsApp",
  "node.schedule.mode.buttons": "Botones",
  "node.schedule.mode_hint.list": "Hasta 8 horarios a la vez, con \"Otros horarios\" y \"Ninguno de estos\".",
  "node.schedule.mode_hint.calendar": "La persona elige el día y luego la hora en un calendario dentro de WhatsApp. Activa el Calendario de WhatsApp en la agenda; sin él, va la lista.",
  "node.schedule.mode_hint.buttons": "Las 2 mejores opciones y \"Otros horarios\".",
  "node.schedule.answer": "Respuesta a \"{question}\"",
  "node.schedule.hint": "La confirmación, los recordatorios y las reglas de reprogramar vienen de la agenda; el bloque solo ofrece y agenda.",
  "builder.exit_booked": "Agendado",
  "builder.exit_declined": "Ningún horario sirve",
  "builder.exit_no_times": "Sin horarios libres",
  "simulator.schedule_offer": "Ofrecería los horarios libres (en la prueba, horarios de ejemplo)",
  "simulator.schedule_book": "Agendaría {when} (en la prueba, no se agenda nada)",
  "assistants.tab.agenda": "Agenda",
  "assistants.agenda.title": "Agenda",
  "assistants.agenda.lead": "Cuando el cliente quiere agendar, {name} consulta la agenda, ofrece horarios libres y agenda el que elija.",
  "assistants.agenda.on": "Agendar en la agenda",
  "assistants.agenda.on_hint": "Ver horarios libres, agendar, reprogramar, cancelar y ver las citas del cliente.",
  "assistants.agenda.types": "Puede agendar en",
  "assistants.agenda.duration": "{min} min",
  "assistants.agenda.no_types": "Aún no hay agendas con tipos de cita.",
  "assistants.agenda.open_agendas": "Abrir Agendas",
  "assistants.agenda.all_types": "Ninguno marcado: puede agendar en todos.",
  "assistants.agenda.some_types": "Solo en los tipos marcados.",
  "assistants.agenda.how": "Cómo ofrece",
  "assistants.agenda.offer": "Ofrecer",
  "assistants.agenda.offer_label": "Cuántos horarios",
  "assistants.agenda.times": "1 horario|{count} horarios",
  "assistants.agenda.at_a_time": "a la vez,",
  "assistants.agenda.prefer": "de preferencia",
  "assistants.agenda.prefer_label": "Preferencia",
  "assistants.agenda.prefer_any": "los primeros libres",
  "assistants.agenda.prefer_days": "en el próximo día|en los próximos {count} días",
  "assistants.agenda.shown_as": "mostrados como",
  "assistants.agenda.shown_as_label": "Cómo mostrar",
  "assistants.agenda.present.list": "lista de WhatsApp",
  "assistants.agenda.present.text": "texto en la respuesta",
  "assistants.agenda.before": "Antes de agendar,",
  "assistants.agenda.before_label": "Antes de agendar",
  "assistants.agenda.confirm_yes": "repetir día, hora y lugar y esperar el sí",
  "assistants.agenda.confirm_no": "agendar en cuanto el cliente elija",
  "assistants.agenda.refusals": "Si ninguno sirve",
  "assistants.agenda.refusals_label": "Cuántas veces",
  "assistants.agenda.refusal_n": "la primera vez|la {count}ª vez",
  "assistants.agenda.handoff": "pasar a una persona ({team}).",
  "assistants.agenda.can_find": "Ver horarios libres: solo horarios que existen de verdad; nunca inventa ni calcula una fecha.",
  "assistants.agenda.can_book": "Agendar: solo un horario de la lista. Si alguien lo tomó antes, ofrece otros.",
  "assistants.agenda.can_move": "Reprogramar: dentro de las reglas del tipo (ej.: hasta 4 h antes).",
  "assistants.agenda.can_cancel": "Cancelar: cuando el cliente lo pide, dentro de las reglas del tipo.",
  "assistants.agenda.can_list": "Ver las citas del cliente: para responder \"¿a qué hora es mi visita?\".",
  "assistant.tool.scheduling": "Agenda",
  "assistant.tool_hint.scheduling": "Ver horarios libres y agendar citas.",
  "assistants.test.appointment_book": "Agendaría: {detail} (en la prueba, no se agenda nada)",
  "assistants.test.appointment_reschedule": "Reprogramaría: {detail}",
  "assistants.test.appointment_cancel": "Cancelaría: {detail}",
  "templates.header.location": "Ubicación (mapa)",
  "templates.header.location_hint": "Cada envío lleva el lugar (ej.: la dirección de la cita), mostrado como mapa arriba.",
  "templates.header.location_preview": "El mapa del lugar",
  "push.appointment.calendar_changed": "El evento cambió en tu calendario: el cliente elegirá otra hora",
  "event.appointment_booked": "Cita agendada: {type} · {when}",
  "event.appointment_booked_with": "Cita agendada: {type} · {when} · con {name}",
  "event.appointment_rescheduled": "Cita reprogramada: {type} · {when}",
  "event.appointment_cancelled": "Cita cancelada: {type} · {when}",
  "event.appointment_confirmed": "El cliente confirmó: {type} · {when}",
  "event.appointment_attended": "Asistió: {type} · {when}",
  "event.appointment_no_show": "Faltó: {type} · {when}",
  "event.appointment_unconfirmed": "Sin confirmación del cliente: {type} · {when}",
  "event.appointment_change_requested_move": "El cliente quiere reprogramar fuera de plazo: {type} · {when}",
  "event.appointment_change_requested_cancel": "El cliente quiere cancelar fuera de plazo: {type} · {when}",
  "event.appointment_calendar_changed": "El evento cambió en el calendario de quien atiende: habla con el cliente sobre {type} · {when}",
  "event.appointment_calendar_changed_asked": "El evento cambió en el calendario de quien atiende; pedimos al cliente un nuevo horario para {type}",
  "nav.agenda": "Agenda",
  "agendaview.title": "Agenda",
  "agendaview.book": "Agendar",
  "agendaview.busy": "Ocupado",
  "agendaview.busy_where": "{calendar} · {name}",
  "agendaview.day_empty": "Nada agendado",
  "agendaview.empty": "Todavía no hay ninguna agenda",
  "agendaview.empty_hint": "Crea una en Configuración › Agendas para agendar citas con los clientes.",
  "agendaview.empty_action": "Crear una agenda",
  "agendaview.filter.agenda": "Agenda",
  "agendaview.filter.all_agendas": "Todas las agendas",
  "agendaview.filter.all_people": "Todas las personas",
  "agendaview.filter.me": "{name} (tú)",
  "agendaview.filter.person": "Persona",
  "agendaview.go_to": "Ir al día",
  "agendaview.legend": "Leyenda",
  "agendaview.legend.confirmed": "Confirmada",
  "agendaview.legend.booked": "Esperando al cliente",
  "agendaview.legend.no_show": "No asistió",
  "agendaview.legend.busy": "Ocupado en Google/Outlook",
  "agendaview.next_week": "Semana siguiente",
  "agendaview.previous_week": "Semana anterior",
  "agendaview.provider.google": "Google",
  "agendaview.provider.microsoft": "Outlook",
  "agendaview.provider.caldav": "iCloud/CalDAV",
  "agendaview.provider.ics": "Enlace de la agenda",
  "agendaview.today": "Hoy",
  "agendaview.tomorrow": "Mañana",
  "agendaview.week": "Semana",
  "agendaview.week_of": "{from} al {to}",
  "agendaview.zone_note": "Horarios en la zona {zone}",
  "agendaview.demo.week": "Semana del equipo (WeekView)",
  "agendaview.demo.week_hint": "Las citas que se superponen quedan lado a lado; la línea roja es la hora actual; lo ocupado de Google/Outlook aparece rayado. En el celular se vuelve una lista de días.",
  "agendaview.demo.slots": "Horarios libres (SlotGrid)",
  "agendaview.demo.slots_hint": "Las flechas recorren los horarios; Enter elige.",
  "agendaview.demo.panel": "Cita abierta (AppointmentPanel)",
  "appointment.status.booked": "Esperando al cliente",
  "appointment.status.confirmed": "Confirmada",
  "appointment.status.cancelled": "Cancelada",
  "appointment.status.attended": "Asistió",
  "appointment.status.no_show": "No asistió",
  "appointment.panel": "Cita",
  "appointment.loading": "Cargando…",
  "appointment.when": "Cuándo",
  "appointment.when_value": "{day} {date}, {start}–{end}",
  "appointment.with": "Con",
  "appointment.contact": "Cliente",
  "appointment.where": "Dónde",
  "appointment.join": "Entrar a la llamada",
  "appointment.cancel_reason": "Motivo",
  "appointment.moved": "Reprogramada",
  "appointment.moved_count": "1 vez|{count} veces",
  "appointment.open_conversation": "Abrir la conversación",
  "appointment.reschedule": "Reprogramar",
  "appointment.confirm_for_contact": "Confirmar por el cliente",
  "appointment.attended": "Asistió",
  "appointment.no_show": "No asistió",
  "appointment.cancel": "Cancelar",
  "appointment.answers": "Respuestas",
  "appointment.notes": "Nota del equipo",
  "appointment.notes_label": "Solo el equipo la ve",
  "appointment.notes_saved": "Nota guardada",
  "appointment.story": "Lo que pasó",
  "appointment.by.member": "por {name}",
  "appointment.by.team": "por alguien del equipo",
  "appointment.by.assistant": "por el asistente {name}",
  "appointment.by.assistant_unnamed": "por el asistente de IA",
  "appointment.by.flow": "por el flujo {name}",
  "appointment.by.flow_unnamed": "por un flujo",
  "appointment.by.api": "por una integración",
  "appointment.by.contact": "por el cliente",
  "appointment.by.system": "por DoneTalk",
  "appointment.history.booked": "Agendada {by}",
  "appointment.history.rescheduled": "Reprogramada {by}",
  "appointment.history.cancelled": "Cancelada {by}",
  "appointment.history.confirmed": "Confirmada {by}",
  "appointment.history.attended": "Asistencia registrada {by}",
  "appointment.history.no_show": "Ausencia registrada {by}",
  "appointment.history.confirmed_by_contact": "El cliente tocó Confirmar",
  "appointment.notice.confirmation": "Confirmación",
  "appointment.notice.confirm_request": "Pedido de confirmación",
  "appointment.notice.reminder": "Recordatorio",
  "appointment.notice.rescheduled": "Aviso del nuevo horario",
  "appointment.notice.cancelled": "Aviso de cancelación",
  "appointment.notice.no_show": "Mensaje “Te extrañamos”",
  "appointment.notice.confirm_deadline": "Plazo para que el cliente confirme",
  "appointment.notice.sent.confirmation": "Confirmación enviada",
  "appointment.notice.sent.confirm_request": "Pedido de confirmación enviado",
  "appointment.notice.sent.reminder": "Recordatorio enviado",
  "appointment.notice.sent.rescheduled": "Aviso del nuevo horario enviado",
  "appointment.notice.sent.cancelled": "Aviso de cancelación enviado",
  "appointment.notice.sent.no_show": "Mensaje “Te extrañamos” enviado",
  "appointment.notice.deadline_passed": "Pasó el plazo para que el cliente confirme",
  "appointment.notice.failed": "{name}: no salió",
  "appointment.notice.skipped": "{name}: no hizo falta",
  "appointment.calendar.synced": "En la agenda {calendar} de {name}",
  "appointment.calendar.pending": "Yendo a la agenda {calendar} de {name}",
  "appointment.calendar.failed": "No entró en la agenda {calendar} de {name}",
  "appointment.cancel_title": "Cancelar la cita",
  "appointment.cancel_lead": "{when}. El horario vuelve a quedar libre.",
  "appointment.cancel_reason_label": "Motivo (opcional)",
  "appointment.cancel_notify": "Avisar al cliente por WhatsApp",
  "appointment.cancel_notify_hint": "Sale el aviso de cancelación de la agenda.",
  "appointment.cancel_keep": "Volver",
  "appointment.cancel_confirm": "Cancelar cita",
  "appointment.cancelled_toast": "Cita cancelada",
  "appointment.marked.confirmed": "Confirmada por el cliente",
  "appointment.marked.attended": "Asistencia registrada",
  "appointment.marked.no_show": "Ausencia registrada",
  "appointment.contact_title": "Citas",
  "appointment.contact_empty": "Todavía no hay citas.",
  "appointment.book": "Agendar",
  "appointment.more_past": "Ver 1 anterior más|Ver {count} anteriores más",
  "appointment.fewer_past": "Ver menos",
  "appointment.place.contact_field": "Dirección del cliente",
  "appointment.place.online_google_meet": "En línea, por Google Meet",
  "appointment.place.online_teams": "En línea, por Microsoft Teams",
  "appointment.place.online_link": "En línea, por enlace",
  "appointment.place.phone": "Por teléfono",
  "appointment.place.to_agree": "Lugar a acordar",
  "appointment.error.slot_taken": "Ese horario acaba de ocuparse. Elige otro.",
  "appointment.error.contact_has_appointment": "Este cliente ya tiene una cita de este tipo.",
  "appointment.error.agenda_inactive": "Esta agenda está pausada o desactivada.",
  "appointment.error.agenda_has_no_people": "Nadie atiende en esta agenda todavía.",
  "appointment.error.appointment_closed": "Esta cita ya fue cancelada o concluida.",
  "appointment.error.appointment_not_started": "Solo se puede marcar asistencia o inasistencia después de que empiece.",
  "appointment.error.appointment_not_found": "Esta cita ya no existe.",
  "appointment.error.contact_not_found": "Este contacto ya no existe.",
  "appointment.error.member_not_in_agenda": "Esta persona no atiende en esta agenda.",
  "book.action": "Agendar",
  "book.title": "Agendar con {name}",
  "book.title_pick": "Agendar",
  "book.title_reschedule": "Reprogramar con {name}",
  "book.pick_hint": "¿Para quién es la cita?",
  "book.pick_search": "Buscar contacto",
  "book.pick_empty": "No se encontró ningún contacto.",
  "book.for": "Para",
  "book.change_contact": "Cambiar",
  "book.from_when": "Horario actual:",
  "book.no_types": "No hay tipos de cita activos. Crea uno en Configuración › Agendas.",
  "book.type": "Agenda y tipo",
  "book.who": "Quién atiende",
  "book.anyone": "Cualquier persona libre",
  "book.together": "Todos juntos",
  "book.required": "{label} (obligatorio)",
  "book.slots": "Horarios libres",
  "book.loading": "Buscando horarios libres…",
  "book.no_slots": "No hay horarios libres en los próximos días.",
  "book.more_times": "+1 horario|+{count} horarios",
  "book.all_times": "Mostrar todos los horarios",
  "book.fewer_times": "Mostrar menos horarios",
  "book.days_before": "Días anteriores",
  "book.days_after": "Días siguientes",
  "book.days_range": "{from} al {to}",
  "book.more": "Ver más días o elegir otro horario",
  "book.other_title": "Elegir otro horario",
  "book.other_hint": "Vale también fuera de los horarios libres. Solo no se puede si la persona ya tiene otro compromiso a esa hora.",
  "book.other_day": "Día",
  "book.other_time": "Hora",
  "book.taken": "Alguien acaba de agendar ese horario. Estos siguen libres:",
  "book.has_one": "{name} ya tiene una cita de este tipo.",
  "book.open_existing": "Abrir la cita",
  "book.note_window_open": "La confirmación sale sola por WhatsApp como mensaje normal, porque la conversación está abierta (gratis hasta 1.000 al mes por número).",
  "book.note_template": "La confirmación sale sola por WhatsApp, con la plantilla aprobada por Meta.",
  "book.note_unknown": "La confirmación sale sola por WhatsApp: como mensaje normal si la conversación está abierta; si no, con la plantilla aprobada por Meta.",
  "book.note_rescheduled": "El aviso del nuevo horario le llega solo al cliente por WhatsApp.",
  "book.note_off": "Esta agenda no envía este aviso por WhatsApp (está desactivado en los avisos de la agenda).",
  "book.summary_when": "{day}, {date}, de {start} a {end}",
  "book.summary_anyone": "quien esté libre",
  "book.summary_calendar": "Va a la agenda {calendar} de {name} y los recordatorios salen solos.",
  "book.summary_donetalk": "Queda en la agenda de DoneTalk y los recordatorios salen solos.",
  "book.summary_reminders": "Los recordatorios salen solos.",
  "book.submit": "Agendar",
  "book.submit_reschedule": "Reprogramar",
  "book.done": "Agendada: {when}",
  "book.done_rescheduled": "Reprogramada: {when}",
  "report.agenda.tab": "Agenda",
  "report.agenda.agenda": "Agenda",
  "report.agenda.all": "Todas las agendas",
  "report.agenda.export": "Exportar CSV",
  "report.agenda.loading": "Calculando…",
  "report.agenda.kpi.booked": "Agendadas",
  "report.agenda.kpi.vs_previous": "{change} frente al período anterior",
  "report.agenda.kpi.no_previous": "Nada en el período anterior",
  "report.agenda.kpi.confirmed": "Confirmaron",
  "report.agenda.kpi.by_button": "{rate} con el botón del pedido",
  "report.agenda.kpi.no_show": "No asistieron",
  "report.agenda.kpi.no_show_count": "1 inasistencia|{count} inasistencias",
  "report.agenda.kpi.to_book": "Del primer “hola” a agendar",
  "report.agenda.kpi.to_book_hint": "con el asistente (mediana)",
  "report.agenda.kpi.meta": "Mensajes de Meta",
  "report.agenda.kpi.per_appointment": "{value} por cita",
  "report.agenda.minutes": "1 min|{count} min",
  "report.agenda.hours": "{h} h {m} min",
  "report.agenda.sources": "Quién agendó",
  "report.agenda.source.assistant": "Asistente de IA",
  "report.agenda.source.flow": "Flujos",
  "report.agenda.source.member": "Personas del equipo",
  "report.agenda.source.contact": "El propio cliente",
  "report.agenda.source.api": "Integraciones",
  "report.agenda.outcomes": "Cómo terminaron",
  "report.agenda.outcome.attended": "Asistieron",
  "report.agenda.outcome.rescheduled": "Reprogramadas",
  "report.agenda.outcome.cancelled": "Canceladas",
  "report.agenda.outcome.noShow": "No asistieron",
  "report.agenda.people": "Por persona",
  "report.agenda.col.person": "Persona",
  "report.agenda.col.booked": "Agendadas",
  "report.agenda.col.confirmed": "Confirmaron",
  "report.agenda.col.no_show": "Inasistencias",
  "report.agenda.col.sales": "Se volvieron venta",
  "report.agenda.empty": "No hay citas en el período.",
  "report.agenda.sales_hint": "“Se volvieron venta”: atenciones del cliente concluidas con un desenlace de éxito hasta 30 días después de la cita.",
  "settings.agendas": "Agendas",
  "settings.my_calendar": "Mi agenda",
  "settings.find.agendas": "agenda cita turno reservar visita consulta calendario horario",
  "settings.find.agenda_types": "tipo de cita duración visita consulta reglas antelación intervalo",
  "settings.find.agenda_notices": "recordatorio aviso confirmación whatsapp plantilla reprogramar cancelar ausencia",
  "settings.find.my_calendar": "mi agenda google outlook icloud calendario conectar ocupado",
  "settings.find.my_calendar_connect": "conectar google outlook microsoft icloud apple caldav ics enlace agenda",
  "agendas.lead": "Donde el asistente, los flujos y el equipo agendan citas con los clientes. Cada agenda dice quién atiende, cuándo y cómo.",
  "agendas.new": "Nueva agenda",
  "agendas.new_title": "Nueva agenda",
  "agendas.new_hint": "Empieza abierta de lunes a viernes, de 09:00 a 12:00 y de 13:00 a 18:00. Después ajustas todo.",
  "agendas.create": "Crear agenda",
  "agendas.created": "Agenda creada",
  "agendas.empty": "Todavía no hay agendas. Crea la primera para que el asistente, los flujos y el equipo agenden horarios.",
  "agendas.field.name": "Nombre de la agenda",
  "agendas.field.name_placeholder": "Ej.: Visitas a inmuebles",
  "agendas.field.person": "Quién atiende",
  "agendas.kind.team": "Un equipo",
  "agendas.kind.person": "Una persona",
  "agendas.kind.resource": "Un lugar o recurso",
  "agendas.kind_hint.team": "Varias personas atienden, por turnos o juntas.",
  "agendas.kind_hint.person": "Solo una persona atiende: un médico, un consultor.",
  "agendas.kind_hint.resource": "Una sala, un equipo: solo guarda el horario.",
  "agendas.state.active": "Activa",
  "agendas.state.off": "Apagada",
  "agendas.state.paused": "En pausa hasta el {day}",
  "agendas.banner.title": "Tu agenda aún no está conectada",
  "agendas.banner.text": "Conecta Google, Outlook o iCloud para que nadie agende nada encima de tus compromisos.",
  "agendas.banner.action": "Conectar mi agenda",
  "agendas.card.who": "Quién atiende",
  "agendas.card.types_title": "Tipos",
  "agendas.card.next": "Próximo horario libre",
  "agendas.card.this_week": "Esta semana",
  "agendas.card.who_resource": "Recurso: solo el horario",
  "agendas.card.who_nobody": "Nadie todavía",
  "agendas.card.who_fixed": "una persona fija",
  "agendas.card.who_round_robin": "turnos de 1 persona|turnos entre {count}",
  "agendas.card.who_owner": "quien ya atiende al cliente",
  "agendas.card.who_collective": "1 persona|{count} personas juntas",
  "agendas.card.types": "1 tipo|{count} tipos",
  "agendas.card.no_types": "Ningún tipo todavía",
  "agendas.card.none_free": "Nada libre en los próximos días",
  "agendas.card.week": "1 agendada · {missed}|{count} agendadas · {missed}",
  "agendas.card.missed": "1 ausencia|{count} ausencias",
  "agendas.card.week_none": "Nada agendado",
  "agendas.card.calendar": "{provider} · {people}",
  "agendas.card.people": "1 persona|{count} personas",
  "agendas.card.only_here": "Solo en DoneTalk",
  "agendas.card.reminders": "Avisos: {list}",
  "agendas.card.and": " y ",
  "agendas.card.asks_confirmation": "Pide confirmación",
  "agenda.tab.hours": "Horarios",
  "agenda.tab.types": "Tipos de cita",
  "agenda.tab.people": "Quién atiende",
  "agenda.tab.calendars": "Agendas conectadas",
  "agenda.tab.notices": "Avisos y recordatorios",
  "agenda.menu.rename": "Cambiar nombre",
  "agenda.menu.turn_off": "Apagar agenda",
  "agenda.menu.turn_on": "Encender agenda",
  "agenda.menu.delete": "Eliminar agenda",
  "agenda.off_done": "Agenda apagada. No se agenda nada nuevo en ella.",
  "agenda.on_done": "Agenda encendida.",
  "agenda.delete.title": "¿Eliminar {name}?",
  "agenda.delete.text": "El asistente, los flujos y el equipo dejan de agendar en ella. Si ya tiene citas, solo se apaga y el historial queda.",
  "agenda.delete.confirm": "Eliminar agenda",
  "agenda.delete.done": "Listo. Si la agenda ya tenía citas, quedó apagada para guardar el historial.",
  "agenda.pause.action": "Pausar agenda",
  "agenda.pause.title": "Pausar la agenda",
  "agenda.pause.text": "Mientras esté en pausa, nadie agenda nada nuevo en ella. Las citas ya agendadas siguen.",
  "agenda.pause.until": "En pausa hasta (inclusive)",
  "agenda.pause.confirm": "Pausar",
  "agenda.pause.done": "Agenda en pausa hasta el {day}.",
  "agenda.pause.resume": "Reanudar",
  "agenda.pause.resumed": "Agenda reanudada.",
  "agenda.save.bad_hours": "Hay franjas fuera de orden o superpuestas. Corrige las marcadas en rojo.",
  "agenda.save.pick_hours": "Elige qué horario de atención usa esta agenda.",
  "agenda.save.event_title": "Escribe el título del evento en Agendas conectadas.",
  "agenda.save.type": "Tipo {name}: {problem}",
  "agenda.undo": "Deshacer",
  "agenda.time.minutes": "{m} min",
  "agenda.time.hours": "{h} h",
  "agenda.time.hours_minutes": "{h} h {m} min",
  "agenda.time.days": "1 día|{count} días",
  "agenda.time.before": "{time} antes",
  "agenda.time.at_start": "hasta la hora",
  "agenda.when.today": "Hoy, {time}",
  "agenda.when.tomorrow": "Mañana, {time}",
  "agenda.when.day": "{day}, {time}",
  "agenda.ago.now": "hace un momento",
  "agenda.ago.minutes": "hace {n} min",
  "agenda.ago.hours": "hace {n} h",
  "agenda.ago.day": "el {day}",
  "agenda.ago.never": "nunca",
  "agenda.hours.title": "Cuándo esta agenda acepta citas",
  "agenda.hours.mode.business_hours": "El horario de atención",
  "agenda.hours.mode.own": "Horarios propios de la agenda",
  "agenda.hours.mode.per_person": "Cada persona tiene los suyos",
  "agenda.hours.mode_hint.business_hours": "Los mismos días y horas de un horario de atención del equipo.",
  "agenda.hours.mode_hint.own": "Una semana solo para esta agenda.",
  "agenda.hours.mode_hint.per_person": "Cada persona tiene su semana en Quién atiende.",
  "agenda.hours.which": "Qué horario de atención",
  "agenda.hours.no_business_hours": "Aún no hay horarios de atención.",
  "agenda.hours.open_business_hours": "Crear en Horarios de atención",
  "agenda.hours.per_person_hint": "Cada persona puede tener su semana en Quién atiende. Quien no la tenga usa la semana de abajo.",
  "agenda.hours.open_people": "Abrir Quién atiende",
  "agenda.weekly.add": "+ franja",
  "agenda.weekly.copy": "Copiar el lunes a los días hábiles",
  "agenda.weekly.from": "Inicio ({day})",
  "agenda.weekly.to": "Fin ({day})",
  "agenda.weekly.remove": "Quitar la franja ({day})",
  "agenda.weekly.order": "El fin debe ir después del inicio.",
  "agenda.weekly.overlap": "Dos franjas se cruzan en este día.",
  "agenda.override.title": "Fechas especiales y excepciones",
  "agenda.override.lead": "Un feriado, otro horario en un día, las vacaciones de alguien. Vale por encima de las reglas de la semana.",
  "agenda.override.add": "Agregar fecha",
  "agenda.override.add_title": "Fecha especial",
  "agenda.override.added": "Fecha agregada",
  "agenda.override.none": "Ninguna fecha especial.",
  "agenda.override.closed": "Cerrado",
  "agenda.override.closed_hint": "No se ofrece nada en esos días.",
  "agenda.override.other_hours": "Otro horario",
  "agenda.override.other_hours_hint": "En esos días, solo en estas franjas.",
  "agenda.override.only": "Solo {ranges}",
  "agenda.override.person_off": "{name} fuera (solo esa persona sale de los turnos)",
  "agenda.override.everyone": "Toda la agenda",
  "agenda.override.who": "Vale para",
  "agenda.override.from": "Desde",
  "agenda.override.to": "Hasta",
  "agenda.override.span": "{from} al {to}",
  "agenda.override.note": "Motivo (opcional)",
  "agenda.override.note_placeholder": "Ej.: Navidad, vacaciones",
  "agenda.override.range_from": "Inicio",
  "agenda.override.range_to": "Fin",
  "agenda.override.range_remove": "Quitar la franja",
  "agenda.override.save": "Agregar",
  "agenda.override.remove": "Quitar la fecha",
  "agenda.override.removed": "Fecha quitada",
  "agenda.holidays.label": "Cerrar sola en los feriados nacionales",
  "agenda.holidays.hint": "En esos días no se ofrece nada. Para un feriado de tu ciudad, usa Agregar fecha.",
  "agenda.holidays.optional": "También en Carnaval y Corpus Christi (días opcionales en Brasil)",
  "agenda.tz.title": "Zona horaria",
  "agenda.tz.contact": "Mostrar al cliente su zona horaria cuando sea otra",
  "agenda.tz.america_sao_paulo": "São Paulo, Río y Brasilia",
  "agenda.tz.america_manaus": "Manaos",
  "agenda.tz.america_belem": "Belém",
  "agenda.tz.america_fortaleza": "Fortaleza",
  "agenda.tz.america_recife": "Recife",
  "agenda.tz.america_cuiaba": "Cuiabá",
  "agenda.tz.america_rio_branco": "Rio Branco (Acre)",
  "agenda.tz.america_noronha": "Fernando de Noronha",
  "agenda.tz.america_argentina_buenos_aires": "Buenos Aires",
  "agenda.tz.america_santiago": "Santiago",
  "agenda.tz.america_bogota": "Bogotá",
  "agenda.tz.america_mexico_city": "Ciudad de México",
  "agenda.tz.america_lima": "Lima",
  "agenda.tz.america_new_york": "Nueva York",
  "agenda.tz.europe_lisbon": "Lisboa",
  "agenda.tz.europe_madrid": "Madrid",
  "agenda.tz.utc": "Tiempo universal",
  "agenda.preview.title": "Así queda la próxima semana",
  "agenda.preview.hint": "Los horarios libres para agendar, ya sin lo ocupado en las agendas conectadas. Muestra lo que está guardado.",
  "agenda.preview.more": "+{count}",
  "agenda.preview.total": "1 horario libre de {type} ({duration}) en los próximos 7 días.|{count} horarios libres de {type} ({duration}) en los próximos 7 días.",
  "agenda.preview.no_type": "Crea un tipo de cita para ver los horarios libres.",
  "agenda.preview.open_types": "Abrir los tipos",
  "agenda.people.title": "Quién atiende",
  "agenda.people.lead": "Quién recibe las citas de esta agenda. El orden desempata los turnos.",
  "agenda.people.team": "Equipo",
  "agenda.people.no_team": "Ningún equipo",
  "agenda.people.add_team": "Agregar 1 persona del equipo {team}|Agregar {count} personas del equipo {team}",
  "agenda.people.add": "Agregar persona",
  "agenda.people.empty": "Nadie atiende todavía. Agrega a las personas abajo.",
  "agenda.people.active": "Atiende",
  "agenda.people.on_hint": "recibe citas",
  "agenda.people.off_hint": "fuera por ahora: no recibe citas nuevas",
  "agenda.people.up": "Subir a {name}",
  "agenda.people.down": "Bajar a {name}",
  "agenda.people.remove": "Quitar a {name}",
  "agenda.people.order_hint": "En los turnos, va a quien tiene menos citas en la semana; si empatan, quien está más arriba.",
  "agenda.people.own_week": "Semana propia",
  "agenda.people.own_week_hint": "Sin semana propia, vale la semana de la agenda.",
  "agenda.people.own_week_on": "semana propia",
  "agenda.people.agenda_week": "usa la semana de la agenda",
  "agenda.people.show_week": "Ver la semana",
  "agenda.people.hide_week": "Cerrar la semana",
  "agenda.people.person": "Quién atiende",
  "agenda.people.person_hint": "Agenda de una sola persona: las citas van siempre a ella.",
  "agenda.people.resource": "Una sala, un equipo: la agenda solo guarda el horario, sin personas. Nadie necesita conectar su agenda.",
  "agenda.type.new": "Nuevo tipo",
  "agenda.type.new_name": "Nuevo tipo",
  "agenda.type.created": "Tipo creado. Ajústalo y guarda.",
  "agenda.type.empty": "Ningún tipo todavía. Crea el primero: es lo que el cliente agenda (una visita, una consulta).",
  "agenda.type.inactive": "apagado",
  "agenda.type.untitled": "Sin nombre",
  "agenda.type.on": "Encendido",
  "agenda.type.off": "Apagado",
  "agenda.type.name": "Nombre",
  "agenda.type.duration": "Duración",
  "agenda.type.step": "Empieza",
  "agenda.type.every": "cada {time}",
  "agenda.type.description": "Qué es (el asistente lo lee para saber cuándo ofrecerlo)",
  "agenda.type.rules": "Reglas del horario",
  "agenda.type.rule.after_a": "Dejar",
  "agenda.type.rule.after_label": "Intervalo después",
  "agenda.type.rule.after_b": "libres después de cada una y",
  "agenda.type.rule.before_label": "Intervalo antes",
  "agenda.type.rule.before_b": "antes.",
  "agenda.type.rule.notice_a": "Agendar con al menos",
  "agenda.type.rule.notice_label": "Antelación mínima",
  "agenda.type.rule.notice_b": "de antelación y como máximo",
  "agenda.type.rule.ahead_label": "Hasta cuántos días adelante",
  "agenda.type.rule.ahead_b": "adelante.",
  "agenda.type.rule.per_day_a": "Como máximo",
  "agenda.type.rule.per_day_label": "Límite por día",
  "agenda.type.rule.per_day_b": "por persona por día y",
  "agenda.type.rule.per_contact_label": "Límite por cliente",
  "agenda.type.rule.per_contact_b": "abiertas por cliente.",
  "agenda.type.appointments": "1 cita|{count} citas",
  "agenda.type.no_limit": "sin límite",
  "agenda.type.where": "Dónde ocurre",
  "agenda.type.place.contact_field": "Dirección del contacto (campo)",
  "agenda.type.place.address": "Dirección fija",
  "agenda.type.place.online": "En línea: Meet, Teams o un enlace",
  "agenda.type.place.phone": "Por teléfono",
  "agenda.type.place.to_agree": "Acordar después",
  "agenda.type.place_hint.none": "Elige dónde ocurre: va en la confirmación y los recordatorios.",
  "agenda.type.place_hint.contact_field": "La dirección del contacto va en la confirmación y los recordatorios.",
  "agenda.type.place_hint.address": "La dirección va en la confirmación y los recordatorios, con el enlace del mapa.",
  "agenda.type.place_hint.online": "El enlace va en la confirmación y los recordatorios.",
  "agenda.type.place_hint.phone": "Quien atiende llama al número del cliente.",
  "agenda.type.place_hint.to_agree": "El lugar se acuerda en la conversación.",
  "agenda.type.place_short.none": "sin lugar",
  "agenda.type.place_short.address": "presencial",
  "agenda.type.place_short.contact_field": "en la dirección del cliente",
  "agenda.type.place_short.online": "en línea",
  "agenda.type.place_short.phone": "por teléfono",
  "agenda.type.place_short.to_agree": "lugar a acordar",
  "agenda.type.place_field": "Campo del contacto con la dirección",
  "agenda.type.place_no_fields": "Aún no hay campos del contacto. Crea uno en Campos del contacto.",
  "agenda.type.address": "Dirección",
  "agenda.type.address_placeholder": "Calle, número, barrio, ciudad",
  "agenda.type.maps": "Enlace de Google Maps (opcional)",
  "agenda.type.maps_hint": "Pega el enlace del lugar en Google Maps para que la confirmación y el recordatorio muestren el mapa.",
  "agenda.type.maps_missed": "No encontramos el punto del mapa en ese enlace. Abre el lugar en Google Maps y copia la barra de direcciones.",
  "agenda.type.pin": "Punto del mapa: {pin}",
  "agenda.type.pin_clear": "Quitar",
  "agenda.type.online.title": "Cómo es la llamada",
  "agenda.type.online.google_meet": "Google Meet (enlace creado solo)",
  "agenda.type.online.teams": "Microsoft Teams (enlace creado solo)",
  "agenda.type.online.link": "Un enlace fijo",
  "agenda.type.online.link_field": "Enlace de la llamada",
  "agenda.type.online.hint": "El enlace se crea en la agenda de quien atiende, que necesita Google (para Meet) u Outlook (para Teams) conectado.",
  "agenda.type.who": "Quién atiende",
  "agenda.type.who_mode.round_robin": "Por turnos",
  "agenda.type.who_mode.owner": "Quien ya atiende al cliente",
  "agenda.type.who_mode.fixed": "Una persona fija",
  "agenda.type.who_mode.collective": "Varias personas juntas",
  "agenda.type.who_hint.round_robin": "Va a quien tiene menos citas en la semana; si empatan, el orden en Quién atiende.",
  "agenda.type.who_hint.owner": "Va a quien ya cuida al cliente; si nadie lo cuida, a cualquier persona libre de la agenda.",
  "agenda.type.who_hint.fixed": "Siempre la misma persona.",
  "agenda.type.who_hint.collective": "Todos en la agenda deben estar libres, y van todos juntos.",
  "agenda.type.who_short.round_robin": "turnos",
  "agenda.type.who_short.owner": "quien ya atiende",
  "agenda.type.who_short.fixed": "persona fija",
  "agenda.type.who_short.collective": "juntos",
  "agenda.type.prefer_owner": "Si alguien ya atendió al cliente, prefiere a la misma persona",
  "agenda.type.fixed_person": "Persona",
  "agenda.type.no_people": "Nadie atiende en esta agenda todavía.",
  "agenda.type.who_person": "Agenda de una sola persona: {name} atiende todas las citas.",
  "agenda.type.who_resource": "Agenda de un recurso: solo guarda el horario, sin persona.",
  "agenda.intake.title": "Antes de agendar, pedir",
  "agenda.intake.label": "Pregunta",
  "agenda.intake.label_placeholder": "Ej.: Código del inmueble",
  "agenda.intake.new_label": "pregunta",
  "agenda.intake.kind_label": "Tipo de respuesta",
  "agenda.intake.kind.text": "Texto libre",
  "agenda.intake.kind.choice": "Elegir entre opciones",
  "agenda.intake.save_to": "Guardar en el campo",
  "agenda.intake.no_save": "No guardar en el contacto",
  "agenda.intake.options": "Opciones",
  "agenda.intake.options_placeholder": "Escribe y presiona Enter",
  "agenda.intake.required": "Obligatoria",
  "agenda.intake.remove": "Quitar la pregunta",
  "agenda.intake.add": "Pregunta",
  "agenda.intake.add_field": "+ campo del contacto",
  "agenda.intake.hint": "El asistente y el flujo preguntan lo que falte; lo que el contacto ya tiene no se pregunta de nuevo.",
  "agenda.type.confirm_title": "Confirmación, reprogramar y cancelar",
  "agenda.type.confirm_a": "Pedir confirmación al cliente:",
  "agenda.type.no_reply_a": "Sin respuesta hasta",
  "agenda.type.reply_by_label": "Plazo para responder",
  "agenda.type.no_reply_label": "Qué hacer sin respuesta",
  "agenda.type.no_reply.notify": "avisar a quien atiende y mantener el horario",
  "agenda.type.no_reply.release": "liberar el horario y avisar al cliente",
  "agenda.type.no_reply.ask_again": "enviar la solicitud de nuevo",
  "agenda.type.reschedule_a": "Reprogramar por su cuenta:",
  "agenda.type.cancel_a": "Cancelar por su cuenta:",
  "agenda.type.cannot": "no puede",
  "agenda.type.until_start": "hasta la hora de empezar",
  "agenda.type.until": "hasta {time} antes",
  "agenda.type.confirm_hint": "La solicitud sale con el aviso “Solicitud de confirmación”, en Avisos y recordatorios. Después del plazo para reprogramar o cancelar, una persona del equipo se hace cargo.",
  "agenda.type.on_book.title": "Al agendar",
  "agenda.type.on_book.tags": "Poner la etiqueta:",
  "agenda.type.on_book.crm": "Registrar en el CRM",
  "agenda.type.on_book.crm_hint": "La cita se vuelve una actividad en el CRM conectado.",
  "agenda.type.on_book.close": "Concluir la atención como",
  "agenda.type.on_book.no_close": "No concluir",
  "agenda.type.delete": "Eliminar tipo",
  "agenda.type.delete_title": "¿Eliminar {name}?",
  "agenda.type.delete_text": "Desaparece de las opciones del asistente, los flujos y el equipo. Si ya tiene citas, solo se apaga y el historial queda.",
  "agenda.type.deleted": "Listo. Si el tipo ya tenía citas, quedó apagado.",
  "agenda.type.problem.name": "ponle un nombre.",
  "agenda.type.problem.address": "escribe la dirección.",
  "agenda.type.problem.field": "elige el campo de la dirección.",
  "agenda.type.problem.link": "el enlace de la llamada debe empezar con https://.",
  "agenda.type.problem.person": "elige a la persona que atiende.",
  "agenda.type.problem.intake": "escribe todas las preguntas.",
  "agenda.type.problem.options": "una pregunta de opciones necesita al menos 2 opciones.",
  "agenda.provider.google": "Google",
  "agenda.provider.microsoft": "Outlook",
  "agenda.provider.caldav": "iCloud/CalDAV",
  "agenda.provider.ics": "Enlace de la agenda",
  "agenda.calendars.title": "La agenda de cada persona",
  "agenda.calendars.lead": "Lo que esté en las agendas que cuentan como ocupado nunca se ofrece. La cita se graba en la agenda que la persona eligió.",
  "agenda.calendars.resource": "Esta agenda es de un recurso (una sala, un equipo): no tiene personas ni agendas conectadas.",
  "agenda.calendars.no_people": "Nadie atiende en esta agenda todavía. Agrega a las personas en Quién atiende.",
  "agenda.calendars.chip": "{provider} · {status}",
  "agenda.calendars.status.active": "conectada",
  "agenda.calendars.status.needs_consent": "falta la aprobación de TI",
  "agenda.calendars.status.needs_reauth": "conectar de nuevo",
  "agenda.calendars.status.error": "con error",
  "agenda.calendars.status.disconnected": "desconectada",
  "agenda.calendars.none": "Sin agenda conectada",
  "agenda.calendars.only_here": "Usa solo la agenda de DoneTalk.",
  "agenda.calendars.read": "leída {ago}",
  "agenda.calendars.not_read": "aún no leída",
  "agenda.calendars.how.google": "avisa los cambios al momento",
  "agenda.calendars.how.microsoft": "avisa los cambios al momento",
  "agenda.calendars.how.caldav": "leída cada 5 min (Apple no avisa los cambios al momento)",
  "agenda.calendars.how.ics": "actualizada cada 15 min · no graba las citas",
  "agenda.calendars.needs_consent": "Microsoft pide que el área de TI apruebe DoneTalk una vez. La persona obtiene el enlace listo en Mi agenda.",
  "agenda.calendars.needs_reauth": "La conexión se cayó (contraseña cambiada o acceso vencido). Hay que conectarla de nuevo.",
  "agenda.calendars.error": "La conexión dio error. La persona debe abrir Mi agenda.",
  "agenda.calendars.ask": "Pedir que conecte",
  "agenda.calendars.ask_text": "¡Hola, {name}! Conecta tu agenda en DoneTalk para que nadie agende nada encima de tus compromisos: {link}",
  "agenda.calendars.asked": "Mensaje con el enlace copiado. Envíalo a {name}.",
  "agenda.calendars.private": "Aquí solo aparece si la agenda de cada uno está conectada; lo que tiene sigue visible solo para la persona.",
  "agenda.calendars.event_title": "Cómo aparece la cita en la agenda",
  "agenda.calendars.title_field": "Título del evento",
  "agenda.calendars.tokens": "Insertar:",
  "agenda.calendars.token.type": "tipo",
  "agenda.calendars.token.contact": "cliente",
  "agenda.calendars.token.agenda": "agenda",
  "agenda.calendars.looks_like": "Queda así:",
  "agenda.calendars.details": "Poner el teléfono y el enlace de la conversación en la descripción",
  "agenda.calendars.details_hint": "Quien abre el evento en Google u Outlook ve con quién es y entra a la conversación con un toque.",
  "agenda.calendars.invite_all": "Grabar en la agenda de todos los que atienden juntos",
  "agenda.calendars.invite_all_hint": "En los tipos con varias personas, el evento va a la agenda de cada una, no solo de la primera.",
  "agenda.calendars.invite_contact": "Invitar al cliente por correo",
  "agenda.calendars.invite_contact_hint": "Usa el correo del contacto, cuando lo haya. La invitación sale de la agenda de quien atiende.",
  "agenda.calendars.on_change": "Si la persona mueve o borra el evento en Google u Outlook",
  "agenda.calendars.change.notify_and_ask": "Avisar a la persona y pedir al cliente un nuevo horario",
  "agenda.calendars.change.notify": "Solo avisar a la persona",
  "agenda.calendars.change.ignore": "No hacer nada",
  "agenda.calendars.connect_title": "Conectar una agenda",
  "agenda.calendars.connect_hint": "Cada persona conecta su propia agenda en Mi agenda.",
  "agenda.notice.title": "Para el cliente, por WhatsApp",
  "agenda.notice.kind.confirmation": "Confirmación",
  "agenda.notice.kind.confirm_request": "Solicitud de confirmación",
  "agenda.notice.kind.reminder": "Recordatorio",
  "agenda.notice.kind.rescheduled": "Nuevo horario",
  "agenda.notice.kind.cancelled": "Cancelación",
  "agenda.notice.kind.no_show": "Te extrañamos",
  "agenda.notice.desc.confirmation": "Día, hora, dirección y quién atiende, con el enlace para guardarla en la agenda.",
  "agenda.notice.desc.confirm_request": "Pregunta si el cliente va y espera la respuesta por los botones.",
  "agenda.notice.desc.reminder": "Corto, con la dirección y quién atiende.",
  "agenda.notice.desc.rescheduled": "Lo que cambió, del horario anterior al nuevo.",
  "agenda.notice.desc.cancelled": "Confirma la cancelación y ofrece agendar otro día.",
  "agenda.notice.desc.no_show": "Sin cobro ni promoción (para seguir siendo utilidad). Responder reprograma.",
  "agenda.notice.buttons.confirmation": "Reprogramar · Cancelar",
  "agenda.notice.buttons.confirm_request": "Confirmo · Reprogramar · Cancelar",
  "agenda.notice.buttons.reminder": "Necesito cambiarla",
  "agenda.notice.buttons.rescheduled": "Está bien · Cancelar",
  "agenda.notice.buttons.cancelled": "Agendar otro día",
  "agenda.notice.buttons.no_show": "Agendar otra hora · Ya no lo necesito",
  "agenda.notice.buttons_line": "Botones: {buttons}.",
  "agenda.notice.on_event.confirmation": "Al agendar",
  "agenda.notice.on_event.confirm_request": "Al agendar",
  "agenda.notice.on_event.reminder": "Al agendar",
  "agenda.notice.on_event.rescheduled": "Al reprogramar",
  "agenda.notice.on_event.cancelled": "Al cancelar",
  "agenda.notice.on_event.no_show": "Si faltó",
  "agenda.notice.label.days_before": "1 día antes, {at}|{count} días antes, {at}",
  "agenda.notice.label.same_day": "El mismo día, {at}",
  "agenda.notice.label.no_show": "{time} después, si faltó",
  "agenda.notice.timing.before": "{time} antes",
  "agenda.notice.timing.after": "{time} después",
  "agenda.notice.timing.after_now": "Justo después",
  "agenda.notice.timing.days_before": "1 día antes|{count} días antes",
  "agenda.notice.timing.same_day": "El mismo día",
  "agenda.notice.goes": "Sale",
  "agenda.notice.when_label": "Cuándo sale",
  "agenda.notice.at": "a las",
  "agenda.notice.at_label": "Hora del aviso",
  "agenda.notice.template": "{name} · {status}",
  "agenda.notice.template_missing": "{name} · aún no creada en Meta",
  "agenda.notice.edit_text": "Editar el texto",
  "agenda.notice.see_text": "Ver el texto",
  "agenda.notice.on": "Encendido",
  "agenda.notice.off": "Apagado",
  "agenda.notice.add": "+ Otro aviso (ej.: 1 semana antes)",
  "agenda.notice.add_title": "Otro aviso",
  "agenda.notice.add_confirm": "Agregar aviso",
  "agenda.notice.added": "Aviso agregado",
  "agenda.notice.remove": "Eliminar aviso",
  "agenda.notice.remove_title": "¿Eliminar este aviso?",
  "agenda.notice.remove_text": "El aviso deja de salir en las próximas citas. Los que ya salieron siguen en el historial.",
  "agenda.notice.removed": "Aviso eliminado",
  "agenda.notice.text_title": "Texto: {kind}",
  "agenda.notice.text_label": "Texto del mensaje",
  "agenda.notice.variables": "Insertar:",
  "agenda.notice.unknown": "Meta no conoce estas partes: {list}. Usa los botones para insertarlas.",
  "agenda.notice.utility_hint": "Habla solo de esta cita: qué, cuándo, dónde y con quién. Un descuento o promoción hace que Meta lo cobre como marketing, que cuesta mucho más.",
  "agenda.notice.save_text": "Guardar texto",
  "agenda.notice.text_saved": "Texto guardado",
  "agenda.notice.use_suggested": "Usar el texto sugerido",
  "agenda.notice.preview": "Así llega a WhatsApp (con datos de ejemplo)",
  "agenda.notice.map_hint": "La versión con mapa muestra el punto de la dirección arriba, cuando el tipo tiene el enlace de Google Maps.",
  "agenda.notice.map": "con mapa",
  "agenda.notice.with_map": "También la versión con mapa",
  "agenda.notice.meta_title": "Plantilla en Meta",
  "agenda.notice.meta_text": "Fuera de la ventana de 24 h, el aviso sale con la plantilla {name} cuando Meta la apruebe. En el idioma de la empresa usa este texto; en los otros, el texto sugerido por DoneTalk.",
  "agenda.notice.meta_create": "Crear en Meta",
  "agenda.notice.meta_hint": "Meta suele revisarla en minutos. Mientras tanto, con la conversación abierta, el aviso ya sale como mensaje normal.",
  "agenda.notice.meta_needs_channels": "Para crear la plantilla en Meta, pide a quien administra los números de WhatsApp.",
  "agenda.notice.meta_sent": "Plantillas enviadas a revisión de Meta.",
  "agenda.notice.meta_failed": "1 plantilla no se creó. Mira el motivo en la ventana.|{count} plantillas no se crearon. Mira los motivos en la ventana.",
  "agenda.notice.meta_result_failed": "no creada ({error})",
  "agenda.notice.account": "Cuenta de WhatsApp",
  "agenda.notice.no_reply_title": "Si el cliente no confirma",
  "agenda.notice.no_reply_text": "El plazo y qué hacer cuando el cliente no responde se eligen en cada tipo de cita: avisar a quien atiende y mantener, liberar el horario y avisar al cliente, o enviar la solicitud de nuevo.",
  "agenda.notice.no_reply_line": "{type}: sin respuesta hasta {until}, {then}.",
  "agenda.notice.no_reply_none": "Ningún tipo pide confirmación todavía.",
  "agenda.team.title": "Para el equipo",
  "agenda.team.push": "Aviso en la app y en el celular al agendar, reprogramar y cancelar",
  "agenda.team.summary": "Resumen del día",
  "agenda.team.summary_hint": "Cada persona recibe por la mañana las citas del día.",
  "agenda.team.summary_at": "Resumen a las",
  "agenda.team.email": "Correo con la invitación (.ics)",
  "agenda.team.email_hint": "Quien atiende recibe la cita por correo para ponerla en cualquier agenda.",
  "agenda.saving.title": "Ahorro",
  "agenda.saving.window": "Enviar como mensaje normal cuando la conversación esté abierta",
  "agenda.saving.window_hint": "Dentro de la ventana de 24 h, el aviso sale como mensaje común con los mismos botones: gratis hasta 1.000 por número al mes.",
  "agenda.saving.quiet": "No enviar avisos de madrugada",
  "agenda.saving.quiet_hint": "Un aviso que caería en ese horario sale antes.",
  "agenda.saving.quiet_from": "Entre",
  "agenda.saving.quiet_to": "y",
  "agenda.saving.quiet_from_label": "Inicio del silencio",
  "agenda.saving.quiet_to_label": "Fin del silencio",
  "agenda.wa.title": "Calendario de WhatsApp",
  "agenda.wa.text": "Un calendario dentro de la conversación: el cliente elige el día y la hora sin salir de WhatsApp. Se prepara una vez en cada cuenta de WhatsApp; después los flujos pueden usarlo.",
  "agenda.wa.status.published": "Listo",
  "agenda.wa.status.pending": "Preparando",
  "agenda.wa.status.failed": "Falló",
  "agenda.wa.status.none": "No preparado",
  "agenda.wa.setup": "Preparar el calendario",
  "agenda.wa.again": "Preparar de nuevo",
  "agenda.wa.done": "Calendario enviado a Meta.",
  "agenda.wa.failed": "1 cuenta falló.|{count} cuentas fallaron.",
  "agenda.wa.no_account": "Conecta un número de WhatsApp primero.",
  "agenda.wa.needs_channels": "Para prepararlo, pide a quien administra los números de WhatsApp.",
  "agenda.var.name": "nombre",
  "agenda.var.type": "tipo",
  "agenda.var.date": "fecha",
  "agenda.var.time": "hora",
  "agenda.var.place": "lugar",
  "agenda.var.with": "con quién",
  "agenda.var.link": "enlace de la agenda",
  "agenda.var.previous": "horario anterior",
  "agenda.lang.pt-BR": "Portugués",
  "agenda.lang.es": "Español",
  "agenda.lang.en": "Inglés",
  "agenda.sample.name": "Ana",
  "agenda.sample.contact": "Ana Souza",
  "agenda.sample.type": "Evaluación",
  "agenda.sample.date": "viernes, 10 de octubre",
  "agenda.sample.time": "14:30",
  "agenda.sample.place": "Av. Paulista, 1000",
  "agenda.sample.with": "Paulo",
  "agenda.sample.previous": "jueves, 9 de octubre, 10:00",
  "agenda.notice.preset.confirmation": "¡Hola, {{name}}! Tu cita de {{type}} quedó para el {{date}}, a las {{time}}, con {{with}}.\n\n📍 {{place}}\n\nPara guardarla en tu calendario: {{link}}\n\nSi necesitas cambiarla, toca abajo.",
  "agenda.notice.preset.confirm_request": "¡Hola, {{name}}! Tu cita de {{type}} es el {{date}}, a las {{time}}, en {{place}}.\n\n¿Confirmas tu asistencia?",
  "agenda.notice.preset.reminder": "¡Hola, {{name}}! Recordatorio: tu cita de {{type}} es el {{date}}, a las {{time}}, con {{with}}.\n\n📍 {{place}}\n\n¡Hasta pronto!",
  "agenda.notice.preset.rescheduled": "¡Hola, {{name}}! Tu cita de {{type}} cambió de {{previous}} al {{date}}, a las {{time}}, con {{with}}.\n\n📍 {{place}}\n\nPara guardarla en tu calendario: {{link}}",
  "agenda.notice.preset.cancelled": "Hola, {{name}}. Tu cita de {{type}} del {{date}}, a las {{time}}, fue cancelada.\n\nSi quieres, agendamos otro día.",
  "agenda.notice.preset.no_show": "Hola, {{name}}. No pudimos verte en tu cita de {{type}} del {{date}}, a las {{time}}.\n\n¿Quieres agendar otra hora?",
  "mycal.lead": "Conecta tu agenda para que nadie agende nada encima de tus compromisos. DoneTalk lee lo que está ocupado y graba ahí lo que se agende contigo.",
  "mycal.empty": "Ninguna agenda conectada todavía. Elige abajo.",
  "mycal.busy": "Cuenta como ocupado",
  "mycal.write": "Graba aquí",
  "mycal.read_only": "solo lectura",
  "mycal.primary": "principal",
  "mycal.no_calendars": "No se encontró ninguna agenda en esa cuenta.",
  "mycal.sync": "Actualizar ahora",
  "mycal.synced": "Agenda actualizada.",
  "mycal.reconnect": "Conectar de nuevo",
  "mycal.disconnect": "Desconectar",
  "mycal.disconnect_title": "¿Desconectar esta agenda?",
  "mycal.disconnect_text": "DoneTalk deja de leer los horarios ocupados y de grabar citas en ella. Los eventos ya grabados siguen ahí.",
  "mycal.disconnected": "Agenda desconectada",
  "mycal.soon": "pronto",
  "mycal.connect.title": "Conectar una agenda",
  "mycal.connect.action": "Conectar",
  "mycal.connect.privacy": "DoneTalk solo lee los horarios ocupados (no qué es cada compromiso) y graba las citas agendadas contigo.",
  "mycal.provider.google": "Google Calendar",
  "mycal.provider.microsoft": "Outlook y Microsoft 365",
  "mycal.provider.icloud": "Apple iCloud",
  "mycal.provider.caldav": "Otra (CalDAV)",
  "mycal.provider.caldav_short": "iCloud o CalDAV",
  "mycal.provider.ics": "Solo un enlace de la agenda",
  "mycal.provider_hint.google": "Lee lo ocupado, graba y se entera de los cambios al momento.",
  "mycal.provider_hint.microsoft": "Cuentas de empresa y personales (outlook.com, hotmail).",
  "mycal.provider_hint.icloud": "Con una contraseña de app creada en tu cuenta de Apple.",
  "mycal.provider_hint.caldav": "Zoho, Fastmail, Nextcloud y similares.",
  "mycal.provider_hint.ics": "Solo lectura, cuando la empresa no deja conectar.",
  "mycal.result.connected": "Agenda conectada.",
  "mycal.result.denied": "No autorizaste el acceso. Inténtalo de nuevo cuando quieras.",
  "mycal.result.expired": "Se acabó el tiempo para conectar. Inténtalo de nuevo.",
  "mycal.result.consent_required": "Tu empresa debe aprobar DoneTalk en Microsoft. Envía el enlace a TI.",
  "mycal.result.needs_consent": "Tu empresa debe aprobar DoneTalk en Microsoft. Envía el enlace a TI.",
  "mycal.result.failed": "No se pudo conectar. Inténtalo de nuevo.",
  "mycal.result.admin_consented": "TI aprobó DoneTalk. Ahora conecta tu cuenta.",
  "mycal.it.title": "Microsoft pide la aprobación de TI",
  "mycal.it.text": "En la mayoría de las empresas TI debe aprobar DoneTalk una vez. Envía este enlace a TI; después, todo el equipo se conecta solo.",
  "mycal.it.copy": "Copiar el enlace para TI",
  "mycal.it.copied": "Enlace copiado. Envíalo a TI de tu empresa.",
  "mycal.it.copy_failed": "No se pudo copiar el enlace. Inténtalo de nuevo.",
  "mycal.caldav.title": "Otra agenda (CalDAV)",
  "mycal.caldav.icloud_title": "Apple iCloud",
  "mycal.caldav.icloud_help": "En Apple, crea una contraseña de app (Inicio de sesión y seguridad › Contraseñas de apps) y pégala aquí. No uses tu contraseña normal.",
  "mycal.caldav.icloud_link": "Abrir account.apple.com",
  "mycal.caldav.help": "Zoho, Fastmail, Nextcloud y similares: usa la dirección CalDAV y la contraseña de app que el servicio muestra en su configuración.",
  "mycal.caldav.url": "Dirección del servidor",
  "mycal.caldav.apple_id": "Correo de la cuenta de Apple",
  "mycal.caldav.username": "Usuario",
  "mycal.caldav.app_password": "Contraseña de app",
  "mycal.caldav.password": "Contraseña (de app, si el servicio la tiene)",
  "mycal.caldav.safe": "La contraseña se guarda cifrada y solo sirve para leer y grabar tu agenda.",
  "mycal.ics.title": "Solo un enlace de la agenda",
  "mycal.ics.url": "Enlace de la agenda (.ics)",
  "mycal.ics.help": "En Google: Configuración de la agenda › Dirección secreta en formato iCal. En Outlook: Calendario › Compartido › Publicar un calendario.",
  "mycal.ics.limits": "Solo lectura: muestra lo ocupado, se actualiza cada 15 min y no graba las citas.",
  "mycal.error.login": "Usuario o contraseña rechazados. Revisa y usa una contraseña de app.",
  "mycal.error.unreachable": "No pudimos comunicarnos con esa dirección. Revisa e inténtalo de nuevo.",
  "mycal.error.invalid": "Revisa la dirección: debe empezar con https://.",
  "agenda.var_token.name": "nombre",
  "agenda.var_token.type": "tipo",
  "agenda.var_token.date": "fecha",
  "agenda.var_token.time": "hora",
  "agenda.var_token.place": "lugar",
  "agenda.var_token.with": "con_quien",
  "agenda.var_token.link": "enlace",
  "agenda.var_token.previous": "horario_anterior",
  "book.send_confirmation": "Enviar la confirmación por WhatsApp ahora",
  "book.confirmation_held": "La confirmación no se envía ahora; los recordatorios salen como siempre.",
  "report.agenda.source_named.assistant": "Asistente {name}",
  "report.agenda.source_named.flow": "Flujo {name}",
  "agenda.holidays.see": "Ver la lista de {year}",
  "agenda.holidays.list_title": "Feriados de {year}",
  "agenda.holidays.list_hint": "Los feriados de tu estado y ciudad se agregan como fechas especiales.",
  "agenda.holiday.new_year": "Año Nuevo",
  "agenda.holiday.tiradentes": "Tiradentes",
  "agenda.holiday.labour_day": "Día del Trabajo",
  "agenda.holiday.independence": "Independencia de Brasil",
  "agenda.holiday.aparecida": "Nuestra Señora Aparecida",
  "agenda.holiday.all_souls": "Día de los Difuntos",
  "agenda.holiday.republic": "Proclamación de la República",
  "agenda.holiday.black_consciousness": "Día de la Conciencia Negra",
  "agenda.holiday.christmas": "Navidad",
  "agenda.holiday.good_friday": "Viernes Santo",
  "agenda.holiday.carnival_monday": "Carnaval (lunes)",
  "agenda.holiday.carnival_tuesday": "Carnaval (martes)",
  "agenda.holiday.corpus_christi": "Corpus Christi",
  "agenda.preview.holiday": "Feriado",
  "agenda.calendars.connect_mine": "Conectar mi calendario",
  "conversas.handoff.assistant_requested": "La IA pidió una persona",
  "conversas.handoff.exit_condition": "La IA llegó a su condición de salida",
  "conversas.handoff.max_turns": "La IA llegó a su límite de respuestas",
  "conversas.handoff.ai_error": "La IA no pudo responder",
  "conversas.handoff.review_hold": "La revisión retuvo la respuesta de la IA",
  "conversas.handoff.assistant_finished": "La IA terminó su parte",
  "conversas.card.context": "Contexto",
  "settings.import": "Importar datos",
  "settings.find.import": "importar traer migrar copiloto otra plataforma historial",
  "settings.find.import-copiloto": "copiloto clave migración historial conversaciones",
  "import.lead": "Trae contactos y conversaciones de otra plataforma. DoneTalk solo lee: nada se borra en el origen.",
  "import.who": "Solo Dueño y Administrador ven esta área. Conectar, importar y cancelar quedan en la auditoría.",
  "import.copiloto.title": "Copiloto",
  "import.copiloto.lead": "Contactos, conversaciones con fotos y audios, etiquetas, notas y motivos de cierre.",
  "import.copiloto.address": "Dirección de Copiloto",
  "import.copiloto.other_address": "Otra dirección",
  "import.copiloto.address_other": "Dirección",
  "import.copiloto.key": "Clave de migración",
  "import.copiloto.key_hint": "Un administrador de la cuenta la genera en Copiloto, en Perfil › API › Clave de migración. Dura hasta 7 días y solo lee.",
  "import.copiloto.connect": "Conectar",
  "import.open.title": "Importación de {account}",
  "import.csv.title": "Planilla de contactos",
  "import.csv.lead": "Solo contactos, desde un archivo CSV. En Contactos › Importar.",
  "import.others.title": "Otras plataformas",
  "import.others.lead": "Próximamente. Si vienes de otro sistema, pídelo al soporte.",
  "import.past": "Importaciones anteriores",
  "import.page.title": "Desde Copiloto · {account}",
  "import.status.connected": "Conectada",
  "import.status.running": "Importando",
  "import.status.paused": "Pausada",
  "import.status.done": "Concluida",
  "import.status.failed": "Se detuvo",
  "import.status.cancelled": "Cancelada",
  "import.step": "Paso {n} de {of}",
  "import.step1.title": "qué viene",
  "import.step2.title": "vincular a DoneTalk",
  "import.continue": "Continuar",
  "import.start": "Empezar la importación",
  "import.cancel": "Cancelar",
  "import.cancel_keep": "Cancelar (lo que ya llegó se queda)",
  "import.pause": "Pausar",
  "import.resume": "Reanudar",
  "import.open_item": "Abrir",
  "import.numbers.title": "Números",
  "import.numbers.official": "API oficial",
  "import.numbers.qr": "Código QR: solo viene el historial",
  "import.numbers.conversations": "{count} conversación|{count} conversaciones",
  "import.numbers.waits_connection": "Entra en DoneTalk esperando la conexión por Meta, con el historial.",
  "import.numbers.on_channel": "El historial va al número {name}.",
  "import.numbers.qr_target": "Vincular al número oficial",
  "import.numbers.same_as": "El mismo de {name}",
  "import.numbers.qr_needs_official": "Elige antes un número de la API oficial para recibir este historial.",
  "import.period.title": "Período",
  "import.period.all": "Todo, desde la primera conversación ({date})",
  "import.period.12m": "Últimos 12 meses",
  "import.period.6m": "Últimos 6 meses",
  "import.period.retention": "La empresa guarda los mensajes por {days} días: las conversaciones más antiguas no vienen.",
  "import.include.title": "Qué viene",
  "import.include.totals": "{contacts} contactos, {conversations} conversaciones y {messages} mensajes en Copiloto.",
  "import.include.files": "Fotos, audios, videos y documentos ({count})",
  "import.include.notes": "Notas del equipo",
  "import.include.assistant": "Instrucciones de la IA como borrador de asistente",
  "import.never": "Nunca viene: conversaciones del simulador y de prueba, grupos, tokens y contraseñas, negocios y embudos del CRM.",
  "import.people.title": "Quién envió los mensajes",
  "import.people.lead": "Cada persona de Copiloto vinculada a su cuenta en DoneTalk, encontrada por correo. Quien no tiene cuenta aparece con el nombre.",
  "import.people.no_account": "Sin cuenta: solo el nombre",
  "import.people.assistant": "Los mensajes de la IA aparecen como del asistente creado a partir de ella.",
  "import.people.same_contact": "Un contacto que ya existe en DoneTalk se une por el número, con o sin el noveno dígito.",
  "import.reasons.title": "Motivos de cierre → desenlaces",
  "import.reasons.lead": "Cada motivo de Copiloto se vuelve un desenlace. \"Pidió salir\" también marca al contacto como sin marketing.",
  "import.reasons.create": "Crear: {name}",
  "import.reasons.none": "Sin desenlace",
  "import.running.lead": "Puedes cerrar esta pantalla y seguir usando DoneTalk. El avance aparece aquí.",
  "import.progress.title": "Avance",
  "import.progress.contacts": "Contactos",
  "import.progress.conversations": "Conversaciones",
  "import.progress.messages": "Mensajes",
  "import.progress.files": "Archivos",
  "import.progress.of": "{done} de {total}",
  "import.progress.files_missing": "{count} archivo que Copiloto no había guardado: aparece como no disponible en la conversación.|{count} archivos que Copiloto no había guardado: aparecen como no disponibles en la conversación.",
  "import.progress.matched": "{count} contacto ya existía en DoneTalk y se unió por el número.|{count} contactos ya existían en DoneTalk y se unieron por el número.",
  "import.progress.no_phone": "{count} contacto sin número de WhatsApp quedó fuera.|{count} contactos sin número de WhatsApp quedaron fuera.",
  "import.progress.groups": "{count} conversación de grupo quedó fuera.|{count} conversaciones de grupo quedaron fuera.",
  "import.progress.assistant_unavailable": "No se pudo leer la configuración de la IA: crea el asistente a mano.",
  "import.failed.title": "La importación se detuvo",
  "import.failed.key": "Copiloto ya no aceptó la clave (venció o fue revocada). Genera otra y conecta de nuevo: lo que ya llegó no se repite.",
  "import.failed.other": "Copiloto no respondió después de varios intentos. Conecta de nuevo en un rato: lo que ya llegó no se repite.",
  "import.failed.again": "Conectar de nuevo",
  "import.todo.title": "Lo que falta configurar en DoneTalk",
  "import.todo.assistant": "Revisar el borrador del asistente y activarlo en el número",
  "import.todo.closing": "Cerrar conversaciones inactivas, como hacía Copiloto",
  "import.todo.systems": "Los sistemas de la empresa que usaban la API de Copiloto pasan a usar la de DoneTalk",
  "import.todo.templates": "Plantillas de mensaje: vienen de Meta con el número",
  "import.key.kept": "La clave de migración queda guardada con cifrado hasta la búsqueda final.",
  "import.key.gone": "La clave de migración se borró aquí. En Copiloto se puede revocar antes de que venza.",
  "import.finished_at": "terminó el {when}",
  "import.switch.title": "Cambiar el número a DoneTalk",
  "import.switch.lead": "El número sigue siendo el mismo, en la misma cuenta de WhatsApp: sin código por SMS, y las plantillas aprobadas vienen juntas.",
  "import.switch.both": "Mientras Copiloto y DoneTalk estén en la cuenta, ambos reciben cada mensaje. Haz los pasos 2 a 5 el mismo día, fuera de las horas de más movimiento.",
  "import.switch.who.copiloto": "Copiloto",
  "import.switch.who.meta": "Meta",
  "import.switch.ready.title": "Deja DoneTalk listo",
  "import.switch.ready.body": "El historial ya está aquí. Revisa el asistente, el equipo y los horarios antes de activar el número.",
  "import.switch.ai.title": "En Copiloto, apaga la IA del número",
  "import.switch.ai.body": "Agentes de IA › el número › apagar las respuestas. Así solo DoneTalk responde después del paso 3.",
  "import.switch.ai.done": "Marcado como hecho el {when}.",
  "import.switch.ai.mark": "Ya la apagué",
  "import.switch.ai.undo": "Desmarcar",
  "import.switch.connect.title": "Conecta el número en DoneTalk",
  "import.switch.connect.body": "En Números, haz clic en Conectar con Meta y elige la misma empresa, cuenta de WhatsApp y número. Sin código por SMS.",
  "import.switch.connect.done": "Conectado. Los mensajes nuevos ya llegan a DoneTalk.",
  "import.switch.connect.go": "Ir a Números",
  "import.switch.final.title": "Búsqueda final",
  "import.switch.final.body": "Después de conectar, DoneTalk busca en Copiloto lo que llegó desde la importación. Unos minutos.",
  "import.switch.final.done": "Hecha. Lo que llegó durante el cambio ya está aquí.",
  "import.switch.final.run": "Hacer la búsqueda final",
  "import.switch.disconnect.title": "En Copiloto, desconecta el número",
  "import.switch.disconnect.after": "Después de la búsqueda final: Configuración › WhatsApp › Desconectar. DoneTalk lo comprueba solo.",
  "import.switch.disconnect.still": "Todavía en la cuenta de WhatsApp: {apps}. Desconecta en Copiloto y vuelve a comprobar.",
  "import.switch.disconnect.done": "Solo DoneTalk recibe los mensajes de este número.",
  "import.switch.disconnect.unknown": "No se pudo comprobar ahora. Inténtalo de nuevo en un momento.",
  "import.switch.disconnect.recheck": "Volver a comprobar",
  "import.switch.systems": "Campañas, avisos y sistemas de la empresa que usan la API de Copiloto se detienen en el paso 5: antes deben pasar a la API de DoneTalk.",
  "numbers.waiting_connection": "Esperando conexión",
  "numbers.imported.lead": "Vino de Copiloto con su historial. Para activarlo, conéctalo por la ventana de Meta eligiendo esta misma cuenta y este número.",
  "numbers.imported.connect": "Conectar con Meta",
  "numbers.imported.see_import": "Ver la importación",
  "contact.history_copiloto": "Historial de Copiloto",
  "errors.import_key_rejected": "Copiloto no aceptó la clave. Revisa que se copió completa, que no venció y que la migración está activa.",
  "errors.import_address_invalid": "Esa dirección no se puede usar. Usa la dirección de Copiloto, con https.",
  "errors.import_source_unreachable": "Copiloto no respondió. Inténtalo de nuevo en un momento.",
  "errors.import_source_busy": "Copiloto pidió esperar un poco. Inténtalo de nuevo en un minuto.",
  "errors.import_open": "Ya hay una importación en curso. Termínala o cancélala antes de empezar otra.",
  "errors.import_not_editable": "Esta importación ya empezó: las elecciones ya no pueden cambiar.",
  "errors.import_not_startable": "Esta importación no puede empezar ahora.",
  "errors.import_wrong_state": "Esa acción no aplica en este momento de la importación.",
  "errors.import_key_gone": "La clave de migración ya se borró. Genera otra en Copiloto y conecta de nuevo.",
  "message.imported": "Vino de Copiloto",
  "message.imported_by": "Vino de Copiloto · enviada por {name}",
  "message.file_unavailable": "archivo no disponible",
  "numbers.meta.steps_title": "En la ventana de Meta",
  "numbers.meta.importing": "¿Vas a traer números de Copiloto? No los conectes aquí ahora: empieza por la importación. Se conectan el día del cambio.",
  "numbers.meta.importing_link": "Importar de Copiloto",
  "campaigns.var.value": "Valor de la integración: {name}",
  "team.capacity_hint": "Cuántas conversaciones atiende cada persona al mismo tiempo, de 0 a {max}.",
  "errors.validation_field": "Revisa el campo “{field}” e inténtalo de nuevo.",
  "field.defaultCapacity": "Capacidad por persona",
  "field.capacityOverride": "Capacidad de la persona",
  "field.name": "Nombre",
  "field.email": "Correo",
  "field.phone": "Teléfono",
  "numbers.handling.first": "Quién atiende primero",
  "numbers.handling.people": "Las personas del equipo",
  "numbers.handling.flow": "Flujo: {name}",
  "numbers.handling.team": "Equipo del número",
  "numbers.handling.no_team": "Ningún equipo",
  "numbers.handling.hint": "Los mensajes que llegan a este número van al equipo elegido.",
  "numbers.handling.hint_assistant": "La asistente responde a quien escribe a este número y pasa al equipo cuando hace falta una persona.",
  "numbers.handling.saved": "Atención del número guardada",
  "numbers.handling.hint_flow": "El flujo responde primero; cuando pasa a una persona, la conversación va al equipo elegido.",
  "numbers.disconnect": "Desconectar",
  "numbers.disconnect_title": "¿Desconectar el {number}?",
  "numbers.disconnect_lead": "El número sale de DoneTalk:",
  "numbers.disconnect_1": "DoneTalk deja de recibir y enviar mensajes por él, incluidas campañas y avisos.",
  "numbers.disconnect_2": "Las conversaciones siguen aquí como historial.",
  "numbers.disconnect_3": "En Meta nada cambia: el número sigue registrado y funcionando en otros sistemas que lo usen.",
  "numbers.disconnect_4": "Para usarlo de nuevo, basta conectarlo por Meta.",
  "numbers.disconnect_keep": "Mantener conectado",
  "numbers.disconnected": "Número desconectado.",
  "numbers.disconnected_meta_failed": "Número desconectado. Meta no respondió ahora, pero lo que envíe para él se ignorará.",
  "numbers.off_since": "Desconectado de DoneTalk el {date}. Nada llega ni sale por él aquí.",
  "numbers.off_lead": "Este número está apagado: nada llega ni sale por él aquí.",
  "numbers.off_hint": "Sus conversaciones siguen en el historial. Para usarlo de nuevo, conéctalo por Meta.",
  "delivery.error.channel_disconnected": "El número fue desconectado de DoneTalk. Conéctalo de nuevo en Configuración › Números para enviar.",
  "errors.number_rented": "Este número fue alquilado por DoneTalk: termina el alquiler en la propia tarjeta del número.",
  "onboarding.org.outcomes_locked_hint": "Los resultados de DoneTalk mantienen su nombre: desmarca los que no sirven y crea los tuyos al final de la lista.",
  "onboarding.org.outcome_locked": "Resultado de DoneTalk: el nombre no cambia. Desmárcalo para no usarlo.",
  "select.chosen": "1 elegido|{count} elegidos",
  "select.add": "Añadir “{value}”",
  "assistant.language_auto": "El mismo del contacto",
  "assistant.tone_option.cordial": "Cordial",
  "assistant.tone_option.friendly": "Amigable",
  "assistant.tone_option.objective": "Objetivo",
  "assistant.tone_option.formal": "Formal",
  "assistant.tone_option.relaxed": "Relajado",
  "assistant.tone_option.empathetic": "Empático",
  "assistant.tone_option.welcoming": "Acogedor",
  "assistant.tone_option.patient": "Paciente",
  "assistant.tone_option.direct": "Directo",
  "assistant.tone_option.humorous": "Con humor",
  "assistant.tone_option.enthusiastic": "Entusiasta",
  "assistant.tone_option.professional": "Profesional",
  "assistant.tone_option.technical": "Técnico",
  "assistant.tone_option.consultative": "Consultivo",
  "assistant.tone_option.persuasive": "Persuasivo",
  "assistant.tone_option.calm": "Calmado",
  "assistant.tone_option.respectful": "Respetuoso",
  "assistant.tone_option.simple": "Sencillo",
  "builder.missing_choice": "Falta elegir {field} en el bloque “{block}” ({id}).",
  "builder.invalid_generic": "El flujo tiene un bloque incompleto. Revisa los bloques e inténtalo de nuevo.",
  "composer.link_preview_remove": "Enviar sin la vista previa del enlace",
  "message.list_view_only": "Solo para ver: quien elige es el cliente, en WhatsApp.",
  "message.list_chosen": "Elegida por el cliente",
  "knowledge.source.file": "Archivo",
  "knowledge.file_choose": "Elegir archivo",
  "knowledge.file_change": "Cambiar archivo",
  "knowledge.file_reading": "Leyendo el archivo…",
  "knowledge.file_ready": "{name}: {chars} caracteres de texto.",
  "knowledge.file_hint": "PDF, Markdown (.md) o texto (.txt). El texto se lee aquí en el navegador; los PDF escaneados (solo imagen) no tienen texto para leer.",
  "knowledge.file_unsupported": "Ese tipo de archivo no se acepta. Usa PDF, Markdown (.md) o texto (.txt).",
  "knowledge.file_empty": "Ese archivo está vacío.",
  "knowledge.file_unreadable": "No se pudo leer ese archivo.",
  "list.drag": "Arrastrar {name} para cambiar el orden (o usa las flechas ↑ ↓)",
  "ai.surface.flow.choice": "Menú respondido por escrito",
  "replies.title": "Respuestas del flujo y del asistente",
  "replies.hint": "Varios mensajes seguidos reciben una sola respuesta. Un toque en un botón se responde al instante.",
  "replies.answer": "Responder",
  "replies.after_last": "después del último mensaje del contacto",
  "replies.wait": "Tiempo de espera",
  "replies.seconds": "{n} segundos",
  "replies.at_once": "justo",
  "node.field.menu_text": "Cuando escriben en vez de tocar",
  "node.menu_text.understand": "La IA entiende y sigue",
  "node.menu_text.fallback": "Sigue por \"Sin respuesta válida\"",
  "node.menu_text.resend": "Envía el menú de nuevo",
  "node.menu_text_hint.understand": "La IA lee lo que la persona escribió y elige la opción correcta. Si no se puede saber, sigue por \"Sin respuesta válida\" (o envía el menú de nuevo, si esa salida no está conectada).",
  "node.menu_text_hint.fallback": "Solo vale el nombre exacto de una opción. Lo demás sigue por \"Sin respuesta válida\" (o envía el menú de nuevo, si esa salida no está conectada).",
  "node.menu_text_hint.resend": "Solo vale el nombre exacto de una opción. Lo demás recibe el texto al no entender y el menú de nuevo; cuando se agotan los intentos, sigue por \"Sin respuesta válida\".",
  "inbox.header.attendances": "{n} atenciones",
  "event.taken_over.flow": "{name} escribió y asumió · el flujo se pausó",
  "event.taken_over.assistant": "{name} escribió y asumió · el asistente se pausó",
  "event.reason.member_reply": "Escribió en la conversación",
  "handoff.from_label": "Empezar",
  "handoff.from.beginning": "Desde el inicio",
  "handoff.from.resume": "Donde se detuvo: {step}",
  "handoff.from.step": "En un paso elegido",
  "handoff.step_label": "Paso",
  "errors.flow_not_stopped": "Este flujo no se detuvo en esta conversación: empieza desde el inicio o en un paso.",
  "errors.flow_step_not_found": "Ese paso ya no existe en la versión publicada del flujo.",
  "outcome.when_label": "Cuándo concluir",
  "outcome.when.now": "Ahora",
  "outcome.when.hour": "Si no responde en 1 hora",
  "outcome.when.hours": "Si no responde en {n} horas",
  "outcome.when.day": "Si no responde en 1 día",
  "outcome.when.days": "Si no responde en {n} días",
  "outcome.when_hint": "Mientras tanto la conversación espera al contacto. Si responde antes, la conclusión se cancela.",
  "outcome.schedule": "Programar",
  "outcome.scheduled": "Conclusión programada.",
  "inbox.scheduled_close.chip": "Concluye en {time} · {outcome}",
  "inbox.scheduled_close.tip": "Concluye como {outcome} el {when}, si el contacto no responde antes.",
  "inbox.scheduled_close.cancel": "Cancelar conclusión programada",
  "inbox.scheduled_close.cancelled": "Conclusión programada cancelada.",
  "event.close_scheduled": "Concluir como {outcome} el {when} si el contacto no responde",
  "event.close_unscheduled.contact_replied": "Conclusión programada cancelada: el contacto respondió",
  "event.close_unscheduled.cancelled": "{name} canceló la conclusión programada",
  "event.close_unscheduled.failed": "La conclusión programada no ocurrió: el resultado se desactivó o ahora pide una nota",
  "node.split": "Dividir",
  "node.repeat": "Repetir",
  "node.goto_flow": "Ir a otro flujo",
  "node.optout": "Mensajes automáticos",
  "builder.exit_path": "Camino {n} · {pct}%",
  "builder.exit_repeat_loop": "Repetir (hasta {n}×)",
  "builder.exit_repeat_done": "Ya repitió",
  "builder.exit_reply": "Si el contacto responde",
  "builder.exit_timeout": "{time} sin respuesta",
  "builder.repeat_summary": "Hasta {n}×",
  "node.optout.label": "Mensajes automáticos",
  "node.optout.on": "Vuelve a recibirlos",
  "node.optout.off": "Deja de recibirlos",
  "node.optout.hint": "\"Deja de recibirlos\" registra la baja del contacto: las campañas y los mensajes automáticos dejan de llegarle. \"Vuelve a recibirlos\" registra que aceptó de nuevo.",
  "node.field.flow": "Flujo",
  "node.goto_flow.hint": "La conversación entra en el flujo elegido (publicado) y este termina aquí. Lo que este flujo guardó no pasa al otro.",
  "node.field.option_keywords": "También acepta",
  "node.field.option_keywords_placeholder": "palabras, apodos… Enter para incluir",
  "node.field.own_timeout": "Esperar respuesta por (minutos)",
  "node.field.own_timeout_placeholder": "El tiempo del flujo",
  "node.field.own_timeout_hint": "Con un tiempo aquí, aparece la salida \"sin respuesta\" de este bloque. Vacío, vale el tiempo de inactividad del flujo.",
  "node.condition.subject": "Sobre",
  "node.condition.subject.tag": "Etiqueta del contacto",
  "node.condition.subject.field": "Campo del contacto",
  "node.condition.subject.message": "Mensaje recibido",
  "node.condition.subject.assignee": "Agente responsable",
  "node.condition.subject.window": "Ventana de 24 horas",
  "node.condition.subject.variable": "Variable del flujo",
  "node.condition.window_open": "Abierta",
  "node.condition.window_closed": "Cerrada",
  "node.condition.label.tag_with": "Tiene la etiqueta {tag}",
  "node.condition.label.tag_without": "No tiene la etiqueta {tag}",
  "node.condition.label.assignee_any": "Tiene agente",
  "node.condition.label.assignee_is": "Lo atiende {name}",
  "node.condition.label.assignee_not": "No lo atiende {name}",
  "node.condition.label.window_open": "Ventana de 24 h abierta",
  "node.condition.label.window_closed": "Ventana de 24 h cerrada",
  "op.not_contains": "no contiene",
  "node.tag.add": "Añadir etiquetas",
  "node.tag.remove": "Quitar etiquetas",
  "node.split.paths": "Caminos",
  "node.split.weight": "Peso",
  "node.split.add": "Añadir camino",
  "node.split.hint": "Cada conversación sigue un camino sorteado, en proporción a los pesos: sirve para probar dos mensajes o repartir el trabajo.",
  "node.repeat.times": "Cuántas veces repetir",
  "node.repeat.hint": "Las primeras veces que la conversación pasa por aquí sigue por \"Repetir\"; después, una vez por \"Ya repitió\", y la cuenta vuelve a empezar.",
  "node.ai_route": "Triaje con IA",
  "node.ai_condition": "Condición con IA",
  "node.ai_tags": "Etiquetas por IA",
  "node.ai_fields": "Campos por IA",
  "ai.surface.flow.blocks": "Bloques de IA de los flujos",
  "builder.exit_ai_unsure": "La IA no identificó",
  "builder.exit_yes": "Sí",
  "builder.exit_no": "No",
  "builder.default_route": "Camino {n}",
  "node.ai_route.reads_message": "Lee el mensaje del cliente",
  "node.ai_route.prompt": "Pregunta (opcional)",
  "node.ai_route.prompt_hint": "Con una pregunta, la IA lee la respuesta. Sin pregunta, lee el mensaje que trajo al cliente hasta aquí.",
  "node.ai_route.routes": "Caminos",
  "node.ai_route.label": "Nombre del camino (ej.: Finanzas)",
  "node.ai_route.description": "Cuándo seguir por aquí (ej.: boleto, pago, factura)",
  "node.ai_route.add": "Añadir camino",
  "node.ai_route.hint": "La IA elige el camino que corresponde a lo que el cliente necesita. Si no se puede saber, sigue por \"La IA no identificó\".",
  "node.ai_condition.question": "Pregunta para la IA",
  "node.ai_condition.hint": "Una pregunta de sí o no sobre la conversación, como \"¿El cliente ya decidió cancelar?\". La IA responde \"No\" cuando la conversación no lo deja claro.",
  "node.ai_tags.tags": "Etiquetas que la IA puede usar",
  "node.ai_tags.any": "Cualquier etiqueta",
  "node.ai_tags.instructions": "Orientación (opcional)",
  "node.ai_tags.hint": "La IA lee la conversación y pone en el contacto las etiquetas que corresponden. Sin ninguna elegida, puede usar todas.",
  "node.ai_fields.fields": "Campos del contacto",
  "node.ai_fields.hint": "La IA completa los campos con lo que el cliente dijo en la conversación. Un campo que la conversación no dice queda como estaba.",
  "node.message.vary": "Variar con IA",
  "node.message.vary_hint": "Cada cliente recibe el mismo mensaje con otras palabras, manteniendo el sentido, enlaces y números.",
  "builder.exit_other_reply": "Otra respuesta",
  "builder.exit_replied": "Respondió",
  "builder.tag_trigger": "Cuando se pone una etiqueta al contacto",
  "builder.tag_trigger_hint": "El flujo empieza en la conversación abierta del contacto. Sin una, abre una: empiece entonces con una plantilla aprobada, porque la ventana de 24 horas está cerrada.",
  "node.message.attach": "Adjuntar archivo",
  "node.message.uploading": "Subiendo…",
  "node.message.remove_file": "Quitar el archivo",
  "node.message.file_hint": "El texto va como pie de la foto, el video o el documento; con un audio, justo después.",
  "node.message.kind.image": "Foto",
  "node.message.kind.video": "Video",
  "node.message.kind.audio": "Audio",
  "node.message.kind.document": "Documento",
  "node.template.wait": "Esperar la respuesta",
  "node.template.wait_hint": "El flujo se detiene aquí hasta que el contacto responda la plantilla, y sigue por \"Respondió\".",
  "node.template.by_button": "Un camino por botón",
  "node.template.by_button_hint": "Cada botón de respuesta rápida de la plantilla tiene su salida; lo demás sigue por \"Otra respuesta\".",
  "builder.remove_link": "Quitar este enlace",
  "builder.search_blocks": "Buscar bloque",
  "builder.no_blocks": "Ningún bloque con ese nombre.",
  "builder.copied": "{count} bloque(s) copiado(s): ⌘/Ctrl+V pega aquí o en otro flujo.",
  "builder.pasted": "{count} bloque(s) pegado(s).",
  "builder.group.messages": "Mensajes",
  "builder.group.ai": "Inteligencia artificial",
  "builder.group.logic": "Caminos",
  "builder.group.contact": "Contacto",
  "builder.group.service": "Atención",
  "builder.group.integrations": "Integraciones",
  "node.desc.message": "Envía un texto, con foto, video, audio o documento si quiere.",
  "node.desc.template": "Envía una plantilla aprobada: la única forma de escribir fuera de la ventana de 24 horas. Puede esperar la respuesta y seguir por botón.",
  "node.desc.menu": "Pregunta con opciones (lista o botones de WhatsApp); cada opción lleva a un camino.",
  "node.desc.input": "Hace una pregunta y guarda la respuesta, revisando CPF, correo, fecha…",
  "node.desc.ai_route": "La IA entiende lo que el cliente necesita y sigue por el camino correcto.",
  "node.desc.ai_condition": "Una pregunta de sí o no sobre la conversación, respondida por la IA.",
  "node.desc.ai_tags": "La IA pone en el contacto las etiquetas que corresponden a la conversación.",
  "node.desc.ai_fields": "La IA completa campos del contacto con lo que dijo.",
  "node.desc.assistant": "Pasa la conversación a un asistente de IA, que puede devolverla al flujo.",
  "node.desc.condition": "Sigue caminos diferentes según etiqueta, campo, mensaje, agente o ventana de 24 h.",
  "node.desc.split": "Sortea un camino, en la proporción que elija.",
  "node.desc.repeat": "Cuenta las pasadas: repite algunas veces y después sigue otro camino.",
  "node.desc.wait": "Espera un tiempo, hasta una fecha o un horario; puede seguir antes si el cliente responde.",
  "node.desc.business_hours": "Un camino dentro del horario de atención, otro fuera.",
  "node.desc.tag": "Pone y quita etiquetas del contacto o de la conversación.",
  "node.desc.set_field": "Guarda un valor en un campo del contacto.",
  "node.desc.set_variable": "Guarda un valor para usar más adelante en el flujo.",
  "node.desc.optout": "Registra si el contacto recibe mensajes automáticos (baja).",
  "node.desc.transfer": "Pasa la conversación a una persona o equipo.",
  "node.desc.schedule": "Ofrece horarios libres y agenda con el cliente.",
  "node.desc.close": "Concluye la atención con un resultado.",
  "node.desc.goto_flow": "Pone la conversación en otro flujo publicado.",
  "node.desc.end": "Termina el flujo aquí.",
  "node.desc.http_request": "Llama a una dirección de otro sistema y guarda la respuesta.",
  "node.desc.script": "Calcula valores con un fragmento de código.",
  "node.desc.event": "Avisa a otros sistemas que algo ocurrió.",
  "node.desc.exception": "A dónde va el flujo cuando algo sale mal.",
  "builder.undo": "Deshacer",
  "builder.redo": "Rehacer",
  "builder.undo_hint": "Deshacer (⌘/Ctrl+Z)",
  "builder.redo_hint": "Rehacer (⌘/Ctrl+Shift+Z)",
  "builder.shortcuts": "Atajos del editor",
  "builder.versions_hint": "Las versiones publicadas: véalas y vuelva a una anterior.",
  "builder.triggers_hint": "Cuándo empieza el flujo: en el número, por palabra, por etiqueta o desde el asistente.",
  "builder.test_hint": "Converse con el flujo aquí, sin enviar nada a nadie.",
  "builder.save_hint": "Guarda los cambios sin publicarlos (⌘/Ctrl+S).",
  "builder.publish_hint": "Lo publica: las próximas conversaciones siguen esta versión.",
  "builder.shortcut.add.keys": "Clic en un bloque del panel",
  "builder.shortcut.add.does": "Crea el bloque enlazado al seleccionado (o en el medio de la pantalla).",
  "builder.shortcut.drop.keys": "Arrastrar del panel",
  "builder.shortcut.drop.does": "Suelta el bloque donde quiera.",
  "builder.shortcut.link.keys": "Arrastrar el punto de una salida",
  "builder.shortcut.link.does": "Enlaza con otro bloque; suelte en el vacío para crear el próximo bloque ya enlazado.",
  "builder.shortcut.unlink.keys": "× en el medio del enlace",
  "builder.shortcut.unlink.does": "Quita el enlace (aparece al pasar el mouse).",
  "builder.shortcut.select.keys": "Shift o ⌘/Ctrl + clic",
  "builder.shortcut.select.does": "Elige varios bloques.",
  "builder.shortcut.box.keys": "Shift o ⌘/Ctrl + arrastrar",
  "builder.shortcut.box.does": "Elige los bloques dentro del área.",
  "builder.shortcut.all.keys": "⌘/Ctrl+A",
  "builder.shortcut.all.does": "Elige todos los bloques.",
  "builder.shortcut.copy.keys": "⌘/Ctrl+C",
  "builder.shortcut.copy.does": "Copia los bloques elegidos.",
  "builder.shortcut.paste.keys": "⌘/Ctrl+V",
  "builder.shortcut.paste.does": "Pega en el medio de la pantalla, en este u otro flujo.",
  "builder.shortcut.duplicate.keys": "⌘/Ctrl+D",
  "builder.shortcut.duplicate.does": "Duplica los bloques elegidos.",
  "builder.shortcut.delete.keys": "Supr o Retroceso",
  "builder.shortcut.delete.does": "Borra los bloques o el enlace elegidos.",
  "builder.shortcut.undo.keys": "⌘/Ctrl+Z",
  "builder.shortcut.undo.does": "Deshace el último cambio.",
  "builder.shortcut.redo.keys": "⌘/Ctrl+Shift+Z",
  "builder.shortcut.redo.does": "Rehace lo deshecho.",
  "builder.shortcut.save.keys": "⌘/Ctrl+S",
  "builder.shortcut.save.does": "Guarda el borrador.",
  "builder.shortcut.arrange.keys": "Shift+Alt+T",
  "builder.shortcut.arrange.does": "Organiza los bloques.",
  "builder.shortcut.zoom.keys": "⌘/Ctrl + rueda, o pellizco",
  "builder.shortcut.zoom.does": "Acerca y aleja; la rueda sola mueve el lienzo.",
  "builder.shortcut.fit.keys": "⛶ en la esquina de abajo",
  "builder.shortcut.fit.does": "Muestra el flujo entero.",
  "builder.channel_default_none": "Esta empresa aún no tiene número conectado. Después de conectarlo, marca aquí el número cuyas conversaciones nuevas empiezan con este flujo.",
  "builder.start_when": "Cuándo empieza este flujo",
  "builder.start_none": "Ningún disparador aún. Así el flujo solo empieza cuando una persona le pasa la conversación o cuando otro flujo va a él.",
  "builder.start_none_short": "Ningún disparador: haz clic para elegir cuándo empieza",
  "builder.start_choose": "Elegir disparadores",
  "builder.start_published_hint": "Los disparadores valen para la versión publicada: mientras el flujo sea solo borrador, nada empieza solo.",
  "builder.start_line.channel_default": "Un contacto inicia una conversación en el número {number}",
  "builder.start_line.keyword": "El contacto escribe: {words}",
  "builder.start_line.tag_added": "Se pone la etiqueta {tag} al contacto",
  "composer.format.bar": "Formato",
  "composer.format.bold": "Negrita",
  "composer.format.italic": "Cursiva",
  "composer.format.strike": "Tachado",
  "composer.format.code": "Código en línea",
  "composer.format.numbered": "Lista numerada",
  "composer.format.bulleted": "Lista con viñetas",
  "composer.format.quote": "Citar",
  "settings.api": "API",
  "api.title": "API",
  "api.lead": "Claves para que otros sistemas (ERP, CRM, sitio, automatizaciones) usen DoneTalk: crear y enviar campañas, registrar contactos, enviar mensajes y más. Cada clave hace solo lo que se marca en ella.",
  "api.address": "Dirección de la API",
  "api.docs": "Ver documentación",
  "api.keys": "Claves",
  "api.new_key": "Nueva clave",
  "api.edit_key": "Editar clave",
  "api.key_name": "Nombre",
  "api.key_name_placeholder": "Ej.: ERP de la empresa",
  "api.environment": "Entorno",
  "api.environment.live": "Producción",
  "api.environment.test": "Prueba (no envía nada)",
  "api.environment.test_short": "Prueba",
  "api.environment_hint": "Una clave de prueba responde como la de producción, con datos de ejemplo, y no guarda, no envía ni cobra nada.",
  "api.scopes": "Qué puede hacer esta clave",
  "api.scopes_required": "Marque al menos un permiso.",
  "api.group.campaigns": "Campañas",
  "api.group.contacts": "Contactos",
  "api.group.templates": "Plantillas",
  "api.group.messages": "Mensajes y conversaciones",
  "api.group.flows": "Flujos y agenda",
  "api.group.other": "Otros",
  "api.scope.campaigns:read": "Ver campañas y resultados",
  "api.scope.campaigns:write": "Crear y editar borradores",
  "api.scope.campaigns:send": "Enviar, pausar y cancelar",
  "api.scope.contacts:read": "Ver contactos y los valores de los campos",
  "api.scope.contacts:write": "Crear y actualizar contactos",
  "api.scope.fields:read": "Ver la lista de campos",
  "api.scope.fields:write": "Crear campos",
  "api.scope.contacts:delete": "Borrar datos de contactos (LGPD)",
  "api.scope.templates:read": "Ver plantillas",
  "api.scope.templates:write": "Crear plantillas y enviarlas a Meta",
  "api.scope.messages:send_template": "Enviar plantillas",
  "api.scope.messages:send_text": "Enviar texto y archivos (ventana de 24 h)",
  "api.scope.conversations:read": "Ver conversaciones y mensajes",
  "api.scope.conversations:write": "Cerrar y reabrir conversaciones",
  "api.scope.flows:start": "Iniciar flujos",
  "api.scope.appointments:read": "Ver citas",
  "api.scope.appointments:write": "Agendar, reprogramar y cancelar citas",
  "api.scope.webhooks:manage": "Gestionar avisos (webhooks)",
  "api.scope.reports:read": "Ver informes y costos",
  "api.scope.workspace:read": "Ver números, equipos y etiquetas",
  "api.scope.integrations:outboundpro": "Conectar OutboundPro Conversas",
  "api.skip_approval": "Enviar campañas sin esperar aprobación",
  "api.skip_approval_hint": "Sin esto, las campañas de esta clave siguen la regla de aprobación de la empresa. El presupuesto siempre vale.",
  "api.expires": "Válida hasta (opcional)",
  "api.ips": "Solo desde estas direcciones IP (opcional)",
  "api.ips_hint": "Una por línea, como 200.155.12.10 o 200.155.12.0/24. Vacío: cualquier dirección.",
  "api.create": "Crear clave",
  "api.created_title": "Clave creada",
  "api.created_hint": "Cópiela y guárdela en un lugar seguro. Por seguridad, no se muestra de nuevo.",
  "api.created_warning": "Quien tenga esta clave actúa en nombre de la empresa dentro de lo que marcó. Si se filtra, revóquela y cree otra.",
  "api.copy_key": "Copiar clave",
  "api.legacy": "Acceso de integración (antigua)",
  "api.legacy_hint": "Hecha antes de los permisos por clave: hace todo lo que hacía una integración. Elija sus permisos para limitarla.",
  "api.all_scopes": "Todo",
  "api.created_by": "creada por {name}",
  "api.expires_on": "válida hasta {date}",
  "api.revoke_confirm": "¿Revocar la clave {name}? El sistema que la usa deja de funcionar al instante.",
  "api.empty": "Ninguna clave aún. Cree una para conectar otro sistema.",
  "api.saved": "Clave guardada",
  "api.keys_moved": "Las claves de la API están en Configuración › API.",
  "integrations.event.campaign.started": "Campaña empezó",
  "integrations.event.campaign.paused": "Campaña pausada",
  "integrations.event.campaign.resumed": "Campaña reanudada",
  "integrations.event.campaign.completed": "Campaña concluida",
  "integrations.event.campaign.cancelled": "Campaña cancelada",
  "integrations.event.campaign.recipient.sent": "Campaña: mensaje enviado",
  "integrations.event.campaign.recipient.delivered": "Campaña: mensaje entregado",
  "integrations.event.campaign.recipient.read": "Campaña: mensaje leído",
  "integrations.event.campaign.recipient.replied": "Campaña: contacto respondió",
  "integrations.event.campaign.recipient.failed": "Campaña: falló para un contacto",
  "integrations.event.campaign.recipient.opted_out": "Campaña: contacto pidió salir",
  "policy.gate.authors": "Revisa los mensajes de",
  "policy.gate.author.member": "Personas del equipo",
  "policy.gate.author.assistant": "Asistente de IA",
  "policy.gate.author.flow": "Flujos",
  "policy.gate.author_short.member": "personas",
  "policy.gate.author_short.assistant": "asistente de IA",
  "policy.gate.author_short.flow": "flujos",
  "policy.gate.authors_hint": "El asistente de IA sigue las reglas de esta política aunque no sea revisado: entran en sus instrucciones. Marque el asistente solo si cada respuesta suya también debe pasar por la revisión.",
  "policy.summary.authors": "Revisa: {who}",
  "event.transfer_note.gate_hold": "la revisión de mensajes retuvo una respuesta",
  "event.transfer_note.max_turns": "el asistente llegó a su límite de respuestas",
  "event.transfer_note.exit_field_set": "el asistente obtuvo el dato que buscaba",
  "event.transfer_note.exit_keyword": "el contacto dijo una palabra de salida del asistente",
  "event.transfer_note.error": "el asistente no pudo continuar",
  "gate.your_edit": "Su mensaje, para editar",
  "errors.gate_override_denied": "La política no le deja enviar este mensaje tal como está. Edite el texto.",
  "errors.gate_decision_unavailable": "Esta revisión venció. Envíe el mensaje de nuevo.",
  "errors.gate_no_rewrite": "No hay sugerencia para usar. Edite el texto.",
  "inbox.draft": "Borrador:",
  "common.delete": "Eliminar",
  "settings.tools": "Herramientas",
  "permission.tools.manage": "Crear y editar las herramientas y conexiones de los asistentes",
  "ai.surface.tools.draft": "Crear herramienta con IA",
  "assistants.tab.tools": "Herramientas",
  "errors.tool_key_taken": "Ya existe una herramienta con este nombre para la IA. Elija otro.",
  "errors.connection_in_use": "Algunas herramientas todavía usan esta conexión. Cámbielas antes.",
  "errors.tool_call_decided": "Otra persona ya decidió sobre este pedido.",
  "errors.package_not_found": "Este paquete no está disponible para la empresa.",
  "errors.tool_not_found": "Herramienta no encontrada.",
  "errors.connection_not_found": "Conexión no encontrada.",
  "tools.lead": "Lo que los asistentes pueden hacer en medio de la conversación: consultar y cambiar datos en el sistema de la empresa.",
  "tools.new": "Nueva herramienta",
  "tools.active": "Activa",
  "tools.inactive": "Apagada",
  "tools.empty": "Aún no hay herramientas. Cree la primera describiéndole a la IA lo que hace.",
  "tools.soon": "Próximamente",
  "tools.group.company": "De la empresa",
  "tools.group.company_hint": "Hechas aquí, activadas en los asistentes que usted elija",
  "tools.group.connections": "Conexiones",
  "tools.group.connections_hint": "La dirección del sistema y el secreto, guardados una vez para varias herramientas",
  "tools.group.platform": "De la plataforma",
  "tools.group.platform_hint": "Listas: solo hay que activarlas en cada asistente",
  "tools.kind.form": "formulario",
  "tools.kind.flow": "flujo",
  "tools.list.assistants": "1 asistente|{count} asistentes",
  "tools.list.no_assistant": "ningún asistente",
  "tools.list.uses": "1 uso en 60 días|{count} usos en 60 días",
  "tools.effect.read": "Solo consulta",
  "tools.effect.read_hint": "Lee y no cambia nada. También se ejecuta de verdad en las pruebas.",
  "tools.effect.write": "Cambia datos",
  "tools.effect.write_hint": "Cambia algo en el sistema. En las pruebas se simula.",
  "tools.confirm_short.contact": "confirma con el contacto",
  "tools.confirm_short.person": "una persona aprueba",
  "tools.confirm_short.none": "sin confirmación",
  "tools.confirm.title": "Antes de cambiar",
  "tools.confirm.contact": "Confirmar con el contacto",
  "tools.confirm.contact_hint": "la IA dice qué va a cambiar; DoneTalk solo llama después de que el contacto acepte, con los mismos datos.",
  "tools.confirm.person": "Una persona aprueba",
  "tools.confirm.person_hint": "el equipo ve el pedido en la conversación y lo aprueba o rechaza.",
  "tools.confirm.none": "Sin confirmación",
  "tools.confirm.none_hint": "llama en cuanto la IA lo decide.",
  "tools.preview": "El sistema describe el cambio antes",
  "tools.preview_hint": "La primera llamada va con confirmed = false y el sistema responde lo que haría; la IA se lo lee al contacto.",
  "tools.timeout": "Esperar la respuesta hasta",
  "tools.seconds": "1 segundo|{n} segundos",
  "tools.hourly_limit": "Llamadas por conversación",
  "tools.per_hour": "hasta {n} por hora",
  "tools.ms": "{n} ms",
  "tools.required": "obligatorio",
  "tools.secret_hint": "secreto que termina en {hint}",
  "tools.auth.donetalk": "Firma DoneTalk",
  "tools.auth.copiloto": "Firma en el formato de Copiloto",
  "tools.auth.bearer": "Token (Bearer)",
  "tools.auth.header": "Clave en un encabezado",
  "tools.auth.none": "Sin autenticación",
  "tools.auth_hint.donetalk": "DoneTalk firma cada llamada con el secreto y la hora (DoneTalk-Signature), como los avisos.",
  "tools.auth_hint.copiloto": "Para sistemas hechos para la consulta externa de Copiloto: X-Copiloto-Timestamp y X-Copiloto-Signature.",
  "tools.auth_hint.bearer": "El secreto va en Authorization: Bearer.",
  "tools.auth_hint.header": "El secreto va en el encabezado que usted indique.",
  "tools.auth_hint.none": "Solo para pruebas: cualquiera que conozca la dirección puede llamarla.",
  "tools.connection.title": "Conexión",
  "tools.connection.new": "Nueva conexión",
  "tools.connection.new_option": "+ Nueva conexión…",
  "tools.connection.edit": "Editar conexión",
  "tools.connection.name": "Nombre",
  "tools.connection.name_placeholder": "Sistema de la tienda",
  "tools.connection.base_url": "Dirección",
  "tools.connection.auth": "Cómo se identifica DoneTalk",
  "tools.connection.header": "Nombre del encabezado",
  "tools.connection.secret": "Secreto",
  "tools.connection.secret_replace": "Secreto nuevo (el actual termina en {hint}; vacío lo mantiene)",
  "tools.connection.secret_hint": "Se guarda cifrado. Una vez guardado, solo se ven los 4 últimos caracteres.",
  "tools.connection.used_by": "usada por 1 herramienta|usada por {count} herramientas",
  "tools.connection.in_use": "Usada por herramientas: cámbielas antes de eliminarla.",
  "tools.name": "Nombre",
  "tools.key": "Nombre para la IA",
  "tools.key_taken": "Ya existe una herramienta con este nombre para la IA.",
  "tools.description": "Cuándo usarla (es lo que lee la IA)",
  "tools.description_hint": "Diga en qué situaciones usarla, qué no hacer y qué decirle al contacto después. Cada asistente puede ajustar este texto en su pestaña Herramientas.",
  "tools.part.name": "Nombre y cuándo usarla",
  "tools.part.inputs": "Lo que la IA necesita saber",
  "tools.part.call": "Adónde llamar",
  "tools.part.response": "Lo que vuelve a la IA",
  "tools.part.safety": "Seguridad",
  "tools.inputs.key": "Campo",
  "tools.inputs.type": "Tipo",
  "tools.inputs.description": "Para la IA",
  "tools.inputs.remove": "Quitar el campo",
  "tools.inputs.add": "Agregar campo",
  "tools.inputs.none": "Ningún campo: la herramienta usa solo lo que viene de la conversación.",
  "tools.inputs.options": "Valores aceptados",
  "tools.inputs.options_placeholder": "hotel, motel",
  "tools.inputs.automatic": "Va solo, tomado de la conversación (la IA nunca lo informa): teléfono y nombre del contacto, la conversación y el asistente.",
  "tools.inputs.contact_fields": "Enviar también estos campos del contacto",
  "tools.inputs.contact_fields_placeholder": "plan, ciudad",
  "tools.input_type.text": "Texto",
  "tools.input_type.number": "Número",
  "tools.input_type.boolean": "Sí o no",
  "tools.input_type.list": "Lista",
  "tools.input_type.date": "Fecha",
  "tools.call.method": "Método",
  "tools.call.path": "Ruta",
  "tools.call.format": "Formato",
  "tools.call.donetalk": "Estándar DoneTalk",
  "tools.call.donetalk_hint": "el sistema recibe el pedido firmado y responde un texto para la IA.",
  "tools.call.docs": "Ver el formato",
  "tools.call.any": "Cualquier API",
  "tools.call.any_hint": "arme la ruta y el cuerpo con los datos de la conversación, por ejemplo {phone} y {input}.",
  "tools.call.headers": "Encabezados (uno por línea)",
  "tools.call.body": "Cuerpo",
  "tools.response.text": "El texto de la respuesta (campo text, o la respuesta entera)",
  "tools.response.field": "Un campo de la respuesta",
  "tools.response.template": "Una frase armada con la respuesta",
  "tools.response.field_path": "Ruta del campo",
  "tools.response.template_text": "Frase",
  "tools.response.limit": "La IA lee hasta {chars} caracteres. Si el sistema no responde en {seconds} s, escucha \"no disponible ahora\" y sigue la conversación sin el dato.",
  "tools.ai_view.title": "Lo que ve la IA",
  "tools.ai_view.phone": "El teléfono no aparece aquí: la IA no puede cambiar de contacto.",
  "tools.ai_view.checked": "DoneTalk lo verifica",
  "tools.missing.title": "Falta para guardar",
  "tools.missing.name": "El nombre de la herramienta",
  "tools.missing.key": "Un nombre para la IA: minúsculas, números y _",
  "tools.missing.description": "El \"cuándo usarla\", con al menos 10 caracteres",
  "tools.missing.connection": "La conexión con el sistema",
  "tools.missing.input_key": "Campos con nombre válido: minúsculas, números y _",
  "tools.missing.input_repeated": "Campos sin nombres repetidos",
  "tools.missing.response_field": "La ruta del campo de la respuesta",
  "tools.missing.response_template": "La frase con la respuesta",
  "tools.flow.title": "¿Necesita más pasos?",
  "tools.flow.hint": "Consultar antes y solo cambiar si la cuenta existe, por ejemplo: la herramienta podrá abrirse como flujo.",
  "tools.on_assistants": "Activada en",
  "tools.on_assistants_hint": "Actívela o ajústela en la pestaña Herramientas de cada asistente.",
  "tools.remove.title": "Eliminar la herramienta",
  "tools.remove.hint": "Los asistentes dejan de usarla al instante. El historial de llamadas se conserva.",
  "tools.remove.action": "Eliminar",
  "tools.how.ai": "Describirla a la IA",
  "tools.how.ai_hint": "Diga en palabras lo que hace, o pegue la documentación de la API. La IA completa todo.",
  "tools.how.form": "Formulario",
  "tools.how.form_hint": "Una llamada a un sistema. Usted completa cada parte.",
  "tools.how.start_form": "Abrir el formulario",
  "tools.how.flow": "Flujo de varios pasos",
  "tools.how.flow_hint": "Consulta, decide y vuelve a llamar, en el constructor de flujos, sin código.",
  "tools.how.package": "Paquete listo",
  "tools.ai.title": "Qué hace la herramienta",
  "tools.ai.describe": "En palabras",
  "tools.ai.describe_placeholder": "Cuando el cliente pregunte por su pedido, consulte el estado por el número de pedido en nuestro sistema.",
  "tools.ai.docs": "Documentación, cURL o ejemplo de la API (opcional)",
  "tools.ai.create": "Crear con IA",
  "tools.ai.hint": "La IA arma el borrador; nada se guarda ni se activa sin que usted lo revise.",
  "tools.ai.drafted": "La IA armó este borrador. Revise cada parte y use \"Probar ahora\" antes de guardar.",
  "tools.test.title": "Probar ahora",
  "tools.test.phone": "Teléfono del contacto de ejemplo",
  "tools.test.real": "Hacerlo de verdad",
  "tools.test.real_hint": "Sin marcar, no se llama a nada: esta herramienta cambia datos.",
  "tools.test.real_hint_preview": "Sin marcar, el sistema solo describe lo que haría (confirmed = false).",
  "tools.test.run": "Probar",
  "tools.test.ai_reads": "Lo que lee la IA",
  "tools.test.sent": "Lo que se envió",
  "tools.test.received": "Lo que volvió",
  "tools.test.not_called": "No se llamó a nada: marque \"Hacerlo de verdad\" para llamar al sistema.",
  "tools.test.note": "La prueba no entra en el historial ni cuenta para el límite. El secreto nunca aparece aquí.",
  "tools.test.status.ok": "Funcionó",
  "tools.test.status.refused": "El sistema respondió que no",
  "tools.test.status.failed": "No respondió",
  "tools.test.status.simulated": "Simulado",
  "tools.call_status.ok": "Funcionó",
  "tools.call_status.refused": "El sistema rechazó",
  "tools.call_status.failed": "Falló",
  "tools.call_status.limited": "Pasó el límite",
  "tools.call_status.simulated": "Simulada",
  "tools.call_status.awaiting_contact": "Esperando el sí del contacto",
  "tools.call_status.awaiting_person": "Esperando aprobación",
  "tools.call_status.declined": "Rechazada por el equipo",
  "tools.call_status.expired": "Venció",
  "tools.error.timeout": "el sistema no respondió a tiempo",
  "tools.error.network": "no se pudo conectar",
  "tools.error.too_large": "respuesta demasiado grande",
  "tools.error.no_text": "la respuesta no trajo texto",
  "tools.error.field_missing": "el campo elegido no vino",
  "tools.error.empty": "respuesta vacía",
  "tools.error.no_connection": "sin conexión",
  "tools.error.bad_address": "dirección inválida",
  "tools.error.unsafe_address": "dirección no permitida (solo https público)",
  "tools.error.hourly_limit": "límite por hora",
  "tools.error.tool_inactive": "herramienta apagada",
  "tools.error.other": "error",
  "tools.error.http": "el sistema respondió HTTP {status}",
  "tools.calls.title": "Historial de llamadas",
  "tools.calls.total": "Llamadas en {n} días",
  "tools.calls.ok": "Funcionaron",
  "tools.calls.failed": "Fallaron",
  "tools.calls.failed_n": "{n} fallaron",
  "tools.calls.all_tools": "Todas las herramientas",
  "tools.calls.any_result": "Cualquier resultado",
  "tools.calls.filter.ok": "Funcionaron",
  "tools.calls.filter.refused": "El sistema rechazó",
  "tools.calls.filter.failed": "Fallaron",
  "tools.calls.filter.limited": "Pasaron el límite",
  "tools.calls.filter.pending": "Esperando",
  "tools.calls.filter.declined": "Rechazadas por el equipo",
  "tools.calls.days": "Últimos {n} días",
  "tools.calls.period": "Período",
  "tools.calls.when": "Cuándo",
  "tools.calls.tool": "Herramienta",
  "tools.calls.assistant": "Asistente",
  "tools.calls.conversation": "Conversación",
  "tools.calls.result": "Resultado",
  "tools.calls.time": "Tiempo",
  "tools.calls.by_tool": "Por herramienta",
  "tools.calls.empty": "Ninguna llamada en el período.",
  "tools.calls.more": "Mostrar más",
  "tools.decide.approve": "Aprobar",
  "tools.decide.decline": "Rechazar",
  "tools.package.install": "Instalar {name}",
  "tools.package.install_n": "Instalar 1 herramienta|Instalar {count} herramientas",
  "tools.package.installed": "1 herramienta instalada|{count} herramientas instaladas",
  "tools.package.connection": "Conexión: {name}",
  "tools.package.secret": "Secreto acordado con el sistema",
  "tools.package.test": "Probar la conexión",
  "tools.package.connected": "Conectado: \"{tool}\" respondió en {ms} ms",
  "tools.package.tools": "Herramientas del paquete",
  "tools.package.already": "ya instalada",
  "tools.package.preview": "vista previa del sistema",
  "tools.package.on": "Activar en",
  "tools.package.on_hint": "Los asistentes marcados empiezan a usar las herramientas al instante (se publica una versión nueva).",
  "tools.package.kit_aco.name": "Kit ACO",
  "tools.package.kit_aco.lead": "Las herramientas de Amanda en Copiloto, listas para DoneTalk: las mismas direcciones y los mismos textos de \"cuándo usarla\". Solo falta el secreto.",
  "event.tool.read": "{who} consultó {tool}",
  "event.tool.write": "{who} usó {tool}",
  "event.tool.write_confirmed": "{who} usó {tool} · confirmado por el contacto",
  "event.tool.approved": "{tool} aprobado por {name}",
  "event.tool.declined": "{name} rechazó {tool}",
  "event.tool.failed": "{tool} no respondió; la conversación siguió sin el dato",
  "event.tool.waiting_contact": "Esperando el sí del contacto: {tool}",
  "event.tool.waiting_person": "Esperando la aprobación del equipo: {tool}",
  "event.info.tool": "Herramienta",
  "event.info.tool_input": "Pedido",
  "event.info.tool_preview": "Vista previa",
  "event.info.tool_result": "La IA leyó",
  "event.info.tool_confirmed": "Confirmado por",
  "event.info.tool_approved": "Aprobado por",
  "event.info.tool_time": "Tiempo",
  "assistants.tools.title": "Herramientas de la empresa",
  "assistants.tools.hint": "Active las que este asistente puede usar. Él decide cuándo, por el \"cuándo usarla\".",
  "assistants.tools.own": "Cuándo usarla, en este asistente",
  "assistants.tools.adjust": "Ajustar el \"cuándo usarla\" para este asistente",
  "assistants.tools.back_to_tool": "Volver al texto de la herramienta",
  "assistants.tools.none": "La empresa aún no tiene herramientas.",
  "assistants.tools.open": "Ver las herramientas de la empresa",
  "assistants.tools.rules_title": "Valen siempre, para cualquier herramienta",
  "assistants.tools.rule_phone": "El teléfono y el nombre vienen de la conversación; la IA no elige de quién es la cuenta.",
  "assistants.tools.rule_confirm": "Lo que cambia datos sigue la confirmación elegida en la herramienta.",
  "assistants.tools.rule_test": "En el \"Probar\" de este asistente, lo que cambia datos se simula.",
  "assistants.tools.rule_fact": "La IA usa la respuesta como hecho y dice \"lo vi aquí\", nunca \"consulté el sistema\".",
  "assistants.tools.rule_limit": "Hasta 5 llamadas de la misma herramienta por conversación por hora.",
  "assistants.test.phone": "Teléfono del contacto de prueba (para las herramientas)",
  "assistants.test.note_tools": "Nada va a WhatsApp. Las herramientas de solo consulta se ejecutan de verdad con el teléfono de arriba; las que cambian datos se simulan.",
  "assistants.test.tool_read": "Consultó {tool}: {text}",
  "assistants.test.tool_preview": "{tool} mostró la vista previa: {text}",
  "assistants.test.tool_waiting": "{tool}: esperaría el sí del contacto",
  "assistants.test.tool_simulated": "Simulado: {tool} {text}",
  "assistants.test.tool_approval": "{tool}: una persona del equipo aprobaría",
  "assistants.test.tool_missing": "{tool}: faltó {text}",
  "email.tool_failing.subject": "DoneTalk · {workspace}: la herramienta {tool} está fallando",
  "email.tool_failing.text": "La herramienta {tool} falló en las últimas 5 llamadas. El asistente siguió las conversaciones sin el dato y la herramienta sigue activada.",
  "email.tool_failing.error": "Último motivo: {error}.",
  "email.tool_failing.cta": "Ver el historial de llamadas",
  "email.tool_failing.why": "Usted recibe este aviso porque es dueño o administrador de la empresa en DoneTalk. Llega como máximo una vez al día por herramienta.",
  "errors.tool_call_not_yours": "Solo quien atiende esta conversación, o quien distribuye las conversaciones, aprueba este pedido.",
  "errors.tool_call_not_found": "Pedido no encontrado.",
  "templates.category.authentication_hint": "Códigos de acceso y de verificación. Meta escribe el texto y agrega el botón de copiar el código.",
  "templates.otp.title": "Código de acceso",
  "templates.otp.lead": "Meta escribe el texto en el idioma de la plantilla, con el código en negrita y el botón Copiar código. Usted elige solo lo que viene con él.",
  "templates.otp.security": "Pedir que no lo comparta",
  "templates.otp.security_hint": "Después del código, Meta agrega un aviso de seguridad.",
  "templates.otp.expiry": "Avisar cuándo vence",
  "templates.otp.expiry_hint": "En el pie, Meta escribe en cuántos minutos vence el código.",
  "templates.otp.minutes": "Minutos hasta que vence",
  "templates.otp.minutes_hint": "De 1 a 90 minutos.",
  "templates.otp.send_hint": "Al enviar, el código va como el primer valor del cuerpo; el botón copia el mismo código.",
  "templates.otp.not_verified": "Meta habilita plantillas de código de acceso solo para empresas verificadas. Verifique la empresa en el Administrador comercial de Meta y vuelva aquí.",
  "templates.otp.refused": "Meta aún no habilitó plantillas de código de acceso para esta cuenta. Lo hace con el tiempo: puede intentarlo de nuevo desde el {date}.",
  "templates.otp.row": "Código de acceso: Meta escribe el texto al aprobar.",
  "templates.otp.preview_body": "Tu código de verificación es *{{1}}*.",
  "templates.otp.preview_security": "Por tu seguridad, no lo compartas.",
  "templates.otp.preview_footer": "Vence en {n} minutos.",
  "templates.otp.preview_button": "Copiar código",
  "templates.issue.otp_expiration_range": "Meta acepta de 1 a 90 minutos.",
  "errors.authentication_not_allowed": "Meta aún no habilitó plantillas de código de acceso para esta cuenta.",
  "settings.skills": "Skills",
  "skills.lead": "Las formas de hacer que siguen tus asistentes de IA: un método de ventas, cómo cobrar, cómo acoger un reclamo. La IA abre cada skill cuando la conversación lo pide.",
  "skills.new": "Nueva skill",
  "skills.add": "Agregar a la empresa",
  "skills.added": "Skill agregada. Ahora actívala en los asistentes que la usarán.",
  "skills.copy": "Copiar para editar",
  "skills.copied": "Copia creada. Es de la empresa y ya no recibe las mejoras de la biblioteca.",
  "skills.removed": "Skill eliminada.",
  "skills.in_use": "Esta skill está activa en: {names}. Desactívala en esos asistentes antes de eliminarla.",
  "skills.version": "Versión {n}",
  "skills.revision": "Revisión {n}",
  "skills.revisions": "Historial de revisiones",
  "skills.ai_view": "Lo que lee el asistente",
  "skills.on_assistants": "En los asistentes",
  "skills.on_assistants_hint": "Cada asistente elige sus skills en la pestaña Skills.",
  "skills.to_assistants": "Ir a los asistentes",
  "skills.group.company": "De la empresa",
  "skills.group.company_hint": "Escritas por ustedes, a su manera.",
  "skills.group.library": "De la biblioteca DoneTalk",
  "skills.group.library_hint": "Métodos conocidos, ajustados a tu empresa. Reciben mejoras.",
  "skills.list.unused": "Ningún asistente la usa",
  "skills.list.company_empty": "Ninguna aún. Crea una o usa “Organizar con IA” para sacar skills de las instrucciones que ya tienen.",
  "skills.list.library_empty": "Ninguna skill de la biblioteca agregada.",
  "skills.area.essentials": "Esenciales",
  "skills.area.sales": "Ventas",
  "skills.area.marketing": "Marketing",
  "skills.area.support": "Atención",
  "skills.area.success": "Éxito del cliente",
  "skills.area.retention": "Retención",
  "skills.area.finance": "Finanzas",
  "skills.area.people": "Personas",
  "skills.area.operations": "Operaciones",
  "skills.audience.customers": "Con clientes",
  "skills.audience.team": "Con el equipo",
  "skills.origin.organize": "Organizada con IA",
  "skills.origin.copy": "Copia de la biblioteca",
  "skills.library.title": "Biblioteca DoneTalk",
  "skills.library.open": "Ver la biblioteca",
  "skills.library.lead": "{count} skill lista para usar. Cada una sigue un método conocido; ustedes solo dicen cómo lo hace la empresa.|{count} skills listas para usar. Cada una sigue un método conocido; ustedes solo dicen cómo lo hace la empresa.",
  "skills.library.search": "Buscar en la biblioteca",
  "skills.library.filter.all": "Todas",
  "skills.library.filter.customers": "Con clientes",
  "skills.library.filter.team": "Con el equipo",
  "skills.library.filter.added": "Agregadas",
  "skills.library.added": "Agregada",
  "skills.library.market_hint": "Por defecto aparecen las skills generales y las de tu país ({country}). Algunas siguen reglas de un país, como cobranza y datos personales.",
  "skills.part.when": "Cuándo usar",
  "skills.part.goal": "Objetivo",
  "skills.part.steps": "Pasos",
  "skills.part.always": "Siempre",
  "skills.part.never": "Nunca",
  "skills.part.examples": "Ejemplos",
  "skills.part.origin": "Basada en:",
  "skills.setup.title": "Ajustes para tu empresa",
  "skills.setup.hint": "El método es de DoneTalk; aquí dicen cómo lo hace la empresa. Lo que quede en blanco la IA no lo inventa: pregunta o pasa a una persona.",
  "skills.setup.pending": "Ajustes en blanco",
  "skills.brings.title": "Lo que trae",
  "skills.brings.hint": "Al agregarla, los elementos marcados se crean en la empresa.",
  "skills.brings.hint_added": "Lo que se creó al agregar la skill. Ajústalo en Campos del contacto y Resultados.",
  "skills.brings.fields": "Campos que la IA completa",
  "skills.brings.outcomes": "Resultados de atención",
  "skills.brings.handoff": "Cuándo pasa a una persona",
  "skills.brings.exists": "Ya existe",
  "skills.update.available": "Nueva versión",
  "skills.update.title": "Versión {n} disponible",
  "skills.update.hint": "Sus ajustes se mantienen. Nada cambia hasta que actualicen.",
  "skills.update.take": "Actualizar",
  "skills.update.later": "Ahora no",
  "skills.update.taken": "Actualizada. Los asistentes ya usan la nueva versión.",
  "skills.update.later_done": "De acuerdo. Avisamos de nuevo en la próxima versión.",
  "skills.remove.title": "Eliminar skill",
  "skills.remove.hint": "Solo se puede eliminar cuando ningún asistente la usa.",
  "skills.remove.action": "Eliminar",
  "skills.field.name": "Nombre",
  "skills.field.area": "Área",
  "skills.field.audience": "Con quién",
  "skills.field.when_hint": "Es lo que la IA lee para decidir abrir esta skill. Sé concreto: “cuando el cliente pide descuento”.",
  "skills.field.lines_hint": "Un elemento por línea.",
  "skills.field.examples_hint": "Un mensaje del contacto y la respuesta ideal. Dos o tres buenos ejemplos enseñan más que muchas reglas.",
  "skills.field.example_contact": "El contacto escribe",
  "skills.field.example_reply": "La IA responde",
  "skills.field.example_add": "Agregar ejemplo",
  "skills.field.example_remove": "Eliminar ejemplo",
  "skills.field.notes": "Observaciones",
  "skills.links.title": "Vínculos",
  "skills.links.handoff_hint": "Situaciones en las que la IA pasa a una persona. Una por línea.",
  "skills.links.fields": "Campos del contacto que completa",
  "skills.links.tools": "Herramientas que usa",
  "skills.links.collections": "Bases de conocimiento que consulta",
  "skills.links.hint": "La skill solo le recuerda a la IA usarlos; cada asistente todavía necesita tenerlos activos.",
  "skills.mode.on_demand": "Cuando haga falta",
  "skills.mode.always": "Siempre",
  "skills.mode.on_demand_hint": "La IA ve solo el nombre y cuándo usarla, y abre la skill cuando la conversación lo pide. Usa poca memoria.",
  "skills.mode.always_hint": "La skill entera va en cada respuesta. Úsala para lo que vale en cualquier conversación, como el tono de la marca.",
  "skills.assistant.title": "Skills de este asistente",
  "skills.assistant.hint": "Activa las que usa. Valen después de publicar.",
  "skills.assistant.mode": "Cómo la usa",
  "skills.assistant.when_own": "Cuándo usar, solo en este asistente",
  "skills.assistant.when_own_hint": "En blanco, vale el de la skill.",
  "skills.assistant.open": "Abrir la skill",
  "skills.assistant.none": "La empresa aún no tiene skills. Agrega de la biblioteca o crea una.",
  "skills.assistant.modes_title": "¿Cuando haga falta o siempre?",
  "skills.assistant.many_always": "{n} skills en “Siempre” pesan en cada respuesta. Deja en “Siempre” solo lo que vale para cualquier conversación.",
  "skills.scenarios.title": "Escenarios",
  "skills.scenarios.hint": "Un cliente simulado escribe, el borrador responde y otra IA revisa lo que hace una buena respuesta. No se envía nada.",
  "skills.scenarios.library_hint": "Ejecútalos en “Probar” de un asistente que usa esta skill.",
  "skills.scenarios.none": "Ningún escenario. Las skills de la biblioteca traen los suyos; crea los de la empresa.",
  "skills.scenarios.run": "Ejecutar",
  "skills.scenarios.run_all": "Ejecutar todos",
  "skills.scenarios.replies": "Ver la conversación",
  "skills.scenarios.add": "Nuevo escenario",
  "skills.scenarios.remove": "Eliminar escenario",
  "skills.scenarios.field.title": "Título",
  "skills.scenarios.field.persona": "Quién es el cliente",
  "skills.scenarios.field.messages": "Lo que escribe el cliente",
  "skills.scenarios.field.messages_hint": "Un mensaje por línea, hasta 6.",
  "skills.scenarios.field.expect": "Lo que hace una buena respuesta",
  "skills.scenarios.field.expect_hint": "Una por línea, hasta 8. Ej.: “pregunta el tamaño antes de dar el precio”.",
  "skills.organize.button": "Organizar con IA",
  "skills.organize.lead": "Pega aquí lo que ya tienen: el prompt de hoy, un manual, guiones. La IA separa lo que es instrucción corta, lo que se vuelve skill, lo que es información para la base de conocimiento y los campos del contacto. Lo que no pueda decidir, lo pregunta.",
  "skills.organize.text": "Texto",
  "skills.organize.chars": "{n} de {max} caracteres",
  "skills.organize.assistant": "Para qué asistente",
  "skills.organize.assistant_hint": "El resultado se vuelve un borrador suyo, para revisar y publicar. Sin asistente, solo se crean las skills, campos e información.",
  "skills.organize.no_assistant": "Ninguno, solo organizar",
  "skills.organize.start": "Organizar",
  "skills.organize.how.title": "Cómo funciona",
  "skills.organize.how.1": "La IA lee todo y lo compara con lo que la empresa ya tiene.",
  "skills.organize.how.2": "Pregunta lo que no puede decidir sola, en rondas cortas.",
  "skills.organize.how.3": "Muestra la propuesta: cada parte con una casilla para marcar.",
  "skills.organize.how.4": "Ustedes aplican lo que quieran. El asistente recibe un borrador.",
  "skills.organize.how.safe": "Nada cambia hasta aplicar, y lo publicado sigue respondiendo.",
  "skills.organize.reading": "La IA está leyendo y organizando…",
  "skills.organize.reading_hint": "Puede tardar unos minutos. Puedes salir de esta pantalla: el análisis sigue.",
  "skills.organize.failed": "No se pudo organizar",
  "skills.organize.failed_hint": "El análisis se detuvo a mitad. Intenta de nuevo; si se repite, habla con soporte.",
  "skills.organize.again": "Intentar de nuevo",
  "skills.organize.into_draft": "Lo que se aplique se vuelve un borrador de {name}.",
  "skills.organize.no_assistant_hint": "Sin asistente: solo se crean las skills, los campos y la información.",
  "skills.organize.instructions": "Instrucciones nuevas, más cortas",
  "skills.organize.skills": "Skills",
  "skills.organize.skills_hint": "Las skills de la empresa se pueden editar luego en Skills.",
  "skills.organize.knowledge": "Información para la base de conocimiento",
  "skills.organize.fact.new": "Nueva",
  "skills.organize.fact.present": "Ya está en la base",
  "skills.organize.fact.outdated": "Distinta de la base",
  "skills.organize.base": "Guardar en",
  "skills.organize.new_base": "Nueva base “Organizado con IA”",
  "skills.organize.fields": "Campos del contacto",
  "skills.organize.field_action.create": "Crear",
  "skills.organize.field_action.fix": "Ajustar",
  "skills.organize.handoff_hint": "Se vuelve una skill de la empresa con estas situaciones.",
  "skills.organize.apply": "Aplicar {n} elementos",
  "skills.organize.applied_toast": "Aplicado.",
  "skills.organize.done": "Listo",
  "skills.organize.done_skills": "Skills: {names}",
  "skills.organize.done_fields": "{n} campos del contacto",
  "skills.organize.done_facts": "{n} datos en la base de conocimiento",
  "skills.organize.done_draft": "Un borrador de {name}, para revisar en Probar y publicar",
  "skills.organize.open_assistant": "Abrir el asistente",
  "skills.organize.to_skills": "Ver las skills",
  "ai_questions.title": "La IA necesita algunas respuestas",
  "ai_questions.round": "Ronda {n} de {total}",
  "ai_questions.recommended": "Recomendado",
  "ai_questions.other": "Otra respuesta…",
  "ai_questions.recorded": "Las respuestas quedan registradas.",
  "ai_questions.submit": "Responder",
  "memory.title": "Memoria del asistente",
  "memory.window": "Memoria de {tokens} tokens",
  "memory.loading": "Calculando…",
  "memory.part.rules": "Reglas e instrucciones",
  "memory.part.skills": "Skills",
  "memory.part.knowledge": "Bases enteras",
  "memory.part.conversation": "Conversación (típica)",
  "memory.tokens": "{tokens} tokens",
  "memory.share": "Usa {percent} de la memoria.",
  "memory.share_room": "Sobra bastante espacio para conversaciones largas.",
  "memory.share_tight": "Conversaciones muy largas pueden quedar justas; deja las bases grandes en búsqueda.",
  "memory.cost": "Cada respuesta cuesta alrededor de {usd} ({brl}), ya con caché.",
  "memory.cost_usd": "Cada respuesta cuesta alrededor de {usd}, ya con caché.",
  "assistants.tab.skills": "Skills",
  "assistants.knows.mode_label": "Cómo lee esta base",
  "assistants.knows.mode.auto": "Automático",
  "assistants.knows.mode.whole": "Entera",
  "assistants.knows.mode.search": "Por búsqueda",
  "assistants.knows.mode_hint": "Entera: la IA lee toda la base en cada respuesta (mejor para bases pequeñas). Por búsqueda: lee solo los fragmentos ligados a la conversación. Automático: entera hasta 150 mil caracteres.",
  "assistants.knows.is_whole": "Leída entera · {chars} caracteres",
  "assistants.knows.is_search": "Leída por búsqueda · {chars} caracteres",
  "assistants.test.view_chat": "Conversación",
  "assistants.test.skill": "Abrió la skill {name}",
  "event.skill_opened": "La IA abrió la skill {name}",
  "event.info.skill": "Skill",
  "event.info.skill_version": "Versión",
  "message.trace.title": "Cómo respondió la IA",
  "message.trace.skills": "Skills:",
  "message.trace.skill_always": "{name} (siempre)",
  "message.trace.skill_earlier": "{name} (abierta antes)",
  "message.trace.skill_here": "{name} (abierta ahora)",
  "message.trace.whole": "Bases leídas enteras:",
  "message.trace.passages": "Fragmentos consultados:",
  "message.trace.tools": "Herramientas:",
  "message.trace.read": "Leyó {n} mensajes de esta conversación",
  "message.trace.previous": "{n} de conversaciones anteriores",
  "message.trace.cached": "{percent}% desde la caché",
  "message.trace.adjust": "Ajustar lo que aparece en la conversación",
  "ai.conversation.title": "En la conversación",
  "ai.conversation.skill_events": "Mostrar cuando la IA abre una skill",
  "ai.conversation.skill_events_hint": "Una línea discreta en la conversación, como “La IA abrió la skill Negociación”. Solo el equipo la ve; nunca el contacto.",
  "ai.surface.skills.organize": "Organizar con IA",
  "ai.surface.skills.draft": "Mejorar skill con IA",
  "ai.surface.skills.judge": "Escenarios de prueba",
  "errors.skill_not_found": "Skill no encontrada.",
  "errors.skill_already_added": "Esta skill ya fue agregada.",
  "errors.skill_not_library": "Esta skill no es de la biblioteca.",
  "errors.skill_in_use": "La skill está activa en algún asistente.",
  "errors.organize_not_found": "Organización no encontrada.",
  "errors.organize_not_ready": "La propuesta aún no está lista.",
  "skills.tips.title": "Una buena skill",
  "skills.tips.1": "Un “cuándo usar” concreto: es con lo que la IA decide abrir la skill.",
  "skills.tips.2": "Pasos cortos, en el orden en que ocurren en la conversación.",
  "skills.tips.3": "Dos o tres ejemplos reales valen más que muchas reglas.",
  "assistants.instructions_long": "{n} caracteres: esto parece más un manual que instrucciones. Partes como métodos y guiones funcionan mejor como skills, y la información como base de conocimiento.",
  "onboarding.step.entry.skills": "Skills del asistente",
  "onboarding.when.entry.skills": "Listo con al menos una skill agregada. Es opcional.",
  "onboarding.done.entry.skills": "Skills agregadas",
  "onboarding.lead.entry.skills": "Elige las formas de hacer que sigue el asistente: ventas, cobranza, reclamos.",
  "onboarding.detail.skills": "1 skill|{count} skills",
  "onboarding.guide.skills.title": "Skills del asistente",
  "onboarding.guide.skills.text": "Métodos listos que sigue el asistente, como calificar un lead o acoger un reclamo. Las sugerencias vienen de lo que contaron en el cuestionario.",
  "onboarding.guide.skills.then": "Luego activa las skills en el asistente, en la pestaña Skills, y responde los ajustes de cada una.",
  "skills.suggested.title": "Sugeridas para tu empresa",
  "skills.suggested.hint": "Por lo que contaron en el cuestionario: lo que hace la empresa y el segmento. Los ajustes de cada una se pueden responder después.",
  "skills.suggested.add": "Agregar 1 marcada|Agregar {count} marcadas",
  "skills.suggested.added": "1 skill agregada.|{count} skills agregadas.",
  "skills.library.show_all": "Mostrar de todos los países",
  "active.title": "Mensajes activos",
  "active.state.can_receive": "Puede recibir mensajes activos",
  "active.state.paused": "En pausa hasta {day}",
  "active.state.opted_out": "No quiere mensajes activos",
  "active.status.can_receive": "Puede recibir",
  "active.status.paused": "En pausa",
  "active.status.opted_out": "No quiere",
  "active.since": "Desde {day}: {how}.",
  "active.answered": "Si escribe, se le atiende normalmente.",
  "active.history": "Historial",
  "active.history_paused": "En pausa hasta {day}",
  "active.origin.button": "tocó “{button}” en la plantilla {template}",
  "active.origin.assistant": "lo pidió en la conversación, la IA lo registró",
  "active.origin.keyword": "escribió “{word}”",
  "active.origin.api": "por una integración",
  "active.origin.pause_ended": "la pausa terminó",
  "active.origin.flow": "por un flujo",
  "active.origin.person": "registrado por alguien del equipo",
  "active.action.pause": "Pausar…",
  "active.action.opt_out": "No quiere",
  "active.action.change_date": "Cambiar fecha",
  "active.action.end_pause": "Terminar pausa",
  "active.action.resume": "Volver a recibir",
  "active.pause.title": "Pausar mensajes activos",
  "active.pause.hint": "Nada que la empresa inicia sale hasta esa fecha. Si el contacto escribe, se le atiende normalmente.",
  "active.pause.for": "Por cuánto tiempo",
  "active.pause.until": "O hasta el día",
  "active.pause.save": "Pausar",
  "active.period.7d": "7 días",
  "active.period.30d": "30 días",
  "active.period.3m": "3 meses",
  "active.period.6m": "6 meses",
  "active.period.1y": "1 año",
  "active.picker.paused": "{name} pausó los mensajes activos hasta {day}. Las plantillas de marketing no salen.",
  "active.picker.opted_out": "{name} no quiere mensajes activos. Las plantillas de marketing no salen.",
  "active.picker.held": "No salen para este contacto",
  "active.confirm.title": "¿Enviar aunque esté en pausa?",
  "active.confirm.paused": "{name} pausó los mensajes activos hasta {day}. Es una plantilla de utilidad: sale si confirmas, y queda registrado quién la envió.",
  "active.confirm.opted_out": "{name} no quiere mensajes activos. Es una plantilla de utilidad: sale si confirmas, y queda registrado quién la envió.",
  "active.confirm.cancel": "No enviar",
  "active.confirm.send": "Enviar",
  "active.refused.paused": "El contacto pausó los mensajes activos hasta {day}.",
  "active.rules.title": "Pausa y baja: qué retienen",
  "active.rules.hint": "Vale para todo lo que la empresa envía primero: campañas, plantillas enviadas en la conversación, flujos y la API.",
  "active.rules.category": "Tipo de plantilla",
  "active.rules.never": "No se envía nunca (política de Meta y LGPD)",
  "active.rules.always": "Se envía siempre: la persona pidió el código",
  "active.rules.utility": "Utilidad",
  "active.rules.answered": "Cuando el contacto escribe, se le atiende normalmente: la pausa y la baja solo retienen lo que la empresa inicia.",
  "active.utility.send": "Envía",
  "active.utility.hold": "No envía",
  "active.utility.ask": "Avisa a quien está enviando",
  "active.end.title": "Cuando la pausa termina",
  "active.end.hint": "El contacto vuelve solo a los públicos de campañas y a los envíos de la API. Además:",
  "active.end.none": "Nada",
  "active.end.team": "Vuelve a la fila del equipo",
  "active.end.tag": "Poner la etiqueta",
  "active.end.flow": "Iniciar el flujo",
  "active.end.flow_hint": "El equipo recibe de vuelta en su fila la última atención del contacto. El flujo debe empezar con una plantilla, porque la ventana de 24 horas ya cerró.",
  "active.assistant.label": "La IA lo aplica cuando el contacto lo pide en la conversación",
  "active.assistant.hint": "“Escríbeme en marzo”, “ya no quiero mensajes”: el asistente pausa o da de baja y lo confirma en la respuesta. Sin fecha clara, pregunta.",
  "buttons.menu": "Qué hacen los botones",
  "buttons.title": "Qué hacen los botones de {name}",
  "buttons.lead": "El texto del botón es de Meta; lo que pasa al tocarlo es de DoneTalk. Vale en todo envío (campaña, conversación, flujo y API) y no necesita nueva aprobación.",
  "buttons.none": "Esta plantilla no tiene botones de respuesta rápida.",
  "buttons.when_tapped": "Al tocarlo:",
  "buttons.action": "Acción",
  "buttons.main.pause": "Pausar mensajes activos",
  "buttons.main.opt_out": "No quiere mensajes activos",
  "buttons.main.opt_in": "Volver a recibir",
  "buttons.main.route": "Abrir una atención",
  "buttons.main.close": "Concluir con un desenlace",
  "buttons.main.record": "Solo registrar el toque",
  "buttons.main_hint.pause": "Completa “Puede contactar desde”. Si el contacto escribe, se le atiende normalmente.",
  "buttons.main_hint.opt_out": "Hasta que pida volver. Es la misma baja que las palabras “sair” y “parar”.",
  "buttons.main_hint.opt_in": "Para un botón “Quiero recibir de nuevo”: termina la pausa o la baja.",
  "buttons.main_hint.route": "La atención se abre en la fila elegida, o empieza el flujo o el asistente.",
  "buttons.main_hint.close": "Cuenta en los informes como cualquier atención concluida.",
  "buttons.main_hint.record": "Cuenta en los informes y avisa a los sistemas, sin cambiar nada.",
  "buttons.pause_for": "Por",
  "buttons.route.with": "Con",
  "buttons.route.team": "Un equipo",
  "buttons.route.flow": "Un flujo",
  "buttons.route.assistant": "Un asistente de IA",
  "buttons.route.which_team": "Equipo",
  "buttons.route.which_flow": "Flujo",
  "buttons.route.which_assistant": "Asistente",
  "buttons.route.usual_queue": "La fila habitual del número",
  "buttons.outcome": "Desenlace",
  "buttons.also_and": "y también",
  "buttons.also_label": "Y también",
  "buttons.also.tag_add": "Poner etiqueta",
  "buttons.also.tag_remove": "Quitar etiqueta",
  "buttons.also.field": "Completar campo",
  "buttons.also.tag": "Etiqueta",
  "buttons.also.field_key": "Campo",
  "buttons.also.field_value": "Valor",
  "buttons.also_add": "+ Otra acción",
  "buttons.also_remove": "Quitar esta acción",
  "buttons.where": "Una campaña puede cambiar la acción de un botón solo para ella. Si no, vale la de la plantilla.",
  "event.button_tapped": "Tocó “{button}”",
  "event.applied.pause": "mensajes activos en pausa hasta {day}",
  "event.applied.opt_out": "no quiere mensajes activos",
  "event.applied.opt_in": "volvió a recibir mensajes activos",
  "event.applied.route": "atención abierta",
  "event.applied.close": "concluida",
  "event.applied.tag_add": "etiqueta agregada",
  "event.applied.tag_remove": "etiqueta quitada",
  "event.applied.field": "campo {field} completado",
  "event.active.paused": "{who} pausó los mensajes activos hasta {day}",
  "event.active.opted_out": "{who} marcó: no quiere mensajes activos",
  "event.active.resumed": "{who} habilitó los mensajes activos",
  "event.active.pause_ended": "Terminó la pausa de los mensajes activos",
  "event.active.integration": "Una integración",
  "event.info.button": "Botón",
  "event.info.template": "Plantilla",
  "event.info.applied": "Aplicado",
  "assistants.test.active_pause": "Pausaría los mensajes activos hasta {day}",
  "assistants.test.active_stop": "Marcaría: no quiere mensajes activos",
  "assistants.test.active_resume": "Habilitaría los mensajes activos",
  "assistant.tool.active_messages": "Pausar o detener mensajes activos",
  "assistant.tool_hint.active_messages": "Cuando el contacto pide “escríbeme en marzo” o “no quiero más mensajes”. Se le sigue atendiendo cuando escribe.",
  "builder.exit_held": "No enviado",
  "node.template.held_hint": "“No enviado”: el contacto pausó o no quiere mensajes activos, y esta plantilla sería uno. Sin ese camino, sigue por el de error.",
  "campaigns.button.template": "Hace lo que dice la plantilla",
  "campaigns.skip.paused": "Pausaron los mensajes activos",
  "campaigns.recipient.skip.paused": "Fuera: en pausa",
  "segments.marketing.paused": "En pausa",
  "segments.marketing.can_receive": "Puede recibir mensajes activos",
  "segments.field.pause_ends_days": "Días hasta que termine la pausa",
  "integrations.event.template.button_clicked": "Botón de plantilla tocado",
  "errors.contact_paused": "El contacto pausó los mensajes activos.",
  "errors.marketing_opted_out": "El contacto no quiere mensajes activos.",
  "errors.active_messages_confirm": "El contacto pausó los mensajes activos: confirma para enviar.",
  "memory.part.tools": "Herramientas",
  "memory.strip.label": "Memoria",
  "memory.strip.share": "{percent} usada",
  "memory.strip.per_reply": "{cost} por respuesta",
  "memory.strip.details": "Ver detalles",
  "inbox.action.clear": "Vaciar conversación",
  "clear.title": "¿Vaciar esta conversación?",
  "clear.text": "Todos los mensajes con {name} desaparecen para el equipo y para la IA, que deja de leer lo anterior. El contacto sigue viendo todo en su WhatsApp.",
  "clear.kept": "Queda registrado quién la vació y cuándo. Quien puede ver mensajes borrados todavía puede verlos y recuperarlos.",
  "clear.confirm": "Vaciar conversación",
  "clear.done": "Conversación vaciada.",
  "event.cleared": "{name} vació la conversación",
  "permission.conversations.clear": "Vaciar conversaciones",
  "export.title": "Conversación con {name}",
  "export.number": "Número: {number}",
  "export.exported": "Exportado por {name} el {when} (zona {zone})",
  "export.counts": "{attendances} atención(es) · {messages} mensaje(s)",
  "export.role.team": "{name} (equipo)",
  "export.role.ai": "{name} (IA)",
  "export.role.flow": "Flujo {name}",
  "export.role.campaign": "Campaña {name}",
  "export.role.system": "Mensaje automático",
  "export.role.api": "Integración",
  "export.reply_to": "↪ En respuesta a {name}: “{text}”",
  "export.from_ad": "Vino del anuncio: {ad}",
  "export.voice": "🎤 Audio de voz",
  "export.audio": "🎵 Audio",
  "export.transcript": "Transcripción: “{text}”",
  "export.no_transcript": "(sin transcripción)",
  "export.location": "📍 Ubicación: {place}",
  "export.contact_card": "👤 Contacto: {name} {phones}",
  "export.template": "Plantilla {name}",
  "export.buttons": "Botones: {buttons}",
  "export.options": "Opciones: {options}",
  "export.chose": "Eligió: {option}",
  "export.flag.edited": "editado",
  "export.flag.deleted": "borrado por el contacto",
  "export.flag.removed": "borrado por {name} el {day}",
  "export.flag.failed": "no entregado",
  "export.flag.read": "leído a las {time}",
  "export.flag.delivered": "entregado",
  "export.flag.played": "escuchado a las {time}",
  "export.attendance_open": "Atención abierta el {start} · Equipo: {team}",
  "export.attendance_closed": "Atención del {start} al {end} · Equipo: {team} · Desenlace: {outcome}",
  "export.note": "Nota interna de {name}",
  "export.attached": "<adjunto: {file}>",
  "export.file": "📎 {file} ({size})",
  "export.reactions": "Reacciones: {list}",
  "export.zip_text": "Conversacion.txt",
  "export.event.snoozed": "En pausa",
  "export.event.opted_out": "Pidió salir: “{word}”",
  "export.event.tool": "Herramienta usada: {tool}",
  "permission.conversations.export": "Exportar conversaciones",
  "inbox.action.export": "Exportar conversación",
  "exportchat.title": "Exportar conversación",
  "exportchat.format": "Formato",
  "exportchat.pdf": "PDF",
  "exportchat.pdf_hint": "Organizado por día, con fotos, para leer o imprimir.",
  "exportchat.txt": "Texto (como WhatsApp)",
  "exportchat.txt_hint": "Una línea por mensaje, en el formato de WhatsApp.",
  "exportchat.zip": "Texto con los archivos (ZIP)",
  "exportchat.zip_hint": "El texto y todas las fotos, audios y documentos, como el “adjuntar archivos” de WhatsApp.",
  "exportchat.scope": "Qué exportar",
  "exportchat.scope_thread": "Toda la conversación con este contacto",
  "exportchat.scope_conversation": "Solo esta atención",
  "exportchat.notes": "Notas internas",
  "exportchat.events": "Eventos de la atención (transferencias, desenlaces, IA…)",
  "exportchat.hidden": "Mensajes borrados (marcados como borrados)",
  "exportchat.audit": "La exportación queda registrada en la auditoría.",
  "exportchat.submit": "Exportar",
  "export.by": "por {name}",
  "export.flag.failed_code": "no entregado (código {code} de Meta)",
  "api.scope.conversations:export": "Exportar conversaciones (PDF, texto, ZIP)",
  "knowledge.download": "Descargar {name}",
  "knowledge.file_not_kept": "{n} fragmentos. No se pudo guardar el archivo original: la IA lee el texto con normalidad.",
  "knowledge.doc.reads": "Lo que lee la IA",
  "knowledge.doc.reads_hint": "El texto completo, como lo recibe la IA, dividido en {chunks} fragmentos para la búsqueda.",
  "knowledge.doc.no_text": "Este contenido aún no tiene texto leído.",
  "knowledge.doc.about": "Sobre este contenido",
  "knowledge.doc.file": "Archivo",
  "knowledge.doc.file_not_kept": "Original no guardado",
  "knowledge.doc.file_not_kept_hint": "Este archivo se envió antes de que DoneTalk guardara los originales, por eso aquí solo está el texto. Para tener el archivo para abrir y descargar, quite este contenido y envíe el archivo de nuevo.",
  "knowledge.doc.added": "Agregado",
  "knowledge.doc.added_by": "{when} por {name}",
  "knowledge.doc.chars": "Caracteres",
  "knowledge.doc.download_text": "Descargar texto",
  "knowledge.doc.download_file": "Descargar archivo",
  "knowledge.doc.open_file": "Abrir archivo",
  "errors.document_not_found": "Este contenido ya no está en la base de conocimiento.",
  "errors.file_not_found": "El archivo original de este contenido no está guardado.",
  "campaigns.banner.waiting": "Fuera del horario de envío · {sent} de {total} enviados. Vuelve a enviar {at}, según los días y horarios de la campaña.",
  "campaigns.status.waiting_at": "Esperando el horario · {at}",
  "fields.search": "Buscar campo por nombre, clave u opción",
  "fields.search_none": "Ningún campo con «{query}».",
  "email.ai_model_off.subject": "DoneTalk · {workspace}: el modelo {model} salió del aire",
  "email.ai_model_off.text": "El modelo {model}, que la empresa eligió, fue apagado. Estas tareas volvieron a usar el modelo de DoneTalk: {tasks}. Nada dejó de funcionar.",
  "email.ai_model_off.cta": "Ver los modelos de IA",
  "email.ai_model_off.why": "Recibes este aviso porque eres dueño o administrador de la empresa en DoneTalk.",
  "aimodels.effort": "Esfuerzo",
  "aimodels.reasoning": "Razonamiento",
  "aimodels.level.none": "Ninguno",
  "aimodels.level.minimal": "Mínimo",
  "aimodels.level.low": "Bajo",
  "aimodels.level.medium": "Medio",
  "aimodels.level.high": "Alto",
  "aimodels.level.xhigh": "Muy alto",
  "aimodels.level.max": "Máximo",
  "aimodels.chip.temperature": "Temperatura: {value}",
  "aimodels.chip.fallback": "Reserva: {model}",
  "aimodels.hint.assistant.reply": "Lo que los asistentes responden a los contactos.",
  "aimodels.hint.gate.judge": "Revisa los mensajes antes de salir, según las Políticas.",
  "aimodels.hint.outcome.classify": "Sugiere el desenlace cuando se concluye una atención.",
  "aimodels.hint.summary.brief": "El resumen que acompaña la conversación cuando pasa a otra persona.",
  "aimodels.hint.knowledge.embed": "Prepara la base de conocimiento para la búsqueda.",
  "aimodels.hint.audio.transcribe": "Convierte los audios recibidos en texto.",
  "aimodels.hint.learning.mine": "Lee la semana de conversaciones y sugiere mejoras.",
  "aimodels.hint.onboarding.propose": "Prepara las sugerencias de la implantación.",
  "aimodels.hint.flow.choice": "Entiende a quien escribe en lugar de tocar el menú de un flujo.",
  "aimodels.hint.flow.blocks": "Los bloques de IA dentro de los flujos.",
  "aimodels.hint.tools.draft": "Arma una herramienta a partir de la descripción.",
  "aimodels.hint.skills.organize": "Divide un prompt largo en instrucciones, skills y conocimiento.",
  "aimodels.hint.skills.draft": "Mejora el texto de una skill de la empresa.",
  "aimodels.hint.skills.judge": "Evalúa las respuestas en los escenarios de prueba.",
  "aimodels.fallback_none": "Ninguno",
  "aimodels.price": "Precio: {input} por millón de tokens leídos, {output} por millón escritos.",
  "aimodels.offered_tools": "Esta tarea necesita un modelo que use herramientas. La lista muestra solo los que sirven.",
  "aimodels.offered": "La lista muestra solo los modelos que sirven para esta tarea.",
  "aimodels.model": "Modelo",
  "aimodels.settings": "Ajustes de este modelo",
  "aimodels.thinking_hint.effort": "Más esfuerzo piensa más antes de responder: más lento y más caro. Para conversar por WhatsApp, bajo.",
  "aimodels.thinking_hint.reasoning": "Más razonamiento piensa más antes de responder: más lento y más caro. Para conversar por WhatsApp, bajo.",
  "aimodels.fallback": "Modelo de reserva, si este falla",
  "aimodels.note.no_temperature": "Temperatura: este modelo no la usa. La Creatividad de los asistentes no tiene efecto con él.",
  "aimodels.note.temperature_without_thinking": "Temperatura: solo vale con razonamiento \"Ninguno\".",
  "aimodels.note.temperature": "Temperatura: usa la de cada tarea y la Creatividad de los asistentes.",
  "aimodels.note.responses": "Herramientas: por la interfaz Responses de OpenAI.",
  "aimodels.none_offered": "Ningún modelo disponible para esta tarea. Active modelos en Consola › IA › Modelos.",
  "aimodels.chosen_company": "Elegido por la empresa",
  "aimodels.chosen_custom": "Personalizado",
  "aimodels.platform_only": "Definido por DoneTalk",
  "aimodels.from_donetalk": "De DoneTalk: ",
  "aimodels.follows_platform": "Sigue la plataforma: ",
  "aimodels.change": "Cambiar",
  "aimodels.choose_other": "Elegir otro",
  "aimodels.use_donetalk": "Usar el de DoneTalk",
  "aimodels.back_to_platform": "Volver al estándar",
  "aimodels.tab.models": "Modelos",
  "aimodels.tab.keys": "Claves",
  "aimodels.tab.usage": "Uso",
  "aimodels.notice.model_off": "El modelo {model} salió del aire. Estas tareas volvieron al modelo de DoneTalk: {tasks}.",
  "aimodels.notice.ok": "Entendido",
  "aimodels.locked": "DoneTalk elige los modelos de IA de esta empresa. Hable con soporte para cambiarlos.",
  "aimodels.keys_note": "Sin cambios, cada tarea usa el modelo de DoneTalk, que se actualiza solo. Los modelos de otro proveedor usan las claves de DoneTalk, y el costo de cada uno aparece en Uso; con \"Usar mis propias claves\" activado, usan la clave de la empresa.",
  "aimodels.footer": "Para dueños y admins. Todo cambio queda en la auditoría. Si un modelo elegido sale del aire, la tarea pasa al sustituto o vuelve al de DoneTalk, con aviso aquí y por correo.",
  "aimodels.compare.title": "Comparar modelos",
  "aimodels.compare.task": "Tarea",
  "aimodels.compare.period": "Período",
  "aimodels.compare.assistant": "Asistente",
  "aimodels.compare.days": "Últimos {n} días",
  "aimodels.compare.all_assistants": "Todos",
  "aimodels.compare.line": "Indicador",
  "aimodels.compare.replies": "Respuestas enviadas",
  "aimodels.compare.reply_time": "Tiempo medio hasta responder",
  "aimodels.compare.calls": "Llamadas",
  "aimodels.compare.call_time": "Tiempo medio del modelo",
  "aimodels.compare.cost": "Costo medio por llamada",
  "aimodels.compare.cache": "Leído del caché",
  "aimodels.compare.handed_off": "Conversaciones pasadas a una persona",
  "aimodels.compare.tools": "Herramientas usadas",
  "aimodels.compare.successes": "Desenlaces de éxito",
  "aimodels.compare.errors": "Errores",
  "aimodels.compare.empty": "Ninguna llamada de esta tarea en el período.",
  "aimodels.compare.few": "Algún modelo tiene menos de 30 en el período: la comparación todavía dice poco.",
  "aimodels.console.following": "{count} clientes siguen",
  "aimodels.console.own": "{count} personalizados: {names}",
  "aimodels.console.impact": "Al guardar, {count} clientes que siguen el estándar pasan a usar el modelo elegido, con los ajustes traducidos para él. Los personalizados siguen con lo que eligieron.",
  "aimodels.console.embed_locked": "Cambiar este modelo exige leer de nuevo las bases de todos los clientes, y eso todavía no es automático. Por eso el cambio está desactivado aquí.",
  "aimodels.console.lock": "El cliente puede elegir los modelos",
  "aimodels.console.lock_hint": "Desactivado, solo la plataforma elige por él aquí; en Configuración › IA ve los modelos, sin cambiarlos.",
  "aimodels.console.assistants": "Asistentes",
  "aimodels.console.assistant_own": "Modelo propio: {model}",
  "aimodels.console.assistant_company": "Usa el de la empresa",
  "aimodels.console.history": "Historial",
  "aimodels.history.chosen": "{task}: {from} → {to}",
  "aimodels.history.assistant": "Modelo de un asistente: {from} → {to}",
  "aimodels.history.locked_on": "Elección bloqueada: solo la plataforma elige",
  "aimodels.history.locked_off": "Elección liberada para el cliente",
  "aimodels.history.platform": "Plataforma",
  "aimodels.history.default": "estándar",
  "aimodels.assistant.title": "Modelo de las respuestas",
  "aimodels.assistant.company": "El de la empresa",
  "aimodels.assistant.own": "Otro solo en este asistente",
  "aimodels.assistant.own_hint": "Bueno para probar un modelo sin tocar a los otros asistentes.",
  "aimodels.assistant.from_next": "Vale desde la próxima respuesta, sin publicar una versión nueva.",
  "aimodels.assistant.choose": "Elegir el modelo",
  "aimodels.assistant.creativity_off": "{model} no usa la Creatividad: la forma de hablar viene del tono y las instrucciones.",
  "aimodels.trace.model": "Modelo",
  "aimodels.trace.time": "Tiempo de la respuesta",
  "aimodels.trace.fallback": "Respondió en lugar de {model}, que falló",
  "platform.page.ai": "IA",
  "marketing.open_conversation.title": "Campaña en una conversación abierta",
  "marketing.open_conversation.hint": "Cuando la campaña llega a un contacto que ya tiene una conversación abierta (de otra campaña o con alguien del equipo) y responde: con quién queda la conversación.",
  "marketing.open_conversation.keep": "Mantener con quien está atendiendo",
  "marketing.open_conversation.keep_hint": "La respuesta queda en la conversación como está: sigue la persona, el asistente o el flujo que ya la atendía.",
  "marketing.open_conversation.route_if_free": "Pasarla al destino de la campaña si nadie está atendiendo",
  "marketing.open_conversation.route_if_free_hint": "Si una persona del equipo tiene la conversación, sigue con ella. Si no, el equipo, el flujo o el asistente de la campaña la asume.",
  "marketing.open_conversation.route": "Pasarla siempre al destino de la campaña",
  "marketing.open_conversation.route_hint": "El equipo, el flujo o el asistente de la campaña la asume aunque alguien estuviera atendiendo; esa persona deja la conversación y queda en la línea de tiempo.",
  "campaigns.open_rule": "Quien tiene una conversación abierta la recibe. Si responde, vale la regla de la empresa: \"{rule}\".",
  "message.transcript": "Transcripción",
  "message.transcribing": "Transcribiendo el audio…",
  "ai.conversation.transcribe": "Transcribir los audios recibidos",
  "ai.conversation.transcribe_hint": "El asistente entiende lo que dijo el contacto y el equipo lee el texto debajo del audio. Cada transcripción es una llamada de IA, con su costo en Uso.",
  "ai.surface.media.describe": "Descripción de imágenes y archivos",
  "aimodels.hint.media.describe": "Describe para el asistente las imágenes, stickers y documentos intercambiados en la conversación.",
  "ai.conversation.describe": "Describir imágenes y archivos para el asistente",
  "ai.conversation.describe_hint": "Cada foto, sticker o documento intercambiado (por el contacto o el equipo) recibe una descripción que solo lee el asistente, y las fotos más recientes van completas a los modelos que ven. Cada descripción es una llamada de IA, con su costo en Uso.",
  "email.ai_provider_down.subject_credit": "DoneTalk · {provider} rechazó la clave de la plataforma: sin crédito",
  "email.ai_provider_down.subject_key": "DoneTalk · {provider} rechazó la clave de la plataforma",
  "email.ai_provider_down.text_credit": "Desde {since}, {provider} rechaza las llamadas de la plataforma por falta de crédito en la cuenta.",
  "email.ai_provider_down.text_key": "Desde {since}, {provider} ya no acepta la clave de la plataforma (inválida o revocada).",
  "email.ai_provider_down.meanwhile": "Mientras tanto, cada tarea pasa a su proveedor de reserva, elegido en Consola › IA › Tareas, y la atención no se detiene. Las tareas sin reserva esperan hasta que se resuelva. Recibirá otro correo cuando el proveedor vuelva.",
  "email.ai_provider_down.cta": "Abrir la Consola",
  "email.ai_provider_down.why": "Recibe este aviso porque es administrador de la plataforma DoneTalk.",
  "email.ai_provider_back.subject": "DoneTalk · {provider} volvió a responder",
  "email.ai_provider_back.text": "{provider} volvió a aceptar la clave de la plataforma a las {until}. Estuvo fuera desde {since}; en ese tiempo, {count} llamadas fueron rechazadas y pasaron al proveedor de reserva cuando había uno.",
  "email.ai_key_refused.subject": "DoneTalk · {workspace}: {provider} rechazó la clave de la empresa",
  "email.ai_key_refused.text_credit": "{provider} rechazó la clave de IA de la empresa por falta de crédito en la cuenta.",
  "email.ai_key_refused.text_key": "{provider} ya no acepta la clave de IA de la empresa (inválida o revocada).",
  "email.ai_key_refused.meanwhile": "Mientras tanto, DoneTalk usa otro proveedor para que la atención no se detenga. Agregue crédito o cambie la clave en Configuración › IA › Claves.",
  "email.ai_key_refused.cta": "Ver las claves de IA",
  "errors.ai_provider_account": "El proveedor de IA rechazó el acceso (crédito o clave). Ya avisamos a quien se encarga.",
  "aimodels.cross": "Si el proveedor falla",
  "aimodels.cross_hint": "Modelo de otro proveedor, usado al final cuando el de la tarea rechaza o se cae (por ejemplo, sin crédito). Vale para todas las empresas.",
  "aimodels.console.cross": "Si el proveedor falla: {model}",
  "aimodels.console.no_cross": "Sin proveedor de reserva: si el proveedor falla, la tarea se detiene",
  "aimodels.notice.key_refused_credit": "{provider} rechazó la clave de la empresa por falta de crédito. Mientras tanto, DoneTalk usa otro proveedor. Agregue crédito o cambie la clave en Claves.",
  "aimodels.notice.key_refused_key": "{provider} ya no acepta la clave de la empresa. Mientras tanto, DoneTalk usa otro proveedor. Cambie la clave en Claves.",
  "aimodels.trace.fallback_account": "Respondió en lugar de {model}: el proveedor rechazó (crédito o clave)",
  "platform.ai.incident.open_credit": "{provider} sin crédito: la clave de la plataforma está siendo rechazada",
  "platform.ai.incident.open_key": "{provider} ya no acepta la clave de la plataforma",
  "platform.ai.incident.open_text": "Desde {since} · {count} llamadas rechazadas. Las tareas están en el proveedor de reserva; las que no tienen están detenidas. Se resuelve solo con la primera llamada que pase después de agregar crédito o cambiar la clave.",
  "platform.ai.incident.past_credit": "{provider} estuvo sin crédito de {since} a {until} ({count} llamadas rechazadas)",
  "platform.ai.incident.past_key": "{provider} rechazó la clave de {since} a {until} ({count} llamadas rechazadas)",
  "campaigns.read_rule": "Leídas cuenta solo a quien deja la confirmación de lectura activada en WhatsApp; quien la desactivó aparece como entregado.",
  "message.trace.version": "Instrucciones",
  "message.trace.version_number": "versión {number}",
  "campaigns.config.title": "Configuración",
  "campaigns.config.start": "Inicio",
  "campaigns.config.started": "Comenzó el {when}",
  "campaigns.config.window": "Horario de envío",
  "campaigns.config.days_hours": "{days}, de {from} a {to}",
  "campaigns.config.every_day": "Todos los días",
  "campaigns.config.no_window": "Sin horario definido",
  "campaigns.config.people": "1 persona|{count} personas",
  "campaigns.config.skips": "No envía a",
  "campaigns.config.skip_open": "quien ya está en atención",
  "campaigns.config.skip_recent": "quien recibió campaña en los últimos {days} días",
  "campaigns.config.no_goal": "Ninguno: el asistente no sabe qué busca esta campaña",
  "campaigns.config.no_fallback": "nada (el mensaje puede fallar)",
  "campaigns.config.never_stops": "Nunca se detiene sola",
  "campaigns.config.approval": "Aprobación",
  "campaigns.config.approved_by": "Aprobada por {name} el {when}",
  "campaigns.config.waiting_approval": "Esperando aprobación",
  "campaigns.pace.title": "Ritmo de envío",
  "campaigns.pace.fast": "Lo más rápido que Meta permita",
  "campaigns.pace.per_minute": "Hasta {count} por hora ({per} por minuto)",
  "campaigns.pace.every_minutes": "Hasta {count} por hora (1 cada {minutes} minutos)",
  "campaigns.pace.hint": "Más despacio da tiempo a que la campaña se detenga sola si mucha gente pide salir, y reparte las respuestas para quien atiende. El límite diario de Meta siempre se aplica.",
  "campaigns.sending.title": "Cambiar envío",
  "campaigns.sending.when": "Vale desde el próximo minuto, sin pausar la campaña. El resto de la campaña sigue como fue aprobado.",
  "inbox.view.automation": "Automatización",
  "inbox.with_flow": "Con el flujo {name}",
  "inbox.with_a_flow": "Con un flujo",
  "inbox.with_assistant": "Con {name} (IA)",
  "inbox.with_an_assistant": "Con el asistente",
  "inbox.contact_wrote": "el contacto escribió {when}",
  "inbox.ago_minutes": "hace {n} min",
  "inbox.ago_hours": "hace {n} h",
  "inbox.ago_days": "hace {n} d",
  "campaigns.filter.in_flow": "En un flujo",
  "campaigns.col.handler": "Quién atiende",
  "campaigns.handler.closed": "Concluido",
  "campaigns.handler.queue": "En la cola",
  "numbers.name.in_use": "En uso, aún no revisado por Meta",
  "numbers.health.code.141012": "El número alcanzó el límite de conversaciones nuevas iniciadas por la empresa (con plantillas) en las últimas 24 horas. Los cupos vuelven a medida que vencen los envíos de hace 24 horas. Las conversaciones que el contacto inició siguen normales.",
  "numbers.health.code.141015": "La empresa (su portafolio en Meta) alcanzó el límite de conversaciones iniciadas por ella en las últimas 24 horas. El límite vale para todos los números del portafolio y se libera de a poco, a medida que vencen los envíos de hace 24 horas.",
  "contact.copy_phone": "Copiar teléfono",
  "contact.phone_copied": "Teléfono copiado",
  "editor.label": "Editor de imagen",
  "editor.undo": "Deshacer",
  "editor.redo": "Rehacer",
  "editor.crop": "Recortar y girar",
  "editor.filter": "Filtrar",
  "editor.draw": "Dibujo",
  "editor.text": "Texto",
  "editor.shapes": "Formas",
  "editor.blur": "Desenfocar",
  "editor.emoji": "Emoji",
  "editor.sticker": "Sticker",
  "editor.quality": "Calidad de la foto",
  "editor.quality_none": "Esta foto no está en alta definición.",
  "editor.quality_standard": "Calidad estándar",
  "editor.quality_hd": "Calidad en alta definición",
  "editor.quality_help": "Las fotos en alta definición son más nítidas, pero las de calidad estándar ocupan menos espacio y se envían más rápido.",
  "editor.copy": "Copiar",
  "editor.copied": "Imagen copiada",
  "editor.copy_failed": "El navegador no permitió copiar la imagen.",
  "editor.download": "Descargar",
  "editor.ok": "OK",
  "editor.rotate_left": "Girar a la izquierda",
  "editor.rotate_right": "Girar a la derecha",
  "editor.reset": "Restablecer",
  "editor.filter_name.none": "Ninguno",
  "editor.filter_name.pop": "Pop",
  "editor.filter_name.bw": "B/N",
  "editor.filter_name.cool": "Frío",
  "editor.filter_name.chrome": "Chrome",
  "editor.filter_name.film": "Película",
  "editor.color.black": "Negro",
  "editor.color.gray": "Gris",
  "editor.color.white": "Blanco",
  "editor.color.blue": "Azul",
  "editor.color.green": "Verde",
  "editor.color.purple": "Morado",
  "editor.color.orange": "Naranja",
  "editor.color.red": "Rojo",
  "editor.more_colors": "Más colores",
  "editor.hex": "Código del color",
  "editor.brush_size": "Grosor {size}",
  "editor.font": "Fuente",
  "editor.align_left": "Alinear a la izquierda",
  "editor.align_center": "Centrar",
  "editor.align_right": "Alinear a la derecha",
  "editor.background": "Fondo",
  "editor.delete": "Eliminar",
  "editor.text_label": "Texto en la imagen",
  "editor.shape.rect": "Cuadrado",
  "editor.shape.circle": "Círculo",
  "editor.shape.line": "Línea",
  "editor.shape.arrow": "Flecha",
  "editor.fill": "Relleno",
  "editor.stroke": "Contorno",
  "editor.no_color": "Sin color",
  "editor.stroke_width": "Grosor del contorno",
  "editor.blur_mode": "Modo de desenfoque",
  "editor.blur_pixelate": "Pixelado",
  "editor.blur_soft": "Desenfocado",
  "editor.blur_size": "Tamaño del pincel",
  "editor.rotate_item": "Girar",
  "editor.stickers_recent": "Recientes",
  "editor.stickers_none": "Los stickers usados en las conversaciones aparecen aquí.",
  "editor.sticker_file": "Usar una imagen",
  "editor.export_failed": "No se pudo preparar la imagen editada. Inténtalo de nuevo.",
  "media.discard_title": "¿Descartar la selección?",
  "campaigns.after.title": "Después del envío",
  "campaigns.after.lead": "Qué pasa con quien no responde y con quien deja de responder. Todo dentro del horario de envío de la campaña.",
  "campaigns.after.never_title": "Quien no responda a la plantilla",
  "campaigns.after.send": "Enviar",
  "campaigns.after.no_reminder": "ningún recordatorio",
  "campaigns.after.one_reminder": "1 recordatorio",
  "campaigns.after.reminders": "Recordatorios",
  "campaigns.after.with_template": "con la plantilla",
  "campaigns.after.template": "Plantilla del recordatorio",
  "campaigns.after.pick_template": "elija la plantilla",
  "campaigns.after.after": "después de",
  "campaigns.after.delay": "Cuándo enviar el recordatorio",
  "campaigns.after.reminder_hint": "Es una nueva plantilla, cobrada como marketing, y cuenta en el límite diario del número. Usa las mismas variables de la campaña. No va a quien pausó o salió de los mensajes activos, y se detiene sola si baja la calidad del número.",
  "campaigns.after.no_templates": "Ninguna otra plantilla aprobada en este número.",
  "campaigns.after.quiet_title": "Quien respondió y dejó de responder",
  "campaigns.after.resumes": "{name} retoma",
  "campaigns.after.the_assistant": "El asistente",
  "campaigns.after.follow_up": "Cuándo retomar",
  "campaigns.after.times": "Cuántas retomas",
  "campaigns.after.quiet_hint": "{name} relee la conversación y decide: un mensaje corto hacia el objetivo, concluir si ya terminó, o pasar a una persona solo en caso extremo. Gratis: va dentro de la ventana de 24 h.",
  "campaigns.after.quiet_needs_assistant": "La retoma es del asistente: vale cuando un asistente responde la campaña.",
  "campaigns.after.closing_title": "Cierre por silencio",
  "campaigns.after.follows.customer": "Sigue la regla de la empresa:",
  "campaigns.after.follows.channel": "Sigue la regla del número:",
  "campaigns.after.follows.team": "Sigue la regla del equipo:",
  "campaigns.after.follows.campaign": "Sigue la regla de la campaña:",
  "campaigns.after.no_rule": "Ninguna regla concluye por silencio: las conversaciones quedan abiertas.",
  "campaigns.after.customize": "Personalizar en esta campaña",
  "campaigns.after.custom": "Personalizada: reemplaza la regla de la empresa en esta campaña.",
  "campaigns.after.back_to_rule": "Volver a la regla de la empresa",
  "campaigns.after.saved_hint": "Vale desde el próximo minuto.",
  "campaigns.after.report": "Resultado después del envío",
  "campaigns.after.reminders_line": "enviados · {replied} respondieron · costo {cost}",
  "campaigns.after.reminders_off": "Solo aparece con el recordatorio activo.",
  "campaigns.after.follow_ups": "Retomas",
  "campaigns.after.follow_ups_of": "Retomas de {name}",
  "campaigns.after.follow_ups_line": "enviadas · {resumed} volvieron a conversar",
  "campaigns.after.follow_ups_hint": "Gratis, dentro de la ventana.",
  "campaigns.after.closed_rule": "Concluidas por silencio",
  "campaigns.after.closed_rule_line": "por la regla de la campaña",
  "campaigns.after.closed_rule_hint": "Con el desenlace que eligió la IA, o {outcome}.",
  "campaigns.after.closed_rule_off": "La campaña sigue la regla de la empresa.",
  "campaigns.after.endings": "Cómo terminaron las conversaciones",
  "campaigns.after.ending.automation": "Concluidas por la automatización",
  "campaigns.after.ending.automation_of": "Concluidas por {name}",
  "campaigns.after.ending.silence": "Concluidas por silencio",
  "campaigns.after.ending.person": "Pasadas a una persona",
  "campaigns.after.ending.open": "Todavía abiertas",
  "campaigns.after.endings_hint": "Cada fila abre la lista de esas conversaciones, con el motivo de cada transferencia.",
  "campaigns.after.endings_empty": "Ninguna conversación aquí.",
  "campaigns.after.reason": "Motivo: {reason}",
  "followup.when.before_close": "1 h antes de que cierre la ventana",
  "followup.when.after_2h": "después de 2 h de silencio",
  "followup.when.after_4h": "después de 4 h de silencio",
  "followup.when.after_8h": "después de 8 h de silencio",
  "followup.when.off": "no retomar",
  "followup.up_to": "hasta",
  "followup.times": "1 vez|{count} veces",
  "followup.hours": "{n} h",
  "followup.days": "1 día|{count} días",
  "policy.choose": "la IA elige (o {outcome})",
  "policy.when_silent": "Cuando el contacto no responde por",
  "policy.close_as": "→ concluir como",
  "policy.short": "{hours} sin respuesta → {outcome}",
  "policy.sentence.choose": "Cuando el contacto no responde por {hours} horas → la IA elige el desenlace (o {outcome})",
  "policy.company": "De la empresa",
  "policy.custom": "Personalizadas",
  "policy.custom_hint": "Una regla personalizada reemplaza la de la empresa donde vale: gana la más específica.",
  "policy.replaces": "reemplaza la de la empresa",
  "policy.level.campaign": "Campaña",
  "policy.level.channel": "Número",
  "policy.level.team": "Equipo",
  "policy.level.customer": "Empresa",
  "policy.order_title": "Qué regla vale para una conversación",
  "policy.order": "Campaña › número › equipo › empresa. Solo una vale por conversación: la primera que se aplica en ese orden. Una conversación en la cola del equipo esperando que la empresa responda nunca se concluye por silencio.",
  "policy.campaign_rule_hint": "Se cambia en la campaña, en Después del envío.",
  "policy.scope_channel": "número {name}",
  "policy.applies_number": "Número",
  "inbox.next.follow_up": "retoma {when}",
  "inbox.next.closes": "concluye en {time} sin respuesta",
  "inbox.next.at": "a las {time}",
  "inbox.next.tomorrow": "mañana a las {time}",
  "inbox.next.chip": "Retoma {when}",
  "inbox.next.chip_tip": "{name} retoma antes de que cierre la ventana si el contacto no responde: retoma {n} de {of}, {when}.",
  "inbox.next.rule": "Regla de cierre",
  "inbox.next.rule_line": "{whose}: {rule}",
  "inbox.next.closes_at": "Concluye {when} si el contacto no responde.",
  "event.follow_up.running": "Retoma {n} de {of}",
  "event.follow_up.sent": "Retoma {n} de {of}",
  "event.follow_up.closed": "Retoma {n} de {of} · la conversación ya había terminado: concluida",
  "event.follow_up.handed_off": "Retoma {n} de {of} · pasada a una persona",
  "event.follow_up.nothing": "Retoma {n} de {of} · nada que decir",
  "event.follow_up.superseded": "Retoma {n} de {of} · el contacto escribió antes",
  "event.follow_up.failed": "Retoma {n} de {of} · no fue posible",
  "event.closed_rule": "Concluida por la regla {whose}: {hours} sin respuesta",
  "event.rule_whose.campaign": "de la campaña",
  "event.rule_whose.channel": "del número",
  "event.rule_whose.team": "del equipo",
  "event.rule_whose.customer": "de la empresa",
  "event.closed_chosen": "desenlace elegido por la IA",
  "event.info.rule": "Regla",
  "message.follow_up": "retoma {n} de {of}",
  "assistant.follow_up.title": "Retoma fuera de campañas",
  "assistant.follow_up.hint": "Cuando el contacto deja de responder, {name} retoma antes de que cierre la ventana de 24 h, dentro del horario elegido, y decide: un mensaje corto, concluir, o una persona solo en caso extremo. En las conversaciones de campaña vale lo que dice la campaña.",
  "assistant.follow_up.hours": "Horario de la retoma",
  "assistant.follow_up.any_time": "A cualquier hora",
  "assistant.follow_up.within": "En el horario de abajo",
  "inbox.next.today": "hoy a las {time}",
  "inbox.next.other_day": "{date} a las {time}",
  "message.trace.follow_up": "Por qué escribió"
}
